import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHoc from '@apollo/client/react/hoc';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * A date string, such as 2007-12-03, compliant with the `full-date` format
   * outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for
   * representation of dates and times using the Gregorian calendar.
   */
  Date: { input: any; output: any; }
  /**
   * A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the
   * `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO
   * 8601 standard for representation of dates and times using the Gregorian calendar.
   */
  DateTime: { input: any; output: any; }
  Json: { input: any; output: any; }
  Time: { input: any; output: any; }
};

export type AccessRestriction =
  | 'DEVELOPMENT'
  | 'PRODUCTION'
  | 'STAGING';

export type Achievement = {
  __typename?: 'Achievement';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  imageShare?: Maybe<Scalars['String']['output']>;
  /** @deprecated [5.1.16] use title instead */
  name?: Maybe<Scalars['String']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type AddInvitedByReturnType = {
  __typename?: 'AddInvitedByReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type AdyenCardConfig = {
  __typename?: 'AdyenCardConfig';
  holderNameRequired?: Maybe<Scalars['Boolean']['output']>;
};

export type AdyenConfiguration = {
  __typename?: 'AdyenConfiguration';
  applepay?: Maybe<ApplePayConfig>;
  card?: Maybe<AdyenCardConfig>;
  clientKey: Scalars['String']['output'];
  environment: Scalars['String']['output'];
  returnUrl: Scalars['String']['output'];
};

export type AdyenSessionResponse = {
  __typename?: 'AdyenSessionResponse';
  config: AdyenConfiguration;
  finalSubscriptionTierId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  sessionData: Scalars['String']['output'];
};

export type AgeFilter = {
  __typename?: 'AgeFilter';
  active: Scalars['Boolean']['output'];
  maxAge?: Maybe<Scalars['Int']['output']>;
  minAge: Scalars['Int']['output'];
};

export type AgeFilterInput = {
  active: Scalars['Boolean']['input'];
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  minAge: Scalars['Int']['input'];
};

export type App = {
  __typename?: 'App';
  device?: Maybe<Scalars['String']['output']>;
  fcmToken?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  os?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

export type AppFeedbackSection = ContentSection & {
  __typename?: 'AppFeedbackSection';
  id: Scalars['ID']['output'];
};

export type AppRelease = {
  __typename?: 'AppRelease';
  deprecationDetails?: Maybe<Scalars['String']['output']>;
  releaseDate: Scalars['Date']['output'];
  supported: Scalars['Boolean']['output'];
  versionCode: Scalars['String']['output'];
};

export type AppTermsStatus = {
  __typename?: 'AppTermsStatus';
  alertButtonLabel?: Maybe<Scalars['String']['output']>;
  alertDescription?: Maybe<Scalars['String']['output']>;
  alertTitle?: Maybe<Scalars['String']['output']>;
  latestTermsAgreed?: Maybe<Scalars['Boolean']['output']>;
};

export type ApplePayConfig = {
  __typename?: 'ApplePayConfig';
  merchantID: Scalars['String']['output'];
  merchantName: Scalars['String']['output'];
};

export type AssociatedCinema = {
  __typename?: 'AssociatedCinema';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type AudioFingerprintingConfig = {
  __typename?: 'AudioFingerprintingConfig';
  bottomFrequencyLimiter?: Maybe<Scalars['Int']['output']>;
  halfWidthOfPeakDetectionWindow?: Maybe<Scalars['Int']['output']>;
  original_numberOfPeakBorderingFrequencies?: Maybe<Scalars['Int']['output']>;
  original_numberOfPeakBorderingTimeBins?: Maybe<Scalars['Int']['output']>;
  original_numberOfVectorNeighbors?: Maybe<Scalars['Int']['output']>;
  sampleRate?: Maybe<Scalars['Int']['output']>;
  samplesPerBin?: Maybe<Scalars['Int']['output']>;
  snippet_numberOfPeakBorderingFrequencies?: Maybe<Scalars['Int']['output']>;
  snippet_numberOfPeakBorderingTimeBins?: Maybe<Scalars['Int']['output']>;
  snippet_numberOfVectorNeighbors?: Maybe<Scalars['Int']['output']>;
  timeDistanceBetweenBins?: Maybe<Scalars['Int']['output']>;
  topFrequencyLimiter?: Maybe<Scalars['Int']['output']>;
};

export type Auditorium = {
  __typename?: 'Auditorium';
  cinema: Cinema;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  seatCategories: Array<SeatCategory>;
  seats: Array<Seat>;
};

export type AverageCinemaVisitsFilter = {
  __typename?: 'AverageCinemaVisitsFilter';
  active: Scalars['Boolean']['output'];
  maxVisits?: Maybe<Scalars['Int']['output']>;
  minVisits: Scalars['Int']['output'];
  timePeriod?: Maybe<TimePeriod>;
};

export type AverageCinemaVisitsFilterInput = {
  active: Scalars['Boolean']['input'];
  maxVisits?: InputMaybe<Scalars['Int']['input']>;
  minVisits: Scalars['Int']['input'];
  timePeriod?: InputMaybe<TimePeriod>;
};

export type AverageGroupSizesFilter = {
  __typename?: 'AverageGroupSizesFilter';
  active: Scalars['Boolean']['output'];
  sizes: Array<GroupSize>;
};

export type AverageGroupSizesFilterInput = {
  active: Scalars['Boolean']['input'];
  sizes: Array<GroupSize>;
};

export type AveragePerDateStatistic = {
  __typename?: 'AveragePerDateStatistic';
  count: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
  newCount?: Maybe<Scalars['Float']['output']>;
};

export type Beacon = {
  __typename?: 'Beacon';
  cinema?: Maybe<Cinema>;
  comments?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  instanceId: Scalars['Float']['output'];
  lastBatteryChange?: Maybe<Scalars['DateTime']['output']>;
  lastScan?: Maybe<Scalars['DateTime']['output']>;
  lastUpdated: Scalars['DateTime']['output'];
};

export type BlockedReason =
  | 'NO_SHOW'
  | 'OTHER'
  | 'PAYMENT_FAILED';

export type BonusCurrency = {
  __typename?: 'BonusCurrency';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BonusPointHistoryConnection = {
  __typename?: 'BonusPointHistoryConnection';
  bonusPointHistoryItems: Array<BonusPointHistoryItem>;
};

export type BonusPointHistoryItem = {
  __typename?: 'BonusPointHistoryItem';
  amount?: Maybe<Scalars['Int']['output']>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type BonusPointsFilter = {
  __typename?: 'BonusPointsFilter';
  active: Scalars['Boolean']['output'];
  maxBonusPoints?: Maybe<Scalars['Int']['output']>;
  minBonusPoints: Scalars['Int']['output'];
};

export type BonusPointsFilterInput = {
  active: Scalars['Boolean']['input'];
  maxBonusPoints?: InputMaybe<Scalars['Int']['input']>;
  minBonusPoints: Scalars['Int']['input'];
};

export type BonusProgram = {
  __typename?: 'BonusProgram';
  accentColor?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  bonusType?: Maybe<BonusType>;
  coinName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  infoLinks?: Maybe<Array<CinemaInfoLink>>;
  legalEntity: Scalars['String']['output'];
  logo?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  participatingCinemas: Array<Cinema>;
  statistics?: Maybe<BonusProgramStatistics>;
  termsLink?: Maybe<Scalars['String']['output']>;
  termsVersion: Scalars['Int']['output'];
  userMembership?: Maybe<BonusProgramMembership>;
  /** @deprecated [5.0.6] use BonusProgramMembership -> voucher Catalog instead (voucher catalog might be user specific) */
  voucherCatalog: Array<VoucherClass>;
};


export type BonusProgramStatisticsArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type BonusProgramUserMembershipArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type BonusProgramMemberStatus =
  | 'BONUSPROGRAM_MEMBERS_ONLY'
  | 'NON_BONUSPROGRAM_MEMBERS_ONLY';

export type BonusProgramMemberStatusFilter = {
  __typename?: 'BonusProgramMemberStatusFilter';
  active: Scalars['Boolean']['output'];
  status?: Maybe<BonusProgramMemberStatus>;
};

export type BonusProgramMemberStatusFilterInput = {
  active: Scalars['Boolean']['input'];
  status?: InputMaybe<BonusProgramMemberStatus>;
};

export type BonusProgramMembership = {
  __typename?: 'BonusProgramMembership';
  achievements: Array<Achievement>;
  active?: Maybe<Scalars['Boolean']['output']>;
  additionalInfoLink?: Maybe<Scalars['String']['output']>;
  avoidStatusLevelDowngradeNumVisits?: Maybe<Scalars['Int']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  bonusProgram?: Maybe<BonusProgram>;
  bookingHistory: Array<BonusPointHistoryItem>;
  coinBalance?: Maybe<Scalars['Int']['output']>;
  collectionDisclaimer?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  id: Scalars['ID']['output'];
  inviteCode?: Maybe<Scalars['String']['output']>;
  isTeenMembership?: Maybe<Scalars['Boolean']['output']>;
  joinedAt?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  ownedVouchers: Array<VoucherInstance>;
  pkpass?: Maybe<Scalars['String']['output']>;
  provisionalBonusPointBookings: Array<ProvisionalBonusPointBooking>;
  qrCode?: Maybe<Scalars['String']['output']>;
  statusLevel?: Maybe<StatusLevel>;
  statusLevelDowngradeAt?: Maybe<Scalars['DateTime']['output']>;
  statusPointBalance?: Maybe<Scalars['Int']['output']>;
  termsStatus?: Maybe<BonusProgramTermsStatus>;
  user?: Maybe<User>;
  /** @deprecated [5.2.1] use voucherClasses instead */
  voucherCatalog: VoucherCatalog;
  voucherClasses: Array<VoucherClass>;
};


export type BonusProgramMembershipOwnedVouchersArgs = {
  validOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BonusProgramStatistics = {
  __typename?: 'BonusProgramStatistics';
  numBpBookingsInInterval?: Maybe<Scalars['Int']['output']>;
  numBpBookingsTotal?: Maybe<Scalars['Int']['output']>;
  numNewUsersInInterval?: Maybe<Scalars['Int']['output']>;
  numNewUsersTotal?: Maybe<Scalars['Int']['output']>;
  numUsersInInterval?: Maybe<Scalars['Int']['output']>;
  numUsersMultipleBookingsTotal?: Maybe<Scalars['Int']['output']>;
  numUsersTotal?: Maybe<Scalars['Int']['output']>;
  redeemedVouchersInInterval: Array<RedeemedVoucher>;
  scannedVouchersInInterval?: Maybe<Scalars['Int']['output']>;
  scannedVouchersTotal?: Maybe<Scalars['Int']['output']>;
  sumBonusPointsInInterval?: Maybe<Scalars['Int']['output']>;
  sumBonusPointsSupportInInterval?: Maybe<Scalars['Int']['output']>;
  sumBonusPointsSupportTotal?: Maybe<Scalars['Int']['output']>;
  sumBonusPointsTotal?: Maybe<Scalars['Int']['output']>;
};

export type BonusProgramTermsStatus = {
  __typename?: 'BonusProgramTermsStatus';
  alertButtonLabel?: Maybe<Scalars['String']['output']>;
  alertDescription?: Maybe<Scalars['String']['output']>;
  alertTitle?: Maybe<Scalars['String']['output']>;
  latestTermsAgreed?: Maybe<Scalars['Boolean']['output']>;
};

export type BonusProgramVoucherStockImage = {
  __typename?: 'BonusProgramVoucherStockImage';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type BonusProgramVoucherType = {
  __typename?: 'BonusProgramVoucherType';
  active: Scalars['Boolean']['output'];
  bookableUntil?: Maybe<Scalars['DateTime']['output']>;
  cinemaId: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  discountPercent?: Maybe<Scalars['Float']['output']>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  initialQuantity?: Maybe<Scalars['Int']['output']>;
  maxQuantityPerPerson?: Maybe<Scalars['Int']['output']>;
  priceCoins?: Maybe<Scalars['Int']['output']>;
  priceEuros?: Maybe<Scalars['Float']['output']>;
  redeemableUntil?: Maybe<Scalars['DateTime']['output']>;
  remainingQuantity?: Maybe<Scalars['Int']['output']>;
  title: Scalars['String']['output'];
  voucherTypeId: Scalars['ID']['output'];
};

export type BonusProgramVoucherTypeInput = {
  active: Scalars['Boolean']['input'];
  bookableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  discountPercent?: InputMaybe<Scalars['Float']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  initialQuantity?: InputMaybe<Scalars['Int']['input']>;
  maxQuantityPerPerson?: InputMaybe<Scalars['Int']['input']>;
  priceCoins?: InputMaybe<Scalars['Int']['input']>;
  priceEuros?: InputMaybe<Scalars['Float']['input']>;
  redeemableUntil?: InputMaybe<Scalars['DateTime']['input']>;
  title: Scalars['String']['input'];
};

export type BonusType =
  | 'COINS'
  | 'STAMPS';

export type BookingProcess = {
  __typename?: 'BookingProcess';
  id: Scalars['ID']['output'];
  isFixedSeating?: Maybe<Scalars['Boolean']['output']>;
  isPaid?: Maybe<Scalars['Boolean']['output']>;
  occupiedSeatingAreas: Array<OccupiedSeatingArea>;
  occupiedSeats: Array<OccupiedSeat>;
  paypalApproveLink?: Maybe<Scalars['String']['output']>;
  paypalOrderId?: Maybe<Scalars['String']['output']>;
  priceInCents: Scalars['Int']['output'];
  selectedSeats: Array<SelectedSeat>;
  subscriptionTicketWarningText?: Maybe<Scalars['String']['output']>;
  timeout: Scalars['DateTime']['output'];
};

export type BookingProcessReturnType = {
  __typename?: 'BookingProcessReturnType';
  bookingProcess: BookingProcess;
  statusMessage?: Maybe<Scalars['String']['output']>;
};

export type Brand =
  | 'CINEPLEX'
  | 'CINEWEB'
  | 'CINFINITY'
  | 'CINURU'
  | 'DREHWERK'
  | 'ELSELICHTSPIELE'
  | 'LUMOS';

export type ButtonSection = ContentSection & {
  __typename?: 'ButtonSection';
  buttonLabel: Scalars['String']['output'];
  hideChevron?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  margin?: Maybe<Scalars['String']['output']>;
  onPressType: ButtonSectionOnPressType;
  routeArgs?: Maybe<Scalars['Json']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
};

export type ButtonSectionOnPressType =
  | 'IN_APP_BROWSER'
  | 'NAVIGATION'
  | 'OTHER_APP';

export type Campaign = {
  __typename?: 'Campaign';
  channels: Array<Channel>;
  cinemas: Array<Cinema>;
  creator: User;
  emailContent?: Maybe<Scalars['Json']['output']>;
  emailSubject?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endTime?: Maybe<Scalars['String']['output']>;
  eventType?: Maybe<CampaignEventType>;
  id: Scalars['ID']['output'];
  intervalEndType?: Maybe<CampaignIntervalEndType>;
  language?: Maybe<Language>;
  link?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  messageImage?: Maybe<Scalars['String']['output']>;
  messageTitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  numberOfIntervals?: Maybe<Scalars['Int']['output']>;
  sendExactlyMinutesAfterTrigger?: Maybe<Scalars['Int']['output']>;
  sendOnDayXAfterTrigger?: Maybe<Scalars['Int']['output']>;
  sendingDate?: Maybe<Scalars['Date']['output']>;
  sendingTime?: Maybe<Scalars['Time']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  startTime?: Maybe<Scalars['String']['output']>;
  status: CampaignStatus;
  targetGroupIds?: Maybe<Array<Scalars['ID']['output']>>;
  timeUnit?: Maybe<CampaignTimeUnit>;
  timeUnitFactor?: Maybe<Scalars['Int']['output']>;
  trigger?: Maybe<CampaignTrigger>;
  triggerThreshold?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CampaignType>;
  userGroupFilter?: Maybe<UserGroupFilter>;
  userGroupFilterOnReferencedMovie?: Maybe<UserGroupFilterOnReferencedMovie>;
};

export type CampaignEventType =
  | 'AFTER'
  | 'BEFORE';

export type CampaignIntervalEndType =
  | 'AFTER'
  | 'NEVER'
  | 'ON';

export type CampaignStatus =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'EDITING'
  | 'FAILED'
  | 'SENT';

export type CampaignTimeUnit =
  | 'DAY'
  | 'HOUR'
  | 'MINUTE'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

export type CampaignTrigger =
  | 'APP_INSTALL'
  | 'BIRTHDAY'
  | 'BOUGHT_CONCESSIONS'
  | 'BOUGHT_TICKET'
  | 'CREATED_ACCOUNT'
  | 'FILM_START'
  | 'JOIN_BONUSPROGRAM'
  | 'NEWSLETTER_SUBSCRIBED'
  | 'NO_VISIT'
  | 'POINTS_REACHED'
  | 'REGULAR'
  | 'SINGLE_EVENT'
  | 'STATUSLEVEL_REACHED'
  | 'VISIT';

export type CampaignType =
  | 'FIXED_DATE'
  | 'MOVIE_ANNOUNCED'
  | 'MOVIE_CINEMA_LEAVE'
  | 'MOVIE_CINEMA_START'
  | 'MOVIE_NEW_TRAILER'
  | 'USER_BIRTHDAY'
  | 'USER_CINEMA_LAST_VISIT'
  | 'USER_MOVIE_MARKED'
  | 'USER_MOVIE_RATED'
  | 'USER_MOVIE_SEEN'
  | 'USER_POINTS_LOST'
  | 'USER_POINTS_REACHED'
  | 'USER_VOUCHER_EXPIRES'
  | 'VOUCHER_LEAVE'
  | 'VOUCHER_START';

export type CampaignsByCinemasReturnType = {
  __typename?: 'CampaignsByCinemasReturnType';
  campaigns: Array<Campaign>;
};

export type CancelBookingProcessResponse = {
  __typename?: 'CancelBookingProcessResponse';
  success: Scalars['Boolean']['output'];
};

export type CancelOrderReturnType = {
  __typename?: 'CancelOrderReturnType';
  canceledOrder?: Maybe<Order>;
  currentUser?: Maybe<User>;
};

export type CancelTicketReturnType = {
  __typename?: 'CancelTicketReturnType';
  canceledTicket?: Maybe<Ticket>;
  currentUser?: Maybe<User>;
};

export type CancellationEffectiveAtType =
  | 'NOW'
  | 'PAYED_UNTIL';

export type CardSection = ContentSection & {
  __typename?: 'CardSection';
  cardSectionImageUrl?: Maybe<Scalars['String']['output']>;
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  collapsible?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  margin?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CastOrCrewMember = {
  __typename?: 'CastOrCrewMember';
  fullName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
};

export type CastOrCrewMemberAffinityFilter = {
  __typename?: 'CastOrCrewMemberAffinityFilter';
  active: Scalars['Boolean']['output'];
  castOrCrewMembers: Array<CastOrCrewMember>;
};

export type CastOrCrewMemberAffinityFilterInput = {
  active: Scalars['Boolean']['input'];
  castOrCrewMembers: Array<Scalars['ID']['input']>;
};

export type CentralPlannerReservation = ContentSection & {
  __typename?: 'CentralPlannerReservation';
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  infoText?: Maybe<Scalars['String']['output']>;
  infoTextAfter?: Maybe<Scalars['String']['output']>;
  margin?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type Channel =
  | 'APP'
  | 'EMAIL'
  | 'IN_APP'
  | 'PUSH';

export type CheckVoucherCodeErrorCode =
  | 'VOUCHER_CODE_ALREADY_REDEEMED'
  | 'VOUCHER_CODE_INVALID'
  | 'VOUCHER_CODE_TOO_OLD';

export type CheckVoucherCodeReturnType = {
  __typename?: 'CheckVoucherCodeReturnType';
  errorCode?: Maybe<CheckVoucherCodeErrorCode>;
  valid: Scalars['Boolean']['output'];
};

export type CheckVoucherCodesReturnType = {
  __typename?: 'CheckVoucherCodesReturnType';
  errorMessage1?: Maybe<Scalars['String']['output']>;
  errorMessage2?: Maybe<Scalars['String']['output']>;
  valid: Scalars['Boolean']['output'];
};

export type Cinema = {
  __typename?: 'Cinema';
  accentColor?: Maybe<Scalars['String']['output']>;
  accessRestrictedTo: AccessRestriction;
  additionalInfoSections?: Maybe<Array<CinemaInformationParagraph>>;
  appleMapsLink?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  barrierFree?: Maybe<Scalars['Boolean']['output']>;
  barrierFreeText?: Maybe<Scalars['String']['output']>;
  beaconScanningRequired?: Maybe<Scalars['Boolean']['output']>;
  beacons: Array<Beacon>;
  blind?: Maybe<Scalars['Boolean']['output']>;
  blindText?: Maybe<Scalars['String']['output']>;
  bonusProgram?: Maybe<BonusProgram>;
  bonusProgramVoucherTypes: Array<BonusProgramVoucherType>;
  brands: Array<Brand>;
  city?: Maybe<Scalars['String']['output']>;
  claim?: Maybe<Scalars['String']['output']>;
  clusters: Array<Scalars['String']['output']>;
  currentInformation?: Maybe<Scalars['String']['output']>;
  currentScreeningAttributes: Array<ScreeningAttribute>;
  email?: Maybe<Scalars['String']['output']>;
  externalCinemaId?: Maybe<Scalars['String']['output']>;
  facebook?: Maybe<Scalars['String']['output']>;
  giftVouchersDisplay: Array<CinemaInformationParagraph>;
  googleMapsLink?: Maybe<Scalars['String']['output']>;
  hasBonusProgram?: Maybe<Scalars['Boolean']['output']>;
  hasDynamicPricing: Scalars['Boolean']['output'];
  hasMigratableCustomerCards: Scalars['Boolean']['output'];
  /** @deprecated [???]: trailerrating has been removed */
  hasTrailerRating?: Maybe<Scalars['Boolean']['output']>;
  headerImage?: Maybe<Scalars['String']['output']>;
  hearingImpaired?: Maybe<Scalars['Boolean']['output']>;
  hearingImpairedText?: Maybe<Scalars['String']['output']>;
  history?: Maybe<Scalars['String']['output']>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imprint?: Maybe<Scalars['String']['output']>;
  infoLinks?: Maybe<Array<CinemaInfoLink>>;
  injectionScript?: Maybe<Scalars['String']['output']>;
  instagram?: Maybe<Scalars['String']['output']>;
  /** @deprecated [4.1.0]: use location instead */
  latitude?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoCoordinates>;
  locationDescription?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  /** @deprecated [4.1.0]: use location instead */
  longitude?: Maybe<Scalars['String']['output']>;
  movies: Array<Movie>;
  moviesWithLastChanceInfo: Array<LastChanceItem>;
  name?: Maybe<Scalars['String']['output']>;
  onlineReservationBaseUrl?: Maybe<Scalars['String']['output']>;
  onlineTicketingBaseUrl?: Maybe<Scalars['String']['output']>;
  onlineTicketingDisclaimer?: Maybe<Scalars['String']['output']>;
  openingHoursDisplay: Array<CinemaOpeningHours>;
  parkingDescription?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  posTokens: Array<Scalars['String']['output']>;
  pricesDisplay: Array<CinemaInformationParagraph>;
  products: Array<CinemaProduct>;
  reservationHotline?: Maybe<Scalars['String']['output']>;
  sneaksDisplay: Array<CinemaInformationParagraph>;
  specialAboutUs?: Maybe<Scalars['String']['output']>;
  specialOffersDisplay: Array<CinemaInformationParagraph>;
  street?: Maybe<Scalars['String']['output']>;
  technologies?: Maybe<Scalars['String']['output']>;
  ticketProvider?: Maybe<Scalars['String']['output']>;
  tiktok?: Maybe<Scalars['String']['output']>;
  twitter?: Maybe<Scalars['String']['output']>;
  userCustomership?: Maybe<CinemaCustomership>;
  website?: Maybe<Scalars['String']['output']>;
  youtube?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type CinemaMoviesArgs = {
  futureOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type CinemaMoviesWithLastChanceInfoArgs = {
  includeOutdated: Scalars['Boolean']['input'];
};


export type CinemaProductsArgs = {
  categories?: InputMaybe<Array<CinemaProductCategory>>;
};


export type CinemaUserCustomershipArgs = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type CinemaCluster = {
  __typename?: 'CinemaCluster';
  cinemas: Array<Cinema>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
};

export type CinemaClusterData = {
  cinemaIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  position: Scalars['Int']['input'];
};

export type CinemaCustomership = {
  __typename?: 'CinemaCustomership';
  cinema?: Maybe<Cinema>;
  id: Scalars['ID']['output'];
  user?: Maybe<User>;
};

export type CinemaInfoLink = {
  __typename?: 'CinemaInfoLink';
  name: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type CinemaInformationParagraph = {
  __typename?: 'CinemaInformationParagraph';
  description?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type CinemaInformationParagraphInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  price?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CinemaLocationInput = {
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
};

export type CinemaOpeningHours = {
  __typename?: 'CinemaOpeningHours';
  hours?: Maybe<Scalars['String']['output']>;
  weekdays?: Maybe<Scalars['String']['output']>;
};

export type CinemaOpeningHoursInput = {
  hours?: InputMaybe<Scalars['String']['input']>;
  weekdays?: InputMaybe<Scalars['String']['input']>;
};

export type CinemaOperatingCompany = {
  __typename?: 'CinemaOperatingCompany';
  accessRightBonusProgram?: Maybe<Scalars['Boolean']['output']>;
  accessRightCampaigning?: Maybe<Scalars['Boolean']['output']>;
  accessRightDashboard?: Maybe<Scalars['Boolean']['output']>;
  accessRightFilmStatistics?: Maybe<Scalars['Boolean']['output']>;
  allVoucherClassesOfCinemaOperatingCompany: Array<VoucherClass>;
  associatedUsers: Array<User>;
  cinemas: Array<AssociatedCinema>;
  externalPhoneNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  pricingLevel?: Maybe<Scalars['String']['output']>;
  pricingScheme?: Maybe<Scalars['String']['output']>;
  targetGroupFilterConfig: Array<TargetGroupFilterConfig>;
};

export type CinemaOperatingCompanyData = {
  accessRightBonusProgram?: InputMaybe<Scalars['Boolean']['input']>;
  accessRightCampaigning?: InputMaybe<Scalars['Boolean']['input']>;
  accessRightDashboard?: InputMaybe<Scalars['Boolean']['input']>;
  accessRightFilmStatistics?: InputMaybe<Scalars['Boolean']['input']>;
  cinemasIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CinemaPayoutInfo = {
  __typename?: 'CinemaPayoutInfo';
  cinema: Cinema;
  numAdditionalTickets: Scalars['Int']['output'];
  numOfSubscriptionTickets: Scalars['Int']['output'];
};

export type CinemaProduct = {
  __typename?: 'CinemaProduct';
  bonusPoints?: Maybe<Scalars['Int']['output']>;
  category?: Maybe<CinemaProductCategory>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtext?: Maybe<Scalars['String']['output']>;
};

export type CinemaProductCategory =
  | 'TICKET';

export type CinemaSpecificContent = {
  __typename?: 'CinemaSpecificContent';
  attributes: Array<ScreeningAttribute>;
  cinema: Cinema;
  teaser?: Maybe<Scalars['String']['output']>;
  week?: Maybe<Scalars['Int']['output']>;
};

export type CinemaVisitSinceFilter = {
  __typename?: 'CinemaVisitSinceFilter';
  active: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  timePeriod?: Maybe<TimePeriod>;
};

export type CinemaVisitSinceFilterInput = {
  active: Scalars['Boolean']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  timePeriod?: InputMaybe<TimePeriod>;
};

export type CinfinityCinemaStatsMonthly = {
  __typename?: 'CinfinityCinemaStatsMonthly';
  additionalTickets: Scalars['Int']['output'];
  month: Scalars['String']['output'];
  visits: Scalars['Int']['output'];
};

export type CinfinityCinemaStatsResponse = {
  __typename?: 'CinfinityCinemaStatsResponse';
  additionalTickets: Scalars['Int']['output'];
  monthlyVisits: Array<CinfinityCinemaStatsMonthly>;
  users: Scalars['Int']['output'];
  visitors: Scalars['Int']['output'];
  visits: Scalars['Int']['output'];
};

export type Company = {
  __typename?: 'Company';
  id: Scalars['ID']['output'];
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numericalID?: Maybe<Scalars['Int']['output']>;
};

export type ComscoreImdbEntry = {
  __typename?: 'ComscoreImdbEntry';
  comscore: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imdb: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ConfirmationCodeType =
  | 'EMAIL_CHANGE'
  | 'LOGIN_CREATION'
  | 'PASSWORD_RESET';

export type ConsentInput = {
  consent: Scalars['Boolean']['input'];
  cookieId: Scalars['String']['input'];
  datetime: Scalars['DateTime']['input'];
};

export type ContentSection = {
  id: Scalars['ID']['output'];
};

export type ContentSectionList = ContentSection & {
  __typename?: 'ContentSectionList';
  displayType?: Maybe<ContentSectionListDisplayType>;
  headerImage?: Maybe<Scalars['String']['output']>;
  headerImageHeight?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  sections: Array<ContentSection>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ContentSectionListDisplayType =
  | 'MOVIE_LIST_ROW';

export type ContentSectionListName =
  | 'CURATED'
  | 'RECOMMENDED';

export type CreateCampaignReturnType = {
  __typename?: 'CreateCampaignReturnType';
  campaign?: Maybe<Campaign>;
};

export type CreateIntercomLeadReturnType = {
  __typename?: 'CreateIntercomLeadReturnType';
  success: Scalars['Boolean']['output'];
};

export type CreateSoonInCinemaItemReturnType = {
  __typename?: 'CreateSoonInCinemaItemReturnType';
  soonInCinemaItem?: Maybe<SoonInCinemaItem>;
  success: Scalars['Boolean']['output'];
};

export type CreateSubscriptionByVoucherResponse = {
  __typename?: 'CreateSubscriptionByVoucherResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateTargetGroupReturnType = {
  __typename?: 'CreateTargetGroupReturnType';
  targetGroup?: Maybe<TargetGroup>;
};

export type Credit = {
  __typename?: 'Credit';
  department?: Maybe<MovieDepartment>;
  id: Scalars['ID']['output'];
  person?: Maybe<CastOrCrewMember>;
  role?: Maybe<Scalars['String']['output']>;
};

export type CurrentOrdersSection = ContentSection & {
  __typename?: 'CurrentOrdersSection';
  id: Scalars['ID']['output'];
  orders: Array<Order>;
};

export type CurrentTicketsSection = ContentSection & {
  __typename?: 'CurrentTicketsSection';
  id: Scalars['ID']['output'];
  tickets: Array<Ticket>;
};

export type DeleteCampaignsReturnType = {
  __typename?: 'DeleteCampaignsReturnType';
  success: Scalars['Boolean']['output'];
};

export type DeleteImageReturnType = {
  __typename?: 'DeleteImageReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteReviewRatingNewReturnType = {
  __typename?: 'DeleteReviewRatingNewReturnType';
  deletedReviewRating: ReviewRating;
};

export type DeleteSeenInCinemaReturnType = {
  __typename?: 'DeleteSeenInCinemaReturnType';
  deletedSeenInCinema: SeenInCinema;
};

export type DeleteSoonInCinemaItemReturnType = {
  __typename?: 'DeleteSoonInCinemaItemReturnType';
  soonInCinemaItemId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type DeleteTargetGroupReturnType = {
  __typename?: 'DeleteTargetGroupReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type DeleteUserReturnType = {
  __typename?: 'DeleteUserReturnType';
  success: Scalars['Boolean']['output'];
};

export type DistanceFilter = {
  __typename?: 'DistanceFilter';
  active: Scalars['Boolean']['output'];
  distanceInKm?: Maybe<Scalars['Int']['output']>;
  zipCode?: Maybe<Scalars['Int']['output']>;
};

export type DistanceFilterInput = {
  active: Scalars['Boolean']['input'];
  distanceInKm?: InputMaybe<Scalars['Int']['input']>;
  zipCode?: InputMaybe<Scalars['Int']['input']>;
};

export type EditCampaignEmailReturnType = {
  __typename?: 'EditCampaignEmailReturnType';
  campaign?: Maybe<Campaign>;
};

export type EditCampaignReturnType = {
  __typename?: 'EditCampaignReturnType';
  campaign?: Maybe<Campaign>;
};

export type EditTargetGroupReturnType = {
  __typename?: 'EditTargetGroupReturnType';
  targetGroup?: Maybe<TargetGroup>;
};

export type EditUserGroupFilterOnReferencedMovieReturnType = {
  __typename?: 'EditUserGroupFilterOnReferencedMovieReturnType';
  userGroupFilterOnReferencedMovie?: Maybe<UserGroupFilterOnReferencedMovie>;
};

export type EditUserGroupFilterReturnType = {
  __typename?: 'EditUserGroupFilterReturnType';
  userGroupFilter?: Maybe<UserGroupFilter>;
};

export type EmailComponent = {
  __typename?: 'EmailComponent';
  html: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type EmailComponentName =
  | 'Button'
  | 'DashboardEmailFooter'
  | 'DashboardEmailHeader'
  | 'FilmSeries'
  | 'FullProgram'
  | 'Image'
  | 'MarkdownText'
  | 'MarkdownTextWithImage'
  | 'QRCode'
  | 'RecommendationSection'
  | 'Spacer';

export type ErrorStatistics = {
  __typename?: 'ErrorStatistics';
  affectedSessions: Scalars['Int']['output'];
  affectedUsers: Scalars['Int']['output'];
  affectedVersions: Array<Scalars['String']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  errorType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  occurrences: Scalars['Int']['output'];
  occurrencesByDay: Array<IntMap>;
  occurrencesByDevice: Array<IntMap>;
  queryName?: Maybe<Scalars['String']['output']>;
  routeName?: Maybe<Scalars['String']['output']>;
  stackTrace?: Maybe<Scalars['String']['output']>;
};

export type ExampleReferenceMovie = {
  __typename?: 'ExampleReferenceMovie';
  movie?: Maybe<Movie>;
  userGroupSize?: Maybe<Scalars['Int']['output']>;
};

export type ExitPollSection = ContentSection & {
  __typename?: 'ExitPollSection';
  id: Scalars['ID']['output'];
  screening: Screening;
};

export type ExtendSubscriptionResponse = {
  __typename?: 'ExtendSubscriptionResponse';
  extendMonthsPeriod?: Maybe<Scalars['Int']['output']>;
};

export type ExternalNewsletterPreferences = {
  __typename?: 'ExternalNewsletterPreferences';
  category?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  subscribed?: Maybe<Scalars['Boolean']['output']>;
};

export type FeaturedMovieSection = ContentSection & {
  __typename?: 'FeaturedMovieSection';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movie: Movie;
  title?: Maybe<Scalars['String']['output']>;
};

export type ForeignIdType = {
  __typename?: 'ForeignIdType';
  foreignId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ForeignMovieIdentifier = {
  __typename?: 'ForeignMovieIdentifier';
  currentMovie?: Maybe<Movie>;
  forCinema?: Maybe<Cinema>;
  foreignIdType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  onlineTicketingUrl?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type Gender =
  | 'DIVERSE'
  | 'FEMALE'
  | 'MALE';

export type GendersFilter = {
  __typename?: 'GendersFilter';
  active: Scalars['Boolean']['output'];
  genders: Array<Gender>;
};

export type GendersFilterInput = {
  active: Scalars['Boolean']['input'];
  genders: Array<Gender>;
};

export type Genre = {
  __typename?: 'Genre';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GenreAffinityFilter = {
  __typename?: 'GenreAffinityFilter';
  active: Scalars['Boolean']['output'];
  genres: Array<Scalars['String']['output']>;
};

export type GenreAffinityFilterInput = {
  active: Scalars['Boolean']['input'];
  genres: Array<Scalars['String']['input']>;
};

export type GeoCoordinates = {
  __typename?: 'GeoCoordinates';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type GeocodeResult = {
  __typename?: 'GeocodeResult';
  country?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  location?: Maybe<GeoCoordinates>;
  postalCode?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
};

export type GoogleAdBannerSection = ContentSection & {
  __typename?: 'GoogleAdBannerSection';
  adUnitName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type GroupSize =
  | 'LARGEGROUP'
  | 'PAIRS'
  | 'SINGLE';

export type HeadingSection = ContentSection & {
  __typename?: 'HeadingSection';
  align?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  margin?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type HeroPlayer = ContentSection & {
  __typename?: 'HeroPlayer';
  content: Array<HeroPlayerContent>;
  id: Scalars['ID']['output'];
};

export type HeroPlayerContent = {
  __typename?: 'HeroPlayerContent';
  appPath?: Maybe<Scalars['String']['output']>;
  buttonLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  video?: Maybe<Scalars['String']['output']>;
};

export type HostingProvider =
  | 'APIVIDEO'
  | 'CINEPLEX'
  | 'CINEWEB'
  | 'SHARC'
  | 'YOUTUBE';

export type Image = {
  __typename?: 'Image';
  cinemaOperatingCompanyId: Scalars['String']['output'];
  datetime: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  url: Scalars['String']['output'];
};

export type ImageCardSection = ContentSection & {
  __typename?: 'ImageCardSection';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ImageCardWithButtonCarouselSection = ContentSection & {
  __typename?: 'ImageCardWithButtonCarouselSection';
  id: Scalars['ID']['output'];
  images: Array<ImageCardWithButtonSection>;
};

export type ImageCardWithButtonSection = ContentSection & {
  __typename?: 'ImageCardWithButtonSection';
  heightFactor: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  imageUrl: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  optionalButtonLabel?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type InitialRateMoviesSection = ContentSection & {
  __typename?: 'InitialRateMoviesSection';
  id: Scalars['ID']['output'];
};

export type InitializeWebBookingReturnType = {
  __typename?: 'InitializeWebBookingReturnType';
  injectionScript: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type IntMap = {
  __typename?: 'IntMap';
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Int']['output']>;
};

export type InterestRating = {
  __typename?: 'InterestRating';
  id: Scalars['ID']['output'];
  movie: Movie;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  value: Scalars['Float']['output'];
};

export type Invoice = {
  __typename?: 'Invoice';
  date: Scalars['Date']['output'];
  id: Scalars['ID']['output'];
  priceInCents: Scalars['Int']['output'];
  url: Scalars['String']['output'];
};

export type JoinBonusProgramReturnType = {
  __typename?: 'JoinBonusProgramReturnType';
  bonusProgramMembership?: Maybe<BonusProgramMembership>;
  success: Scalars['Boolean']['output'];
};

export type Language = {
  __typename?: 'Language';
  foreignIdType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  programUrl: Scalars['String']['output'];
  trailerAutoplay: Scalars['Boolean']['output'];
  url: Scalars['String']['output'];
};

export type LastChanceItem = {
  __typename?: 'LastChanceItem';
  lastKnownScreening?: Maybe<Screening>;
  movie: Movie;
  screeningsMarkedAsLastChance: Array<Screening>;
};

export type LeaveBonusProgramReturnType = {
  __typename?: 'LeaveBonusProgramReturnType';
  success: Scalars['Boolean']['output'];
};

export type LineItem = {
  __typename?: 'LineItem';
  amount?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  subItems: Array<LineItem>;
};

export type LinkedAccount = {
  __typename?: 'LinkedAccount';
  acceptedDatetime?: Maybe<Scalars['DateTime']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status: LinkedAccountStatus;
  userId: Scalars['ID']['output'];
  username: Scalars['String']['output'];
};

export type LinkedAccountStatus =
  | 'ACCEPTED'
  | 'DECLINED_BY_FRIEND'
  | 'DECLINED_BY_USER'
  | 'INCOMING_INVITE'
  | 'INVITED';

export type ListOfMovies = {
  __typename?: 'ListOfMovies';
  id: Scalars['ID']['output'];
  items: Array<ListOfMoviesItem>;
};

export type ListOfMoviesItem = {
  __typename?: 'ListOfMoviesItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movie?: Maybe<Movie>;
};

export type LocationForZipCodeResult = {
  __typename?: 'LocationForZipCodeResult';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type LogItem = {
  datetime?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type LogItemsReturnType = {
  __typename?: 'LogItemsReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LogOptions = {
  appId?: InputMaybe<Scalars['String']['input']>;
  appVersion?: InputMaybe<Scalars['String']['input']>;
  device?: InputMaybe<Scalars['String']['input']>;
  session?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<LogSource>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type LogSource =
  | 'APP'
  | 'DASHBOARD'
  | 'NOTIFICATION_SERVICE'
  | 'OTHER'
  | 'POS';

export type LogUserScreeningInterestResponse = {
  __typename?: 'LogUserScreeningInterestResponse';
  errorMessage?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
  vc?: Maybe<Scalars['String']['output']>;
};

export type LoginError =
  | 'NEITHER_EMAIL_NOR_ID_PROVIDED'
  | 'WRONG_EMAIL_OR_ID'
  | 'WRONG_PASSWORD';

export type LoginReturnType = {
  __typename?: 'LoginReturnType';
  csrf?: Maybe<Scalars['String']['output']>;
  fileServerToken?: Maybe<Scalars['String']['output']>;
  jwt?: Maybe<Scalars['String']['output']>;
  posApp?: Maybe<PosApp>;
  refreshToken?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<LoginRole>>;
  user?: Maybe<User>;
};

export type LoginRole =
  | 'ADMIN'
  | 'CINEMA_ADMIN'
  | 'CONTENT_EDITOR'
  | 'POS_APP'
  | 'ROOT'
  | 'SUPPORT'
  | 'USER';

export type LoginStatusType = {
  __typename?: 'LoginStatusType';
  errors?: Maybe<Array<LoginError>>;
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LogoutReturnType = {
  __typename?: 'LogoutReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type LongTermBenefitsStatus =
  | 'LONGTERMBENEFITS_RECEIVED_ONLY'
  | 'NO_LONGTERMBENEFITS_RECEIVED_ONLY';

export type LongetermBenefitsReceivedFilter = {
  __typename?: 'LongetermBenefitsReceivedFilter';
  active: Scalars['Boolean']['output'];
  status?: Maybe<LongTermBenefitsStatus>;
};

export type LongetermBenefitsReceivedFilterInput = {
  active: Scalars['Boolean']['input'];
  status?: InputMaybe<LongTermBenefitsStatus>;
};

export type MissedPayoutInfo = {
  __typename?: 'MissedPayoutInfo';
  subscription: Subscription;
  user?: Maybe<User>;
};

export type Movie = {
  __typename?: 'Movie';
  ageRating?: Maybe<Scalars['String']['output']>;
  averageRating?: Maybe<Scalars['Float']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  cinemaSpecificContent: Array<CinemaSpecificContent>;
  country?: Maybe<Scalars['String']['output']>;
  credits: Array<Credit>;
  currentOrNextAvailableInCinemaDate?: Maybe<Scalars['Date']['output']>;
  directedBy?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  /** @deprecated [4.1.14] use currentOrNextAvailableInCinemaDate instead */
  firstScreening?: Maybe<Screening>;
  foreignMovieId?: Maybe<ForeignIdType>;
  genres: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  interestRatingByCurrentUser?: Maybe<InterestRating>;
  isFromMasterFilmDB?: Maybe<Scalars['Boolean']['output']>;
  nonMovieEvent?: Maybe<Scalars['Boolean']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  reviewRatingByCurrentUser?: Maybe<ReviewRating>;
  screeningStatus?: Maybe<ScreeningStatusType>;
  screenings: Array<Screening>;
  seenInCinemaByCurrentUser?: Maybe<SeenInCinema>;
  statistics?: Maybe<MovieStatistics>;
  synopsis?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  trailers: Array<Trailer>;
  youtubeTrailerId?: Maybe<Scalars['String']['output']>;
};


export type MovieCinemaSpecificContentArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
};


export type MovieCreditsArgs = {
  departments?: InputMaybe<Array<MovieDepartment>>;
};


export type MovieCurrentOrNextAvailableInCinemaDateArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
};


export type MovieFirstScreeningArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MovieForeignMovieIdArgs = {
  foreignIdType: Scalars['String']['input'];
};


export type MovieScreeningsArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type MovieStatisticsArgs = {
  userGroupDefinition?: InputMaybe<UserGroupDefinition>;
};

export type MovieAffinityFilter = {
  __typename?: 'MovieAffinityFilter';
  active: Scalars['Boolean']['output'];
  movies: Array<Movie>;
};

export type MovieAffinityFilterInput = {
  active: Scalars['Boolean']['input'];
  movies: Array<Scalars['ID']['input']>;
};

export type MovieAttributesAffinityFilter = {
  __typename?: 'MovieAttributesAffinityFilter';
  active: Scalars['Boolean']['output'];
  movieAttributes: Array<ScreeningAttribute>;
};

export type MovieAttributesAffinityFilterInput = {
  active: Scalars['Boolean']['input'];
  movieAttributes: Array<ScreeningAttributeInput>;
};

export type MovieDepartment =
  | 'ACTING'
  | 'DIRECTING'
  | 'WRITING';

export type MovieEditorialAssignmentResult = {
  __typename?: 'MovieEditorialAssignmentResult';
  comscoreIdentifierConflict?: Maybe<MovieEditorialComscoreIdentifierConflict>;
  movieId: Scalars['ID']['output'];
  success: Scalars['Boolean']['output'];
};

export type MovieEditorialComscoreIdentifierConflict = {
  __typename?: 'MovieEditorialComscoreIdentifierConflict';
  existingIdentifier: MovieEditorialForeignIdentifier;
  movie: MovieEditorialSearchResult;
  newIdentifier: MovieEditorialForeignIdentifier;
};

export type MovieEditorialExternalReference = {
  __typename?: 'MovieEditorialExternalReference';
  ageRating?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  genres: Array<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  releaseDate?: Maybe<Scalars['Date']['output']>;
  synopsis?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MovieEditorialForeignIdentifier = {
  __typename?: 'MovieEditorialForeignIdentifier';
  foreignId: Scalars['String']['output'];
  foreignIdType: Scalars['String']['output'];
  identifierId: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type MovieEditorialImageType =
  | 'BANNER'
  | 'POSTER';

export type MovieEditorialImdbConflict = {
  __typename?: 'MovieEditorialImdbConflict';
  currentMovie: MovieEditorialMergeMovie;
  existingMovie: MovieEditorialMergeMovie;
  imdbId: Scalars['String']['output'];
};

export type MovieEditorialMergeMovie = {
  __typename?: 'MovieEditorialMergeMovie';
  ageRating?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  genres: Array<Scalars['String']['output']>;
  imdbIds: Array<Scalars['String']['output']>;
  incomplete: Scalars['Boolean']['output'];
  lastEdit?: Maybe<Scalars['DateTime']['output']>;
  movieId: Scalars['ID']['output'];
  poster?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  shownIn: Array<Scalars['String']['output']>;
  synopsis?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

export type MovieEditorialMergeResult = {
  __typename?: 'MovieEditorialMergeResult';
  movieId: Scalars['ID']['output'];
};

export type MovieEditorialMovie = {
  __typename?: 'MovieEditorialMovie';
  ageRating?: Maybe<Scalars['String']['output']>;
  banner?: Maybe<Scalars['String']['output']>;
  bannerSource?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  externalReferences: Array<MovieEditorialExternalReference>;
  genres: Array<Scalars['String']['output']>;
  imdbId?: Maybe<Scalars['String']['output']>;
  incomplete: Scalars['Boolean']['output'];
  lastEdit?: Maybe<Scalars['DateTime']['output']>;
  movieId: Scalars['ID']['output'];
  poster?: Maybe<Scalars['String']['output']>;
  posterSource?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  shownIn: Array<Scalars['String']['output']>;
  special: Scalars['Boolean']['output'];
  stages: MovieEditorialStages;
  synopsis?: Maybe<Scalars['String']['output']>;
  synopsisSource?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  youtubeTrailerId?: Maybe<Scalars['String']['output']>;
};

export type MovieEditorialMovieInput = {
  ageRating?: InputMaybe<Scalars['String']['input']>;
  banner?: InputMaybe<Scalars['String']['input']>;
  bannerSource?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['Int']['input']>;
  genres: Array<Scalars['String']['input']>;
  imdbId?: InputMaybe<Scalars['String']['input']>;
  incomplete: Scalars['Boolean']['input'];
  poster?: InputMaybe<Scalars['String']['input']>;
  posterSource?: InputMaybe<Scalars['String']['input']>;
  releaseDate?: InputMaybe<Scalars['Date']['input']>;
  special: Scalars['Boolean']['input'];
  stages: MovieEditorialStagesInput;
  synopsis?: InputMaybe<Scalars['String']['input']>;
  synopsisSource?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  youtubeTrailerId?: InputMaybe<Scalars['String']['input']>;
};

export type MovieEditorialOptions = {
  __typename?: 'MovieEditorialOptions';
  ageRatings: Array<Scalars['String']['output']>;
  genres: Array<Scalars['String']['output']>;
};

export type MovieEditorialSearchResult = {
  __typename?: 'MovieEditorialSearchResult';
  directedBy: Array<Scalars['String']['output']>;
  incomplete: Scalars['Boolean']['output'];
  lastEdit?: Maybe<Scalars['DateTime']['output']>;
  movieId: Scalars['ID']['output'];
  poster?: Maybe<Scalars['String']['output']>;
  releaseDate?: Maybe<Scalars['Date']['output']>;
  title: Scalars['String']['output'];
};

export type MovieEditorialStages = {
  __typename?: 'MovieEditorialStages';
  firstAppVisibility: Scalars['Boolean']['output'];
  initial: Scalars['Boolean']['output'];
  manualReminder?: Maybe<Scalars['Date']['output']>;
  release: Scalars['Boolean']['output'];
  shouldFirstAppVisibility: Scalars['Boolean']['output'];
  shouldRelease: Scalars['Boolean']['output'];
  shouldSoonExpectedInApp: Scalars['Boolean']['output'];
  soonExpectedInApp: Scalars['Boolean']['output'];
};

export type MovieEditorialStagesInput = {
  firstAppVisibility: Scalars['Boolean']['input'];
  initial: Scalars['Boolean']['input'];
  manualReminder?: InputMaybe<Scalars['Date']['input']>;
  release: Scalars['Boolean']['input'];
  soonExpectedInApp: Scalars['Boolean']['input'];
};

export type MovieEditorialStockImage = {
  __typename?: 'MovieEditorialStockImage';
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type MovieEditorialTmdbReference = {
  __typename?: 'MovieEditorialTmdbReference';
  ageRating?: Maybe<Scalars['String']['output']>;
  bannerImages: Array<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  genres: Array<Scalars['String']['output']>;
  posterImages: Array<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  releaseDate?: Maybe<Scalars['Date']['output']>;
  synopsis?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MovieEditorialTodoItem = {
  __typename?: 'MovieEditorialTodoItem';
  cinemaId?: Maybe<Scalars['ID']['output']>;
  cinemaName?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  foreignId?: Maybe<Scalars['String']['output']>;
  foreignIdType?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lastEdit?: Maybe<Scalars['DateTime']['output']>;
  movieId?: Maybe<Scalars['ID']['output']>;
  title: Scalars['String']['output'];
};

export type MovieEditorialTodoOverview = {
  __typename?: 'MovieEditorialTodoOverview';
  brokenTrailers: MovieEditorialTodoQueue;
  contentFollowUp: Array<MovieEditorialTodoQueue>;
  unmatchedForeignIdentifiers: MovieEditorialTodoQueue;
  unmatchedSoonInCinema: MovieEditorialTodoQueue;
};

export type MovieEditorialTodoQueue = {
  __typename?: 'MovieEditorialTodoQueue';
  items: Array<MovieEditorialTodoItem>;
  total: Scalars['Int']['output'];
  type: MovieEditorialTodoQueueType;
};

export type MovieEditorialTodoQueueType =
  | 'BROKEN_TRAILER'
  | 'DEACTIVATED'
  | 'FIRST_APP_VISIBILITY'
  | 'MANUAL_REMINDER'
  | 'NEWLY_CREATED'
  | 'RELEASE'
  | 'SOON_EXPECTED_IN_APP'
  | 'UNMATCHED_FOREIGN_IDENTIFIER'
  | 'UNMATCHED_SOON_IN_CINEMA';

export type MovieList = {
  __typename?: 'MovieList';
  artwork?: Maybe<Scalars['String']['output']>;
  cinemas: Array<Cinema>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  itemDisplayType?: Maybe<MovieListItemDisplayType>;
  items: Array<MovieListItem>;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type MovieListItem = {
  __typename?: 'MovieListItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movie: Movie;
  screenings: Array<Screening>;
};

export type MovieListItemDisplayType =
  | 'POSTER_WALL'
  | 'POSTER_WALL_RATINGS'
  | 'RELEASE_DATE'
  | 'SCREENINGS'
  | 'SYNOPSIS';

export type MovieListSection = ContentSection & {
  __typename?: 'MovieListSection';
  displayType: MovieListSectionDisplayType;
  emptyMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  movieList: MovieList;
  subTitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type MovieListSectionDisplayType =
  | 'ARTWORK_CARD'
  | 'BANNER_COLUMN'
  | 'BANNER_ROW'
  | 'COLLAGE_CARD'
  | 'POSTER_ROW'
  | 'SMALL_BANNER_COLUMN';

export type MovieStatistics = {
  __typename?: 'MovieStatistics';
  id: Scalars['ID']['output'];
  movie: Movie;
  numInteractions: Scalars['Int']['output'];
  numWatchlistings: Scalars['Int']['output'];
};

export type MoviesNotSeenFilter = {
  __typename?: 'MoviesNotSeenFilter';
  active: Scalars['Boolean']['output'];
  movies: Array<Movie>;
};

export type MoviesNotSeenFilterInput = {
  active: Scalars['Boolean']['input'];
  movies: Array<Scalars['ID']['input']>;
};

export type MoviesOnWatchListFilter = {
  __typename?: 'MoviesOnWatchListFilter';
  active: Scalars['Boolean']['output'];
  movies: Array<Movie>;
};

export type MoviesOnWatchListFilterInput = {
  active: Scalars['Boolean']['input'];
  movies: Array<Scalars['ID']['input']>;
};

export type MoviesSeenFilter = {
  __typename?: 'MoviesSeenFilter';
  active: Scalars['Boolean']['output'];
  movies: Array<Movie>;
};

export type MoviesSeenFilterInput = {
  active: Scalars['Boolean']['input'];
  movies: Array<Scalars['ID']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  a?: Maybe<Scalars['String']['output']>;
  acceptAppTerms?: Maybe<AcceptAppTermsReturnType>;
  acceptBonusProgramTerms?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated [5.0.12] use acceptAppTerms instead */
  acceptCinuruTerms?: Maybe<Scalars['Boolean']['output']>;
  acceptLinkAccount: User;
  addInvitedBy: AddInvitedByReturnType;
  /** @deprecated [5.2.3] use requestLoginCreation instead */
  addLogin?: Maybe<LoginReturnType>;
  allowAppTracking?: Maybe<AcceptAppTermsReturnType>;
  allowDataUsage?: Maybe<AcceptAppTermsReturnType>;
  assignEditorialForeignIdentifier: MovieEditorialAssignmentResult;
  assignEditorialSoonInCinemaItem: MovieEditorialAssignmentResult;
  bookCinemaTicketPoints?: Maybe<BookCinemaTicketPointsReturnType>;
  bookCoupon?: Maybe<BookCouponReturnType>;
  buyAndRedeemVoucher?: Maybe<BuyAndRedeemVoucherReturnType>;
  buyVoucher?: Maybe<BuyVoucherReturnType>;
  cancelBookingProcess: CancelBookingProcessResponse;
  cancelOrder: CancelOrderReturnType;
  cancelSubscriptionImmediately: Subscription;
  cancelTicket?: Maybe<CancelTicketReturnType>;
  capturePaypalOrderAndCreateTickets: Array<Ticket>;
  changePassword?: Maybe<LoginReturnType>;
  claimOrDiscardProvisionalBonusPointBooking?: Maybe<ClaimOrDiscardProvisionalBonusPointBookingReturnType>;
  confirmEmail?: Maybe<LoginReturnType>;
  confirmOnlineTicketingBooking: RecordTicketPurchaseReturnType;
  createAdyenSession: AdyenSessionResponse;
  createAndAssignEditorialMovie: MovieEditorialAssignmentResult;
  createAnonymousUser?: Maybe<LoginReturnType>;
  createBeacon: Beacon;
  createBonusProgramVoucherType: BonusProgramVoucherType;
  createCampaign?: Maybe<CreateCampaignReturnType>;
  createCinema: CreateCinemaReturnType;
  createCinemaCluster: CinemaCluster;
  createCinemaOperatingCompany: CinemaOperatingCompany;
  createCompany: Company;
  createContentSectionList: ContentSectionList;
  createGoogleWalletBonusCard?: Maybe<CreateGoogleWalletBonusCardReturnType>;
  createIntercomLead: CreateIntercomLeadReturnType;
  createOnlineTicketingOutlinkId?: Maybe<CreateOnlineTicketingOutlinkIdReturnType>;
  createSoonInCinemaItem?: Maybe<CreateSoonInCinemaItemReturnType>;
  createSubscriptionByVoucher: CreateSubscriptionByVoucherResponse;
  createTargetGroup: CreateTargetGroupReturnType;
  createUserTokenForSubscriptionValidation: UserTokenResponse;
  createVoucherInstances: Array<VoucherInstance>;
  declineLinkAccount: User;
  deleteBeacon: DeleteBeaconReturnType;
  deleteCampaigns: DeleteCampaignsReturnType;
  deleteCinemaClusters: Scalars['Int']['output'];
  deleteCineplexUser: DeleteCineplexUserReturnType;
  deleteCompanies: Scalars['Int']['output'];
  deleteImage?: Maybe<DeleteImageReturnType>;
  deleteLinkedAccount: User;
  deleteReviewRating?: Maybe<Scalars['Boolean']['output']>;
  deleteReviewRating_2?: Maybe<DeleteReviewRatingNewReturnType>;
  deleteSeenInCinema?: Maybe<DeleteSeenInCinemaReturnType>;
  deleteSoonInCinemaItem?: Maybe<DeleteSoonInCinemaItemReturnType>;
  deleteTargetGroups?: Maybe<DeleteTargetGroupReturnType>;
  deleteUser: DeleteUserReturnType;
  deselectCinema?: Maybe<DeselectCinemaReturnType>;
  dismissExitPoll: Scalars['Boolean']['output'];
  editBonusProgramMembership: BonusProgramMembership;
  editCampaign: EditCampaignReturnType;
  editCampaignEmail: EditCampaignEmailReturnType;
  editCompany: Company;
  editTargetGroup: EditTargetGroupReturnType;
  editUserGroupFilter: EditUserGroupFilterReturnType;
  editUserGroupFilterOnReferencedMovie: EditUserGroupFilterOnReferencedMovieReturnType;
  extendSubscription?: Maybe<ExtendSubscriptionResponse>;
  increaseUserTestingStatus?: Maybe<IncreaseUserTestingStatusReturnType>;
  joinBonusProgram?: Maybe<JoinBonusProgramReturnType>;
  leaveBonusProgram: LeaveBonusProgramReturnType;
  logItems?: Maybe<LogItemsReturnType>;
  logUserScreeningInterests: Array<LogUserScreeningInterestResponse>;
  login?: Maybe<LoginReturnType>;
  loginPOS?: Maybe<LoginReturnType>;
  logout?: Maybe<LogoutReturnType>;
  mergeEditorialMoviesForImdbConflict: MovieEditorialMergeResult;
  openTicket?: Maybe<Ticket>;
  optInToMarketingEmails?: Maybe<AcceptAppTermsReturnType>;
  processScannedQrCode?: Maybe<ProcessScannedQrCodeReturnType>;
  reactivateSubscription: ReactivateSubscriptionResponse;
  recordTicketPurchase: RecordTicketPurchaseReturnType;
  redeemVoucher?: Maybe<RedeemVoucherReturnType>;
  refreshLogin?: Maybe<LoginReturnType>;
  registerBeaconScanned?: Maybe<RegisterBeaconScannedReturnType>;
  rejectBonusProgramTerms?: Maybe<Scalars['Boolean']['output']>;
  rememberSkippedOnboardingStep: RememberSkippedOnboardingStepReturnType;
  /** @deprecated [1350/1351] completed subscriptions will be recognized via User.subscriptions */
  reportApprovedSubscription: Array<Subscription>;
  /** @deprecated [>1394] rely on prevalidation */
  reportScreeningError: ReportScreeningErrorResponse;
  requestEmailChange?: Maybe<RequestCodeReturnType>;
  requestLinkAccount: User;
  requestLoginCreation?: Maybe<RequestCodeReturnType>;
  requestPasswordReset?: Maybe<RequestPasswordResetReturnType>;
  reschedulePayment: ReschedulePaymentResponse;
  /** @deprecated [5.0.12] use resendConfirmationEmail instead */
  resendActivationEmail: ResendActivationEmailReturnType;
  resendEmailConfirmation?: Maybe<ResendActivationEmailReturnType>;
  saveImagePath?: Maybe<SaveImagePathReturnType>;
  selectCinema?: Maybe<SelectCinemaReturnType>;
  selectCinemas?: Maybe<SelectCinemasReturnType>;
  selectSeatPricingCategories?: Maybe<BookingProcessReturnType>;
  selectSeatingAreaPricingCategories?: Maybe<BookingProcessReturnType>;
  selectSeats?: Maybe<BookingProcessReturnType>;
  sendNotifications: Scalars['String']['output'];
  /** @deprecated [5.0.12] use requestPasswordReset instead */
  sendResetPasswordEmail: RequestPasswordResetReturnType;
  sendShowtimeAnalyticsCampaign: Scalars['String']['output'];
  sendTestEmail: SendTestEmail;
  sendTestNotification?: Maybe<SendTestNotificationReturnType>;
  setCampaignStatus: SetCampaignStatusReturnType;
  setInitialRatedMovies?: Maybe<SetInitialRatedMoviesReturnType>;
  setUserContentEditorStatus: SetUserContentEditorStatusReturnType;
  socialLogin?: Maybe<LoginReturnType>;
  startBookingProcess?: Maybe<BookingProcessReturnType>;
  startOrderPreparation: StartPreparationReturnType;
  startPendingSubscription: StartPendingSubscriptionResponse;
  startWebBooking?: Maybe<InitializeWebBookingReturnType>;
  storeConsent?: Maybe<StoreConsentReturnType>;
  storeEikonaPreshowData?: Maybe<Scalars['Boolean']['output']>;
  storeSDKLogin?: Maybe<StoreSdkLoginReturnType>;
  storeSeatPlan: StoreSeatPlanReturnType;
  submitAppFeedback?: Maybe<SubmitAppFeedbackReturnType>;
  submitBookingProcess?: Maybe<BookingProcessReturnType>;
  /** @deprecated use createIntercomLead instead */
  submitContactForm?: Maybe<SubmitContactFormReturnType>;
  subscribe: SubscribeResponse;
  subscribeToNewsletter?: Maybe<SubscribeToNewsletterReturnType>;
  suggestCinema?: Maybe<SuggestCinemaReturnType>;
  syncTicket?: Maybe<Ticket>;
  unsubscribe: Array<Subscription>;
  updateBeacon: Beacon;
  updateBonusProgram: UpdateBonusProgramReturnType;
  updateBonusProgramParticipatingCinemas: UpdateBonusProgramReturnType;
  updateBonusProgramVoucherType: BonusProgramVoucherType;
  updateCampaignsStatus: UpdateCampaignsStatusReturnType;
  updateCinema: UpdateCinemaReturnType;
  updateCinemaCluster: CinemaCluster;
  updateCinemaOperatingCompany: CinemaOperatingCompany;
  updateCinemaOperatingCompanyTargetGroupFilterConfig: UpdateCinemaOperatingCompanyTargetGroupFilterConfigReturnType;
  updateContentSectionList: ContentSectionList;
  updateEditorialMovie: MovieEditorialMovie;
  /** @deprecated [5.2.3] use requestEmailChange instead */
  updateEmail?: Maybe<CreateOrUpdateUserReturnType>;
  updateExternalNewsletterPreference: UpdateExternalNewsletterPreferenceReturnType;
  updateForeignMovieMapping: Scalars['Boolean']['output'];
  updateNotificationPreference?: Maybe<UpdateNotificationPreferenceReturnType>;
  /** @deprecated [5.2.3] use requestPasswordReset instead */
  updatePassword?: Maybe<LoginReturnType>;
  updateScreening?: Maybe<UpdateScreeningReturnType>;
  updateSoonInCinemaItem?: Maybe<UpdatedSoonInCinemaItemReturnType>;
  updateTargetGroupsStatus?: Maybe<UpdateTargetGroupsStatusReturnType>;
  updateTicket?: Maybe<Ticket>;
  updateUser: User;
  updateUserAdminStatus: UpdateUserAdminStatusReturnType;
  updateUserProfile?: Maybe<CreateOrUpdateUserReturnType>;
  updateUserSubscription: Subscription;
  updateVoucherInstance?: Maybe<VoucherInstance>;
  upsertApp?: Maybe<UpsertAppReturnType>;
  upsertInterestRating?: Maybe<UpsertInterestRatingReturnType>;
  upsertNewsItem: UpsertNewsItemReturnType;
  upsertQuizReviewRating?: Maybe<UpsertReviewRatingReturnType>;
  upsertReviewRating?: Maybe<UpsertReviewRatingReturnType>;
  upsertSeenInCinema?: Maybe<UpsertSeenInCinemaReturnType>;
  validateVoucherCode: ValidateVoucherCodeResponse;
  /** @deprecated [5.2.3] use confirmEmail instead */
  verifyEmail?: Maybe<LoginReturnType>;
};


export type MutationAArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAcceptBonusProgramTermsArgs = {
  bonusProgramId: Scalars['ID']['input'];
};


export type MutationAcceptLinkAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationAddInvitedByArgs = {
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
  inviteCode: Scalars['String']['input'];
};


export type MutationAddLoginArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};


export type MutationAllowAppTrackingArgs = {
  allowed: Scalars['Boolean']['input'];
};


export type MutationAssignEditorialForeignIdentifierArgs = {
  identifierId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
  replaceExistingComscoreIdentifierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationAssignEditorialSoonInCinemaItemArgs = {
  itemId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
};


export type MutationBookCinemaTicketPointsArgs = {
  amount: Scalars['Int']['input'];
  bonusProgramId?: InputMaybe<Scalars['String']['input']>;
  cinemaId?: InputMaybe<Scalars['String']['input']>;
  groupSize?: InputMaybe<Scalars['Int']['input']>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
  userQrCode: Scalars['String']['input'];
};


export type MutationBookCouponArgs = {
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
  couponIdentifier: Scalars['ID']['input'];
};


export type MutationBuyAndRedeemVoucherArgs = {
  userId: Scalars['ID']['input'];
  voucherClassId: Scalars['ID']['input'];
};


export type MutationBuyVoucherArgs = {
  voucherClassId: Scalars['ID']['input'];
};


export type MutationCancelBookingProcessArgs = {
  bookingProcessId: Scalars['ID']['input'];
  screeningId: Scalars['ID']['input'];
};


export type MutationCancelOrderArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelSubscriptionImmediatelyArgs = {
  cancellationEffectiveAtType: CancellationEffectiveAtType;
  id: Scalars['ID']['input'];
};


export type MutationCancelTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCapturePaypalOrderAndCreateTicketsArgs = {
  bookingProcessId: Scalars['ID']['input'];
};


export type MutationChangePasswordArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};


export type MutationClaimOrDiscardProvisionalBonusPointBookingArgs = {
  claim: Scalars['Boolean']['input'];
  provisionalBonusPointBookingId: Scalars['ID']['input'];
  screeningId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationConfirmEmailArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  code: Scalars['String']['input'];
  email: Scalars['String']['input'];
  isChangeRequest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationConfirmOnlineTicketingBookingArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  cinemaId?: InputMaybe<Scalars['ID']['input']>;
  confirmPageLink?: InputMaybe<Scalars['String']['input']>;
  screeningId: Scalars['ID']['input'];
  userTokens?: InputMaybe<Array<Scalars['String']['input']>>;
  voucherCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationCreateAdyenSessionArgs = {
  isAuthorizationPayment?: InputMaybe<Scalars['Boolean']['input']>;
  isUpselling?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  subscriptionTierId?: InputMaybe<Scalars['ID']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateAndAssignEditorialMovieArgs = {
  identifierId: Scalars['ID']['input'];
};


export type MutationCreateAnonymousUserArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationCreateBeaconArgs = {
  cinemaId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  lastBatteryChange?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationCreateBonusProgramVoucherTypeArgs = {
  cinemaId: Scalars['ID']['input'];
  input: BonusProgramVoucherTypeInput;
};


export type MutationCreateCampaignArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
  isNewCampaign?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  trigger?: InputMaybe<CampaignTrigger>;
  type?: InputMaybe<CampaignType>;
};


export type MutationCreateCinemaClusterArgs = {
  data: CinemaClusterData;
};


export type MutationCreateCinemaOperatingCompanyArgs = {
  data: CinemaOperatingCompanyData;
};


export type MutationCreateCompanyArgs = {
  logo: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationCreateContentSectionListArgs = {
  contentsections: Scalars['Json']['input'];
  displayType?: InputMaybe<ContentSectionListDisplayType>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  headerImageHeight?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateGoogleWalletBonusCardArgs = {
  bonusProgramId: Scalars['ID']['input'];
};


export type MutationCreateIntercomLeadArgs = {
  attributes?: InputMaybe<Scalars['Json']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  newsletterRequested?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  visitorId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateOnlineTicketingOutlinkIdArgs = {
  screeningId: Scalars['ID']['input'];
};


export type MutationCreateSoonInCinemaItemArgs = {
  cinemaId: Scalars['ID']['input'];
  movieId?: InputMaybe<Scalars['ID']['input']>;
  movieTitle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationCreateSubscriptionByVoucherArgs = {
  voucherCode: Scalars['String']['input'];
};


export type MutationCreateTargetGroupArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
};


export type MutationCreateVoucherInstancesArgs = {
  companyId?: InputMaybe<Scalars['ID']['input']>;
  numberOfVouchers: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
  voucherClassId: Scalars['ID']['input'];
};


export type MutationDeclineLinkAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBeaconArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCampaignsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCinemaClustersArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteCineplexUserArgs = {
  apiKey: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationDeleteCompaniesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeleteImageArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteLinkedAccountArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteReviewRatingArgs = {
  movieId: Scalars['ID']['input'];
};


export type MutationDeleteReviewRating_2Args = {
  movieId: Scalars['ID']['input'];
};


export type MutationDeleteSeenInCinemaArgs = {
  movieId: Scalars['ID']['input'];
};


export type MutationDeleteSoonInCinemaItemArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteTargetGroupsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationDeselectCinemaArgs = {
  cinemaId: Scalars['ID']['input'];
};


export type MutationDismissExitPollArgs = {
  movieId: Scalars['ID']['input'];
};


export type MutationEditBonusProgramMembershipArgs = {
  bonusProgramId: Scalars['ID']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};


export type MutationEditCampaignArgs = {
  channels: Array<Channel>;
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  eventType?: InputMaybe<CampaignEventType>;
  id: Scalars['ID']['input'];
  intervalEndType?: InputMaybe<CampaignIntervalEndType>;
  link?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageImage?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  numberOfIntervals?: InputMaybe<Scalars['Int']['input']>;
  sendExactlyMinutesAfterTrigger?: InputMaybe<Scalars['Int']['input']>;
  sendOnDayXAfterTrigger?: InputMaybe<Scalars['Int']['input']>;
  sendingDate?: InputMaybe<Scalars['Date']['input']>;
  sendingTime?: InputMaybe<Scalars['Time']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<CampaignStatus>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  timeUnit?: InputMaybe<CampaignTimeUnit>;
  timeUnitFactor?: InputMaybe<Scalars['Int']['input']>;
  trigger?: InputMaybe<CampaignTrigger>;
  triggerThreshold?: InputMaybe<Scalars['String']['input']>;
};


export type MutationEditCampaignEmailArgs = {
  emailContent: Scalars['Json']['input'];
  id: Scalars['ID']['input'];
};


export type MutationEditCompanyArgs = {
  id: Scalars['ID']['input'];
  logo: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationEditTargetGroupArgs = {
  cluster: Array<TargetGroupClusterInput>;
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationEditUserGroupFilterArgs = {
  userGroupFilter: UserGroupFilterInput;
};


export type MutationEditUserGroupFilterOnReferencedMovieArgs = {
  userGroupFilterOnReferencedMovie: UserGroupFilterOnReferencedMovieInput;
};


export type MutationExtendSubscriptionArgs = {
  voucherCode: Scalars['String']['input'];
};


export type MutationIncreaseUserTestingStatusArgs = {
  testingStatus: TestingStatus;
};


export type MutationJoinBonusProgramArgs = {
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
  teenBonuscardId?: InputMaybe<Scalars['ID']['input']>;
  teenData?: InputMaybe<TeenInputData>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
  voucherCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type MutationLeaveBonusProgramArgs = {
  bonusProgramId: Scalars['ID']['input'];
};


export type MutationLogItemsArgs = {
  items?: InputMaybe<Array<InputMaybe<LogItem>>>;
  options?: InputMaybe<LogOptions>;
};


export type MutationLogUserScreeningInterestsArgs = {
  cinemaId: Scalars['ID']['input'];
  freeTicketSpend?: InputMaybe<Scalars['Int']['input']>;
  linkedUserIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  screeningId: Scalars['ID']['input'];
};


export type MutationLoginArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  logoutFromOtherApps?: InputMaybe<Scalars['Boolean']['input']>;
  nativeBuildCode?: InputMaybe<Scalars['Int']['input']>;
  password: Scalars['String']['input'];
  privileged?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationLoginPosArgs = {
  authToken: Scalars['String']['input'];
};


export type MutationLogoutArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationMergeEditorialMoviesForImdbConflictArgs = {
  imdbId: Scalars['String']['input'];
  movieId: Scalars['ID']['input'];
  movieIdToKeep: Scalars['ID']['input'];
};


export type MutationOpenTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationOptInToMarketingEmailsArgs = {
  rejected?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationProcessScannedQrCodeArgs = {
  bonusProgramId: Scalars['ID']['input'];
  qrCodeText: Scalars['String']['input'];
};


export type MutationReactivateSubscriptionArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationRecordTicketPurchaseArgs = {
  screeningId: Scalars['ID']['input'];
  selectedSeats: Array<SeatSelection>;
};


export type MutationRedeemVoucherArgs = {
  voucherQR: Scalars['String']['input'];
};


export type MutationRefreshLoginArgs = {
  privileged?: InputMaybe<Scalars['Boolean']['input']>;
  refreshToken: Scalars['String']['input'];
};


export type MutationRegisterBeaconScannedArgs = {
  instanceId: Scalars['Int']['input'];
};


export type MutationRememberSkippedOnboardingStepArgs = {
  step: OnboardingStep;
};


export type MutationReportApprovedSubscriptionArgs = {
  paypalApproveLink: Scalars['String']['input'];
};


export type MutationReportScreeningErrorArgs = {
  screeningId: Scalars['ID']['input'];
  userId?: InputMaybe<Scalars['ID']['input']>;
  voucherCode: Scalars['String']['input'];
};


export type MutationRequestEmailChangeArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestLinkAccountArgs = {
  email: Scalars['String']['input'];
};


export type MutationRequestLoginCreationArgs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  inviteCode?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  street?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationRequestPasswordResetArgs = {
  email: Scalars['String']['input'];
};


export type MutationReschedulePaymentArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationResendActivationEmailArgs = {
  email?: InputMaybe<Scalars['String']['input']>;
  updating?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationResendEmailConfirmationArgs = {
  email: Scalars['String']['input'];
  isChangeRequest?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSaveImagePathArgs = {
  filePath: Scalars['String']['input'];
};


export type MutationSelectCinemaArgs = {
  cinemaId: Scalars['ID']['input'];
};


export type MutationSelectCinemasArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
};


export type MutationSelectSeatPricingCategoriesArgs = {
  bookingProcessId: Scalars['ID']['input'];
  screeningId: Scalars['ID']['input'];
  seatPricingCategories: Array<SeatPricingCategoryInput>;
};


export type MutationSelectSeatingAreaPricingCategoriesArgs = {
  bookingProcessId: Scalars['ID']['input'];
  pricingCategoryIds: Array<Scalars['ID']['input']>;
  screeningId: Scalars['ID']['input'];
  seatingAreaId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationSelectSeatsArgs = {
  bookingProcessId: Scalars['ID']['input'];
  screeningId: Scalars['ID']['input'];
  seatIds: Array<Scalars['ID']['input']>;
};


export type MutationSendNotificationsArgs = {
  appLink: Scalars['String']['input'];
  authToken: Scalars['String']['input'];
  body: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  inAppNotification: Scalars['Boolean']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  pushNotificationChannel: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationSendShowtimeAnalyticsCampaignArgs = {
  authKey: Scalars['String']['input'];
  callbackEvents: Array<Scalars['String']['input']>;
  channels: Array<Scalars['String']['input']>;
  customerIds: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
  pushData: ShowtimesCampaignData;
};


export type MutationSendTestEmailArgs = {
  brand: Brand;
  componentData: Scalars['String']['input'];
};


export type MutationSendTestNotificationArgs = {
  body: Scalars['String']['input'];
  cinemaIds: Array<Scalars['ID']['input']>;
  imageUrl: Scalars['String']['input'];
  inAppNotification: Scalars['Boolean']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  link: Scalars['String']['input'];
  pushNotificationChannel: Scalars['String']['input'];
  title: Scalars['String']['input'];
};


export type MutationSetCampaignStatusArgs = {
  id: Scalars['ID']['input'];
  status: CampaignStatus;
};


export type MutationSetUserContentEditorStatusArgs = {
  isContentEditor: Scalars['Boolean']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationSocialLoginArgs = {
  accessToken?: InputMaybe<Scalars['String']['input']>;
  appId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  idToken?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  provider: SocialAuthProvider;
  socialLoginSession?: InputMaybe<Scalars['String']['input']>;
};


export type MutationStartBookingProcessArgs = {
  screeningId: Scalars['ID']['input'];
};


export type MutationStartOrderPreparationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationStartPendingSubscriptionArgs = {
  subscriptionTierId?: InputMaybe<Scalars['ID']['input']>;
};


export type MutationStartWebBookingArgs = {
  freeTicketSpend?: InputMaybe<Scalars['Int']['input']>;
  linkedUsersIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  screeningId: Scalars['ID']['input'];
};


export type MutationStoreConsentArgs = {
  data: ConsentInput;
};


export type MutationStoreEikonaPreshowDataArgs = {
  authorization: Scalars['String']['input'];
  data: Scalars['String']['input'];
};


export type MutationStoreSdkLoginArgs = {
  data: SdkLoginInput;
};


export type MutationStoreSeatPlanArgs = {
  screeningId: Scalars['ID']['input'];
};


export type MutationSubmitAppFeedbackArgs = {
  agreedToRateOrGiveFeedback: Scalars['Boolean']['input'];
  likesApp?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationSubmitBookingProcessArgs = {
  bookingProcessId: Scalars['ID']['input'];
  screeningId: Scalars['ID']['input'];
};


export type MutationSubmitContactFormArgs = {
  fromEmail: Scalars['String']['input'];
  fromName: Scalars['String']['input'];
  fromPhone?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};


export type MutationSubscribeArgs = {
  subscriptionTierId?: InputMaybe<Scalars['ID']['input']>;
  voucherCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSubscribeToNewsletterArgs = {
  brand: Brand;
  channel: Scalars['String']['input'];
  email: Scalars['String']['input'];
};


export type MutationSuggestCinemaArgs = {
  cinemaName: Scalars['String']['input'];
  fromEmail?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSyncTicketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUnsubscribeArgs = {
  subscriptionId: Scalars['ID']['input'];
};


export type MutationUpdateBeaconArgs = {
  comments?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  lastBatteryChange?: InputMaybe<Scalars['DateTime']['input']>;
};


export type MutationUpdateBonusProgramArgs = {
  bonusProgramId: Scalars['ID']['input'];
  legalEntity: Scalars['String']['input'];
  name: Scalars['String']['input'];
  termsLink?: InputMaybe<Scalars['String']['input']>;
  termsVersion: Scalars['Int']['input'];
};


export type MutationUpdateBonusProgramParticipatingCinemasArgs = {
  bonusProgramId: Scalars['ID']['input'];
  cinemaIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateBonusProgramVoucherTypeArgs = {
  input: BonusProgramVoucherTypeInput;
  voucherTypeId: Scalars['ID']['input'];
};


export type MutationUpdateCampaignsStatusArgs = {
  ids: Array<Scalars['ID']['input']>;
  status: CampaignStatus;
};


export type MutationUpdateCinemaArgs = {
  cinema: UpdateCinemaInput;
};


export type MutationUpdateCinemaClusterArgs = {
  data: CinemaClusterData;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCinemaOperatingCompanyArgs = {
  data: CinemaOperatingCompanyData;
  id: Scalars['ID']['input'];
};


export type MutationUpdateCinemaOperatingCompanyTargetGroupFilterConfigArgs = {
  targetGroupFilterConfig: Array<TargetGroupFilterConfigInput>;
};


export type MutationUpdateContentSectionListArgs = {
  contentsections: Scalars['Json']['input'];
  displayType?: InputMaybe<ContentSectionListDisplayType>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  headerImageHeight?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateEditorialMovieArgs = {
  expectedLastEdit?: InputMaybe<Scalars['DateTime']['input']>;
  input: MovieEditorialMovieInput;
  movieId: Scalars['ID']['input'];
};


export type MutationUpdateEmailArgs = {
  email: Scalars['String']['input'];
};


export type MutationUpdateExternalNewsletterPreferenceArgs = {
  externalNewsletterId: Scalars['ID']['input'];
  subscribed: Scalars['Boolean']['input'];
};


export type MutationUpdateForeignMovieMappingArgs = {
  foreignId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
};


export type MutationUpdateNotificationPreferenceArgs = {
  channel: Scalars['String']['input'];
  emailRequested?: InputMaybe<Scalars['Boolean']['input']>;
  pushRequested?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationUpdatePasswordArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  oldPassword?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  token?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateScreeningArgs = {
  id: Scalars['ID']['input'];
  lastChance: Scalars['Boolean']['input'];
};


export type MutationUpdateSoonInCinemaItemArgs = {
  id: Scalars['ID']['input'];
  movieTitle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
};


export type MutationUpdateTargetGroupsStatusArgs = {
  ids: Array<Scalars['ID']['input']>;
  newStatus?: InputMaybe<UpdatedTargetGroupStatus>;
};


export type MutationUpdateTicketArgs = {
  id: Scalars['ID']['input'];
  scanned: Scalars['Boolean']['input'];
};


export type MutationUpdateUserArgs = {
  adminCinemaOperatingCompanyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  blockedText?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  resetAppChangeBlockedUntil?: InputMaybe<Scalars['Boolean']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['ID']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserAdminStatusArgs = {
  cinemaOperatingCompanyId: Scalars['ID']['input'];
  setAdminPrivilege?: InputMaybe<Scalars['Boolean']['input']>;
  userId: Scalars['ID']['input'];
};


export type MutationUpdateUserProfileArgs = {
  birthDate?: InputMaybe<Scalars['Date']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  telephone?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpdateUserSubscriptionArgs = {
  blocked: Scalars['Boolean']['input'];
  blockedText?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVoucherInstanceArgs = {
  id: Scalars['ID']['input'];
  isValid: Scalars['Boolean']['input'];
};


export type MutationUpsertAppArgs = {
  device?: InputMaybe<Scalars['String']['input']>;
  fcmToken?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  os: Scalars['String']['input'];
  version?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertInterestRatingArgs = {
  movieId: Scalars['ID']['input'];
  value: Scalars['Float']['input'];
};


export type MutationUpsertNewsItemArgs = {
  body?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
  poster?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};


export type MutationUpsertQuizReviewRatingArgs = {
  movieId: Scalars['ID']['input'];
  sentEmailId: Scalars['String']['input'];
  value?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationUpsertReviewRatingArgs = {
  movieId: Scalars['ID']['input'];
  value: Scalars['Float']['input'];
};


export type MutationUpsertSeenInCinemaArgs = {
  movieId: Scalars['ID']['input'];
};


export type MutationValidateVoucherCodeArgs = {
  isExtendingSubscription?: InputMaybe<Scalars['Boolean']['input']>;
  voucherCode: Scalars['String']['input'];
};


export type MutationVerifyEmailArgs = {
  appId?: InputMaybe<Scalars['ID']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  updating?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NewSubscriptionStatisticsResponse = {
  __typename?: 'NewSubscriptionStatisticsResponse';
  averageData: Array<AveragePerDateStatistic>;
  numberOfActiveSubscriptions: Scalars['Int']['output'];
  numberOfUsers: Scalars['Int']['output'];
};


export type NewSubscriptionStatisticsResponseAverageDataArgs = {
  dataType: StatisticDataType;
  groupBy: StatisticGroupBy;
};

export type NewsItem = {
  __typename?: 'NewsItem';
  body?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['Date']['output']>;
  hideOnOverview?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  linkText?: Maybe<Scalars['String']['output']>;
  movie?: Maybe<Movie>;
  overviewPoster?: Maybe<Scalars['String']['output']>;
  poster?: Maybe<Scalars['String']['output']>;
  screenings: Array<Screening>;
  teaser?: Maybe<Scalars['String']['output']>;
  time?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NewsListSection = ContentSection & {
  __typename?: 'NewsListSection';
  id: Scalars['ID']['output'];
  newsItems: Array<NewsItem>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NoCinemaVisitSinceFilter = {
  __typename?: 'NoCinemaVisitSinceFilter';
  active: Scalars['Boolean']['output'];
  amount?: Maybe<Scalars['Int']['output']>;
  timePeriod?: Maybe<TimePeriod>;
};

export type NoCinemaVisitSinceFilterInput = {
  active: Scalars['Boolean']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  timePeriod?: InputMaybe<TimePeriod>;
};

export type Notification = {
  __typename?: 'Notification';
  body?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  showUntil?: Maybe<Scalars['DateTime']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type NotificationChannelPriority =
  | 'DEFAULT'
  | 'HIGH'
  | 'LOW'
  | 'MIN';

export type NotificationInbox = ContentSection & {
  __typename?: 'NotificationInbox';
  id: Scalars['ID']['output'];
  notifications: Array<Notification>;
};

export type NotificationPreference = {
  __typename?: 'NotificationPreference';
  askPermissionMessage?: Maybe<Scalars['String']['output']>;
  channel: Scalars['String']['output'];
  channelPriority: NotificationChannelPriority;
  description?: Maybe<Scalars['String']['output']>;
  emailRequested?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  pushRequested?: Maybe<Scalars['Boolean']['output']>;
};

export type OccupiedSeat = {
  __typename?: 'OccupiedSeat';
  id: Scalars['ID']['output'];
  seatId?: Maybe<Scalars['String']['output']>;
  seatStatus: SeatStatus;
  type: SeatType;
};

export type OccupiedSeatingArea = {
  __typename?: 'OccupiedSeatingArea';
  id: Scalars['ID']['output'];
  numFreeSeats: Scalars['Int']['output'];
  numUserSelectableSeats: Scalars['Int']['output'];
  seatingAreaId: Scalars['ID']['output'];
};

export type OnboardingContent = {
  __typename?: 'OnboardingContent';
  bonusType?: Maybe<BonusType>;
  movies: Array<Movie>;
  notifications: Array<Notification>;
};

export type OnboardingStep =
  | 'JOIN_BONUS_PROGRAM'
  | 'REGISTRATION';

export type OnlineTicketingBooking = {
  __typename?: 'OnlineTicketingBooking';
  auditorium?: Maybe<Scalars['String']['output']>;
  bookingId?: Maybe<Scalars['String']['output']>;
  isCancelable?: Maybe<Scalars['Boolean']['output']>;
  ticketStatus?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<OnlineTicketingBookingTicket>>;
  ticketsQRCode?: Maybe<Scalars['String']['output']>;
};

export type OnlineTicketingBookingTicket = {
  __typename?: 'OnlineTicketingBookingTicket';
  cancelUrl?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  isCancelable?: Maybe<Scalars['Boolean']['output']>;
  isSubscriptionTicket?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  rowName?: Maybe<Scalars['String']['output']>;
  seatName?: Maybe<Scalars['String']['output']>;
  ticketNumber?: Maybe<Scalars['String']['output']>;
  ticketStatus?: Maybe<Scalars['String']['output']>;
};

export type OnlineTicketingVoucherStatsByCinema = {
  __typename?: 'OnlineTicketingVoucherStatsByCinema';
  cinemaCity?: Maybe<Scalars['String']['output']>;
  cinemaId: Scalars['ID']['output'];
  cinemaName: Scalars['String']['output'];
  freeVouchers: Scalars['Int']['output'];
  totalVouchers: Scalars['Int']['output'];
  usedVouchers: Scalars['Int']['output'];
};

export type Order = {
  __typename?: 'Order';
  canStartPreparation: Scalars['Boolean']['output'];
  cinema?: Maybe<Cinema>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  googlePayPass?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<LineItem>;
  pickupCode?: Maybe<Scalars['Int']['output']>;
  pkpass?: Maybe<Scalars['String']['output']>;
  qrCode?: Maybe<Scalars['String']['output']>;
  qrCodeImage?: Maybe<Scalars['String']['output']>;
  refundable: Scalars['Boolean']['output'];
  screening?: Maybe<Screening>;
  startPreparationLink?: Maybe<Scalars['String']['output']>;
  status: OrderStatus;
  user: User;
};

export type OrderStatus =
  | 'INITIAL'
  | 'PREPARATION'
  | 'REFUNDED'
  | 'REFUND_FAILED'
  | 'REFUND_WAITING';

export type ParentStatus =
  | 'NON_PARENTS_ONLY'
  | 'PARENTS_ONLY';

export type ParentStatusFilter = {
  __typename?: 'ParentStatusFilter';
  active: Scalars['Boolean']['output'];
  status?: Maybe<ParentStatus>;
};

export type ParentStatusFilterInput = {
  active: Scalars['Boolean']['input'];
  status?: InputMaybe<ParentStatus>;
};

export type PayoutMissedFilter = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type PaypalBillingCycleConfig = {
  __typename?: 'PaypalBillingCycleConfig';
  frequency: PaypalFrequency;
  pricing_scheme: PaypalPricingScheme;
  sequence: Scalars['Int']['output'];
  tenure_type: PaypalTenureType;
  total_cycles: Scalars['Int']['output'];
};

export type PaypalFixedPrice = {
  __typename?: 'PaypalFixedPrice';
  currency_code: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type PaypalFrequency = {
  __typename?: 'PaypalFrequency';
  interval_count: Scalars['Int']['output'];
  interval_unit: Scalars['String']['output'];
};

export type PaypalPricingScheme = {
  __typename?: 'PaypalPricingScheme';
  fixed_price: PaypalFixedPrice;
};

export type PaypalTenureType =
  | 'REGULAR'
  | 'TRIAL';

export type PosApp = {
  __typename?: 'PosApp';
  bonusProgramId?: Maybe<Scalars['ID']['output']>;
  cinemaId?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
};

export type Price = {
  __typename?: 'Price';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type PricingCategory = {
  __typename?: 'PricingCategory';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isSubscription?: Maybe<Scalars['Boolean']['output']>;
  maxNumTickets?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  priceInCents: Scalars['Int']['output'];
  validForUserId?: Maybe<Scalars['String']['output']>;
};

export type ProcessScannedQrCodeReturnType = {
  __typename?: 'ProcessScannedQrCodeReturnType';
  bonusProgram?: Maybe<BonusProgram>;
  numberOfBookedPoints?: Maybe<Scalars['Int']['output']>;
};

export type ProvisionalBonusPointBooking = {
  __typename?: 'ProvisionalBonusPointBooking';
  bonusProgram: BonusProgram;
  cinema: Cinema;
  id: Scalars['ID']['output'];
  potentialScreenings: Array<Screening>;
  scannedAt: Scalars['DateTime']['output'];
};

export type QrCodeScannerSection = ContentSection & {
  __typename?: 'QRCodeScannerSection';
  buttonLabel: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  margin?: Maybe<Scalars['String']['output']>;
  modalDescription?: Maybe<Scalars['String']['output']>;
  modalManualInputHint?: Maybe<Scalars['String']['output']>;
  modalManualInputLabel?: Maybe<Scalars['String']['output']>;
  modalManualInputSeparator?: Maybe<Scalars['String']['output']>;
  modalNoPermissionsDisclaimer?: Maybe<Scalars['String']['output']>;
  modalRequestPersmissionsButtonLabel?: Maybe<Scalars['String']['output']>;
  modalTitle?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  adminUsers: Array<User>;
  allAchievements: Array<Achievement>;
  allCinemaFilmSeries: Array<MovieList>;
  allGenres: Array<Genre>;
  allImages: Array<Image>;
  allMovies: Array<Movie>;
  allPerks: Array<StatusLevelPerk>;
  allScreeningAttributes: Array<ScreeningAttribute>;
  allTargetGroupsByCinemaOperatingCompanies: TargetGroupsByCinemaOperatingCompanysReturnType;
  allVoucherClassesOfCinemaOperatingCompany: Array<VoucherClass>;
  appDeepLink?: Maybe<Scalars['String']['output']>;
  appLanguage?: Maybe<Language>;
  appReleases: Array<AppRelease>;
  audioFingerprintingConfig?: Maybe<AudioFingerprintingConfig>;
  beaconById?: Maybe<Beacon>;
  beacons: Array<Beacon>;
  bonusProgram?: Maybe<BonusProgram>;
  bonusProgramVoucherStockImages: Array<BonusProgramVoucherStockImage>;
  bonusPrograms: Array<BonusProgram>;
  campaign?: Maybe<Campaign>;
  campaignsByCinemas: CampaignsByCinemasReturnType;
  /** @deprecated [6.1.0] use checkVoucherCodes i.e. plural instead */
  checkVoucherCode: CheckVoucherCodeReturnType;
  checkVoucherCodes: CheckVoucherCodesReturnType;
  cinema?: Maybe<Cinema>;
  cinemaCluster: CinemaCluster;
  cinemaClusters: Array<CinemaCluster>;
  cinemas: Array<Cinema>;
  cinfinityCinemaStats: CinfinityCinemaStatsResponse;
  companies: Array<Company>;
  company?: Maybe<Company>;
  contentSectionList?: Maybe<ContentSectionList>;
  contentSectionListByNameAndCinemas: ContentSectionList;
  currentCinema?: Maybe<Cinema>;
  currentPOS?: Maybe<PosApp>;
  currentUser?: Maybe<User>;
  /** @deprecated [5.2.1] Use contentSectionListByNameAndCinemas(name:CURATED, cinemaIds:[...]) instead */
  discoverContent: ContentSectionList;
  emailComponent: EmailComponent;
  errorStatistics: Array<ErrorStatistics>;
  estimateCampaignSize: EstimateCampaignSizeReturnType;
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** @deprecated [5.0.11] use  instead */
  geocode?: Maybe<GeocodeResult>;
  getAllEditableContentSectionLists: Array<ContentSectionList>;
  getAvailableVoucherClasses: Array<VoucherClass>;
  getImdbIds: Array<ComscoreImdbEntry>;
  getOnlineTicketingBooking?: Maybe<OnlineTicketingBooking>;
  getServiceStatus: ServiceStatus;
  getTeenBonusCardPdf?: Maybe<TeenBonusCardPdf>;
  incomingForeignMovieIdentifiers: Array<ForeignMovieIdentifier>;
  invoice: Invoice;
  locationForZipCode?: Maybe<LocationForZipCodeResult>;
  missedPayouts: Array<MissedPayoutInfo>;
  movie?: Maybe<Movie>;
  movieEditorialImdbConflict?: Maybe<MovieEditorialImdbConflict>;
  movieEditorialMovie: MovieEditorialMovie;
  movieEditorialOptions: MovieEditorialOptions;
  movieEditorialStockImages: Array<MovieEditorialStockImage>;
  movieEditorialTmdbReference?: Maybe<MovieEditorialTmdbReference>;
  movieEditorialTodoOverview: MovieEditorialTodoOverview;
  movieList?: Maybe<MovieList>;
  movieStatistics: Array<MovieStatistics>;
  movies: Array<Movie>;
  moviesToRateToInitializeRecommender: Array<Maybe<Movie>>;
  newSubscriptionStatistics: NewSubscriptionStatisticsResponse;
  newsItem?: Maybe<NewsItem>;
  newsListSection?: Maybe<NewsListSection>;
  notification: Notification;
  onboardingContent?: Maybe<OnboardingContent>;
  onlineTicketingVoucherStats: Array<OnlineTicketingVoucherStatsByCinema>;
  order?: Maybe<Order>;
  payoutInfo: Array<CinemaPayoutInfo>;
  /** @deprecated [5.0.11] removed */
  reverseGeocode?: Maybe<ReverseGeocodeResult>;
  screenedMovies: Array<ScreenedMoviesReturnType>;
  screening?: Maybe<Screening>;
  screeningAuditorium: ScreeningAuditorium;
  screenings: Array<Screening>;
  searchCastOrCrewMember: Array<CastOrCrewMember>;
  searchEditorialMovies: Array<MovieEditorialSearchResult>;
  searchMovie: Array<Movie>;
  searchUsers: Array<User>;
  searchUsersTotal: Scalars['Int']['output'];
  similarMovies: Array<Movie>;
  soonInCinemaItems: Array<SoonInCinemaItem>;
  subscriptionTiers?: Maybe<Array<SubscriptionTier>>;
  subscriptionsStatistics?: Maybe<SubscriptionStatisticsResponse>;
  targetGroup: TargetGroup;
  test?: Maybe<Scalars['String']['output']>;
  testing_forceDeleteUser?: Maybe<DeleteUserReturnType>;
  testing_getConfirmationCode?: Maybe<Scalars['String']['output']>;
  ticket?: Maybe<Ticket>;
  usageStatistics?: Maybe<UsageStatistics>;
  userById?: Maybe<User>;
  userByQr?: Maybe<User>;
  validateSubscriptionUsers?: Maybe<ValidateSubscriptionUsersResponse>;
  /** @deprecated [5.0.6] use BonusProgramMembership -> voucher Catalog instead (voucher catalog might be user specific) */
  voucherCatalog?: Maybe<VoucherCatalog>;
  voucherInstanceByQR?: Maybe<VoucherInstance>;
  voucherInstancesByOrderNumber: Array<VoucherInstance>;
};


export type QueryAllCinemaFilmSeriesArgs = {
  before?: InputMaybe<Scalars['DateTime']['input']>;
  cinemaIds: Array<Scalars['ID']['input']>;
};


export type QueryAllMoviesArgs = {
  isFromMasterFilmDB?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryAllTargetGroupsByCinemaOperatingCompaniesArgs = {
  cinemaOperatingCompanyIds: Array<Scalars['ID']['input']>;
};


export type QueryAppDeepLinkArgs = {
  externalUrl: Scalars['String']['input'];
};


export type QueryAppLanguageArgs = {
  language?: InputMaybe<Scalars['String']['input']>;
};


export type QueryAppReleasesArgs = {
  latestOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryBeaconByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBonusProgramArgs = {
  id: Scalars['ID']['input'];
};


export type QueryBonusProgramsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryCampaignArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryCampaignsByCinemasArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
  newCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryCheckVoucherCodeArgs = {
  voucherCode: Scalars['String']['input'];
};


export type QueryCheckVoucherCodesArgs = {
  voucherCodes?: InputMaybe<Array<Scalars['String']['input']>>;
};


export type QueryCinemaArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCinemaClusterArgs = {
  id: Scalars['ID']['input'];
};


export type QueryCinemasArgs = {
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryCinfinityCinemaStatsArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};


export type QueryCompanyArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSectionListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryContentSectionListByNameAndCinemasArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
  name: ContentSectionListName;
};


export type QueryEmailComponentArgs = {
  brand: Brand;
  componentName: EmailComponentName;
  componentProps: Scalars['Json']['input'];
  identifier: Scalars['ID']['input'];
};


export type QueryErrorStatisticsArgs = {
  pastDays?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryEstimateCampaignSizeArgs = {
  campaignId: Scalars['ID']['input'];
};


export type QueryExternalUrlArgs = {
  appDeepLink: Scalars['String']['input'];
};


export type QueryGeocodeArgs = {
  query?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetImdbIdsArgs = {
  key: Scalars['String']['input'];
};


export type QueryGetOnlineTicketingBookingArgs = {
  bookingId?: InputMaybe<Scalars['String']['input']>;
  cinemaId?: InputMaybe<Scalars['ID']['input']>;
  referenceUrl?: InputMaybe<Scalars['String']['input']>;
  securityKey?: InputMaybe<Scalars['String']['input']>;
  ticketId?: InputMaybe<Scalars['String']['input']>;
  ticketProvider?: InputMaybe<Scalars['String']['input']>;
};


export type QueryGetTeenBonusCardPdfArgs = {
  bonusProgramId: Scalars['ID']['input'];
};


export type QueryIncomingForeignMovieIdentifiersArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
  force?: InputMaybe<Scalars['Boolean']['input']>;
};


export type QueryInvoiceArgs = {
  id: Scalars['ID']['input'];
};


export type QueryLocationForZipCodeArgs = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
};


export type QueryMissedPayoutsArgs = {
  filter: PayoutMissedFilter;
};


export type QueryMovieArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMovieEditorialImdbConflictArgs = {
  imdbId: Scalars['String']['input'];
  movieId: Scalars['ID']['input'];
};


export type QueryMovieEditorialMovieArgs = {
  movieId: Scalars['ID']['input'];
};


export type QueryMovieEditorialStockImagesArgs = {
  type: MovieEditorialImageType;
};


export type QueryMovieEditorialTmdbReferenceArgs = {
  movieId: Scalars['ID']['input'];
};


export type QueryMovieEditorialTodoOverviewArgs = {
  limitPerQueue?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryMovieListArgs = {
  id: Scalars['ID']['input'];
};


export type QueryMoviesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type QueryMoviesToRateToInitializeRecommenderArgs = {
  amount: Scalars['Int']['input'];
  sentEmailId: Scalars['String']['input'];
};


export type QueryNewSubscriptionStatisticsArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryNewsItemArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNewsListSectionArgs = {
  id: Scalars['ID']['input'];
};


export type QueryNotificationArgs = {
  id: Scalars['ID']['input'];
};


export type QueryOnboardingContentArgs = {
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryOrderArgs = {
  id: Scalars['ID']['input'];
};


export type QueryPayoutInfoArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryReverseGeocodeArgs = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};


export type QueryScreenedMoviesArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
  from?: InputMaybe<Scalars['DateTime']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


export type QueryScreeningArgs = {
  id: Scalars['ID']['input'];
};


export type QueryScreeningAuditoriumArgs = {
  nCols?: InputMaybe<Scalars['Int']['input']>;
  nRows?: InputMaybe<Scalars['Int']['input']>;
  screeningId: Scalars['ID']['input'];
};


export type QueryScreeningsArgs = {
  after?: InputMaybe<Scalars['DateTime']['input']>;
  before?: InputMaybe<Scalars['DateTime']['input']>;
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  movieIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QuerySearchCastOrCrewMemberArgs = {
  fullName: Scalars['String']['input'];
};


export type QuerySearchEditorialMoviesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


export type QuerySearchMovieArgs = {
  title: Scalars['String']['input'];
};


export type QuerySearchUsersArgs = {
  filterActiveSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  queryText?: InputMaybe<Scalars['String']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySearchUsersTotalArgs = {
  filterActiveSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  queryText?: InputMaybe<Scalars['String']['input']>;
};


export type QuerySimilarMoviesArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  movieId: Scalars['ID']['input'];
};


export type QuerySoonInCinemaItemsArgs = {
  cinemaId: Scalars['ID']['input'];
};


export type QuerySubscriptionTiersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};


export type QuerySubscriptionsStatisticsArgs = {
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
};


export type QueryTargetGroupArgs = {
  id: Scalars['ID']['input'];
};


export type QueryTestArgs = {
  inputVal?: InputMaybe<Scalars['String']['input']>;
};


export type QueryTesting_ForceDeleteUserArgs = {
  email: Scalars['String']['input'];
};


export type QueryTesting_GetConfirmationCodeArgs = {
  email: Scalars['String']['input'];
  type: ConfirmationCodeType;
};


export type QueryTicketArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUsageStatisticsArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type QueryUserByIdArgs = {
  id: Scalars['ID']['input'];
};


export type QueryUserByQrArgs = {
  qrCode: Scalars['String']['input'];
};


export type QueryValidateSubscriptionUsersArgs = {
  screeningId?: InputMaybe<Scalars['ID']['input']>;
  userId?: InputMaybe<Scalars['ID']['input']>;
};


export type QueryVoucherCatalogArgs = {
  cinemaId: Scalars['ID']['input'];
};


export type QueryVoucherInstanceByQrArgs = {
  qrCode: Scalars['String']['input'];
};


export type QueryVoucherInstancesByOrderNumberArgs = {
  orderNumber: Scalars['String']['input'];
};

export type QuizReviewRating = {
  __typename?: 'QuizReviewRating';
  id: Scalars['ID']['output'];
  movie: Movie;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  value: Scalars['Float']['output'];
};

export type ReactivateSubscriptionResponse = {
  __typename?: 'ReactivateSubscriptionResponse';
  subscription: Subscription;
  success: Scalars['Boolean']['output'];
};

export type RecordTicketPurchaseReturnType = {
  __typename?: 'RecordTicketPurchaseReturnType';
  success: Scalars['Boolean']['output'];
};

export type RedeemedVoucher = {
  __typename?: 'RedeemedVoucher';
  amountPoints?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  redeemedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegisterBeaconScannedReturnType = {
  __typename?: 'RegisterBeaconScannedReturnType';
  success: Scalars['Boolean']['output'];
};

export type ReportScreeningErrorResponse = {
  __typename?: 'ReportScreeningErrorResponse';
  nvc?: Maybe<Scalars['String']['output']>;
};

export type RequestCodeReturnType = {
  __typename?: 'RequestCodeReturnType';
  user?: Maybe<User>;
};

export type RequestPasswordResetReturnType = {
  __typename?: 'RequestPasswordResetReturnType';
  success: Scalars['Boolean']['output'];
};

export type ReschedulePaymentResponse = {
  __typename?: 'ReschedulePaymentResponse';
  success: Scalars['Boolean']['output'];
};

export type ReverseGeocodeResult = {
  __typename?: 'ReverseGeocodeResult';
  country?: Maybe<Scalars['String']['output']>;
  locality?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  route?: Maybe<Scalars['String']['output']>;
};

export type ReviewRating = {
  __typename?: 'ReviewRating';
  id: Scalars['ID']['output'];
  movie: Movie;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
  value: Scalars['Float']['output'];
};

export type SdkLoginInput = {
  cookieId: Scalars['String']['input'];
  datetime: Scalars['DateTime']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveImagePathReturnType = {
  __typename?: 'SaveImagePathReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
  uploadedImage: Image;
};

export type Screening = {
  __typename?: 'Screening';
  attributes: Array<ScreeningAttribute>;
  auditoriumName?: Maybe<Scalars['String']['output']>;
  cinema?: Maybe<Cinema>;
  datetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated [5.1.3]: use attributes instead */
  is2d?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated [5.1.3]: use attributes instead */
  is3d?: Maybe<Scalars['Boolean']['output']>;
  isInfoOnly?: Maybe<Scalars['Boolean']['output']>;
  isLastChance?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated [5.1.3]: use attributes instead */
  isOV?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated [5.1.3]: use movieList instead */
  isSpecial?: Maybe<Scalars['Boolean']['output']>;
  movie?: Maybe<Movie>;
  movieList?: Maybe<MovieList>;
  onlineTicketingId?: Maybe<Scalars['ID']['output']>;
  /** @deprecated [5.1.4]: use movieList.description instead */
  specialDescription?: Maybe<Scalars['String']['output']>;
  traileredMovies: Array<Movie>;
};


export type ScreeningMovieListArgs = {
  cinemaIds: Array<Scalars['ID']['input']>;
};

export type ScreeningAttribute = {
  __typename?: 'ScreeningAttribute';
  description?: Maybe<Scalars['String']['output']>;
  /** @deprecated [5.1.4]: use type instead */
  displayType?: Maybe<ScreeningAttributeDisplayType>;
  icon?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  /** @deprecated [5.1.4]: use label instead */
  name: Scalars['String']['output'];
  sectionTitle: Scalars['String']['output'];
  type?: Maybe<ScreeningAttributeType>;
};

export type ScreeningAttributeDisplayType =
  | 'BOTTOM'
  | 'TOP';

export type ScreeningAttributeInput = {
  id: Scalars['ID']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
};

export type ScreeningAttributeType =
  | 'AUDITORIUM'
  | 'MOVIE'
  | 'SCREENING';

export type ScreeningAuditorium = {
  __typename?: 'ScreeningAuditorium';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  seatSelectionType: SeatSelectionType;
  seatingAreas: Array<ScreeningAuditoriumSeatingArea>;
  seats: Array<ScreeningAuditoriumSeat>;
};

export type ScreeningAuditoriumSeat = {
  __typename?: 'ScreeningAuditoriumSeat';
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  rowName: Scalars['String']['output'];
  seatId: Scalars['String']['output'];
  seatName?: Maybe<Scalars['String']['output']>;
  seatingAreaId: Scalars['String']['output'];
  type: SeatType;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type ScreeningAuditoriumSeatingArea = {
  __typename?: 'ScreeningAuditoriumSeatingArea';
  color: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: SeatingAreaName;
  pricingCategories: Array<PricingCategory>;
};

export type ScreeningStatusType =
  | 'CURRENT'
  | 'NONE'
  | 'SOON';

export type Seat = {
  __typename?: 'Seat';
  auditorium: Auditorium;
  categoryId: Scalars['ID']['output'];
  height: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  indexInRow: Scalars['Int']['output'];
  neighborLeftId?: Maybe<Scalars['ID']['output']>;
  neighborRightId?: Maybe<Scalars['ID']['output']>;
  rowName: Scalars['String']['output'];
  seatName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<SeatStatus>;
  type: SeatType;
  width: Scalars['Float']['output'];
  x: Scalars['Float']['output'];
  y: Scalars['Float']['output'];
};

export type SeatCategory = {
  __typename?: 'SeatCategory';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  prices: Array<Price>;
};

export type SeatPricingCategoryInput = {
  pricingCategoryId: Scalars['ID']['input'];
  seatId: Scalars['ID']['input'];
};

export type SeatSelection = {
  seatNumber: Scalars['Int']['input'];
  seatRow: Scalars['Int']['input'];
};

export type SeatSelectionType =
  | 'FIXED_SEATING'
  | 'SEATING_AREA';

export type SeatStatus =
  | 'BLOCKED'
  | 'INACTIVE'
  | 'OCCUPIED';

export type SeatType =
  | 'LOVE_SEAT_LEFT'
  | 'LOVE_SEAT_RIGHT'
  | 'STANDARD_SEAT'
  | 'WHEEL_CHAIR_SEAT';

export type SeatingAreaName =
  | 'LOGE'
  | 'PARKETT';

export type SeenInCinema = {
  __typename?: 'SeenInCinema';
  id: Scalars['ID']['output'];
  movie: Movie;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  user: User;
};

export type SeenMovies = {
  __typename?: 'SeenMovies';
  movie: Movie;
  numVisits: Scalars['Int']['output'];
};

export type SelectedSeat = {
  __typename?: 'SelectedSeat';
  id: Scalars['ID']['output'];
  priceInCents?: Maybe<Scalars['Int']['output']>;
  pricingCategoryId?: Maybe<Scalars['String']['output']>;
  seatId?: Maybe<Scalars['String']['output']>;
  seatingAreaId: Scalars['String']['output'];
  usedSubscription?: Maybe<Scalars['Boolean']['output']>;
  validForUserId?: Maybe<Scalars['String']['output']>;
};

export type SendTestEmail = {
  __typename?: 'SendTestEmail';
  success: Scalars['Boolean']['output'];
};

export type SendTestNotificationReturnType = {
  __typename?: 'SendTestNotificationReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SentMessages = {
  __typename?: 'SentMessages';
  numberOfCountedMessages?: Maybe<Scalars['Int']['output']>;
  numberOfFreeMessages?: Maybe<Scalars['Int']['output']>;
};

export type ServiceStatus = {
  __typename?: 'ServiceStatus';
  text?: Maybe<Scalars['String']['output']>;
  type: ServiceStatusType;
};

export type ServiceStatusType =
  | 'DOWN'
  | 'OPERATIONAL'
  | 'PARTIAL';

export type SetCampaignStatusReturnType = {
  __typename?: 'SetCampaignStatusReturnType';
  campaign?: Maybe<Campaign>;
};

export type SetInitialRatedMoviesReturnType = {
  __typename?: 'SetInitialRatedMoviesReturnType';
  success: Scalars['Boolean']['output'];
};

export type SetUserContentEditorStatusReturnType = {
  __typename?: 'SetUserContentEditorStatusReturnType';
  success: Scalars['Boolean']['output'];
  user: User;
};

export type ShowtimesCampaignData = {
  body: Scalars['String']['input'];
  image?: InputMaybe<Scalars['String']['input']>;
  targetMovieId?: InputMaybe<Scalars['String']['input']>;
  targetType: Scalars['String']['input'];
  title: Scalars['String']['input'];
};

export type SocialAuthProvider =
  | 'APPLE'
  | 'GOOGLE';

export type SoonInCinemaItem = {
  __typename?: 'SoonInCinemaItem';
  id: Scalars['ID']['output'];
  movie?: Maybe<Movie>;
  movieTitle?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['Date']['output']>;
};

export type SponsoredBy = {
  __typename?: 'SponsoredBy';
  logo: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type StartPendingSubscriptionResponse = {
  __typename?: 'StartPendingSubscriptionResponse';
  id: Scalars['String']['output'];
};

export type StartPreparationReturnType = {
  __typename?: 'StartPreparationReturnType';
  order?: Maybe<Order>;
  ticket?: Maybe<Ticket>;
};

export type StatisticDataType =
  | 'MOVIE'
  | 'SUBSCRIPTION'
  | 'TICKET';

export type StatisticGroupBy =
  | 'DAY'
  | 'MONTH'
  | 'WEEK';

export type StatusLevel = {
  __typename?: 'StatusLevel';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  nextLevel?: Maybe<StatusLevel>;
  number: Scalars['Int']['output'];
  perks: Array<StatusLevelPerk>;
  pointsNeeded: Scalars['Int']['output'];
};

export type StatusLevelFilter = {
  __typename?: 'StatusLevelFilter';
  active: Scalars['Boolean']['output'];
  maxStatusLevel?: Maybe<Scalars['Int']['output']>;
  minStatusLevel: Scalars['Int']['output'];
};

export type StatusLevelFilterInput = {
  active: Scalars['Boolean']['input'];
  maxStatusLevel?: InputMaybe<Scalars['Int']['input']>;
  minStatusLevel: Scalars['Int']['input'];
};

export type StatusLevelPerk = {
  __typename?: 'StatusLevelPerk';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  /** @deprecated [5.1.16] use title instead */
  name?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type StatusPointsFilter = {
  __typename?: 'StatusPointsFilter';
  active: Scalars['Boolean']['output'];
  maxStatusPoints?: Maybe<Scalars['Int']['output']>;
  minStatusPoints: Scalars['Int']['output'];
};

export type StatusPointsFilterInput = {
  active: Scalars['Boolean']['input'];
  maxStatusPoints?: InputMaybe<Scalars['Int']['input']>;
  minStatusPoints: Scalars['Int']['input'];
};

export type StickersReceivedFilter = {
  __typename?: 'StickersReceivedFilter';
  active: Scalars['Boolean']['output'];
  stickers: Array<Achievement>;
};

export type StickersReceivedFilterInput = {
  active: Scalars['Boolean']['input'];
  stickers: Array<Scalars['ID']['input']>;
};

export type StoreConsentReturnType = {
  __typename?: 'StoreConsentReturnType';
  success: Scalars['Boolean']['output'];
};

export type StoreSdkLoginReturnType = {
  __typename?: 'StoreSDKLoginReturnType';
  success: Scalars['Boolean']['output'];
};

export type StoreSeatPlanReturnType = {
  __typename?: 'StoreSeatPlanReturnType';
  success: Scalars['Boolean']['output'];
};

export type SubmitAppFeedbackReturnType = {
  __typename?: 'SubmitAppFeedbackReturnType';
  success: Scalars['Boolean']['output'];
  user: User;
};

export type SubmitContactFormReturnType = {
  __typename?: 'SubmitContactFormReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type SubscribeResponse = {
  __typename?: 'SubscribeResponse';
  approveLink?: Maybe<Scalars['String']['output']>;
  /** @deprecated not used anymore, but we need to keep it for backwards compatibility of old apps */
  infoText?: Maybe<Scalars['String']['output']>;
};

export type SubscribeToNewsletterReturnType = {
  __typename?: 'SubscribeToNewsletterReturnType';
  success: Scalars['Boolean']['output'];
};

export type Subscription = {
  __typename?: 'Subscription';
  active?: Maybe<Scalars['Boolean']['output']>;
  adyenNextBillingAt?: Maybe<Scalars['Date']['output']>;
  adyenStatus?: Maybe<Scalars['String']['output']>;
  allowVouchers?: Maybe<Scalars['Boolean']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  blockedReason?: Maybe<BlockedReason>;
  blockedText?: Maybe<Scalars['String']['output']>;
  canceled?: Maybe<Scalars['Boolean']['output']>;
  cancellationEffectiveDate?: Maybe<Scalars['Date']['output']>;
  company?: Maybe<Company>;
  id: Scalars['ID']['output'];
  isReactivatableAfterCancellation?: Maybe<Scalars['Boolean']['output']>;
  noShowWarningText?: Maybe<Scalars['String']['output']>;
  payedUntil?: Maybe<Scalars['Date']['output']>;
  paypalOrderId?: Maybe<Scalars['String']['output']>;
  paypalStatus?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  subscriptionTier: SubscriptionTier;
  upsellBanner?: Maybe<UpsellBanner>;
  validFrom?: Maybe<Scalars['Date']['output']>;
};

export type SubscriptionStatisticsResponse = {
  __typename?: 'SubscriptionStatisticsResponse';
  canceledSubscriptions: Scalars['Int']['output'];
  numberOfActiveSubscriptions: Scalars['Int']['output'];
  numberOfNewSubscriptions: Scalars['Int']['output'];
  numberOfSubscriptionTickets: Scalars['Int']['output'];
  numberOfUsers: Scalars['Int']['output'];
  numberOfUsersPerTier: Array<TierStatistics>;
  seenMovies: Array<SeenMovies>;
  visitFrequency?: Maybe<VisitFrequency>;
};

export type SubscriptionTier = {
  __typename?: 'SubscriptionTier';
  billingCycleConfigs: Array<PaypalBillingCycleConfig>;
  description: Scalars['String']['output'];
  details?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isAutoRenewal: Scalars['Boolean']['output'];
  isExtendableWithVoucher: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  paypalBillingPlanId: Scalars['String']['output'];
  priceLabel?: Maybe<Scalars['String']['output']>;
};

export type SuggestCinemaReturnType = {
  __typename?: 'SuggestCinemaReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type TargetGroup = {
  __typename?: 'TargetGroup';
  cinemaOperatingCompanies: Array<CinemaOperatingCompany>;
  cinemas: Array<Cinema>;
  cluster: Array<TargetGroupCluster>;
  createdDatetime?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['ID']['output'];
  lastEditedDatetime?: Maybe<Scalars['DateTime']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  status?: Maybe<TargetGroupStatus>;
  targetGroupSize?: Maybe<Scalars['Int']['output']>;
};

export type TargetGroupCluster = {
  __typename?: 'TargetGroupCluster';
  ageFilter?: Maybe<AgeFilter>;
  averageCinemaVisitsFilter?: Maybe<AverageCinemaVisitsFilter>;
  averageGroupSizesFilter?: Maybe<AverageGroupSizesFilter>;
  bonusPointsFilter?: Maybe<BonusPointsFilter>;
  bonusProgramMemberStatusFilter?: Maybe<BonusProgramMemberStatusFilter>;
  castOrCrewMemberAffinityFilter?: Maybe<CastOrCrewMemberAffinityFilter>;
  cinemaVisitSinceFilter?: Maybe<CinemaVisitSinceFilter>;
  clusterSize?: Maybe<Scalars['Int']['output']>;
  createdDatetime?: Maybe<Scalars['DateTime']['output']>;
  distanceFilter?: Maybe<DistanceFilter>;
  gendersFilter?: Maybe<GendersFilter>;
  genreAffinityFilter?: Maybe<GenreAffinityFilter>;
  id: Scalars['ID']['output'];
  lastEditedDatetime?: Maybe<Scalars['DateTime']['output']>;
  longTermBenefitsReceivedFilter?: Maybe<LongetermBenefitsReceivedFilter>;
  movieAffinityFilter?: Maybe<MovieAffinityFilter>;
  movieAttributesAffinityFilter?: Maybe<MovieAttributesAffinityFilter>;
  moviesNotSeenFilter?: Maybe<MoviesNotSeenFilter>;
  moviesOnWatchListFilter?: Maybe<MoviesOnWatchListFilter>;
  moviesSeenFilter?: Maybe<MoviesSeenFilter>;
  name?: Maybe<Scalars['String']['output']>;
  noCinemaVisitSinceFilter?: Maybe<NoCinemaVisitSinceFilter>;
  parentStatusFilter?: Maybe<ParentStatusFilter>;
  position: Scalars['Int']['output'];
  statusLevelFilter?: Maybe<StatusLevelFilter>;
  statusPointsFilter?: Maybe<StatusPointsFilter>;
  stickersReceivedFilter?: Maybe<StickersReceivedFilter>;
  targetGroupId: Scalars['ID']['output'];
  vouchersReceivedFilter?: Maybe<VouchersReceivedFilter>;
  vouchersRedeemedFilter?: Maybe<VouchersRedeemedFilter>;
};

export type TargetGroupClusterInput = {
  ageFilter?: InputMaybe<AgeFilterInput>;
  averageCinemaVisitsFilter?: InputMaybe<AverageCinemaVisitsFilterInput>;
  averageGroupSizesFilter?: InputMaybe<AverageGroupSizesFilterInput>;
  bonusPointsFilter?: InputMaybe<BonusPointsFilterInput>;
  bonusProgramMemberStatusFilter?: InputMaybe<BonusProgramMemberStatusFilterInput>;
  castOrCrewMemberAffinityFilter?: InputMaybe<CastOrCrewMemberAffinityFilterInput>;
  cinemaVisitSinceFilter?: InputMaybe<CinemaVisitSinceFilterInput>;
  clusterSize?: InputMaybe<Scalars['Int']['input']>;
  createdDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  distanceFilter?: InputMaybe<DistanceFilterInput>;
  gendersFilter?: InputMaybe<GendersFilterInput>;
  genreAffinityFilter?: InputMaybe<GenreAffinityFilterInput>;
  id: Scalars['ID']['input'];
  lastEditedDatetime?: InputMaybe<Scalars['DateTime']['input']>;
  longTermBenefitsReceivedFilter?: InputMaybe<LongetermBenefitsReceivedFilterInput>;
  movieAffinityFilter?: InputMaybe<MovieAffinityFilterInput>;
  movieAttributesAffinityFilter?: InputMaybe<MovieAttributesAffinityFilterInput>;
  moviesNotSeenFilter?: InputMaybe<MoviesNotSeenFilterInput>;
  moviesOnWatchListFilter?: InputMaybe<MoviesOnWatchListFilterInput>;
  moviesSeenFilter?: InputMaybe<MoviesSeenFilterInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  noCinemaVisitSinceFilter?: InputMaybe<NoCinemaVisitSinceFilterInput>;
  parentStatusFilter?: InputMaybe<ParentStatusFilterInput>;
  position: Scalars['Int']['input'];
  statusLevelFilter?: InputMaybe<StatusLevelFilterInput>;
  statusPointsFilter?: InputMaybe<StatusPointsFilterInput>;
  stickersReceivedFilter?: InputMaybe<StickersReceivedFilterInput>;
  targetGroupId: Scalars['ID']['input'];
  vouchersReceivedFilter?: InputMaybe<VouchersReceivedFilterInput>;
  vouchersRedeemedFilter?: InputMaybe<VouchersRedeemedFilterInput>;
};

export type TargetGroupFilterConfig = {
  __typename?: 'TargetGroupFilterConfig';
  name: Scalars['String']['output'];
  showFilter: Scalars['Boolean']['output'];
};

export type TargetGroupFilterConfigInput = {
  name: Scalars['String']['input'];
  showFilter: Scalars['Boolean']['input'];
};

export type TargetGroupStatus =
  | 'ARCHIVED'
  | 'IN_USE'
  | 'NOT_IN_USE';

export type TargetGroupsByCinemaOperatingCompanysReturnType = {
  __typename?: 'TargetGroupsByCinemaOperatingCompanysReturnType';
  targetGroups: Array<TargetGroup>;
};

export type TeenBonusCardPdf = {
  __typename?: 'TeenBonusCardPdf';
  dataUri: Scalars['String']['output'];
};

export type TeenInputData = {
  birthdate: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  gender: Gender;
  lastName: Scalars['String']['input'];
};

export type TestUserTokenReturnType = {
  __typename?: 'TestUserTokenReturnType';
  emailToken?: Maybe<Scalars['String']['output']>;
  passwordToken?: Maybe<Scalars['String']['output']>;
};

export type TestingStatus =
  | 'CINEMA_EMPLOYEE'
  | 'DEVELOPMENT'
  | 'PRODUCTION'
  | 'STAGING'
  | 'TESTING';

export type Ticket = {
  __typename?: 'Ticket';
  auditoriumName?: Maybe<Scalars['String']['output']>;
  bluetoothRequired?: Maybe<Scalars['Boolean']['output']>;
  boughtAt?: Maybe<Scalars['DateTime']['output']>;
  cancelationLink?: Maybe<Scalars['String']['output']>;
  displayAllowedAfter?: Maybe<Scalars['DateTime']['output']>;
  googlePayPass?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  isFlatrateTicket?: Maybe<Scalars['Boolean']['output']>;
  onlineTicketingId?: Maybe<Scalars['ID']['output']>;
  order?: Maybe<Order>;
  pkpass?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<TicketProvider>;
  qrCode?: Maybe<Scalars['String']['output']>;
  refundable: Scalars['Boolean']['output'];
  refundedAt?: Maybe<Scalars['DateTime']['output']>;
  scanned?: Maybe<Scalars['Boolean']['output']>;
  screening: Screening;
  seats: Array<Seat>;
  sponsoredBy?: Maybe<SponsoredBy>;
  status: TicketStatus;
  user: User;
  vouchers?: Maybe<Array<TicketVoucher>>;
};

export type TicketProvider =
  | 'CINETIXX'
  | 'COMPESO'
  | 'KINOHELD'
  | 'MARS'
  | 'TICKET_INTERNATIONAL';

export type TicketStatus =
  | 'COMPLETE'
  | 'PREPARATION'
  | 'REFUNDED'
  | 'REFUND_FAILED'
  | 'REFUND_WAITING'
  | 'RESERVATION'
  | 'UNKNOWN';

export type TicketVoucher = {
  __typename?: 'TicketVoucher';
  image?: Maybe<Scalars['String']['output']>;
  qrCode: Scalars['String']['output'];
};

export type TierStatistics = {
  __typename?: 'TierStatistics';
  numActiveSubscribers: Scalars['Int']['output'];
  tierName: Scalars['String']['output'];
};

export type TimePeriod =
  | 'DAY'
  | 'MONTH'
  | 'WEEK'
  | 'YEAR';

export type Trailer = {
  __typename?: 'Trailer';
  externalId?: Maybe<Scalars['String']['output']>;
  hostingProvider?: Maybe<HostingProvider>;
  id: Scalars['ID']['output'];
  movie: Movie;
  releaseDate?: Maybe<Scalars['Date']['output']>;
};

export type UpdateBonusProgramReturnType = {
  __typename?: 'UpdateBonusProgramReturnType';
  bonusProgram?: Maybe<BonusProgram>;
  success: Scalars['Boolean']['output'];
};

export type UpdateCampaignsStatusReturnType = {
  __typename?: 'UpdateCampaignsStatusReturnType';
  campaigns: Array<Campaign>;
};

export type UpdateCinemaInput = {
  accessRestrictedTo: AccessRestriction;
  additionalInfoSections?: InputMaybe<Array<CinemaInformationParagraphInput>>;
  appleMapsLink?: InputMaybe<Scalars['String']['input']>;
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  barrierFreeText?: InputMaybe<Scalars['String']['input']>;
  blind?: InputMaybe<Scalars['Boolean']['input']>;
  blindText?: InputMaybe<Scalars['String']['input']>;
  brands: Array<Brand>;
  city?: InputMaybe<Scalars['String']['input']>;
  claim?: InputMaybe<Scalars['String']['input']>;
  currentInformation?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  giftVouchersDisplay: Array<CinemaInformationParagraphInput>;
  googleMapsLink?: InputMaybe<Scalars['String']['input']>;
  hasBonusProgram?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  hearingImpaired?: InputMaybe<Scalars['Boolean']['input']>;
  hearingImpairedText?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  imprint?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  location?: InputMaybe<CinemaLocationInput>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  onlineTicketingBaseUrl?: InputMaybe<Scalars['String']['input']>;
  openingHoursDisplay: Array<CinemaOpeningHoursInput>;
  parkingDescription?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  pricesDisplay: Array<CinemaInformationParagraphInput>;
  sneaksDisplay: Array<CinemaInformationParagraphInput>;
  specialAboutUs?: InputMaybe<Scalars['String']['input']>;
  specialOffersDisplay: Array<CinemaInformationParagraphInput>;
  street?: InputMaybe<Scalars['String']['input']>;
  technologies?: InputMaybe<Scalars['String']['input']>;
  ticketProvider?: InputMaybe<Scalars['String']['input']>;
  tiktok?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateScreeningReturnType = {
  __typename?: 'UpdateScreeningReturnType';
  screening?: Maybe<Screening>;
  success: Scalars['Boolean']['output'];
};

export type UpdateTargetGroupsStatusReturnType = {
  __typename?: 'UpdateTargetGroupsStatusReturnType';
  targetGroups: Array<TargetGroup>;
};

export type UpdatedSoonInCinemaItemReturnType = {
  __typename?: 'UpdatedSoonInCinemaItemReturnType';
  soonInCinemaItem?: Maybe<SoonInCinemaItem>;
  success: Scalars['Boolean']['output'];
};

export type UpdatedTargetGroupStatus =
  | 'ARCHIVED'
  | 'NOT_IN_USE';

export type UpsellBanner = {
  __typename?: 'UpsellBanner';
  imageUrl: Scalars['String']['output'];
  subscriptionToUpsellId: Scalars['ID']['output'];
};

export type UpsertSeenInCinemaReturnType = {
  __typename?: 'UpsertSeenInCinemaReturnType';
  seenInCinema?: Maybe<SeenInCinema>;
};

export type UsageStatistics = {
  __typename?: 'UsageStatistics';
  activeUsersInInterval?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  installationsInInterval?: Maybe<Scalars['Int']['output']>;
  sentMessagesInInterval?: Maybe<SentMessages>;
  watchlistUsedInInterval?: Maybe<Scalars['Int']['output']>;
};


export type UsageStatisticsActiveUsersInIntervalArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type UsageStatisticsInstallationsInIntervalArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type UsageStatisticsSentMessagesInIntervalArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};


export type UsageStatisticsWatchlistUsedInIntervalArgs = {
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
};

export type User = {
  __typename?: 'User';
  /** @deprecated [3.3.1] use blocked instead */
  active?: Maybe<Scalars['Boolean']['output']>;
  anonymous: Scalars['Boolean']['output'];
  appTrackingAllowed?: Maybe<Scalars['Boolean']['output']>;
  askForAppFeedback: Scalars['Boolean']['output'];
  askToJoinBonusProgram: Scalars['Boolean']['output'];
  askToRegister: Scalars['Boolean']['output'];
  birthDate?: Maybe<Scalars['Date']['output']>;
  blocked: Scalars['Boolean']['output'];
  blockedReason?: Maybe<UserBlockedReason>;
  blockedText?: Maybe<Scalars['String']['output']>;
  bonusProgramMembership?: Maybe<BonusProgramMembership>;
  bonusProgramMemberships: Array<BonusProgramMembership>;
  cinemaCustomerships: Array<CinemaCustomership>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  dataUsageAllowed?: Maybe<Scalars['Boolean']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalNewsletterPreferences?: Maybe<Array<ExternalNewsletterPreferences>>;
  firstName?: Maybe<Scalars['String']['output']>;
  freeTicketCount: Scalars['Int']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Gender>;
  houseNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /** @deprecated [5.2.3] use watchlist instead */
  interestRatings: Array<InterestRating>;
  inviteCode?: Maybe<Scalars['String']['output']>;
  invoices: Array<Invoice>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastSync?: Maybe<Scalars['DateTime']['output']>;
  linkedAccounts: Array<LinkedAccount>;
  marketingEmailsAllowed?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notificationPreferences: Array<NotificationPreference>;
  notifications?: Maybe<Array<Notification>>;
  onlineTicketingToken?: Maybe<Scalars['String']['output']>;
  orders: Array<Order>;
  privileges: UserPrivileges;
  ratedlist: MovieList;
  /** @deprecated [5.2.3] use ratedlist instead */
  reviewRatings: Array<ReviewRating>;
  seenInCinemaList: MovieList;
  /** @deprecated [4.0.15] use cinemaCustomerships instead */
  selectedCinemas?: Maybe<Array<Cinema>>;
  street?: Maybe<Scalars['String']['output']>;
  subscriptions: Array<Subscription>;
  telephone?: Maybe<Scalars['String']['output']>;
  termsStatus?: Maybe<AppTermsStatus>;
  testingStatus?: Maybe<TestingStatus>;
  tickets: Array<Ticket>;
  vouchers: Array<VoucherInstance>;
  watchlist: MovieList;
  watchlistInCinema: MovieList;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type UserBonusProgramMembershipArgs = {
  bonusProgramId?: InputMaybe<Scalars['ID']['input']>;
  cinemaId?: InputMaybe<Scalars['ID']['input']>;
};


export type UserCinemaCustomershipsArgs = {
  currentlySelectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserExternalNewsletterPreferencesArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};


export type UserInterestRatingsArgs = {
  removeReviewRatedMovies?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserOrdersArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  openOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sync?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserTicketsArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  openOnly?: InputMaybe<Scalars['Boolean']['input']>;
  sync?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserVouchersArgs = {
  onlyRedeemed?: InputMaybe<Scalars['Boolean']['input']>;
};


export type UserWatchlistArgs = {
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  lastChance?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserBlockedReason =
  | 'ANONYMOUS_USER_LOGGED_OUT'
  | 'MISSING_EMAIL_VERIFICATION'
  | 'OTHER'
  | 'OTHER_ACCOUNT_EXISTED'
  | 'WRONG_EMAIL';

export type UserGroupDefinition = {
  clientOfCinemasAny?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type UserGroupFilter = {
  __typename?: 'UserGroupFilter';
  bonusPointsGeq?: Maybe<Scalars['Int']['output']>;
  bonusPointsLeq?: Maybe<Scalars['Int']['output']>;
  excludeIfMovieSeen?: Maybe<Array<Movie>>;
  id: Scalars['ID']['output'];
  moviesNotSeen?: Maybe<Array<Movie>>;
  moviesOnWatchlist?: Maybe<Array<Movie>>;
  moviesRatedNegatively?: Maybe<Array<Movie>>;
  moviesRatedPositively?: Maybe<Array<Movie>>;
  moviesSeen?: Maybe<Array<Movie>>;
  name?: Maybe<Scalars['String']['output']>;
  visitFrequency?: Maybe<VisitFrequency>;
};

export type UserGroupFilterInput = {
  bonusPointsGeq?: InputMaybe<Scalars['Int']['input']>;
  bonusPointsLeq?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['ID']['input'];
  moviesNotSeenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moviesOnWatchlistIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moviesRatedNegativelyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moviesRatedPositivelyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  moviesSeenIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  name?: InputMaybe<Scalars['String']['input']>;
  visitFrequencyIntervalLengthDays?: InputMaybe<Scalars['Int']['input']>;
  visitFrequencyVisits?: InputMaybe<Scalars['Int']['input']>;
};

export type UserGroupFilterOnReferencedMovie = {
  __typename?: 'UserGroupFilterOnReferencedMovie';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  onWatchlist?: Maybe<Scalars['Boolean']['output']>;
  ratedNegatively?: Maybe<Scalars['Boolean']['output']>;
  ratedPositively?: Maybe<Scalars['Boolean']['output']>;
  seen?: Maybe<Scalars['Boolean']['output']>;
};

export type UserGroupFilterOnReferencedMovieInput = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  onWatchlist?: InputMaybe<Scalars['Boolean']['input']>;
  ratedNegatively?: InputMaybe<Scalars['Boolean']['input']>;
  ratedPositively?: InputMaybe<Scalars['Boolean']['input']>;
  seen?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserPrivileges = {
  __typename?: 'UserPrivileges';
  accessRightBonusProgram: Scalars['Boolean']['output'];
  accessRightCampaigns: Scalars['Boolean']['output'];
  accessRightDashboard: Scalars['Boolean']['output'];
  accessRightFilmStatistics: Scalars['Boolean']['output'];
  adminForBonusPrograms: Array<BonusProgram>;
  adminForCinemas: Array<Cinema>;
  adminRole: Scalars['Boolean']['output'];
  belongsToCinemaOperatingCompanies: Array<CinemaOperatingCompany>;
  canEditBonusPrograms: Scalars['Boolean']['output'];
  canEditContent: Scalars['Boolean']['output'];
  contentEditorRole: Scalars['Boolean']['output'];
  rootRole: Scalars['Boolean']['output'];
  supportRole: Scalars['Boolean']['output'];
};

export type UserTokenResponse = {
  __typename?: 'UserTokenResponse';
  userToken: Scalars['String']['output'];
};

export type ValidateSubscriptionUsersResponse = {
  __typename?: 'ValidateSubscriptionUsersResponse';
  maxLinkedAccounts: Scalars['Int']['output'];
  validatedUsers: Array<ValidatedUser>;
};

export type ValidateVoucherCodeResponse = {
  __typename?: 'ValidateVoucherCodeResponse';
  allowedToCreateSubscription: Scalars['Boolean']['output'];
  allowedToExtendSubscription: Scalars['Boolean']['output'];
  company?: Maybe<Company>;
  description?: Maybe<Scalars['String']['output']>;
  requiresPayment: Scalars['Boolean']['output'];
  title?: Maybe<Scalars['String']['output']>;
};

export type ValidatedUser = {
  __typename?: 'ValidatedUser';
  allowed?: Maybe<Scalars['Boolean']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  userId: Scalars['ID']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type VisitFrequency = {
  __typename?: 'VisitFrequency';
  elevenToTwenty: Scalars['Int']['output'];
  five: Scalars['Int']['output'];
  four: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  intervalLengthDays: Scalars['Int']['output'];
  one: Scalars['Int']['output'];
  sixToTen: Scalars['Int']['output'];
  three: Scalars['Int']['output'];
  twentyPlus: Scalars['Int']['output'];
  two: Scalars['Int']['output'];
  visits: Scalars['Int']['output'];
  zero: Scalars['Int']['output'];
};

export type VoucherCatalog = {
  __typename?: 'VoucherCatalog';
  voucherClasses: Array<VoucherClass>;
};

export type VoucherClass = {
  __typename?: 'VoucherClass';
  autoRedeem?: Maybe<Scalars['Boolean']['output']>;
  bonusProgram: BonusProgram;
  bookableUntil?: Maybe<Scalars['DateTime']['output']>;
  cinema?: Maybe<Cinema>;
  description?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['Int']['output']>;
  iconName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  image?: Maybe<Scalars['String']['output']>;
  initialCapacity?: Maybe<Scalars['Int']['output']>;
  maxQuantityPerPerson?: Maybe<Scalars['Int']['output']>;
  minStatusPoints?: Maybe<Scalars['Int']['output']>;
  priceCoins?: Maybe<Scalars['Int']['output']>;
  priceEuros?: Maybe<Scalars['Float']['output']>;
  priceStatusPoints?: Maybe<Scalars['Int']['output']>;
  redeemableUntil?: Maybe<Scalars['DateTime']['output']>;
  remainingCapacity?: Maybe<Scalars['Int']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type VoucherInstance = {
  __typename?: 'VoucherInstance';
  company?: Maybe<Company>;
  companyId?: Maybe<Scalars['ID']['output']>;
  createdDatetime?: Maybe<Scalars['DateTime']['output']>;
  descriptionOverwrite?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  qrCode?: Maybe<Scalars['String']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  redeemable?: Maybe<Scalars['Boolean']['output']>;
  redeemedDatetime?: Maybe<Scalars['DateTime']['output']>;
  user?: Maybe<User>;
  valid?: Maybe<Scalars['Boolean']['output']>;
  voucherClass?: Maybe<VoucherClass>;
};

export type VouchersReceivedFilter = {
  __typename?: 'VouchersReceivedFilter';
  active: Scalars['Boolean']['output'];
  vouchers: Array<VoucherClass>;
};

export type VouchersReceivedFilterInput = {
  active: Scalars['Boolean']['input'];
  vouchers: Array<Scalars['ID']['input']>;
};

export type VouchersRedeemedFilter = {
  __typename?: 'VouchersRedeemedFilter';
  active: Scalars['Boolean']['output'];
  vouchers: Array<VoucherClass>;
};

export type VouchersRedeemedFilterInput = {
  active: Scalars['Boolean']['input'];
  vouchers: Array<Scalars['ID']['input']>;
};

export type WebViewSection = ContentSection & {
  __typename?: 'WebViewSection';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  collapsed?: Maybe<Scalars['Boolean']['output']>;
  height: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  infoText?: Maybe<Scalars['String']['output']>;
  infoTextAfter?: Maybe<Scalars['String']['output']>;
  injectionScript?: Maybe<Scalars['String']['output']>;
  margin?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
  width: Scalars['String']['output'];
};

export type AcceptAppTermsReturnType = {
  __typename?: 'acceptAppTermsReturnType';
  user?: Maybe<User>;
};

export type BookCinemaTicketPointsReturnType = {
  __typename?: 'bookCinemaTicketPointsReturnType';
  status?: Maybe<Scalars['String']['output']>;
};

export type BookCouponReturnType = {
  __typename?: 'bookCouponReturnType';
  bonusProgram?: Maybe<BonusProgram>;
  couponMessage?: Maybe<Scalars['String']['output']>;
  couponType?: Maybe<Scalars['String']['output']>;
  user?: Maybe<User>;
};

export type BuyAndRedeemVoucherReturnType = {
  __typename?: 'buyAndRedeemVoucherReturnType';
  success: Scalars['Boolean']['output'];
};

export type BuyVoucherReturnType = {
  __typename?: 'buyVoucherReturnType';
  voucherInstance?: Maybe<VoucherInstance>;
};

export type ClaimOrDiscardProvisionalBonusPointBookingReturnType = {
  __typename?: 'claimOrDiscardProvisionalBonusPointBookingReturnType';
  bonusProgramMembership: BonusProgramMembership;
  showExitPoll?: Maybe<Scalars['Boolean']['output']>;
};

export type CreateCinemaReturnType = {
  __typename?: 'createCinemaReturnType';
  cinema?: Maybe<Cinema>;
  success: Scalars['Boolean']['output'];
};

export type CreateGoogleWalletBonusCardReturnType = {
  __typename?: 'createGoogleWalletBonusCardReturnType';
  jwtUrl?: Maybe<Scalars['String']['output']>;
};

export type CreateOnlineTicketingOutlinkIdReturnType = {
  __typename?: 'createOnlineTicketingOutlinkIdReturnType';
  identifier: Scalars['String']['output'];
};

export type CreateOrUpdateUserReturnType = {
  __typename?: 'createOrUpdateUserReturnType';
  user?: Maybe<User>;
};

export type DeleteBeaconReturnType = {
  __typename?: 'deleteBeaconReturnType';
  success: Scalars['Boolean']['output'];
};

export type DeleteCineplexUserReturnType = {
  __typename?: 'deleteCineplexUserReturnType';
  success: Scalars['Boolean']['output'];
};

export type DeselectCinemaReturnType = {
  __typename?: 'deselectCinemaReturnType';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type EstimateCampaignSizeReturnType = {
  __typename?: 'estimateCampaignSizeReturnType';
  exampleReferenceMovie?: Maybe<ExampleReferenceMovie>;
  userGroupSize?: Maybe<Scalars['Int']['output']>;
};

export type IncreaseUserTestingStatusReturnType = {
  __typename?: 'increaseUserTestingStatusReturnType';
  user?: Maybe<User>;
};

export type RedeemVoucherReturnType = {
  __typename?: 'redeemVoucherReturnType';
  success: Scalars['Boolean']['output'];
};

export type RememberSkippedOnboardingStepReturnType = {
  __typename?: 'rememberSkippedOnboardingStepReturnType';
  user?: Maybe<User>;
};

export type ResendActivationEmailReturnType = {
  __typename?: 'resendActivationEmailReturnType';
  sentToEmail?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
};

export type ScreenedMoviesReturnType = {
  __typename?: 'screenedMoviesReturnType';
  firstScreening: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  movie: Movie;
};

export type SelectCinemaReturnType = {
  __typename?: 'selectCinemaReturnType';
  cinemaCustomership: CinemaCustomership;
};

export type SelectCinemasReturnType = {
  __typename?: 'selectCinemasReturnType';
  cinemas: Array<Cinema>;
  user: User;
};

export type UpdateCinemaOperatingCompanyTargetGroupFilterConfigReturnType = {
  __typename?: 'updateCinemaOperatingCompanyTargetGroupFilterConfigReturnType';
  success: Scalars['Boolean']['output'];
};

export type UpdateCinemaReturnType = {
  __typename?: 'updateCinemaReturnType';
  cinema?: Maybe<Cinema>;
  success: Scalars['Boolean']['output'];
};

export type UpdateExternalNewsletterPreferenceReturnType = {
  __typename?: 'updateExternalNewsletterPreferenceReturnType';
  externalNewsletterPreference?: Maybe<ExternalNewsletterPreferences>;
};

export type UpdateNotificationPreferenceReturnType = {
  __typename?: 'updateNotificationPreferenceReturnType';
  notificationPreference?: Maybe<NotificationPreference>;
};

export type UpdateUserAdminStatusReturnType = {
  __typename?: 'updateUserAdminStatusReturnType';
  success: Scalars['Boolean']['output'];
  user?: Maybe<User>;
};

export type UpsertAppReturnType = {
  __typename?: 'upsertAppReturnType';
  app?: Maybe<App>;
};

export type UpsertInterestRatingReturnType = {
  __typename?: 'upsertInterestRatingReturnType';
  interestRating?: Maybe<InterestRating>;
};

export type UpsertNewsItemReturnType = {
  __typename?: 'upsertNewsItemReturnType';
  newsItem?: Maybe<NewsItem>;
  user?: Maybe<User>;
};

export type UpsertReviewRatingReturnType = {
  __typename?: 'upsertReviewRatingReturnType';
  reviewRating?: Maybe<ReviewRating>;
};

export type BonusProgramSelectFieldOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BonusProgramSelectFieldOptionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminForBonusPrograms: Array<{ __typename?: 'BonusProgram', id: string, name?: string | undefined }> } } | undefined };

export type CurrentUserCinemasQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCinemasQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> } } | undefined };

export type SearchUsersOldQueryVariables = Exact<{
  queryText: Scalars['String']['input'];
}>;


export type SearchUsersOldQuery = { __typename?: 'Query', users: Array<{ __typename?: 'User', id: string, name?: string | undefined, email?: string | undefined }> };

export type ContentSectionListEditorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ContentSectionListEditorQuery = { __typename?: 'Query', contentSectionList?: { __typename?: 'ContentSectionList', id: string, title?: string | undefined, headerImage?: string | undefined, headerImageHeight?: string | undefined, listDisplayType?: ContentSectionListDisplayType | undefined, sections: Array<{ __typename: 'AppFeedbackSection', id: string } | { __typename: 'ButtonSection', buttonLabel: string, onPressType: ButtonSectionOnPressType, routeName?: string | undefined, routeArgs?: any | undefined, margin?: string | undefined, hideChevron?: boolean | undefined, id: string } | { __typename: 'CardSection', title?: string | undefined, text?: string | undefined, collapsible?: boolean | undefined, collapsed?: boolean | undefined, margin?: string | undefined, cardSectionImageUrl?: string | undefined, id: string } | { __typename: 'CentralPlannerReservation', id: string } | { __typename: 'ContentSectionList', title?: string | undefined, headerImage?: string | undefined, headerImageHeight?: string | undefined, id: string, listDisplayType?: ContentSectionListDisplayType | undefined, sections: Array<{ __typename: 'AppFeedbackSection', id: string } | { __typename: 'ButtonSection', buttonLabel: string, onPressType: ButtonSectionOnPressType, routeName?: string | undefined, routeArgs?: any | undefined, margin?: string | undefined, hideChevron?: boolean | undefined, id: string } | { __typename: 'CardSection', title?: string | undefined, text?: string | undefined, collapsible?: boolean | undefined, collapsed?: boolean | undefined, margin?: string | undefined, cardSectionImageUrl?: string | undefined, id: string } | { __typename: 'CentralPlannerReservation', id: string } | { __typename: 'ContentSectionList', title?: string | undefined, headerImage?: string | undefined, headerImageHeight?: string | undefined, id: string, listDisplayType?: ContentSectionListDisplayType | undefined } | { __typename: 'CurrentOrdersSection', id: string, orders: Array<{ __typename?: 'Order', id: string }> } | { __typename: 'CurrentTicketsSection', id: string, tickets: Array<{ __typename?: 'Ticket', id: string }> } | { __typename: 'ExitPollSection', id: string, screening: { __typename?: 'Screening', id: string } } | { __typename: 'FeaturedMovieSection', description?: string | undefined, title?: string | undefined, id: string, movie: { __typename?: 'Movie', id: string } } | { __typename: 'GoogleAdBannerSection', adUnitName?: string | undefined, id: string } | { __typename: 'HeadingSection', text?: string | undefined, size?: string | undefined, align?: string | undefined, margin?: string | undefined, id: string } | { __typename: 'HeroPlayer', id: string, content: Array<{ __typename?: 'HeroPlayerContent', id: string, title?: string | undefined, url?: string | undefined }> } | { __typename: 'ImageCardSection', title?: string | undefined, description?: string | undefined, link?: string | undefined, imageUrl: string, id: string } | { __typename: 'ImageCardWithButtonCarouselSection', id: string, images: Array<{ __typename?: 'ImageCardWithButtonSection', id: string, imageUrl: string, title?: string | undefined, link?: string | undefined, optionalButtonLabel?: string | undefined, heightFactor: number }> } | { __typename: 'ImageCardWithButtonSection', imageUrl: string, title?: string | undefined, link?: string | undefined, optionalButtonLabel?: string | undefined, heightFactor: number, id: string } | { __typename: 'InitialRateMoviesSection', id: string } | { __typename: 'MovieListSection', title?: string | undefined, subTitle?: string | undefined, emptyMessage?: string | undefined, id: string, movieListDisplayType: MovieListSectionDisplayType, movieList: { __typename?: 'MovieList', id: string } } | { __typename: 'NewsListSection', title?: string | undefined, id: string, newsItems: Array<{ __typename?: 'NewsItem', id: string }> } | { __typename: 'NotificationInbox', id: string, notifications: Array<{ __typename?: 'Notification', id: string }> } | { __typename: 'QRCodeScannerSection', buttonLabel: string, margin?: string | undefined, modalTitle?: string | undefined, modalDescription?: string | undefined, modalNoPermissionsDisclaimer?: string | undefined, modalRequestPersmissionsButtonLabel?: string | undefined, modalManualInputSeparator?: string | undefined, modalManualInputLabel?: string | undefined, modalManualInputHint?: string | undefined, id: string } | { __typename: 'WebViewSection', title?: string | undefined, url: string, margin?: string | undefined, collapsed?: boolean | undefined, infoText?: string | undefined, infoTextAfter?: string | undefined, height: string, width: string, injectionScript?: string | undefined, backgroundColor?: string | undefined, id: string }> } | { __typename: 'CurrentOrdersSection', id: string, orders: Array<{ __typename?: 'Order', id: string }> } | { __typename: 'CurrentTicketsSection', id: string, tickets: Array<{ __typename?: 'Ticket', id: string }> } | { __typename: 'ExitPollSection', id: string, screening: { __typename?: 'Screening', id: string } } | { __typename: 'FeaturedMovieSection', description?: string | undefined, title?: string | undefined, id: string, movie: { __typename?: 'Movie', id: string } } | { __typename: 'GoogleAdBannerSection', adUnitName?: string | undefined, id: string } | { __typename: 'HeadingSection', text?: string | undefined, size?: string | undefined, align?: string | undefined, margin?: string | undefined, id: string } | { __typename: 'HeroPlayer', id: string, content: Array<{ __typename?: 'HeroPlayerContent', id: string, title?: string | undefined, url?: string | undefined }> } | { __typename: 'ImageCardSection', title?: string | undefined, description?: string | undefined, link?: string | undefined, imageUrl: string, id: string } | { __typename: 'ImageCardWithButtonCarouselSection', id: string, images: Array<{ __typename?: 'ImageCardWithButtonSection', id: string, imageUrl: string, title?: string | undefined, link?: string | undefined, optionalButtonLabel?: string | undefined, heightFactor: number }> } | { __typename: 'ImageCardWithButtonSection', imageUrl: string, title?: string | undefined, link?: string | undefined, optionalButtonLabel?: string | undefined, heightFactor: number, id: string } | { __typename: 'InitialRateMoviesSection', id: string } | { __typename: 'MovieListSection', title?: string | undefined, subTitle?: string | undefined, emptyMessage?: string | undefined, id: string, movieListDisplayType: MovieListSectionDisplayType, movieList: { __typename?: 'MovieList', id: string } } | { __typename: 'NewsListSection', title?: string | undefined, id: string, newsItems: Array<{ __typename?: 'NewsItem', id: string }> } | { __typename: 'NotificationInbox', id: string, notifications: Array<{ __typename?: 'Notification', id: string }> } | { __typename: 'QRCodeScannerSection', buttonLabel: string, margin?: string | undefined, modalTitle?: string | undefined, modalDescription?: string | undefined, modalNoPermissionsDisclaimer?: string | undefined, modalRequestPersmissionsButtonLabel?: string | undefined, modalManualInputSeparator?: string | undefined, modalManualInputLabel?: string | undefined, modalManualInputHint?: string | undefined, id: string } | { __typename: 'WebViewSection', title?: string | undefined, url: string, margin?: string | undefined, collapsed?: boolean | undefined, infoText?: string | undefined, infoTextAfter?: string | undefined, height: string, width: string, injectionScript?: string | undefined, backgroundColor?: string | undefined, id: string }> } | undefined };

export type UpdateContentSectionListMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  contentsections: Scalars['Json']['input'];
  title?: InputMaybe<Scalars['String']['input']>;
  displayType?: InputMaybe<ContentSectionListDisplayType>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  headerImageHeight?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateContentSectionListMutation = { __typename?: 'Mutation', updateContentSectionList: { __typename?: 'ContentSectionList', id: string, title?: string | undefined } };

export type GetAllEditableContentSectionListsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllEditableContentSectionListsQuery = { __typename?: 'Query', getAllEditableContentSectionLists: Array<{ __typename?: 'ContentSectionList', id: string, title?: string | undefined }> };

export type CreateContentSectionListMutationVariables = Exact<{
  title?: InputMaybe<Scalars['String']['input']>;
  displayType?: InputMaybe<ContentSectionListDisplayType>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  headerImageHeight?: InputMaybe<Scalars['String']['input']>;
  contentsections: Scalars['Json']['input'];
}>;


export type CreateContentSectionListMutation = { __typename?: 'Mutation', createContentSectionList: { __typename?: 'ContentSectionList', id: string, title?: string | undefined } };

export type BonusProgramVoucherEditorQueryVariables = Exact<{
  cinemaId: Scalars['ID']['input'];
}>;


export type BonusProgramVoucherEditorQuery = { __typename?: 'Query', cinema?: { __typename?: 'Cinema', id: string, bonusProgramVoucherTypes: Array<{ __typename?: 'BonusProgramVoucherType', voucherTypeId: string, cinemaId: string, title: string, description?: string | undefined, priceCoins?: number | undefined, priceEuros?: number | undefined, discountPercent?: number | undefined, maxQuantityPerPerson?: number | undefined, initialQuantity?: number | undefined, remainingQuantity?: number | undefined, bookableUntil?: any | undefined, redeemableUntil?: any | undefined, active: boolean, imageUrl?: string | undefined }> } | undefined, bonusProgramVoucherStockImages: Array<{ __typename?: 'BonusProgramVoucherStockImage', id: string, title?: string | undefined, url: string }> };

export type CreateBonusProgramVoucherTypeMutationVariables = Exact<{
  cinemaId: Scalars['ID']['input'];
  input: BonusProgramVoucherTypeInput;
}>;


export type CreateBonusProgramVoucherTypeMutation = { __typename?: 'Mutation', createBonusProgramVoucherType: { __typename?: 'BonusProgramVoucherType', voucherTypeId: string } };

export type UpdateBonusProgramVoucherTypeMutationVariables = Exact<{
  voucherTypeId: Scalars['ID']['input'];
  input: BonusProgramVoucherTypeInput;
}>;


export type UpdateBonusProgramVoucherTypeMutation = { __typename?: 'Mutation', updateBonusProgramVoucherType: { __typename?: 'BonusProgramVoucherType', voucherTypeId: string } };

export type NewsItemOldQueryVariables = Exact<{
  newsItemId: Scalars['ID']['input'];
}>;


export type NewsItemOldQuery = { __typename?: 'Query', newsItem?: { __typename?: 'NewsItem', id: string, title?: string | undefined, body?: string | undefined, movie?: { __typename?: 'Movie', id: string } | undefined } | undefined };

export type UpsertNewsItemOldMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type UpsertNewsItemOldMutation = { __typename?: 'Mutation', result: { __typename?: 'upsertNewsItemReturnType', newsItem?: { __typename?: 'NewsItem', id: string, title?: string | undefined, body?: string | undefined, movie?: { __typename?: 'Movie', id: string } | undefined } | undefined } };

export type MoviesQueryVariables = Exact<{ [key: string]: never; }>;


export type MoviesQuery = { __typename?: 'Query', movies: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> };

export type CurrentUserCinemasV2QueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCinemasV2Query = { __typename?: 'Query', user?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> } } | undefined };

export type CampaignsOldQueryVariables = Exact<{
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CampaignsOldQuery = { __typename?: 'Query', campaignsByCinemas: { __typename?: 'CampaignsByCinemasReturnType', campaigns: Array<{ __typename?: 'Campaign', id: string, type?: CampaignType | undefined, name: string, status: CampaignStatus, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> }> } };

export type CreateCampaignOldMutationVariables = Exact<{
  name: Scalars['String']['input'];
  type: CampaignType;
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateCampaignOldMutation = { __typename?: 'Mutation', result?: { __typename?: 'CreateCampaignReturnType', campaign?: { __typename?: 'Campaign', id: string, type?: CampaignType | undefined, name: string, userGroupFilter?: { __typename?: 'UserGroupFilter', id: string } | undefined, userGroupFilterOnReferencedMovie?: { __typename?: 'UserGroupFilterOnReferencedMovie', id: string } | undefined } | undefined } | undefined };

export type EditCampaignOldMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  channels: Array<Channel> | Channel;
  message?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  sendingTime?: InputMaybe<Scalars['Time']['input']>;
  sendingDate?: InputMaybe<Scalars['Date']['input']>;
  sendOnDayXAfterTrigger?: InputMaybe<Scalars['Int']['input']>;
  sendExactlyMinutesAfterTrigger?: InputMaybe<Scalars['Int']['input']>;
  userGroupFilter: UserGroupFilterInput;
  userGroupFilterOnReferencedMovie: UserGroupFilterOnReferencedMovieInput;
  status: CampaignStatus;
}>;


export type EditCampaignOldMutation = { __typename?: 'Mutation', editCampaign: { __typename?: 'EditCampaignReturnType', campaign?: { __typename?: 'Campaign', id: string } | undefined }, editUserGroupFilter: { __typename?: 'EditUserGroupFilterReturnType', userGroupFilter?: { __typename?: 'UserGroupFilter', id: string } | undefined }, editUserGroupFilterOnReferencedMovie: { __typename?: 'EditUserGroupFilterOnReferencedMovieReturnType', userGroupFilterOnReferencedMovie?: { __typename?: 'UserGroupFilterOnReferencedMovie', id: string } | undefined } };

export type EstimateSizeOldQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EstimateSizeOldQuery = { __typename?: 'Query', size: { __typename?: 'estimateCampaignSizeReturnType', userGroupSize?: number | undefined, exampleReferenceMovie?: { __typename?: 'ExampleReferenceMovie', userGroupSize?: number | undefined, movie?: { __typename?: 'Movie', title?: string | undefined } | undefined } | undefined } };

export type DeleteCampaignsOldMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCampaignsOldMutation = { __typename?: 'Mutation', deleteCampaigns: { __typename?: 'DeleteCampaignsReturnType', success: boolean } };

export type SetCampaignEditableMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetCampaignEditableMutation = { __typename?: 'Mutation', setCampaignStatus: { __typename?: 'SetCampaignStatusReturnType', campaign?: { __typename?: 'Campaign', id: string } | undefined } };

export type EstimateSizeQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EstimateSizeQuery = { __typename?: 'Query', size: { __typename?: 'estimateCampaignSizeReturnType', userGroupSize?: number | undefined } };

export type CampaignQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, type?: CampaignType | undefined, name: string, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, link?: string | undefined, status: CampaignStatus, sendingTime?: any | undefined, sendingDate?: any | undefined, sendOnDayXAfterTrigger?: number | undefined, sendExactlyMinutesAfterTrigger?: number | undefined, userGroupFilter?: { __typename?: 'UserGroupFilter', id: string, bonusPointsGeq?: number | undefined, bonusPointsLeq?: number | undefined, moviesOnWatchlist?: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> | undefined, moviesSeen?: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> | undefined, moviesNotSeen?: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> | undefined, moviesRatedPositively?: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> | undefined, moviesRatedNegatively?: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> | undefined, visitFrequency?: { __typename?: 'VisitFrequency', id: string, visits: number, intervalLengthDays: number } | undefined } | undefined, userGroupFilterOnReferencedMovie?: { __typename?: 'UserGroupFilterOnReferencedMovie', id: string, onWatchlist?: boolean | undefined, seen?: boolean | undefined, ratedPositively?: boolean | undefined, ratedNegatively?: boolean | undefined } | undefined } | undefined };

export type CinemaClustersOverviewQueryVariables = Exact<{ [key: string]: never; }>;


export type CinemaClustersOverviewQuery = { __typename?: 'Query', cinemaClusters: Array<{ __typename?: 'CinemaCluster', id: string, name: string, position: number }> };

export type CreateCinemaClusterMutationVariables = Exact<{
  data: CinemaClusterData;
}>;


export type CreateCinemaClusterMutation = { __typename?: 'Mutation', createCinemaCluster: { __typename?: 'CinemaCluster', id: string, name: string, position: number, cinemas: Array<{ __typename?: 'Cinema', id: string }> } };

export type UpdateCinemaClusterMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: CinemaClusterData;
}>;


export type UpdateCinemaClusterMutation = { __typename?: 'Mutation', updateCinemaCluster: { __typename?: 'CinemaCluster', id: string, name: string, position: number, cinemas: Array<{ __typename?: 'Cinema', id: string }> } };

export type DeleteCinemaClustersMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCinemaClustersMutation = { __typename?: 'Mutation', deleteCinemaClusters: number };

export type SingleCinemaClusterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SingleCinemaClusterQuery = { __typename?: 'Query', cinemaCluster: { __typename?: 'CinemaCluster', id: string, name: string, position: number, cinemas: Array<{ __typename?: 'Cinema', id: string }> } };

export type CreateCinemaOperatingCompanyMutationVariables = Exact<{
  data: CinemaOperatingCompanyData;
}>;


export type CreateCinemaOperatingCompanyMutation = { __typename?: 'Mutation', createCinemaOperatingCompany: { __typename?: 'CinemaOperatingCompany', id: string } };

export type UpdateCinemaOperatingCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  data: CinemaOperatingCompanyData;
}>;


export type UpdateCinemaOperatingCompanyMutation = { __typename?: 'Mutation', updateCinemaOperatingCompany: { __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined, accessRightDashboard?: boolean | undefined, accessRightFilmStatistics?: boolean | undefined, accessRightBonusProgram?: boolean | undefined, accessRightCampaigning?: boolean | undefined, cinemas: Array<{ __typename?: 'AssociatedCinema', id: string, name: string }>, associatedUsers: Array<{ __typename?: 'User', id: string, fullName?: string | undefined, email?: string | undefined }> } };

export type AllCinemasQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCinemasQuery = { __typename?: 'Query', cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> };

export type CurrentUserCinemasV3QueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCinemasV3Query = { __typename?: 'Query', user?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> } } | undefined };

export type CurrentUserCinemasV4QueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCinemasV4Query = { __typename?: 'Query', user?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> } } | undefined };

export type CurrentUserCinemaOperatingCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserCinemaOperatingCompaniesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined }> } } | undefined };

export type RemoveAdminPrivilegesMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  cinemaOperatingCompanyId: Scalars['ID']['input'];
}>;


export type RemoveAdminPrivilegesMutation = { __typename?: 'Mutation', updateUserAdminStatus: { __typename?: 'updateUserAdminStatusReturnType', success: boolean, user?: { __typename?: 'User', id: string, name?: string | undefined, email?: string | undefined, privileges: { __typename?: 'UserPrivileges', rootRole: boolean, belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined }> } } | undefined } };

export type AddAdminUserPrivilegeMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  cinemaOperatingCompanyId: Scalars['ID']['input'];
}>;


export type AddAdminUserPrivilegeMutation = { __typename?: 'Mutation', updateUserAdminStatus: { __typename?: 'updateUserAdminStatusReturnType', success: boolean, user?: { __typename?: 'User', id: string, name?: string | undefined, email?: string | undefined, privileges: { __typename?: 'UserPrivileges', rootRole: boolean, belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined }> } } | undefined } };

export type GetAdminUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminUsersQuery = { __typename?: 'Query', adminUsers: Array<{ __typename?: 'User', id: string, name?: string | undefined, email?: string | undefined, privileges: { __typename?: 'UserPrivileges', rootRole: boolean, belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined }> } }> };

export type BonusProgramEditorOptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type BonusProgramEditorOptionsQuery = { __typename?: 'Query', currentUser?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminRole: boolean, rootRole: boolean, supportRole: boolean, adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }>, adminForBonusPrograms: Array<{ __typename?: 'BonusProgram', id: string, name?: string | undefined, participatingCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> }> } } | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string, name?: string | undefined } | undefined }> };

export type BonusProgramEditorQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BonusProgramEditorQuery = { __typename?: 'Query', bonusProgram?: { __typename?: 'BonusProgram', id: string, name?: string | undefined, termsLink?: string | undefined, legalEntity: string, termsVersion: number } | undefined };

export type UpdateBonusProgramEditorMutationVariables = Exact<{
  bonusProgramId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  legalEntity: Scalars['String']['input'];
  termsVersion: Scalars['Int']['input'];
  termsLink?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateBonusProgramEditorMutation = { __typename?: 'Mutation', updateBonusProgram: { __typename?: 'UpdateBonusProgramReturnType', success: boolean, bonusProgram?: { __typename?: 'BonusProgram', id: string, name?: string | undefined, termsLink?: string | undefined, legalEntity: string, termsVersion: number } | undefined } };

export type UpdateBonusProgramParticipatingCinemasMutationVariables = Exact<{
  bonusProgramId: Scalars['ID']['input'];
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type UpdateBonusProgramParticipatingCinemasMutation = { __typename?: 'Mutation', updateBonusProgramParticipatingCinemas: { __typename?: 'UpdateBonusProgramReturnType', success: boolean, bonusProgram?: { __typename?: 'BonusProgram', id: string, name?: string | undefined, participatingCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }> } | undefined } };

export type UpdateScreeningMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  marked: Scalars['Boolean']['input'];
}>;


export type UpdateScreeningMutation = { __typename?: 'Mutation', updateScreening?: { __typename?: 'UpdateScreeningReturnType', success: boolean } | undefined };

export type GetMoviesWithLastChanceInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetMoviesWithLastChanceInfoQuery = { __typename?: 'Query', cinema?: { __typename?: 'Cinema', id: string, moviesWithLastChanceInfo: Array<{ __typename?: 'LastChanceItem', movie: { __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined, nonMovieEvent?: boolean | undefined }, lastKnownScreening?: { __typename?: 'Screening', id: string, datetime?: any | undefined } | undefined, screeningsMarkedAsLastChance: Array<{ __typename?: 'Screening', id: string, datetime?: any | undefined }> }> } | undefined };

export type CreateSoonInCinemaItemMutationVariables = Exact<{
  cinemaId: Scalars['ID']['input'];
  movieTitle?: InputMaybe<Scalars['String']['input']>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreateSoonInCinemaItemMutation = { __typename?: 'Mutation', createSoonInCinemaItem?: { __typename?: 'CreateSoonInCinemaItemReturnType', success: boolean } | undefined };

export type UpdateSoonInCinemaItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  movieTitle?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['Date']['input']>;
}>;


export type UpdateSoonInCinemaItemMutation = { __typename?: 'Mutation', updateSoonInCinemaItem?: { __typename?: 'UpdatedSoonInCinemaItemReturnType', success: boolean } | undefined };

export type AllMoviesOldQueryVariables = Exact<{ [key: string]: never; }>;


export type AllMoviesOldQuery = { __typename?: 'Query', allMovies: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined }> };

export type DeleteSoonInCinemaItemMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteSoonInCinemaItemMutation = { __typename?: 'Mutation', deleteSoonInCinemaItem?: { __typename?: 'DeleteSoonInCinemaItemReturnType', success: boolean } | undefined };

export type SoonInCinemaItemsQueryVariables = Exact<{
  cinemaId: Scalars['ID']['input'];
}>;


export type SoonInCinemaItemsQuery = { __typename?: 'Query', soonInCinemaItems: Array<{ __typename?: 'SoonInCinemaItem', id: string, startDate?: any | undefined, movieTitle?: string | undefined, movie?: { __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined } | undefined }> };

export type SetUserContentEditorStatusMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  isContentEditor: Scalars['Boolean']['input'];
}>;


export type SetUserContentEditorStatusMutation = { __typename?: 'Mutation', setUserContentEditorStatus: { __typename?: 'SetUserContentEditorStatusReturnType', success: boolean, user: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', contentEditorRole: boolean } } } };

export type EmailComponentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  componentName: EmailComponentName;
  componentProps: Scalars['Json']['input'];
  brand: Brand;
}>;


export type EmailComponentQuery = { __typename?: 'Query', emailComponent: { __typename?: 'EmailComponent', id: string, html: string } };

export type AllMovieListsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AllMovieListsQuery = { __typename?: 'Query', allCinemaFilmSeries: Array<{ __typename?: 'MovieList', id: string, title?: string | undefined }> };

export type SendTestEmailMutationVariables = Exact<{
  brand: Brand;
  componentData: Scalars['String']['input'];
}>;


export type SendTestEmailMutation = { __typename?: 'Mutation', sendTestEmail: { __typename?: 'SendTestEmail', success: boolean } };

export type ScreeningsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  foreignIdType: Scalars['String']['input'];
  before?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type ScreeningsQuery = { __typename?: 'Query', screenings: Array<{ __typename?: 'Screening', movie?: { __typename?: 'Movie', id: string, title?: string | undefined, synopsis?: string | undefined, duration?: number | undefined, poster?: string | undefined, ageRating?: string | undefined, foreignMovieId?: { __typename?: 'ForeignIdType', foreignId?: string | undefined } | undefined } | undefined }> };

export type CinemasAndScreeningsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  foreignIdType: Scalars['String']['input'];
  before?: InputMaybe<Scalars['DateTime']['input']>;
  after?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CinemasAndScreeningsQuery = { __typename?: 'Query', cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, movies: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, synopsis?: string | undefined, duration?: number | undefined, poster?: string | undefined, ageRating?: string | undefined, foreignMovieId?: { __typename?: 'ForeignIdType', foreignId?: string | undefined } | undefined }> }>, screenings: Array<{ __typename?: 'Screening', id: string, datetime?: any | undefined, is3d?: boolean | undefined, is2d?: boolean | undefined, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined } | undefined, movie?: { __typename?: 'Movie', title?: string | undefined, id: string } | undefined }> };

export type MovieListsFullQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  foreignIdType: Scalars['String']['input'];
  before?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type MovieListsFullQuery = { __typename?: 'Query', cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }>, allCinemaFilmSeries: Array<{ __typename?: 'MovieList', id: string, title?: string | undefined, subTitle?: string | undefined, description?: string | undefined, items: Array<{ __typename?: 'MovieListItem', description?: string | undefined, movie: { __typename?: 'Movie', id: string, title?: string | undefined, synopsis?: string | undefined, duration?: number | undefined, poster?: string | undefined, ageRating?: string | undefined, foreignMovieId?: { __typename?: 'ForeignIdType', foreignId?: string | undefined } | undefined } }> }> };

export type AssignEditorialForeignIdentifierMutationVariables = Exact<{
  identifierId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
  replaceExistingComscoreIdentifierId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type AssignEditorialForeignIdentifierMutation = { __typename?: 'Mutation', assignEditorialForeignIdentifier: { __typename?: 'MovieEditorialAssignmentResult', success: boolean, movieId: string, comscoreIdentifierConflict?: { __typename?: 'MovieEditorialComscoreIdentifierConflict', movie: { __typename?: 'MovieEditorialSearchResult', movieId: string, title: string, releaseDate?: any | undefined, poster?: string | undefined, directedBy: Array<string>, incomplete: boolean, lastEdit?: any | undefined }, existingIdentifier: { __typename?: 'MovieEditorialForeignIdentifier', identifierId: string, title: string, foreignId: string, foreignIdType: string }, newIdentifier: { __typename?: 'MovieEditorialForeignIdentifier', identifierId: string, title: string, foreignId: string, foreignIdType: string } } | undefined } };

export type CreateAndAssignEditorialMovieMutationVariables = Exact<{
  identifierId: Scalars['ID']['input'];
}>;


export type CreateAndAssignEditorialMovieMutation = { __typename?: 'Mutation', createAndAssignEditorialMovie: { __typename?: 'MovieEditorialAssignmentResult', success: boolean, movieId: string } };

export type AssignEditorialSoonInCinemaItemMutationVariables = Exact<{
  itemId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
}>;


export type AssignEditorialSoonInCinemaItemMutation = { __typename?: 'Mutation', assignEditorialSoonInCinemaItem: { __typename?: 'MovieEditorialAssignmentResult', success: boolean, movieId: string } };

export type MovieEditorialOverviewQueryVariables = Exact<{
  limitPerQueue: Scalars['Int']['input'];
}>;


export type MovieEditorialOverviewQuery = { __typename?: 'Query', movieEditorialTodoOverview: { __typename?: 'MovieEditorialTodoOverview', contentFollowUp: Array<{ __typename?: 'MovieEditorialTodoQueue', type: MovieEditorialTodoQueueType, total: number, items: Array<{ __typename?: 'MovieEditorialTodoItem', id: string, title: string, movieId?: string | undefined, cinemaId?: string | undefined, cinemaName?: string | undefined, lastEdit?: any | undefined, date?: any | undefined, foreignId?: string | undefined, foreignIdType?: string | undefined }> }>, brokenTrailers: { __typename?: 'MovieEditorialTodoQueue', type: MovieEditorialTodoQueueType, total: number, items: Array<{ __typename?: 'MovieEditorialTodoItem', id: string, title: string, movieId?: string | undefined, cinemaId?: string | undefined, cinemaName?: string | undefined, lastEdit?: any | undefined, date?: any | undefined, foreignId?: string | undefined, foreignIdType?: string | undefined }> }, unmatchedSoonInCinema: { __typename?: 'MovieEditorialTodoQueue', type: MovieEditorialTodoQueueType, total: number, items: Array<{ __typename?: 'MovieEditorialTodoItem', id: string, title: string, movieId?: string | undefined, cinemaId?: string | undefined, cinemaName?: string | undefined, lastEdit?: any | undefined, date?: any | undefined, foreignId?: string | undefined, foreignIdType?: string | undefined }> }, unmatchedForeignIdentifiers: { __typename?: 'MovieEditorialTodoQueue', type: MovieEditorialTodoQueueType, total: number, items: Array<{ __typename?: 'MovieEditorialTodoItem', id: string, title: string, movieId?: string | undefined, cinemaId?: string | undefined, cinemaName?: string | undefined, lastEdit?: any | undefined, date?: any | undefined, foreignId?: string | undefined, foreignIdType?: string | undefined }> } } };

export type SearchEditorialMoviesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
}>;


export type SearchEditorialMoviesQuery = { __typename?: 'Query', searchEditorialMovies: Array<{ __typename?: 'MovieEditorialSearchResult', movieId: string, title: string, releaseDate?: any | undefined, poster?: string | undefined, directedBy: Array<string>, incomplete: boolean, lastEdit?: any | undefined }> };

export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = { __typename?: 'Mutation', login?: { __typename?: 'LoginReturnType', csrf?: string | undefined, fileServerToken?: string | undefined, user?: { __typename?: 'User', id: string } | undefined } | undefined };

export type MissedPayoutsQueryVariables = Exact<{
  from?: InputMaybe<Scalars['Date']['input']>;
  to?: InputMaybe<Scalars['Date']['input']>;
}>;


export type MissedPayoutsQuery = { __typename?: 'Query', missedPayouts: Array<{ __typename?: 'MissedPayoutInfo', user?: { __typename?: 'User', id: string, fullName?: string | undefined, email?: string | undefined } | undefined, subscription: { __typename?: 'Subscription', id: string, paidUntil?: any | undefined } }> };

export type IncomingForeignMovieIdentifiersQueryVariables = Exact<{
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  force?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type IncomingForeignMovieIdentifiersQuery = { __typename?: 'Query', incomingForeignMovieIdentifiers: Array<{ __typename?: 'ForeignMovieIdentifier', id: string, foreignIdType: string, title: string, onlineTicketingUrl?: string | undefined, currentMovie?: { __typename?: 'Movie', title?: string | undefined, id: string } | undefined, forCinema?: { __typename?: 'Cinema', id: string, name?: string | undefined } | undefined }> };

export type UpdateMovieMappingMutationVariables = Exact<{
  foreignId: Scalars['ID']['input'];
  movieId: Scalars['ID']['input'];
}>;


export type UpdateMovieMappingMutation = { __typename?: 'Mutation', updateForeignMovieMapping: boolean };

export type EditorialMovieQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
}>;


export type EditorialMovieQuery = { __typename?: 'Query', movieEditorialMovie: { __typename?: 'MovieEditorialMovie', movieId: string, title: string, releaseDate?: any | undefined, synopsis?: string | undefined, synopsisSource?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, poster?: string | undefined, posterSource?: string | undefined, banner?: string | undefined, bannerSource?: string | undefined, youtubeTrailerId?: string | undefined, incomplete: boolean, special: boolean, imdbId?: string | undefined, shownIn: Array<string>, lastEdit?: any | undefined, stages: { __typename?: 'MovieEditorialStages', initial: boolean, shouldSoonExpectedInApp: boolean, soonExpectedInApp: boolean, shouldFirstAppVisibility: boolean, firstAppVisibility: boolean, shouldRelease: boolean, release: boolean, manualReminder?: any | undefined }, externalReferences: Array<{ __typename?: 'MovieEditorialExternalReference', provider: string, title?: string | undefined, releaseDate?: any | undefined, synopsis?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, poster?: string | undefined, banner?: string | undefined }> }, movieEditorialOptions: { __typename?: 'MovieEditorialOptions', ageRatings: Array<string>, genres: Array<string> }, posterStockImages: Array<{ __typename?: 'MovieEditorialStockImage', id: string, title?: string | undefined, url: string }>, bannerStockImages: Array<{ __typename?: 'MovieEditorialStockImage', id: string, title?: string | undefined, url: string }> };

export type UpdateEditorialMovieMutationVariables = Exact<{
  movieId: Scalars['ID']['input'];
  expectedLastEdit?: InputMaybe<Scalars['DateTime']['input']>;
  input: MovieEditorialMovieInput;
}>;


export type UpdateEditorialMovieMutation = { __typename?: 'Mutation', updateEditorialMovie: { __typename?: 'MovieEditorialMovie', movieId: string, title: string, releaseDate?: any | undefined, synopsis?: string | undefined, synopsisSource?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, poster?: string | undefined, posterSource?: string | undefined, banner?: string | undefined, bannerSource?: string | undefined, youtubeTrailerId?: string | undefined, incomplete: boolean, special: boolean, imdbId?: string | undefined, shownIn: Array<string>, lastEdit?: any | undefined, stages: { __typename?: 'MovieEditorialStages', initial: boolean, shouldSoonExpectedInApp: boolean, soonExpectedInApp: boolean, shouldFirstAppVisibility: boolean, firstAppVisibility: boolean, shouldRelease: boolean, release: boolean, manualReminder?: any | undefined }, externalReferences: Array<{ __typename?: 'MovieEditorialExternalReference', provider: string, title?: string | undefined, releaseDate?: any | undefined, synopsis?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, poster?: string | undefined, banner?: string | undefined }> } };

export type EditorialMovieTmdbReferenceQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
}>;


export type EditorialMovieTmdbReferenceQuery = { __typename?: 'Query', movieEditorialTmdbReference?: { __typename?: 'MovieEditorialTmdbReference', provider: string, title?: string | undefined, releaseDate?: any | undefined, synopsis?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, posterImages: Array<string>, bannerImages: Array<string> } | undefined };

export type EditorialMovieImdbConflictQueryVariables = Exact<{
  movieId: Scalars['ID']['input'];
  imdbId: Scalars['String']['input'];
}>;


export type EditorialMovieImdbConflictQuery = { __typename?: 'Query', movieEditorialImdbConflict?: { __typename?: 'MovieEditorialImdbConflict', imdbId: string, currentMovie: { __typename?: 'MovieEditorialMergeMovie', movieId: string, title: string, releaseDate?: any | undefined, synopsis?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, poster?: string | undefined, imdbIds: Array<string>, shownIn: Array<string>, incomplete: boolean, lastEdit?: any | undefined }, existingMovie: { __typename?: 'MovieEditorialMergeMovie', movieId: string, title: string, releaseDate?: any | undefined, synopsis?: string | undefined, duration?: number | undefined, ageRating?: string | undefined, genres: Array<string>, poster?: string | undefined, imdbIds: Array<string>, shownIn: Array<string>, incomplete: boolean, lastEdit?: any | undefined } } | undefined };

export type MergeEditorialMoviesForImdbConflictMutationVariables = Exact<{
  movieId: Scalars['ID']['input'];
  imdbId: Scalars['String']['input'];
  movieIdToKeep: Scalars['ID']['input'];
}>;


export type MergeEditorialMoviesForImdbConflictMutation = { __typename?: 'Mutation', mergeEditorialMoviesForImdbConflict: { __typename?: 'MovieEditorialMergeResult', movieId: string } };

export type CurrentUserPosTokensQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentUserPosTokensQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, privileges: { __typename?: 'UserPrivileges', adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, posTokens: Array<string> }> } } | undefined };

export type BonusProgramStatisticsQueryVariables = Exact<{
  bonusProgramIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type BonusProgramStatisticsQuery = { __typename?: 'Query', bonusPrograms: Array<{ __typename?: 'BonusProgram', name?: string | undefined, statistics?: { __typename?: 'BonusProgramStatistics', numBpBookingsInInterval?: number | undefined, numBpBookingsTotal?: number | undefined, numNewUsersInInterval?: number | undefined, numNewUsersTotal?: number | undefined, numUsersInInterval?: number | undefined, numUsersTotal?: number | undefined, scannedVouchersInInterval?: number | undefined, scannedVouchersTotal?: number | undefined, sumBonusPointsInInterval?: number | undefined, sumBonusPointsTotal?: number | undefined, sumBonusPointsSupportInInterval?: number | undefined, sumBonusPointsSupportTotal?: number | undefined, numUsersMultipleBookingsTotal?: number | undefined, redeemedVouchersInInterval: Array<{ __typename?: 'RedeemedVoucher', id?: string | undefined, name?: string | undefined, redeemedAt?: any | undefined, amountPoints?: number | undefined }> } | undefined }> };

export type MovieStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type MovieStatisticsQuery = { __typename?: 'Query', movieStatistics: Array<{ __typename?: 'MovieStatistics', id: string, numWatchlistings: number, numInteractions: number, movie: { __typename?: 'Movie', title?: string | undefined, poster?: string | undefined, averageRating?: number | undefined } }> };

export type UsageStatisticsQueryVariables = Exact<{
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type UsageStatisticsQuery = { __typename?: 'Query', usageStatistics?: { __typename?: 'UsageStatistics', id: string, watchlistUsedInInterval?: number | undefined, installsInterval?: number | undefined, totalInstalls?: number | undefined, activeInInterval?: number | undefined, activeTotal?: number | undefined, watchllistUsedTotal?: number | undefined, sentMessagesInterval?: { __typename?: 'SentMessages', numberOfCountedMessages?: number | undefined, numberOfFreeMessages?: number | undefined } | undefined, totalSentMessages?: { __typename?: 'SentMessages', numberOfCountedMessages?: number | undefined, numberOfFreeMessages?: number | undefined } | undefined } | undefined, cinemas: Array<{ __typename?: 'Cinema', hasDynamicPricing: boolean }> };

export type GetAvailableVoucherClassesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAvailableVoucherClassesQuery = { __typename?: 'Query', getAvailableVoucherClasses: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> };

export type LogAnalyticsItemsMutationVariables = Exact<{
  items?: InputMaybe<Array<InputMaybe<LogItem>> | InputMaybe<LogItem>>;
  options?: InputMaybe<LogOptions>;
}>;


export type LogAnalyticsItemsMutation = { __typename?: 'Mutation', logItems?: { __typename?: 'LogItemsReturnType', success?: boolean | undefined } | undefined };

export type AllAchievementsQueryVariables = Exact<{ [key: string]: never; }>;


export type AllAchievementsQuery = { __typename?: 'Query', allAchievements: Array<{ __typename?: 'Achievement', id: string, title?: string | undefined, description?: string | undefined }> };

export type FetchBeaconsQueryVariables = Exact<{ [key: string]: never; }>;


export type FetchBeaconsQuery = { __typename?: 'Query', beacons: Array<{ __typename?: 'Beacon', id: string, instanceId: number, lastUpdated: any, lastScan?: any | undefined, comments?: string | undefined, lastBatteryChange?: any | undefined, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined } | undefined }> };

export type BeaconByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type BeaconByIdQuery = { __typename?: 'Query', beaconById?: { __typename?: 'Beacon', id: string, instanceId: number, lastUpdated: any, lastScan?: any | undefined, comments?: string | undefined, lastBatteryChange?: any | undefined, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined } | undefined } | undefined };

export type CreateBeaconMutationVariables = Exact<{
  cinemaId: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  lastBatteryChange?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type CreateBeaconMutation = { __typename?: 'Mutation', createBeacon: { __typename?: 'Beacon', id: string, instanceId: number, lastUpdated: any, lastScan?: any | undefined, comments?: string | undefined, lastBatteryChange?: any | undefined, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined } | undefined } };

export type UpdateBeaconMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  lastBatteryChange?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type UpdateBeaconMutation = { __typename?: 'Mutation', updateBeacon: { __typename?: 'Beacon', id: string, instanceId: number, lastUpdated: any, lastScan?: any | undefined, comments?: string | undefined, lastBatteryChange?: any | undefined, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined } | undefined } };

export type DeleteBeaconMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBeaconMutation = { __typename?: 'Mutation', deleteBeacon: { __typename?: 'deleteBeaconReturnType', success: boolean } };

export type NewsItemQueryVariables = Exact<{
  newsItemId: Scalars['ID']['input'];
}>;


export type NewsItemQuery = { __typename?: 'Query', newsItem?: { __typename?: 'NewsItem', id: string, title?: string | undefined, teaser?: string | undefined, body?: string | undefined, link?: string | undefined, image?: string | undefined, poster?: string | undefined, linkText?: string | undefined } | undefined };

export type UpsertNewsItemMutationVariables = Exact<{
  id?: InputMaybe<Scalars['ID']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  teaser?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['String']['input']>;
  movieId?: InputMaybe<Scalars['ID']['input']>;
  poster?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  linkText?: InputMaybe<Scalars['String']['input']>;
  image?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpsertNewsItemMutation = { __typename?: 'Mutation', result: { __typename?: 'upsertNewsItemReturnType', newsItem?: { __typename?: 'NewsItem', id: string, title?: string | undefined, teaser?: string | undefined, body?: string | undefined, poster?: string | undefined, link?: string | undefined, image?: string | undefined, linkText?: string | undefined, movie?: { __typename?: 'Movie', id: string } | undefined } | undefined } };

export type EditCampaignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  channels: Array<Channel> | Channel;
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  messageTitle?: InputMaybe<Scalars['String']['input']>;
  messageImage?: InputMaybe<Scalars['String']['input']>;
  link?: InputMaybe<Scalars['String']['input']>;
  sendingTime?: InputMaybe<Scalars['Time']['input']>;
  sendingDate?: InputMaybe<Scalars['Date']['input']>;
  sendOnDayXAfterTrigger?: InputMaybe<Scalars['Int']['input']>;
  sendExactlyMinutesAfterTrigger?: InputMaybe<Scalars['Int']['input']>;
  status: CampaignStatus;
  trigger: CampaignTrigger;
  startDate?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  startTime?: InputMaybe<Scalars['String']['input']>;
  endTime?: InputMaybe<Scalars['String']['input']>;
  timeUnit?: InputMaybe<CampaignTimeUnit>;
  timeUnitFactor?: InputMaybe<Scalars['Int']['input']>;
  numberOfIntervals?: InputMaybe<Scalars['Int']['input']>;
  intervalEndType?: InputMaybe<CampaignIntervalEndType>;
  eventType?: InputMaybe<CampaignEventType>;
  emailSubject?: InputMaybe<Scalars['String']['input']>;
  targetGroupIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  triggerThreshold?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditCampaignMutation = { __typename?: 'Mutation', editCampaign: { __typename?: 'EditCampaignReturnType', campaign?: { __typename?: 'Campaign', id: string, trigger?: CampaignTrigger | undefined, name: string, type?: CampaignType | undefined, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, messageImage?: string | undefined, link?: string | undefined, status: CampaignStatus, emailContent?: any | undefined, sendingTime?: any | undefined, sendingDate?: any | undefined, startDate?: string | undefined, endDate?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, timeUnit?: CampaignTimeUnit | undefined, timeUnitFactor?: number | undefined, numberOfIntervals?: number | undefined, intervalEndType?: CampaignIntervalEndType | undefined, eventType?: CampaignEventType | undefined, emailSubject?: string | undefined, targetGroupIds?: Array<string> | undefined, triggerThreshold?: string | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string } | undefined }>, language?: { __typename?: 'Language', id: string, url: string, foreignIdType: string, programUrl: string, trailerAutoplay: boolean } | undefined } | undefined } };

export type CampaignDataQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CampaignDataQuery = { __typename?: 'Query', campaign?: { __typename?: 'Campaign', id: string, trigger?: CampaignTrigger | undefined, name: string, type?: CampaignType | undefined, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, messageImage?: string | undefined, link?: string | undefined, status: CampaignStatus, emailContent?: any | undefined, sendingTime?: any | undefined, sendingDate?: any | undefined, startDate?: string | undefined, endDate?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, timeUnit?: CampaignTimeUnit | undefined, timeUnitFactor?: number | undefined, numberOfIntervals?: number | undefined, intervalEndType?: CampaignIntervalEndType | undefined, eventType?: CampaignEventType | undefined, emailSubject?: string | undefined, targetGroupIds?: Array<string> | undefined, triggerThreshold?: string | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string } | undefined }>, language?: { __typename?: 'Language', id: string, url: string, foreignIdType: string, programUrl: string, trailerAutoplay: boolean } | undefined } | undefined };

export type CampaignsQueryVariables = Exact<{
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  newCampaigns?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CampaignsQuery = { __typename?: 'Query', campaignsByCinemas: { __typename?: 'CampaignsByCinemasReturnType', campaigns: Array<{ __typename?: 'Campaign', id: string, trigger?: CampaignTrigger | undefined, name: string, type?: CampaignType | undefined, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, messageImage?: string | undefined, link?: string | undefined, status: CampaignStatus, emailContent?: any | undefined, sendingTime?: any | undefined, sendingDate?: any | undefined, startDate?: string | undefined, endDate?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, timeUnit?: CampaignTimeUnit | undefined, timeUnitFactor?: number | undefined, numberOfIntervals?: number | undefined, intervalEndType?: CampaignIntervalEndType | undefined, eventType?: CampaignEventType | undefined, emailSubject?: string | undefined, targetGroupIds?: Array<string> | undefined, triggerThreshold?: string | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string } | undefined }>, language?: { __typename?: 'Language', id: string, url: string, foreignIdType: string, programUrl: string, trailerAutoplay: boolean } | undefined }> } };

export type CreateCampaignMutationVariables = Exact<{
  name: Scalars['String']['input'];
  trigger: CampaignTrigger;
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  isNewCampaign?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CreateCampaignMutation = { __typename?: 'Mutation', result?: { __typename?: 'CreateCampaignReturnType', campaign?: { __typename?: 'Campaign', id: string, trigger?: CampaignTrigger | undefined, name: string, type?: CampaignType | undefined, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, messageImage?: string | undefined, link?: string | undefined, status: CampaignStatus, emailContent?: any | undefined, sendingTime?: any | undefined, sendingDate?: any | undefined, startDate?: string | undefined, endDate?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, timeUnit?: CampaignTimeUnit | undefined, timeUnitFactor?: number | undefined, numberOfIntervals?: number | undefined, intervalEndType?: CampaignIntervalEndType | undefined, eventType?: CampaignEventType | undefined, emailSubject?: string | undefined, targetGroupIds?: Array<string> | undefined, triggerThreshold?: string | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string } | undefined }>, language?: { __typename?: 'Language', id: string, url: string, foreignIdType: string, programUrl: string, trailerAutoplay: boolean } | undefined } | undefined } | undefined };

export type DeleteCampaignsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCampaignsMutation = { __typename?: 'Mutation', deleteCampaigns: { __typename?: 'DeleteCampaignsReturnType', success: boolean } };

export type UpdateCampaignsStatusMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  status: CampaignStatus;
}>;


export type UpdateCampaignsStatusMutation = { __typename?: 'Mutation', updateCampaignsStatus: { __typename?: 'UpdateCampaignsStatusReturnType', campaigns: Array<{ __typename?: 'Campaign', id: string, trigger?: CampaignTrigger | undefined, name: string, type?: CampaignType | undefined, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, messageImage?: string | undefined, link?: string | undefined, status: CampaignStatus, emailContent?: any | undefined, sendingTime?: any | undefined, sendingDate?: any | undefined, startDate?: string | undefined, endDate?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, timeUnit?: CampaignTimeUnit | undefined, timeUnitFactor?: number | undefined, numberOfIntervals?: number | undefined, intervalEndType?: CampaignIntervalEndType | undefined, eventType?: CampaignEventType | undefined, emailSubject?: string | undefined, targetGroupIds?: Array<string> | undefined, triggerThreshold?: string | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string } | undefined }>, language?: { __typename?: 'Language', id: string, url: string, foreignIdType: string, programUrl: string, trailerAutoplay: boolean } | undefined }> } };

export type SaveCampaignEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  emailContent: Scalars['Json']['input'];
}>;


export type SaveCampaignEmailMutation = { __typename?: 'Mutation', editCampaignEmail: { __typename?: 'EditCampaignEmailReturnType', campaign?: { __typename?: 'Campaign', id: string, trigger?: CampaignTrigger | undefined, name: string, type?: CampaignType | undefined, channels: Array<Channel>, message?: string | undefined, messageTitle?: string | undefined, messageImage?: string | undefined, link?: string | undefined, status: CampaignStatus, emailContent?: any | undefined, sendingTime?: any | undefined, sendingDate?: any | undefined, startDate?: string | undefined, endDate?: string | undefined, startTime?: string | undefined, endTime?: string | undefined, timeUnit?: CampaignTimeUnit | undefined, timeUnitFactor?: number | undefined, numberOfIntervals?: number | undefined, intervalEndType?: CampaignIntervalEndType | undefined, eventType?: CampaignEventType | undefined, emailSubject?: string | undefined, targetGroupIds?: Array<string> | undefined, triggerThreshold?: string | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, bonusProgram?: { __typename?: 'BonusProgram', id: string } | undefined }>, language?: { __typename?: 'Language', id: string, url: string, foreignIdType: string, programUrl: string, trailerAutoplay: boolean } | undefined } | undefined } };

export type SearchCastOrCrewMemberQueryVariables = Exact<{
  fullName: Scalars['String']['input'];
}>;


export type SearchCastOrCrewMemberQuery = { __typename?: 'Query', searchCastOrCrewMember: Array<{ __typename?: 'CastOrCrewMember', id: string, fullName?: string | undefined }> };

export type CinemaDetailsQueryVariables = Exact<{
  cinemaId: Scalars['ID']['input'];
}>;


export type CinemaDetailsQuery = { __typename?: 'Query', cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined, logo?: string | undefined, claim?: string | undefined, hasBonusProgram?: boolean | undefined, headerImage?: string | undefined, imprint?: string | undefined, technologies?: string | undefined, history?: string | undefined, currentInformation?: string | undefined, specialAboutUs?: string | undefined, onlineTicketingBaseUrl?: string | undefined, street?: string | undefined, houseNumber?: string | undefined, zipCode?: string | undefined, city?: string | undefined, parkingDescription?: string | undefined, locationDescription?: string | undefined, googleMapsLink?: string | undefined, appleMapsLink?: string | undefined, phone?: string | undefined, facebook?: string | undefined, twitter?: string | undefined, website?: string | undefined, email?: string | undefined, instagram?: string | undefined, barrierFree?: boolean | undefined, barrierFreeText?: string | undefined, hearingImpaired?: boolean | undefined, hearingImpairedText?: string | undefined, brands: Array<Brand>, blind?: boolean | undefined, blindText?: string | undefined, accessRestrictedTo: AccessRestriction, location?: { __typename?: 'GeoCoordinates', latitude: number, longitude: number } | undefined, openingHoursDisplay: Array<{ __typename?: 'CinemaOpeningHours', weekdays?: string | undefined, hours?: string | undefined }>, pricesDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, price?: string | undefined, description?: string | undefined }>, specialOffersDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, giftVouchersDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, sneaksDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, additionalInfoSections?: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, description?: string | undefined }> | undefined } | undefined };

export type UpdateCinemaMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  logo?: InputMaybe<Scalars['String']['input']>;
  claim?: InputMaybe<Scalars['String']['input']>;
  hasBonusProgram?: InputMaybe<Scalars['Boolean']['input']>;
  headerImage?: InputMaybe<Scalars['String']['input']>;
  imprint?: InputMaybe<Scalars['String']['input']>;
  technologies?: InputMaybe<Scalars['String']['input']>;
  history?: InputMaybe<Scalars['String']['input']>;
  currentInformation?: InputMaybe<Scalars['String']['input']>;
  specialAboutUs?: InputMaybe<Scalars['String']['input']>;
  onlineTicketingBaseUrl?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  parkingDescription?: InputMaybe<Scalars['String']['input']>;
  locationDescription?: InputMaybe<Scalars['String']['input']>;
  googleMapsLink?: InputMaybe<Scalars['String']['input']>;
  appleMapsLink?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  facebook?: InputMaybe<Scalars['String']['input']>;
  twitter?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  instagram?: InputMaybe<Scalars['String']['input']>;
  barrierFree?: InputMaybe<Scalars['Boolean']['input']>;
  barrierFreeText?: InputMaybe<Scalars['String']['input']>;
  hearingImpaired?: InputMaybe<Scalars['Boolean']['input']>;
  hearingImpairedText?: InputMaybe<Scalars['String']['input']>;
  blind?: InputMaybe<Scalars['Boolean']['input']>;
  blindText?: InputMaybe<Scalars['String']['input']>;
  brands: Array<Brand> | Brand;
  openingHoursDisplay: Array<CinemaOpeningHoursInput> | CinemaOpeningHoursInput;
  pricesDisplay: Array<CinemaInformationParagraphInput> | CinemaInformationParagraphInput;
  specialOffersDisplay: Array<CinemaInformationParagraphInput> | CinemaInformationParagraphInput;
  giftVouchersDisplay: Array<CinemaInformationParagraphInput> | CinemaInformationParagraphInput;
  sneaksDisplay: Array<CinemaInformationParagraphInput> | CinemaInformationParagraphInput;
  additionalInfoSections: Array<CinemaInformationParagraphInput> | CinemaInformationParagraphInput;
  accessRestrictedTo: AccessRestriction;
  location?: InputMaybe<CinemaLocationInput>;
}>;


export type UpdateCinemaMutation = { __typename?: 'Mutation', updateCinema: { __typename?: 'updateCinemaReturnType', success: boolean, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined, logo?: string | undefined, claim?: string | undefined, hasBonusProgram?: boolean | undefined, headerImage?: string | undefined, imprint?: string | undefined, technologies?: string | undefined, history?: string | undefined, currentInformation?: string | undefined, specialAboutUs?: string | undefined, onlineTicketingBaseUrl?: string | undefined, street?: string | undefined, houseNumber?: string | undefined, zipCode?: string | undefined, city?: string | undefined, parkingDescription?: string | undefined, locationDescription?: string | undefined, googleMapsLink?: string | undefined, appleMapsLink?: string | undefined, phone?: string | undefined, facebook?: string | undefined, twitter?: string | undefined, website?: string | undefined, email?: string | undefined, instagram?: string | undefined, barrierFree?: boolean | undefined, barrierFreeText?: string | undefined, hearingImpaired?: boolean | undefined, hearingImpairedText?: string | undefined, brands: Array<Brand>, blind?: boolean | undefined, blindText?: string | undefined, accessRestrictedTo: AccessRestriction, location?: { __typename?: 'GeoCoordinates', latitude: number, longitude: number } | undefined, openingHoursDisplay: Array<{ __typename?: 'CinemaOpeningHours', weekdays?: string | undefined, hours?: string | undefined }>, pricesDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, price?: string | undefined, description?: string | undefined }>, specialOffersDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, giftVouchersDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, sneaksDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, additionalInfoSections?: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, description?: string | undefined }> | undefined } | undefined } };

export type CreateCinemaMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateCinemaMutation = { __typename?: 'Mutation', createCinema: { __typename?: 'createCinemaReturnType', success: boolean, cinema?: { __typename?: 'Cinema', id: string, name?: string | undefined, logo?: string | undefined, claim?: string | undefined, hasBonusProgram?: boolean | undefined, headerImage?: string | undefined, imprint?: string | undefined, technologies?: string | undefined, history?: string | undefined, currentInformation?: string | undefined, specialAboutUs?: string | undefined, onlineTicketingBaseUrl?: string | undefined, street?: string | undefined, houseNumber?: string | undefined, zipCode?: string | undefined, city?: string | undefined, parkingDescription?: string | undefined, locationDescription?: string | undefined, googleMapsLink?: string | undefined, appleMapsLink?: string | undefined, phone?: string | undefined, facebook?: string | undefined, twitter?: string | undefined, website?: string | undefined, email?: string | undefined, instagram?: string | undefined, barrierFree?: boolean | undefined, barrierFreeText?: string | undefined, hearingImpaired?: boolean | undefined, hearingImpairedText?: string | undefined, brands: Array<Brand>, blind?: boolean | undefined, blindText?: string | undefined, accessRestrictedTo: AccessRestriction, location?: { __typename?: 'GeoCoordinates', latitude: number, longitude: number } | undefined, openingHoursDisplay: Array<{ __typename?: 'CinemaOpeningHours', weekdays?: string | undefined, hours?: string | undefined }>, pricesDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, price?: string | undefined, description?: string | undefined }>, specialOffersDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, giftVouchersDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, sneaksDisplay: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, image?: string | undefined, description?: string | undefined, price?: string | undefined }>, additionalInfoSections?: Array<{ __typename?: 'CinemaInformationParagraph', title?: string | undefined, description?: string | undefined }> | undefined } | undefined } };

export type SingleCompanyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SingleCompanyQuery = { __typename?: 'Query', company?: { __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined } | undefined };

export type AllCompaniesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllCompaniesQuery = { __typename?: 'Query', companies: Array<{ __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined }> };

export type EditCompanyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  logo: Scalars['String']['input'];
}>;


export type EditCompanyMutation = { __typename?: 'Mutation', editCompany: { __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined } };

export type DeleteCompaniesMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteCompaniesMutation = { __typename?: 'Mutation', deleteCompanies: number };

export type CreateCompanyMutationVariables = Exact<{
  name: Scalars['String']['input'];
  logo: Scalars['String']['input'];
}>;


export type CreateCompanyMutation = { __typename?: 'Mutation', createCompany: { __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined } };

export type AllGenresQueryVariables = Exact<{ [key: string]: never; }>;


export type AllGenresQuery = { __typename?: 'Query', allGenres: Array<{ __typename?: 'Genre', id: string, name?: string | undefined }> };

export type AllImagesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllImagesQuery = { __typename?: 'Query', allImages: Array<{ __typename?: 'Image', id: string, datetime: any, url: string }> };

export type SaveImagePathMutationVariables = Exact<{
  filePath: Scalars['String']['input'];
}>;


export type SaveImagePathMutation = { __typename?: 'Mutation', saveImagePath?: { __typename?: 'SaveImagePathReturnType', success?: boolean | undefined, uploadedImage: { __typename?: 'Image', id: string, datetime: any, url: string } } | undefined };

export type DeleteImageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteImageMutation = { __typename?: 'Mutation', deleteImage?: { __typename?: 'DeleteImageReturnType', success?: boolean | undefined } | undefined };

export type AllMoviesQueryVariables = Exact<{
  isFromMasterFilmDB?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AllMoviesQuery = { __typename?: 'Query', allMovies: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined, banner?: string | undefined, directedBy?: string | undefined, releaseDate?: any | undefined }> };

export type SearchMovieQueryVariables = Exact<{
  title: Scalars['String']['input'];
}>;


export type SearchMovieQuery = { __typename?: 'Query', searchMovie: Array<{ __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined, banner?: string | undefined, directedBy?: string | undefined, releaseDate?: any | undefined }> };

export type MoviePosterQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MoviePosterQuery = { __typename?: 'Query', movie?: { __typename?: 'Movie', title?: string | undefined, poster?: string | undefined, banner?: string | undefined } | undefined };

export type MovieListsQueryVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type MovieListsQuery = { __typename?: 'Query', allCinemaFilmSeries: Array<{ __typename?: 'MovieList', id: string, title?: string | undefined, type?: string | undefined }> };

export type MovieListQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MovieListQuery = { __typename?: 'Query', movieList?: { __typename?: 'MovieList', id: string, title?: string | undefined } | undefined };

export type SendTestNotificationMutationVariables = Exact<{
  title: Scalars['String']['input'];
  body: Scalars['String']['input'];
  link: Scalars['String']['input'];
  imageUrl: Scalars['String']['input'];
  inAppNotification: Scalars['Boolean']['input'];
  pushNotificationChannel: Scalars['String']['input'];
  language: Scalars['String']['input'];
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type SendTestNotificationMutation = { __typename?: 'Mutation', sendTestNotification?: { __typename?: 'SendTestNotificationReturnType', success?: boolean | undefined } | undefined };

export type AllScreeningAttributesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllScreeningAttributesQuery = { __typename?: 'Query', allScreeningAttributes: Array<{ __typename?: 'ScreeningAttribute', id: string, label?: string | undefined }> };

export type SubscriptionStaticticsQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type SubscriptionStaticticsQuery = { __typename?: 'Query', subscriptionsStatistics?: { __typename?: 'SubscriptionStatisticsResponse', numberOfUsers: number, numberOfActiveSubscriptions: number, numberOfSubscriptionTickets: number, numberOfNewSubscriptions: number, canceledSubscriptions: number, numberOfUsersPerTier: Array<{ __typename?: 'TierStatistics', tierName: string, numActiveSubscribers: number }>, visitFrequency?: { __typename?: 'VisitFrequency', zero: number, one: number, two: number, three: number, four: number, five: number, sixToTen: number, elevenToTwenty: number, twentyPlus: number } | undefined, seenMovies: Array<{ __typename?: 'SeenMovies', numVisits: number, movie: { __typename?: 'Movie', id: string, title?: string | undefined, banner?: string | undefined, poster?: string | undefined, averageRating?: number | undefined } }> } | undefined };

export type PayoutInfoQueryVariables = Exact<{
  from: Scalars['Date']['input'];
  to: Scalars['Date']['input'];
}>;


export type PayoutInfoQuery = { __typename?: 'Query', payoutInfo: Array<{ __typename?: 'CinemaPayoutInfo', numOfSubscriptionTickets: number, numAdditionalTickets: number, cinema: { __typename?: 'Cinema', id: string, name?: string | undefined, city?: string | undefined } }> };

export type NewSubscriptionStatisticsQueryVariables = Exact<{
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
}>;


export type NewSubscriptionStatisticsQuery = { __typename?: 'Query', newSubscriptionStatistics: { __typename?: 'NewSubscriptionStatisticsResponse', numberOfUsers: number, numberOfActiveSubscriptions: number, subscriptionsPerMonth: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number, newCount?: number | undefined }>, subscriptionsPerWeek: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number, newCount?: number | undefined }>, subscriptionsPerDay: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number, newCount?: number | undefined }>, moviesPerDay: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number }>, moviesPerWeek: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number }>, moviesPerMonth: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number }>, ticketsUserPerDay: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number }>, ticketsUserPerWeek: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number }>, ticketsUserPerMonth: Array<{ __typename?: 'AveragePerDateStatistic', date: any, count: number }> } };

export type CinfinityCinemaStatsQueryVariables = Exact<{
  cinemaIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
}>;


export type CinfinityCinemaStatsQuery = { __typename?: 'Query', cinfinityCinemaStats: { __typename?: 'CinfinityCinemaStatsResponse', users: number, visitors: number, visits: number, additionalTickets: number, monthlyVisits: Array<{ __typename?: 'CinfinityCinemaStatsMonthly', month: string, visits: number, additionalTickets: number }> } };

export type OnlineTicketingVoucherStatsQueryVariables = Exact<{ [key: string]: never; }>;


export type OnlineTicketingVoucherStatsQuery = { __typename?: 'Query', onlineTicketingVoucherStats: Array<{ __typename?: 'OnlineTicketingVoucherStatsByCinema', cinemaId: string, cinemaName: string, cinemaCity?: string | undefined, totalVouchers: number, usedVouchers: number, freeVouchers: number }> };

export type SubscriptionTiersQueryVariables = Exact<{ [key: string]: never; }>;


export type SubscriptionTiersQuery = { __typename?: 'Query', subscriptionTiers?: Array<{ __typename?: 'SubscriptionTier', id: string, name: string, description: string, details?: string | undefined, paypalBillingPlanId: string }> | undefined };

export type ReschedulePaymentMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type ReschedulePaymentMutation = { __typename?: 'Mutation', reschedulePayment: { __typename?: 'ReschedulePaymentResponse', success: boolean } };

export type CancelSubscriptionImmediatelyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  cancellationEffectiveAtType: CancellationEffectiveAtType;
}>;


export type CancelSubscriptionImmediatelyMutation = { __typename?: 'Mutation', cancelSubscriptionImmediately: { __typename?: 'Subscription', id: string } };

export type ReactivateSubscriptionMutationVariables = Exact<{
  subscriptionId: Scalars['ID']['input'];
}>;


export type ReactivateSubscriptionMutation = { __typename?: 'Mutation', reactivateSubscription: { __typename?: 'ReactivateSubscriptionResponse', success: boolean, subscription: { __typename?: 'Subscription', id: string, validFrom?: any | undefined, payedUntil?: any | undefined, blocked?: boolean | undefined, active?: boolean | undefined, canceled?: boolean | undefined, blockedReason?: BlockedReason | undefined, blockedText?: string | undefined, paypalOrderId?: string | undefined, paypalStatus?: string | undefined, cancellationEffectiveDate?: any | undefined, adyenStatus?: string | undefined, adyenNextBillingAt?: any | undefined, provider?: string | undefined, isReactivatableAfterCancellation?: boolean | undefined, subscriptionTier: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, details?: string | undefined }, company?: { __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined } | undefined } } };

export type TargetGroupQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type TargetGroupQuery = { __typename?: 'Query', targetGroup: { __typename?: 'TargetGroup', id: string, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupSize?: number | undefined, status?: TargetGroupStatus | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }>, cinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, targetGroupFilterConfig: Array<{ __typename?: 'TargetGroupFilterConfig', name: string, showFilter: boolean }>, allVoucherClassesOfCinemaOperatingCompany: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> }>, cluster: Array<{ __typename?: 'TargetGroupCluster', id: string, position: number, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupId: string, clusterSize?: number | undefined, ageFilter?: { __typename?: 'AgeFilter', active: boolean, minAge: number, maxAge?: number | undefined } | undefined, gendersFilter?: { __typename?: 'GendersFilter', active: boolean, genders: Array<Gender> } | undefined, parentStatusFilter?: { __typename?: 'ParentStatusFilter', active: boolean, status?: ParentStatus | undefined } | undefined, longTermBenefitsReceivedFilter?: { __typename?: 'LongetermBenefitsReceivedFilter', active: boolean, status?: LongTermBenefitsStatus | undefined } | undefined, distanceFilter?: { __typename?: 'DistanceFilter', active: boolean, zipCode?: number | undefined, distanceInKm?: number | undefined } | undefined, movieAffinityFilter?: { __typename?: 'MovieAffinityFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, genreAffinityFilter?: { __typename?: 'GenreAffinityFilter', active: boolean, genres: Array<string> } | undefined, castOrCrewMemberAffinityFilter?: { __typename?: 'CastOrCrewMemberAffinityFilter', active: boolean, castOrCrewMembers: Array<{ __typename?: 'CastOrCrewMember', id: string, fullName?: string | undefined }> } | undefined, movieAttributesAffinityFilter?: { __typename?: 'MovieAttributesAffinityFilter', active: boolean, movieAttributes: Array<{ __typename?: 'ScreeningAttribute', id: string, label?: string | undefined }> } | undefined, moviesSeenFilter?: { __typename?: 'MoviesSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesNotSeenFilter?: { __typename?: 'MoviesNotSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesOnWatchListFilter?: { __typename?: 'MoviesOnWatchListFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, bonusProgramMemberStatusFilter?: { __typename?: 'BonusProgramMemberStatusFilter', active: boolean, status?: BonusProgramMemberStatus | undefined } | undefined, bonusPointsFilter?: { __typename?: 'BonusPointsFilter', active: boolean, minBonusPoints: number, maxBonusPoints?: number | undefined } | undefined, statusPointsFilter?: { __typename?: 'StatusPointsFilter', active: boolean, minStatusPoints: number, maxStatusPoints?: number | undefined } | undefined, statusLevelFilter?: { __typename?: 'StatusLevelFilter', active: boolean, minStatusLevel: number, maxStatusLevel?: number | undefined } | undefined, vouchersReceivedFilter?: { __typename?: 'VouchersReceivedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, vouchersRedeemedFilter?: { __typename?: 'VouchersRedeemedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, stickersReceivedFilter?: { __typename?: 'StickersReceivedFilter', active: boolean, stickers: Array<{ __typename?: 'Achievement', id: string, title?: string | undefined, description?: string | undefined }> } | undefined, averageCinemaVisitsFilter?: { __typename?: 'AverageCinemaVisitsFilter', active: boolean, minVisits: number, maxVisits?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, noCinemaVisitSinceFilter?: { __typename?: 'NoCinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, cinemaVisitSinceFilter?: { __typename?: 'CinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, averageGroupSizesFilter?: { __typename?: 'AverageGroupSizesFilter', active: boolean, sizes: Array<GroupSize> } | undefined }> } };

export type AllTargetGroupsByCinemaOperatingCompaniesQueryVariables = Exact<{
  cinemaOperatingCompanyIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type AllTargetGroupsByCinemaOperatingCompaniesQuery = { __typename?: 'Query', allTargetGroupsByCinemaOperatingCompanies: { __typename?: 'TargetGroupsByCinemaOperatingCompanysReturnType', targetGroups: Array<{ __typename?: 'TargetGroup', id: string, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupSize?: number | undefined, status?: TargetGroupStatus | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }>, cinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, targetGroupFilterConfig: Array<{ __typename?: 'TargetGroupFilterConfig', name: string, showFilter: boolean }>, allVoucherClassesOfCinemaOperatingCompany: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> }>, cluster: Array<{ __typename?: 'TargetGroupCluster', id: string, position: number, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupId: string, clusterSize?: number | undefined, ageFilter?: { __typename?: 'AgeFilter', active: boolean, minAge: number, maxAge?: number | undefined } | undefined, gendersFilter?: { __typename?: 'GendersFilter', active: boolean, genders: Array<Gender> } | undefined, parentStatusFilter?: { __typename?: 'ParentStatusFilter', active: boolean, status?: ParentStatus | undefined } | undefined, longTermBenefitsReceivedFilter?: { __typename?: 'LongetermBenefitsReceivedFilter', active: boolean, status?: LongTermBenefitsStatus | undefined } | undefined, distanceFilter?: { __typename?: 'DistanceFilter', active: boolean, zipCode?: number | undefined, distanceInKm?: number | undefined } | undefined, movieAffinityFilter?: { __typename?: 'MovieAffinityFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, genreAffinityFilter?: { __typename?: 'GenreAffinityFilter', active: boolean, genres: Array<string> } | undefined, castOrCrewMemberAffinityFilter?: { __typename?: 'CastOrCrewMemberAffinityFilter', active: boolean, castOrCrewMembers: Array<{ __typename?: 'CastOrCrewMember', id: string, fullName?: string | undefined }> } | undefined, movieAttributesAffinityFilter?: { __typename?: 'MovieAttributesAffinityFilter', active: boolean, movieAttributes: Array<{ __typename?: 'ScreeningAttribute', id: string, label?: string | undefined }> } | undefined, moviesSeenFilter?: { __typename?: 'MoviesSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesNotSeenFilter?: { __typename?: 'MoviesNotSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesOnWatchListFilter?: { __typename?: 'MoviesOnWatchListFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, bonusProgramMemberStatusFilter?: { __typename?: 'BonusProgramMemberStatusFilter', active: boolean, status?: BonusProgramMemberStatus | undefined } | undefined, bonusPointsFilter?: { __typename?: 'BonusPointsFilter', active: boolean, minBonusPoints: number, maxBonusPoints?: number | undefined } | undefined, statusPointsFilter?: { __typename?: 'StatusPointsFilter', active: boolean, minStatusPoints: number, maxStatusPoints?: number | undefined } | undefined, statusLevelFilter?: { __typename?: 'StatusLevelFilter', active: boolean, minStatusLevel: number, maxStatusLevel?: number | undefined } | undefined, vouchersReceivedFilter?: { __typename?: 'VouchersReceivedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, vouchersRedeemedFilter?: { __typename?: 'VouchersRedeemedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, stickersReceivedFilter?: { __typename?: 'StickersReceivedFilter', active: boolean, stickers: Array<{ __typename?: 'Achievement', id: string, title?: string | undefined, description?: string | undefined }> } | undefined, averageCinemaVisitsFilter?: { __typename?: 'AverageCinemaVisitsFilter', active: boolean, minVisits: number, maxVisits?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, noCinemaVisitSinceFilter?: { __typename?: 'NoCinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, cinemaVisitSinceFilter?: { __typename?: 'CinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, averageGroupSizesFilter?: { __typename?: 'AverageGroupSizesFilter', active: boolean, sizes: Array<GroupSize> } | undefined }> }> } };

export type SaveTargetGroupMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  cluster: Array<TargetGroupClusterInput> | TargetGroupClusterInput;
}>;


export type SaveTargetGroupMutation = { __typename?: 'Mutation', editTargetGroup: { __typename?: 'EditTargetGroupReturnType', targetGroup?: { __typename?: 'TargetGroup', id: string, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupSize?: number | undefined, status?: TargetGroupStatus | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }>, cinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, targetGroupFilterConfig: Array<{ __typename?: 'TargetGroupFilterConfig', name: string, showFilter: boolean }>, allVoucherClassesOfCinemaOperatingCompany: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> }>, cluster: Array<{ __typename?: 'TargetGroupCluster', id: string, position: number, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupId: string, clusterSize?: number | undefined, ageFilter?: { __typename?: 'AgeFilter', active: boolean, minAge: number, maxAge?: number | undefined } | undefined, gendersFilter?: { __typename?: 'GendersFilter', active: boolean, genders: Array<Gender> } | undefined, parentStatusFilter?: { __typename?: 'ParentStatusFilter', active: boolean, status?: ParentStatus | undefined } | undefined, longTermBenefitsReceivedFilter?: { __typename?: 'LongetermBenefitsReceivedFilter', active: boolean, status?: LongTermBenefitsStatus | undefined } | undefined, distanceFilter?: { __typename?: 'DistanceFilter', active: boolean, zipCode?: number | undefined, distanceInKm?: number | undefined } | undefined, movieAffinityFilter?: { __typename?: 'MovieAffinityFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, genreAffinityFilter?: { __typename?: 'GenreAffinityFilter', active: boolean, genres: Array<string> } | undefined, castOrCrewMemberAffinityFilter?: { __typename?: 'CastOrCrewMemberAffinityFilter', active: boolean, castOrCrewMembers: Array<{ __typename?: 'CastOrCrewMember', id: string, fullName?: string | undefined }> } | undefined, movieAttributesAffinityFilter?: { __typename?: 'MovieAttributesAffinityFilter', active: boolean, movieAttributes: Array<{ __typename?: 'ScreeningAttribute', id: string, label?: string | undefined }> } | undefined, moviesSeenFilter?: { __typename?: 'MoviesSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesNotSeenFilter?: { __typename?: 'MoviesNotSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesOnWatchListFilter?: { __typename?: 'MoviesOnWatchListFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, bonusProgramMemberStatusFilter?: { __typename?: 'BonusProgramMemberStatusFilter', active: boolean, status?: BonusProgramMemberStatus | undefined } | undefined, bonusPointsFilter?: { __typename?: 'BonusPointsFilter', active: boolean, minBonusPoints: number, maxBonusPoints?: number | undefined } | undefined, statusPointsFilter?: { __typename?: 'StatusPointsFilter', active: boolean, minStatusPoints: number, maxStatusPoints?: number | undefined } | undefined, statusLevelFilter?: { __typename?: 'StatusLevelFilter', active: boolean, minStatusLevel: number, maxStatusLevel?: number | undefined } | undefined, vouchersReceivedFilter?: { __typename?: 'VouchersReceivedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, vouchersRedeemedFilter?: { __typename?: 'VouchersRedeemedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, stickersReceivedFilter?: { __typename?: 'StickersReceivedFilter', active: boolean, stickers: Array<{ __typename?: 'Achievement', id: string, title?: string | undefined, description?: string | undefined }> } | undefined, averageCinemaVisitsFilter?: { __typename?: 'AverageCinemaVisitsFilter', active: boolean, minVisits: number, maxVisits?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, noCinemaVisitSinceFilter?: { __typename?: 'NoCinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, cinemaVisitSinceFilter?: { __typename?: 'CinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, averageGroupSizesFilter?: { __typename?: 'AverageGroupSizesFilter', active: boolean, sizes: Array<GroupSize> } | undefined }> } | undefined } };

export type CreateTargetGroupMutationVariables = Exact<{
  name: Scalars['String']['input'];
  cinemaIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type CreateTargetGroupMutation = { __typename?: 'Mutation', result: { __typename?: 'CreateTargetGroupReturnType', targetGroup?: { __typename?: 'TargetGroup', id: string } | undefined } };

export type DeleteTargetGroupsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type DeleteTargetGroupsMutation = { __typename?: 'Mutation', result?: { __typename?: 'DeleteTargetGroupReturnType', success?: boolean | undefined } | undefined };

export type UpdateTargetGroupsStatusMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  newStatus: UpdatedTargetGroupStatus;
}>;


export type UpdateTargetGroupsStatusMutation = { __typename?: 'Mutation', updateTargetGroupsStatus?: { __typename?: 'UpdateTargetGroupsStatusReturnType', targetGroups: Array<{ __typename?: 'TargetGroup', id: string, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupSize?: number | undefined, status?: TargetGroupStatus | undefined, cinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined }>, cinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, targetGroupFilterConfig: Array<{ __typename?: 'TargetGroupFilterConfig', name: string, showFilter: boolean }>, allVoucherClassesOfCinemaOperatingCompany: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> }>, cluster: Array<{ __typename?: 'TargetGroupCluster', id: string, position: number, name?: string | undefined, createdDatetime?: any | undefined, lastEditedDatetime?: any | undefined, targetGroupId: string, clusterSize?: number | undefined, ageFilter?: { __typename?: 'AgeFilter', active: boolean, minAge: number, maxAge?: number | undefined } | undefined, gendersFilter?: { __typename?: 'GendersFilter', active: boolean, genders: Array<Gender> } | undefined, parentStatusFilter?: { __typename?: 'ParentStatusFilter', active: boolean, status?: ParentStatus | undefined } | undefined, longTermBenefitsReceivedFilter?: { __typename?: 'LongetermBenefitsReceivedFilter', active: boolean, status?: LongTermBenefitsStatus | undefined } | undefined, distanceFilter?: { __typename?: 'DistanceFilter', active: boolean, zipCode?: number | undefined, distanceInKm?: number | undefined } | undefined, movieAffinityFilter?: { __typename?: 'MovieAffinityFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, genreAffinityFilter?: { __typename?: 'GenreAffinityFilter', active: boolean, genres: Array<string> } | undefined, castOrCrewMemberAffinityFilter?: { __typename?: 'CastOrCrewMemberAffinityFilter', active: boolean, castOrCrewMembers: Array<{ __typename?: 'CastOrCrewMember', id: string, fullName?: string | undefined }> } | undefined, movieAttributesAffinityFilter?: { __typename?: 'MovieAttributesAffinityFilter', active: boolean, movieAttributes: Array<{ __typename?: 'ScreeningAttribute', id: string, label?: string | undefined }> } | undefined, moviesSeenFilter?: { __typename?: 'MoviesSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesNotSeenFilter?: { __typename?: 'MoviesNotSeenFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, moviesOnWatchListFilter?: { __typename?: 'MoviesOnWatchListFilter', active: boolean, movies: Array<{ __typename?: 'Movie', title?: string | undefined, id: string }> } | undefined, bonusProgramMemberStatusFilter?: { __typename?: 'BonusProgramMemberStatusFilter', active: boolean, status?: BonusProgramMemberStatus | undefined } | undefined, bonusPointsFilter?: { __typename?: 'BonusPointsFilter', active: boolean, minBonusPoints: number, maxBonusPoints?: number | undefined } | undefined, statusPointsFilter?: { __typename?: 'StatusPointsFilter', active: boolean, minStatusPoints: number, maxStatusPoints?: number | undefined } | undefined, statusLevelFilter?: { __typename?: 'StatusLevelFilter', active: boolean, minStatusLevel: number, maxStatusLevel?: number | undefined } | undefined, vouchersReceivedFilter?: { __typename?: 'VouchersReceivedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, vouchersRedeemedFilter?: { __typename?: 'VouchersRedeemedFilter', active: boolean, vouchers: Array<{ __typename?: 'VoucherClass', id: string, title?: string | undefined }> } | undefined, stickersReceivedFilter?: { __typename?: 'StickersReceivedFilter', active: boolean, stickers: Array<{ __typename?: 'Achievement', id: string, title?: string | undefined, description?: string | undefined }> } | undefined, averageCinemaVisitsFilter?: { __typename?: 'AverageCinemaVisitsFilter', active: boolean, minVisits: number, maxVisits?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, noCinemaVisitSinceFilter?: { __typename?: 'NoCinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, cinemaVisitSinceFilter?: { __typename?: 'CinemaVisitSinceFilter', active: boolean, amount?: number | undefined, timePeriod?: TimePeriod | undefined } | undefined, averageGroupSizesFilter?: { __typename?: 'AverageGroupSizesFilter', active: boolean, sizes: Array<GroupSize> } | undefined }> }> } | undefined };

export type UpdateTicketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  scanned: Scalars['Boolean']['input'];
}>;


export type UpdateTicketMutation = { __typename?: 'Mutation', updateTicket?: { __typename?: 'Ticket', id: string, boughtAt?: any | undefined, status: TicketStatus, refundedAt?: any | undefined, onlineTicketingId?: string | undefined, isFlatrateTicket?: boolean | undefined, qrCode?: string | undefined, auditoriumName?: string | undefined, scanned?: boolean | undefined, refundable: boolean, cancelationLink?: string | undefined, screening: { __typename?: 'Screening', id: string, datetime?: any | undefined, movie?: { __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined } | undefined, cinema?: { __typename?: 'Cinema', name?: string | undefined } | undefined }, seats: Array<{ __typename?: 'Seat', seatName?: string | undefined, rowName: string }> } | undefined };

export type SyncTicketMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncTicketMutation = { __typename?: 'Mutation', syncTicket?: { __typename?: 'Ticket', id: string, boughtAt?: any | undefined, status: TicketStatus, refundedAt?: any | undefined, onlineTicketingId?: string | undefined, isFlatrateTicket?: boolean | undefined, qrCode?: string | undefined, auditoriumName?: string | undefined, scanned?: boolean | undefined, refundable: boolean, cancelationLink?: string | undefined, screening: { __typename?: 'Screening', id: string, datetime?: any | undefined, movie?: { __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined } | undefined, cinema?: { __typename?: 'Cinema', name?: string | undefined } | undefined }, seats: Array<{ __typename?: 'Seat', seatName?: string | undefined, rowName: string }> } | undefined };

export type CancelTicketMutationVariables = Exact<{
  ticketId: Scalars['ID']['input'];
}>;


export type CancelTicketMutation = { __typename?: 'Mutation', cancelTicket?: { __typename?: 'CancelTicketReturnType', canceledTicket?: { __typename?: 'Ticket', id: string, status: TicketStatus, screening: { __typename?: 'Screening', id: string, movie?: { __typename?: 'Movie', title?: string | undefined, id: string } | undefined } } | undefined, user?: { __typename?: 'User', id: string, name?: string | undefined } | undefined } | undefined };

export type PrivilegesQueryVariables = Exact<{ [key: string]: never; }>;


export type PrivilegesQuery = { __typename?: 'Query', user?: { __typename?: 'User', id: string, name?: string | undefined, email?: string | undefined, privileges: { __typename?: 'UserPrivileges', accessRightDashboard: boolean, accessRightFilmStatistics: boolean, accessRightBonusProgram: boolean, accessRightCampaigns: boolean, adminRole: boolean, rootRole: boolean, supportRole: boolean, contentEditorRole: boolean, canEditContent: boolean, canEditBonusPrograms: boolean, adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, accessRestrictedTo: AccessRestriction, city?: string | undefined, clusters: Array<string> }>, adminForBonusPrograms: Array<{ __typename?: 'BonusProgram', id: string }>, belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined, accessRightDashboard?: boolean | undefined, accessRightFilmStatistics?: boolean | undefined, accessRightBonusProgram?: boolean | undefined, accessRightCampaigning?: boolean | undefined, cinemas: Array<{ __typename?: 'AssociatedCinema', id: string, name: string }>, associatedUsers: Array<{ __typename?: 'User', id: string, fullName?: string | undefined, email?: string | undefined }> }> } } | undefined };

export type LogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type LogoutMutation = { __typename?: 'Mutation', logout?: { __typename?: 'LogoutReturnType', success?: boolean | undefined } | undefined };

export type UpdateUserMutationVariables = Exact<{
  userId: Scalars['ID']['input'];
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  blockedText?: InputMaybe<Scalars['String']['input']>;
  firstname?: InputMaybe<Scalars['String']['input']>;
  lastname?: InputMaybe<Scalars['String']['input']>;
  street?: InputMaybe<Scalars['String']['input']>;
  houseNumber?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  adminCinemaOperatingCompanyIds?: InputMaybe<Array<Scalars['ID']['input']> | Scalars['ID']['input']>;
  resetAppChangeBlockedUntil?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UpdateUserMutation = { __typename?: 'Mutation', updateUser: { __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined, street?: string | undefined, houseNumber?: string | undefined, zipCode?: string | undefined, city?: string | undefined, email?: string | undefined, blocked: boolean, blockedText?: string | undefined, invoices: Array<{ __typename?: 'Invoice', id: string, priceInCents: number, date: any, url: string }>, linkedAccounts: Array<{ __typename?: 'LinkedAccount', id: string, userId: string, username: string, email?: string | undefined, acceptedDatetime?: any | undefined, status: LinkedAccountStatus }>, subscriptions: Array<{ __typename?: 'Subscription', id: string, validFrom?: any | undefined, payedUntil?: any | undefined, blocked?: boolean | undefined, active?: boolean | undefined, canceled?: boolean | undefined, blockedReason?: BlockedReason | undefined, blockedText?: string | undefined, paypalOrderId?: string | undefined, paypalStatus?: string | undefined, cancellationEffectiveDate?: any | undefined, adyenStatus?: string | undefined, adyenNextBillingAt?: any | undefined, provider?: string | undefined, isReactivatableAfterCancellation?: boolean | undefined, subscriptionTier: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, details?: string | undefined }, company?: { __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined } | undefined }>, tickets: Array<{ __typename?: 'Ticket', id: string, boughtAt?: any | undefined, status: TicketStatus, refundedAt?: any | undefined, onlineTicketingId?: string | undefined, isFlatrateTicket?: boolean | undefined, qrCode?: string | undefined, auditoriumName?: string | undefined, scanned?: boolean | undefined, refundable: boolean, cancelationLink?: string | undefined, screening: { __typename?: 'Screening', id: string, datetime?: any | undefined, movie?: { __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined } | undefined, cinema?: { __typename?: 'Cinema', name?: string | undefined } | undefined }, seats: Array<{ __typename?: 'Seat', seatName?: string | undefined, rowName: string }> }>, privileges: { __typename?: 'UserPrivileges', contentEditorRole: boolean, adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, accessRestrictedTo: AccessRestriction, city?: string | undefined, clusters: Array<string> }>, belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined }> }, vouchers: Array<{ __typename?: 'VoucherInstance', id: string, reason?: string | undefined, valid?: boolean | undefined, qrCode?: string | undefined, redeemedDatetime?: any | undefined, createdDatetime?: any | undefined, user?: { __typename?: 'User', email?: string | undefined, fullName?: string | undefined } | undefined, voucherClass?: { __typename?: 'VoucherClass', id: string, title?: string | undefined } | undefined, company?: { __typename?: 'Company', id: string, name: string, logo: string } | undefined }> } };

export type UserByIdQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UserByIdQuery = { __typename?: 'Query', userById?: { __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined, street?: string | undefined, houseNumber?: string | undefined, zipCode?: string | undefined, city?: string | undefined, email?: string | undefined, blocked: boolean, blockedText?: string | undefined, invoices: Array<{ __typename?: 'Invoice', id: string, priceInCents: number, date: any, url: string }>, linkedAccounts: Array<{ __typename?: 'LinkedAccount', id: string, userId: string, username: string, email?: string | undefined, acceptedDatetime?: any | undefined, status: LinkedAccountStatus }>, subscriptions: Array<{ __typename?: 'Subscription', id: string, validFrom?: any | undefined, payedUntil?: any | undefined, blocked?: boolean | undefined, active?: boolean | undefined, canceled?: boolean | undefined, blockedReason?: BlockedReason | undefined, blockedText?: string | undefined, paypalOrderId?: string | undefined, paypalStatus?: string | undefined, cancellationEffectiveDate?: any | undefined, adyenStatus?: string | undefined, adyenNextBillingAt?: any | undefined, provider?: string | undefined, isReactivatableAfterCancellation?: boolean | undefined, subscriptionTier: { __typename?: 'SubscriptionTier', id: string, name: string, description: string, details?: string | undefined }, company?: { __typename?: 'Company', id: string, name: string, logo: string, numericalID?: number | undefined } | undefined }>, tickets: Array<{ __typename?: 'Ticket', id: string, boughtAt?: any | undefined, status: TicketStatus, refundedAt?: any | undefined, onlineTicketingId?: string | undefined, isFlatrateTicket?: boolean | undefined, qrCode?: string | undefined, auditoriumName?: string | undefined, scanned?: boolean | undefined, refundable: boolean, cancelationLink?: string | undefined, screening: { __typename?: 'Screening', id: string, datetime?: any | undefined, movie?: { __typename?: 'Movie', id: string, title?: string | undefined, poster?: string | undefined } | undefined, cinema?: { __typename?: 'Cinema', name?: string | undefined } | undefined }, seats: Array<{ __typename?: 'Seat', seatName?: string | undefined, rowName: string }> }>, privileges: { __typename?: 'UserPrivileges', contentEditorRole: boolean, adminForCinemas: Array<{ __typename?: 'Cinema', id: string, name?: string | undefined, accessRestrictedTo: AccessRestriction, city?: string | undefined, clusters: Array<string> }>, belongsToCinemaOperatingCompanies: Array<{ __typename?: 'CinemaOperatingCompany', id: string, name?: string | undefined }> }, vouchers: Array<{ __typename?: 'VoucherInstance', id: string, reason?: string | undefined, valid?: boolean | undefined, qrCode?: string | undefined, redeemedDatetime?: any | undefined, createdDatetime?: any | undefined, user?: { __typename?: 'User', email?: string | undefined, fullName?: string | undefined } | undefined, voucherClass?: { __typename?: 'VoucherClass', id: string, title?: string | undefined } | undefined, company?: { __typename?: 'Company', id: string, name: string, logo: string } | undefined }> } | undefined };

export type UpdateUserSubscriptionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  blocked: Scalars['Boolean']['input'];
  blockedText?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateUserSubscriptionMutation = { __typename?: 'Mutation', updateUserSubscription: { __typename?: 'Subscription', id: string } };

export type SearchUsersTotalQueryVariables = Exact<{
  queryText?: InputMaybe<Scalars['String']['input']>;
  filterActiveSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SearchUsersTotalQuery = { __typename?: 'Query', searchUsersTotal: number };

export type SearchUsersQueryVariables = Exact<{
  queryText?: InputMaybe<Scalars['String']['input']>;
  filterActiveSubscriptions?: InputMaybe<Scalars['Boolean']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchUsersQuery = { __typename?: 'Query', searchUsers: Array<{ __typename?: 'User', id: string, firstName?: string | undefined, lastName?: string | undefined, email?: string | undefined, telephone?: string | undefined, country?: string | undefined, blocked: boolean, privileges: { __typename?: 'UserPrivileges', contentEditorRole: boolean, adminForCinemas: Array<{ __typename?: 'Cinema', id: string }> } }> };

export type CreateVouchersMutationVariables = Exact<{
  voucherClassId: Scalars['ID']['input'];
  companyId?: InputMaybe<Scalars['ID']['input']>;
  numberOfVouchers: Scalars['Int']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  validUntil?: InputMaybe<Scalars['Date']['input']>;
}>;


export type CreateVouchersMutation = { __typename?: 'Mutation', createVoucherInstances: Array<{ __typename?: 'VoucherInstance', id: string, reason?: string | undefined, valid?: boolean | undefined, qrCode?: string | undefined, redeemedDatetime?: any | undefined, createdDatetime?: any | undefined, user?: { __typename?: 'User', email?: string | undefined, fullName?: string | undefined } | undefined, voucherClass?: { __typename?: 'VoucherClass', id: string, title?: string | undefined } | undefined, company?: { __typename?: 'Company', id: string, name: string, logo: string } | undefined }> };

export type GetVoucherInstanceQueryVariables = Exact<{
  qrCode: Scalars['String']['input'];
}>;


export type GetVoucherInstanceQuery = { __typename?: 'Query', voucherInstanceByQR?: { __typename?: 'VoucherInstance', id: string, reason?: string | undefined, valid?: boolean | undefined, qrCode?: string | undefined, redeemedDatetime?: any | undefined, createdDatetime?: any | undefined, user?: { __typename?: 'User', email?: string | undefined, fullName?: string | undefined } | undefined, voucherClass?: { __typename?: 'VoucherClass', id: string, title?: string | undefined } | undefined, company?: { __typename?: 'Company', id: string, name: string, logo: string } | undefined } | undefined };

export type GetVoucherInstancesByOrderNumberQueryVariables = Exact<{
  orderNumber: Scalars['String']['input'];
}>;


export type GetVoucherInstancesByOrderNumberQuery = { __typename?: 'Query', voucherInstancesByOrderNumber: Array<{ __typename?: 'VoucherInstance', id: string, reason?: string | undefined, valid?: boolean | undefined, qrCode?: string | undefined, redeemedDatetime?: any | undefined, createdDatetime?: any | undefined, user?: { __typename?: 'User', email?: string | undefined, fullName?: string | undefined } | undefined, voucherClass?: { __typename?: 'VoucherClass', id: string, title?: string | undefined } | undefined, company?: { __typename?: 'Company', id: string, name: string, logo: string } | undefined }> };

export type UpdateVoucherInstanceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  isValid: Scalars['Boolean']['input'];
}>;


export type UpdateVoucherInstanceMutation = { __typename?: 'Mutation', updateVoucherInstance?: { __typename?: 'VoucherInstance', id: string, reason?: string | undefined, valid?: boolean | undefined, qrCode?: string | undefined, redeemedDatetime?: any | undefined, createdDatetime?: any | undefined, user?: { __typename?: 'User', email?: string | undefined, fullName?: string | undefined } | undefined, voucherClass?: { __typename?: 'VoucherClass', id: string, title?: string | undefined } | undefined, company?: { __typename?: 'Company', id: string, name: string, logo: string } | undefined } | undefined };

export const CinemaClusterTableFragmentDoc = gql`
    fragment CinemaClusterTable on CinemaCluster {
  id
  name
  position
}
    `;
export const CinemaClusterDetailsFragmentDoc = gql`
    fragment CinemaClusterDetails on CinemaCluster {
  id
  name
  position
  cinemas {
    id
  }
}
    `;
export const MovieEditorialTodoQueueFragmentDoc = gql`
    fragment MovieEditorialTodoQueue on MovieEditorialTodoQueue {
  type
  total
  items {
    id
    title
    movieId
    cinemaId
    cinemaName
    lastEdit
    date
    foreignId
    foreignIdType
  }
}
    `;
export const ForeignMovieIdentifierListingFragmentDoc = gql`
    fragment ForeignMovieIdentifierListing on ForeignMovieIdentifier {
  id
  foreignIdType
  title
  currentMovie {
    id
    title
  }
  forCinema {
    id
    name
  }
  onlineTicketingUrl
}
    `;
export const BeaconFragmentDoc = gql`
    fragment BeaconFragment on Beacon {
  id
  instanceId
  lastUpdated
  lastScan
  cinema {
    id
    name
  }
  comments
  lastBatteryChange
}
    `;
export const CampaignDataFragmentDoc = gql`
    fragment campaignDataFragment on Campaign {
  id
  trigger
  name
  type
  channels
  message
  messageTitle
  messageImage
  link
  status
  cinemas {
    id
    name
    bonusProgram {
      id
    }
  }
  language {
    id
    url
    foreignIdType
    programUrl
    trailerAutoplay
  }
  emailContent
  sendingTime
  sendingDate
  startDate
  endDate
  startTime
  endTime
  timeUnit
  timeUnitFactor
  numberOfIntervals
  intervalEndType
  eventType
  emailSubject
  targetGroupIds
  triggerThreshold
}
    `;
export const CinemaDetailsFragmentDoc = gql`
    fragment CinemaDetailsFragment on Cinema {
  id
  name
  logo
  claim
  hasBonusProgram
  headerImage
  imprint
  technologies
  history
  currentInformation
  specialAboutUs
  onlineTicketingBaseUrl
  street
  houseNumber
  zipCode
  city
  parkingDescription
  locationDescription
  location {
    latitude
    longitude
  }
  googleMapsLink
  appleMapsLink
  phone
  facebook
  twitter
  website
  email
  instagram
  barrierFree
  barrierFreeText
  hearingImpaired
  hearingImpairedText
  brands
  blind
  blindText
  openingHoursDisplay {
    weekdays
    hours
  }
  pricesDisplay {
    title
    price
    description
  }
  specialOffersDisplay {
    title
    image
    description
    price
  }
  giftVouchersDisplay {
    title
    image
    description
    price
  }
  sneaksDisplay {
    description
    title
    price
    image
  }
  additionalInfoSections {
    title
    description
  }
  accessRestrictedTo
}
    `;
export const MovieInfoFragmentDoc = gql`
    fragment MovieInfoFragment on Movie {
  id
  title
  poster
  banner
  directedBy
  releaseDate
}
    `;
export const TargetGroupDataFragmentDoc = gql`
    fragment targetGroupDataFragment on TargetGroup {
  id
  name
  createdDatetime
  lastEditedDatetime
  cinemas {
    id
    name
  }
  cinemaOperatingCompanies {
    id
    targetGroupFilterConfig {
      name
      showFilter
    }
    allVoucherClassesOfCinemaOperatingCompany {
      id
      title
    }
  }
  targetGroupSize
  status
  cluster {
    id
    position
    name
    createdDatetime
    lastEditedDatetime
    targetGroupId
    clusterSize
    ageFilter {
      active
      minAge
      maxAge
    }
    gendersFilter {
      active
      genders
    }
    parentStatusFilter {
      active
      status
    }
    longTermBenefitsReceivedFilter {
      active
      status
    }
    distanceFilter {
      active
      zipCode
      distanceInKm
    }
    movieAffinityFilter {
      active
      movies {
        id
        title
      }
    }
    genreAffinityFilter {
      active
      genres
    }
    castOrCrewMemberAffinityFilter {
      active
      castOrCrewMembers {
        id
        fullName
      }
    }
    movieAttributesAffinityFilter {
      active
      movieAttributes {
        id
        label
      }
    }
    moviesSeenFilter {
      active
      movies {
        id
        title
      }
    }
    moviesNotSeenFilter {
      active
      movies {
        id
        title
      }
    }
    moviesOnWatchListFilter {
      active
      movies {
        id
        title
      }
    }
    bonusProgramMemberStatusFilter {
      active
      status
    }
    bonusPointsFilter {
      active
      minBonusPoints
      maxBonusPoints
    }
    statusPointsFilter {
      active
      minStatusPoints
      maxStatusPoints
    }
    statusLevelFilter {
      active
      minStatusLevel
      maxStatusLevel
    }
    vouchersReceivedFilter {
      active
      vouchers {
        id
        title
      }
    }
    vouchersRedeemedFilter {
      active
      vouchers {
        id
        title
      }
    }
    stickersReceivedFilter {
      active
      stickers {
        id
        title
        description
      }
    }
    averageCinemaVisitsFilter {
      active
      minVisits
      maxVisits
      timePeriod
    }
    noCinemaVisitSinceFilter {
      active
      amount
      timePeriod
    }
    cinemaVisitSinceFilter {
      active
      amount
      timePeriod
    }
    averageGroupSizesFilter {
      active
      sizes
    }
  }
}
    `;
export const CinemaFragmentDoc = gql`
    fragment CinemaFragment on Cinema {
  id
  name
  accessRestrictedTo
  city
  clusters
}
    `;
export const CinemaOperatingCompanyFragmentDoc = gql`
    fragment cinemaOperatingCompanyFragment on CinemaOperatingCompany {
  id
  name
  accessRightDashboard
  accessRightFilmStatistics
  accessRightBonusProgram
  accessRightCampaigning
  cinemas {
    id
    name
  }
  associatedUsers {
    id
    fullName
    email
  }
}
    `;
export const UserFragmentDoc = gql`
    fragment UserFragment on User {
  id
  name
  email
  privileges {
    accessRightDashboard
    accessRightFilmStatistics
    accessRightBonusProgram
    accessRightCampaigns
    adminForCinemas {
      ...CinemaFragment
    }
    adminForBonusPrograms {
      id
    }
    adminRole
    rootRole
    supportRole
    contentEditorRole
    canEditContent
    canEditBonusPrograms
    belongsToCinemaOperatingCompanies {
      ...cinemaOperatingCompanyFragment
    }
  }
}
    `;
export const CompanyFragmentDoc = gql`
    fragment companyFragment on Company {
  id
  name
  logo
  numericalID
}
    `;
export const SubscriptionDetailFragmentDoc = gql`
    fragment SubscriptionDetailFragment on Subscription {
  id
  subscriptionTier {
    id
    name
    description
    details
  }
  company {
    ...companyFragment
  }
  validFrom
  payedUntil
  blocked
  active
  canceled
  blockedReason
  blockedText
  paypalOrderId
  paypalStatus
  cancellationEffectiveDate
  adyenStatus
  adyenNextBillingAt
  provider
  isReactivatableAfterCancellation
}
    `;
export const TicketDetailsFragmentDoc = gql`
    fragment TicketDetails on Ticket {
  id
  screening {
    id
    movie {
      id
      title
      poster
    }
    datetime
    cinema {
      name
    }
  }
  boughtAt
  status
  refundedAt
  onlineTicketingId
  isFlatrateTicket
  qrCode
  auditoriumName
  seats {
    seatName
    rowName
  }
  scanned
  refundable
  cancelationLink
}
    `;
export const VoucherInstanceFragmentDoc = gql`
    fragment VoucherInstanceFragment on VoucherInstance {
  id
  user {
    email
    fullName
  }
  voucherClass {
    id
    title
  }
  company {
    id
    name
    logo
  }
  reason
  valid
  qrCode
  redeemedDatetime
  createdDatetime
}
    `;
export const UserDetailsFragmentDoc = gql`
    fragment UserDetails on User {
  id
  firstName
  lastName
  street
  houseNumber
  zipCode
  city
  email
  blocked
  blockedText
  invoices {
    id
    priceInCents
    date
    url
  }
  linkedAccounts {
    id
    userId
    username
    email
    acceptedDatetime
    status
  }
  subscriptions {
    ...SubscriptionDetailFragment
  }
  tickets {
    ...TicketDetails
  }
  privileges {
    contentEditorRole
    adminForCinemas {
      ...CinemaFragment
    }
    belongsToCinemaOperatingCompanies {
      id
      name
    }
  }
  vouchers(onlyRedeemed: false) {
    ...VoucherInstanceFragment
  }
}
    `;
export const BonusProgramSelectFieldOptionsDocument = gql`
    query BonusProgramSelectFieldOptions {
  currentUser {
    id
    privileges {
      adminForBonusPrograms {
        id
        name
      }
    }
  }
}
    `;
export type BonusProgramSelectFieldOptionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>
    } & TChildProps;
export function withBonusProgramSelectFieldOptions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BonusProgramSelectFieldOptionsQuery,
  BonusProgramSelectFieldOptionsQueryVariables,
  BonusProgramSelectFieldOptionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables, BonusProgramSelectFieldOptionsProps<TChildProps, TDataName>>(BonusProgramSelectFieldOptionsDocument, {
      alias: 'bonusProgramSelectFieldOptions',
      ...operationOptions
    });
};

/**
 * __useBonusProgramSelectFieldOptionsQuery__
 *
 * To run a query within a React component, call `useBonusProgramSelectFieldOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusProgramSelectFieldOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusProgramSelectFieldOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBonusProgramSelectFieldOptionsQuery(baseOptions?: Apollo.QueryHookOptions<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>(BonusProgramSelectFieldOptionsDocument, options);
      }
export function useBonusProgramSelectFieldOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>(BonusProgramSelectFieldOptionsDocument, options);
        }
export function useBonusProgramSelectFieldOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>(BonusProgramSelectFieldOptionsDocument, options);
        }
export type BonusProgramSelectFieldOptionsQueryHookResult = ReturnType<typeof useBonusProgramSelectFieldOptionsQuery>;
export type BonusProgramSelectFieldOptionsLazyQueryHookResult = ReturnType<typeof useBonusProgramSelectFieldOptionsLazyQuery>;
export type BonusProgramSelectFieldOptionsSuspenseQueryHookResult = ReturnType<typeof useBonusProgramSelectFieldOptionsSuspenseQuery>;
export type BonusProgramSelectFieldOptionsQueryResult = Apollo.QueryResult<BonusProgramSelectFieldOptionsQuery, BonusProgramSelectFieldOptionsQueryVariables>;
export const CurrentUserCinemasDocument = gql`
    query CurrentUserCinemas {
  user: currentUser {
    id
    privileges {
      adminForCinemas {
        id
        name
      }
    }
  }
}
    `;
export type CurrentUserCinemasProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>
    } & TChildProps;
export function withCurrentUserCinemas<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserCinemasQuery,
  CurrentUserCinemasQueryVariables,
  CurrentUserCinemasProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables, CurrentUserCinemasProps<TChildProps, TDataName>>(CurrentUserCinemasDocument, {
      alias: 'currentUserCinemas',
      ...operationOptions
    });
};

/**
 * __useCurrentUserCinemasQuery__
 *
 * To run a query within a React component, call `useCurrentUserCinemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCinemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCinemasQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCinemasQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>(CurrentUserCinemasDocument, options);
      }
export function useCurrentUserCinemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>(CurrentUserCinemasDocument, options);
        }
export function useCurrentUserCinemasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>(CurrentUserCinemasDocument, options);
        }
export type CurrentUserCinemasQueryHookResult = ReturnType<typeof useCurrentUserCinemasQuery>;
export type CurrentUserCinemasLazyQueryHookResult = ReturnType<typeof useCurrentUserCinemasLazyQuery>;
export type CurrentUserCinemasSuspenseQueryHookResult = ReturnType<typeof useCurrentUserCinemasSuspenseQuery>;
export type CurrentUserCinemasQueryResult = Apollo.QueryResult<CurrentUserCinemasQuery, CurrentUserCinemasQueryVariables>;
export const SearchUsersOldDocument = gql`
    query searchUsersOld($queryText: String!) {
  users: searchUsers(queryText: $queryText) {
    id
    name
    email
  }
}
    `;
export type SearchUsersOldProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchUsersOldQuery, SearchUsersOldQueryVariables>
    } & TChildProps;
export function withSearchUsersOld<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchUsersOldQuery,
  SearchUsersOldQueryVariables,
  SearchUsersOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchUsersOldQuery, SearchUsersOldQueryVariables, SearchUsersOldProps<TChildProps, TDataName>>(SearchUsersOldDocument, {
      alias: 'searchUsersOld',
      ...operationOptions
    });
};

/**
 * __useSearchUsersOldQuery__
 *
 * To run a query within a React component, call `useSearchUsersOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersOldQuery({
 *   variables: {
 *      queryText: // value for 'queryText'
 *   },
 * });
 */
export function useSearchUsersOldQuery(baseOptions: Apollo.QueryHookOptions<SearchUsersOldQuery, SearchUsersOldQueryVariables> & ({ variables: SearchUsersOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersOldQuery, SearchUsersOldQueryVariables>(SearchUsersOldDocument, options);
      }
export function useSearchUsersOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersOldQuery, SearchUsersOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersOldQuery, SearchUsersOldQueryVariables>(SearchUsersOldDocument, options);
        }
export function useSearchUsersOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersOldQuery, SearchUsersOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersOldQuery, SearchUsersOldQueryVariables>(SearchUsersOldDocument, options);
        }
export type SearchUsersOldQueryHookResult = ReturnType<typeof useSearchUsersOldQuery>;
export type SearchUsersOldLazyQueryHookResult = ReturnType<typeof useSearchUsersOldLazyQuery>;
export type SearchUsersOldSuspenseQueryHookResult = ReturnType<typeof useSearchUsersOldSuspenseQuery>;
export type SearchUsersOldQueryResult = Apollo.QueryResult<SearchUsersOldQuery, SearchUsersOldQueryVariables>;
export const ContentSectionListEditorDocument = gql`
    query ContentSectionListEditor($id: ID!) {
  contentSectionList(id: $id) {
    id
    title
    listDisplayType: displayType
    headerImage
    headerImageHeight
    sections {
      __typename
      id
      ... on ContentSectionList {
        title
        listDisplayType: displayType
        headerImage
        headerImageHeight
        sections {
          __typename
          id
          ... on ContentSectionList {
            title
            listDisplayType: displayType
            headerImage
            headerImageHeight
          }
          ... on ExitPollSection {
            screening {
              id
            }
          }
          ... on FeaturedMovieSection {
            description
            title
            movie {
              id
            }
          }
          ... on AppFeedbackSection {
            id
          }
          ... on CurrentTicketsSection {
            tickets {
              id
            }
          }
          ... on CurrentOrdersSection {
            orders {
              id
            }
          }
          ... on HeroPlayer {
            content {
              id
              title
              url
            }
          }
          ... on InitialRateMoviesSection {
            id
          }
          ... on NotificationInbox {
            notifications {
              id
            }
          }
          ... on MovieListSection {
            movieListDisplayType: displayType
            title
            subTitle
            emptyMessage
            movieList {
              id
            }
          }
          ... on ImageCardSection {
            title
            description
            link
            imageUrl
          }
          ... on ImageCardWithButtonSection {
            imageUrl
            title
            link
            optionalButtonLabel
            heightFactor
          }
          ... on ImageCardWithButtonCarouselSection {
            images {
              id
              imageUrl
              title
              link
              optionalButtonLabel
              heightFactor
            }
          }
          ... on GoogleAdBannerSection {
            adUnitName
          }
          ... on HeadingSection {
            text
            size
            align
            margin
          }
          ... on CardSection {
            title
            text
            collapsible
            collapsed
            margin
            cardSectionImageUrl
          }
          ... on ButtonSection {
            buttonLabel
            onPressType
            routeName
            routeArgs
            margin
            hideChevron
          }
          ... on NewsListSection {
            title
            newsItems {
              id
            }
          }
          ... on WebViewSection {
            title
            url
            margin
            collapsed
            infoText
            infoTextAfter
            height
            width
            injectionScript
            backgroundColor
          }
          ... on QRCodeScannerSection {
            buttonLabel
            margin
            modalTitle
            modalDescription
            modalNoPermissionsDisclaimer
            modalRequestPersmissionsButtonLabel
            modalManualInputSeparator
            modalManualInputLabel
            modalManualInputHint
          }
        }
      }
      ... on ExitPollSection {
        screening {
          id
        }
      }
      ... on FeaturedMovieSection {
        description
        title
        movie {
          id
        }
      }
      ... on AppFeedbackSection {
        id
      }
      ... on CurrentTicketsSection {
        tickets {
          id
        }
      }
      ... on CurrentOrdersSection {
        orders {
          id
        }
      }
      ... on HeroPlayer {
        content {
          id
          title
          url
        }
      }
      ... on InitialRateMoviesSection {
        id
      }
      ... on NotificationInbox {
        notifications {
          id
        }
      }
      ... on MovieListSection {
        movieListDisplayType: displayType
        title
        subTitle
        emptyMessage
        movieList {
          id
        }
      }
      ... on ImageCardSection {
        title
        description
        link
        imageUrl
      }
      ... on ImageCardWithButtonSection {
        imageUrl
        title
        link
        optionalButtonLabel
        heightFactor
      }
      ... on ImageCardWithButtonCarouselSection {
        images {
          id
          imageUrl
          title
          link
          optionalButtonLabel
          heightFactor
        }
      }
      ... on GoogleAdBannerSection {
        adUnitName
      }
      ... on HeadingSection {
        text
        size
        align
        margin
      }
      ... on CardSection {
        title
        text
        collapsible
        collapsed
        margin
        cardSectionImageUrl
      }
      ... on ButtonSection {
        buttonLabel
        onPressType
        routeName
        routeArgs
        margin
        hideChevron
      }
      ... on NewsListSection {
        title
        newsItems {
          id
        }
      }
      ... on WebViewSection {
        title
        url
        margin
        collapsed
        infoText
        infoTextAfter
        height
        width
        injectionScript
        backgroundColor
      }
      ... on QRCodeScannerSection {
        buttonLabel
        margin
        modalTitle
        modalDescription
        modalNoPermissionsDisclaimer
        modalRequestPersmissionsButtonLabel
        modalManualInputSeparator
        modalManualInputLabel
        modalManualInputHint
      }
    }
  }
}
    `;
export type ContentSectionListEditorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>
    } & TChildProps;
export function withContentSectionListEditor<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ContentSectionListEditorQuery,
  ContentSectionListEditorQueryVariables,
  ContentSectionListEditorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables, ContentSectionListEditorProps<TChildProps, TDataName>>(ContentSectionListEditorDocument, {
      alias: 'contentSectionListEditor',
      ...operationOptions
    });
};

/**
 * __useContentSectionListEditorQuery__
 *
 * To run a query within a React component, call `useContentSectionListEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useContentSectionListEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContentSectionListEditorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContentSectionListEditorQuery(baseOptions: Apollo.QueryHookOptions<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables> & ({ variables: ContentSectionListEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>(ContentSectionListEditorDocument, options);
      }
export function useContentSectionListEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>(ContentSectionListEditorDocument, options);
        }
export function useContentSectionListEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>(ContentSectionListEditorDocument, options);
        }
export type ContentSectionListEditorQueryHookResult = ReturnType<typeof useContentSectionListEditorQuery>;
export type ContentSectionListEditorLazyQueryHookResult = ReturnType<typeof useContentSectionListEditorLazyQuery>;
export type ContentSectionListEditorSuspenseQueryHookResult = ReturnType<typeof useContentSectionListEditorSuspenseQuery>;
export type ContentSectionListEditorQueryResult = Apollo.QueryResult<ContentSectionListEditorQuery, ContentSectionListEditorQueryVariables>;
export const UpdateContentSectionListDocument = gql`
    mutation UpdateContentSectionList($id: ID!, $contentsections: Json!, $title: String, $displayType: ContentSectionListDisplayType, $headerImage: String, $headerImageHeight: String) {
  updateContentSectionList(
    id: $id
    contentsections: $contentsections
    title: $title
    displayType: $displayType
    headerImage: $headerImage
    headerImageHeight: $headerImageHeight
  ) {
    id
    title
  }
}
    `;
export type UpdateContentSectionListMutationFn = Apollo.MutationFunction<UpdateContentSectionListMutation, UpdateContentSectionListMutationVariables>;
export type UpdateContentSectionListProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateContentSectionListMutation, UpdateContentSectionListMutationVariables>
    } & TChildProps;
export function withUpdateContentSectionList<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateContentSectionListMutation,
  UpdateContentSectionListMutationVariables,
  UpdateContentSectionListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateContentSectionListMutation, UpdateContentSectionListMutationVariables, UpdateContentSectionListProps<TChildProps, TDataName>>(UpdateContentSectionListDocument, {
      alias: 'updateContentSectionList',
      ...operationOptions
    });
};

/**
 * __useUpdateContentSectionListMutation__
 *
 * To run a mutation, you first call `useUpdateContentSectionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateContentSectionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateContentSectionListMutation, { data, loading, error }] = useUpdateContentSectionListMutation({
 *   variables: {
 *      id: // value for 'id'
 *      contentsections: // value for 'contentsections'
 *      title: // value for 'title'
 *      displayType: // value for 'displayType'
 *      headerImage: // value for 'headerImage'
 *      headerImageHeight: // value for 'headerImageHeight'
 *   },
 * });
 */
export function useUpdateContentSectionListMutation(baseOptions?: Apollo.MutationHookOptions<UpdateContentSectionListMutation, UpdateContentSectionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateContentSectionListMutation, UpdateContentSectionListMutationVariables>(UpdateContentSectionListDocument, options);
      }
export type UpdateContentSectionListMutationHookResult = ReturnType<typeof useUpdateContentSectionListMutation>;
export type UpdateContentSectionListMutationResult = Apollo.MutationResult<UpdateContentSectionListMutation>;
export type UpdateContentSectionListMutationOptions = Apollo.BaseMutationOptions<UpdateContentSectionListMutation, UpdateContentSectionListMutationVariables>;
export const GetAllEditableContentSectionListsDocument = gql`
    query GetAllEditableContentSectionLists {
  getAllEditableContentSectionLists {
    id
    title
  }
}
    `;
export type GetAllEditableContentSectionListsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>
    } & TChildProps;
export function withGetAllEditableContentSectionLists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllEditableContentSectionListsQuery,
  GetAllEditableContentSectionListsQueryVariables,
  GetAllEditableContentSectionListsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables, GetAllEditableContentSectionListsProps<TChildProps, TDataName>>(GetAllEditableContentSectionListsDocument, {
      alias: 'getAllEditableContentSectionLists',
      ...operationOptions
    });
};

/**
 * __useGetAllEditableContentSectionListsQuery__
 *
 * To run a query within a React component, call `useGetAllEditableContentSectionListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllEditableContentSectionListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllEditableContentSectionListsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllEditableContentSectionListsQuery(baseOptions?: Apollo.QueryHookOptions<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>(GetAllEditableContentSectionListsDocument, options);
      }
export function useGetAllEditableContentSectionListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>(GetAllEditableContentSectionListsDocument, options);
        }
export function useGetAllEditableContentSectionListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>(GetAllEditableContentSectionListsDocument, options);
        }
export type GetAllEditableContentSectionListsQueryHookResult = ReturnType<typeof useGetAllEditableContentSectionListsQuery>;
export type GetAllEditableContentSectionListsLazyQueryHookResult = ReturnType<typeof useGetAllEditableContentSectionListsLazyQuery>;
export type GetAllEditableContentSectionListsSuspenseQueryHookResult = ReturnType<typeof useGetAllEditableContentSectionListsSuspenseQuery>;
export type GetAllEditableContentSectionListsQueryResult = Apollo.QueryResult<GetAllEditableContentSectionListsQuery, GetAllEditableContentSectionListsQueryVariables>;
export const CreateContentSectionListDocument = gql`
    mutation CreateContentSectionList($title: String, $displayType: ContentSectionListDisplayType, $headerImage: String, $headerImageHeight: String, $contentsections: Json!) {
  createContentSectionList(
    title: $title
    displayType: $displayType
    headerImage: $headerImage
    headerImageHeight: $headerImageHeight
    contentsections: $contentsections
  ) {
    id
    title
  }
}
    `;
export type CreateContentSectionListMutationFn = Apollo.MutationFunction<CreateContentSectionListMutation, CreateContentSectionListMutationVariables>;
export type CreateContentSectionListProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateContentSectionListMutation, CreateContentSectionListMutationVariables>
    } & TChildProps;
export function withCreateContentSectionList<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateContentSectionListMutation,
  CreateContentSectionListMutationVariables,
  CreateContentSectionListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateContentSectionListMutation, CreateContentSectionListMutationVariables, CreateContentSectionListProps<TChildProps, TDataName>>(CreateContentSectionListDocument, {
      alias: 'createContentSectionList',
      ...operationOptions
    });
};

/**
 * __useCreateContentSectionListMutation__
 *
 * To run a mutation, you first call `useCreateContentSectionListMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateContentSectionListMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createContentSectionListMutation, { data, loading, error }] = useCreateContentSectionListMutation({
 *   variables: {
 *      title: // value for 'title'
 *      displayType: // value for 'displayType'
 *      headerImage: // value for 'headerImage'
 *      headerImageHeight: // value for 'headerImageHeight'
 *      contentsections: // value for 'contentsections'
 *   },
 * });
 */
export function useCreateContentSectionListMutation(baseOptions?: Apollo.MutationHookOptions<CreateContentSectionListMutation, CreateContentSectionListMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateContentSectionListMutation, CreateContentSectionListMutationVariables>(CreateContentSectionListDocument, options);
      }
export type CreateContentSectionListMutationHookResult = ReturnType<typeof useCreateContentSectionListMutation>;
export type CreateContentSectionListMutationResult = Apollo.MutationResult<CreateContentSectionListMutation>;
export type CreateContentSectionListMutationOptions = Apollo.BaseMutationOptions<CreateContentSectionListMutation, CreateContentSectionListMutationVariables>;
export const BonusProgramVoucherEditorDocument = gql`
    query BonusProgramVoucherEditor($cinemaId: ID!) {
  cinema(id: $cinemaId) {
    id
    bonusProgramVoucherTypes {
      voucherTypeId
      cinemaId
      title
      description
      priceCoins
      priceEuros
      discountPercent
      maxQuantityPerPerson
      initialQuantity
      remainingQuantity
      bookableUntil
      redeemableUntil
      active
      imageUrl
    }
  }
  bonusProgramVoucherStockImages {
    id
    title
    url
  }
}
    `;
export type BonusProgramVoucherEditorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>
    } & TChildProps;
export function withBonusProgramVoucherEditor<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BonusProgramVoucherEditorQuery,
  BonusProgramVoucherEditorQueryVariables,
  BonusProgramVoucherEditorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables, BonusProgramVoucherEditorProps<TChildProps, TDataName>>(BonusProgramVoucherEditorDocument, {
      alias: 'bonusProgramVoucherEditor',
      ...operationOptions
    });
};

/**
 * __useBonusProgramVoucherEditorQuery__
 *
 * To run a query within a React component, call `useBonusProgramVoucherEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusProgramVoucherEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusProgramVoucherEditorQuery({
 *   variables: {
 *      cinemaId: // value for 'cinemaId'
 *   },
 * });
 */
export function useBonusProgramVoucherEditorQuery(baseOptions: Apollo.QueryHookOptions<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables> & ({ variables: BonusProgramVoucherEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>(BonusProgramVoucherEditorDocument, options);
      }
export function useBonusProgramVoucherEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>(BonusProgramVoucherEditorDocument, options);
        }
export function useBonusProgramVoucherEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>(BonusProgramVoucherEditorDocument, options);
        }
export type BonusProgramVoucherEditorQueryHookResult = ReturnType<typeof useBonusProgramVoucherEditorQuery>;
export type BonusProgramVoucherEditorLazyQueryHookResult = ReturnType<typeof useBonusProgramVoucherEditorLazyQuery>;
export type BonusProgramVoucherEditorSuspenseQueryHookResult = ReturnType<typeof useBonusProgramVoucherEditorSuspenseQuery>;
export type BonusProgramVoucherEditorQueryResult = Apollo.QueryResult<BonusProgramVoucherEditorQuery, BonusProgramVoucherEditorQueryVariables>;
export const CreateBonusProgramVoucherTypeDocument = gql`
    mutation CreateBonusProgramVoucherType($cinemaId: ID!, $input: BonusProgramVoucherTypeInput!) {
  createBonusProgramVoucherType(cinemaId: $cinemaId, input: $input) {
    voucherTypeId
  }
}
    `;
export type CreateBonusProgramVoucherTypeMutationFn = Apollo.MutationFunction<CreateBonusProgramVoucherTypeMutation, CreateBonusProgramVoucherTypeMutationVariables>;
export type CreateBonusProgramVoucherTypeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateBonusProgramVoucherTypeMutation, CreateBonusProgramVoucherTypeMutationVariables>
    } & TChildProps;
export function withCreateBonusProgramVoucherType<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBonusProgramVoucherTypeMutation,
  CreateBonusProgramVoucherTypeMutationVariables,
  CreateBonusProgramVoucherTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBonusProgramVoucherTypeMutation, CreateBonusProgramVoucherTypeMutationVariables, CreateBonusProgramVoucherTypeProps<TChildProps, TDataName>>(CreateBonusProgramVoucherTypeDocument, {
      alias: 'createBonusProgramVoucherType',
      ...operationOptions
    });
};

/**
 * __useCreateBonusProgramVoucherTypeMutation__
 *
 * To run a mutation, you first call `useCreateBonusProgramVoucherTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBonusProgramVoucherTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBonusProgramVoucherTypeMutation, { data, loading, error }] = useCreateBonusProgramVoucherTypeMutation({
 *   variables: {
 *      cinemaId: // value for 'cinemaId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBonusProgramVoucherTypeMutation(baseOptions?: Apollo.MutationHookOptions<CreateBonusProgramVoucherTypeMutation, CreateBonusProgramVoucherTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBonusProgramVoucherTypeMutation, CreateBonusProgramVoucherTypeMutationVariables>(CreateBonusProgramVoucherTypeDocument, options);
      }
export type CreateBonusProgramVoucherTypeMutationHookResult = ReturnType<typeof useCreateBonusProgramVoucherTypeMutation>;
export type CreateBonusProgramVoucherTypeMutationResult = Apollo.MutationResult<CreateBonusProgramVoucherTypeMutation>;
export type CreateBonusProgramVoucherTypeMutationOptions = Apollo.BaseMutationOptions<CreateBonusProgramVoucherTypeMutation, CreateBonusProgramVoucherTypeMutationVariables>;
export const UpdateBonusProgramVoucherTypeDocument = gql`
    mutation UpdateBonusProgramVoucherType($voucherTypeId: ID!, $input: BonusProgramVoucherTypeInput!) {
  updateBonusProgramVoucherType(voucherTypeId: $voucherTypeId, input: $input) {
    voucherTypeId
  }
}
    `;
export type UpdateBonusProgramVoucherTypeMutationFn = Apollo.MutationFunction<UpdateBonusProgramVoucherTypeMutation, UpdateBonusProgramVoucherTypeMutationVariables>;
export type UpdateBonusProgramVoucherTypeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateBonusProgramVoucherTypeMutation, UpdateBonusProgramVoucherTypeMutationVariables>
    } & TChildProps;
export function withUpdateBonusProgramVoucherType<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBonusProgramVoucherTypeMutation,
  UpdateBonusProgramVoucherTypeMutationVariables,
  UpdateBonusProgramVoucherTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBonusProgramVoucherTypeMutation, UpdateBonusProgramVoucherTypeMutationVariables, UpdateBonusProgramVoucherTypeProps<TChildProps, TDataName>>(UpdateBonusProgramVoucherTypeDocument, {
      alias: 'updateBonusProgramVoucherType',
      ...operationOptions
    });
};

/**
 * __useUpdateBonusProgramVoucherTypeMutation__
 *
 * To run a mutation, you first call `useUpdateBonusProgramVoucherTypeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBonusProgramVoucherTypeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBonusProgramVoucherTypeMutation, { data, loading, error }] = useUpdateBonusProgramVoucherTypeMutation({
 *   variables: {
 *      voucherTypeId: // value for 'voucherTypeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBonusProgramVoucherTypeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBonusProgramVoucherTypeMutation, UpdateBonusProgramVoucherTypeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBonusProgramVoucherTypeMutation, UpdateBonusProgramVoucherTypeMutationVariables>(UpdateBonusProgramVoucherTypeDocument, options);
      }
export type UpdateBonusProgramVoucherTypeMutationHookResult = ReturnType<typeof useUpdateBonusProgramVoucherTypeMutation>;
export type UpdateBonusProgramVoucherTypeMutationResult = Apollo.MutationResult<UpdateBonusProgramVoucherTypeMutation>;
export type UpdateBonusProgramVoucherTypeMutationOptions = Apollo.BaseMutationOptions<UpdateBonusProgramVoucherTypeMutation, UpdateBonusProgramVoucherTypeMutationVariables>;
export const NewsItemOldDocument = gql`
    query NewsItemOld($newsItemId: ID!) {
  newsItem(id: $newsItemId) {
    id
    title
    body
    movie {
      id
    }
  }
}
    `;
export type NewsItemOldProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NewsItemOldQuery, NewsItemOldQueryVariables>
    } & TChildProps;
export function withNewsItemOld<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NewsItemOldQuery,
  NewsItemOldQueryVariables,
  NewsItemOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NewsItemOldQuery, NewsItemOldQueryVariables, NewsItemOldProps<TChildProps, TDataName>>(NewsItemOldDocument, {
      alias: 'newsItemOld',
      ...operationOptions
    });
};

/**
 * __useNewsItemOldQuery__
 *
 * To run a query within a React component, call `useNewsItemOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemOldQuery({
 *   variables: {
 *      newsItemId: // value for 'newsItemId'
 *   },
 * });
 */
export function useNewsItemOldQuery(baseOptions: Apollo.QueryHookOptions<NewsItemOldQuery, NewsItemOldQueryVariables> & ({ variables: NewsItemOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemOldQuery, NewsItemOldQueryVariables>(NewsItemOldDocument, options);
      }
export function useNewsItemOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemOldQuery, NewsItemOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemOldQuery, NewsItemOldQueryVariables>(NewsItemOldDocument, options);
        }
export function useNewsItemOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsItemOldQuery, NewsItemOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemOldQuery, NewsItemOldQueryVariables>(NewsItemOldDocument, options);
        }
export type NewsItemOldQueryHookResult = ReturnType<typeof useNewsItemOldQuery>;
export type NewsItemOldLazyQueryHookResult = ReturnType<typeof useNewsItemOldLazyQuery>;
export type NewsItemOldSuspenseQueryHookResult = ReturnType<typeof useNewsItemOldSuspenseQuery>;
export type NewsItemOldQueryResult = Apollo.QueryResult<NewsItemOldQuery, NewsItemOldQueryVariables>;
export const UpsertNewsItemOldDocument = gql`
    mutation UpsertNewsItemOld($id: ID, $title: String, $body: String, $movieId: ID) {
  result: upsertNewsItem(id: $id, title: $title, body: $body, movieId: $movieId) {
    newsItem {
      id
      title
      body
      movie {
        id
      }
    }
  }
}
    `;
export type UpsertNewsItemOldMutationFn = Apollo.MutationFunction<UpsertNewsItemOldMutation, UpsertNewsItemOldMutationVariables>;
export type UpsertNewsItemOldProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpsertNewsItemOldMutation, UpsertNewsItemOldMutationVariables>
    } & TChildProps;
export function withUpsertNewsItemOld<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertNewsItemOldMutation,
  UpsertNewsItemOldMutationVariables,
  UpsertNewsItemOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertNewsItemOldMutation, UpsertNewsItemOldMutationVariables, UpsertNewsItemOldProps<TChildProps, TDataName>>(UpsertNewsItemOldDocument, {
      alias: 'upsertNewsItemOld',
      ...operationOptions
    });
};

/**
 * __useUpsertNewsItemOldMutation__
 *
 * To run a mutation, you first call `useUpsertNewsItemOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNewsItemOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNewsItemOldMutation, { data, loading, error }] = useUpsertNewsItemOldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useUpsertNewsItemOldMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNewsItemOldMutation, UpsertNewsItemOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNewsItemOldMutation, UpsertNewsItemOldMutationVariables>(UpsertNewsItemOldDocument, options);
      }
export type UpsertNewsItemOldMutationHookResult = ReturnType<typeof useUpsertNewsItemOldMutation>;
export type UpsertNewsItemOldMutationResult = Apollo.MutationResult<UpsertNewsItemOldMutation>;
export type UpsertNewsItemOldMutationOptions = Apollo.BaseMutationOptions<UpsertNewsItemOldMutation, UpsertNewsItemOldMutationVariables>;
export const MoviesDocument = gql`
    query Movies {
  movies: allMovies {
    id
    title
    poster
  }
}
    `;
export type MoviesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MoviesQuery, MoviesQueryVariables>
    } & TChildProps;
export function withMovies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoviesQuery,
  MoviesQueryVariables,
  MoviesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MoviesQuery, MoviesQueryVariables, MoviesProps<TChildProps, TDataName>>(MoviesDocument, {
      alias: 'movies',
      ...operationOptions
    });
};

/**
 * __useMoviesQuery__
 *
 * To run a query within a React component, call `useMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoviesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMoviesQuery(baseOptions?: Apollo.QueryHookOptions<MoviesQuery, MoviesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoviesQuery, MoviesQueryVariables>(MoviesDocument, options);
      }
export function useMoviesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoviesQuery, MoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoviesQuery, MoviesQueryVariables>(MoviesDocument, options);
        }
export function useMoviesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MoviesQuery, MoviesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MoviesQuery, MoviesQueryVariables>(MoviesDocument, options);
        }
export type MoviesQueryHookResult = ReturnType<typeof useMoviesQuery>;
export type MoviesLazyQueryHookResult = ReturnType<typeof useMoviesLazyQuery>;
export type MoviesSuspenseQueryHookResult = ReturnType<typeof useMoviesSuspenseQuery>;
export type MoviesQueryResult = Apollo.QueryResult<MoviesQuery, MoviesQueryVariables>;
export const CurrentUserCinemasV2Document = gql`
    query CurrentUserCinemasV2 {
  user: currentUser {
    id
    privileges {
      adminForCinemas {
        id
        name
      }
    }
  }
}
    `;
export type CurrentUserCinemasV2Props<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>
    } & TChildProps;
export function withCurrentUserCinemasV2<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserCinemasV2Query,
  CurrentUserCinemasV2QueryVariables,
  CurrentUserCinemasV2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables, CurrentUserCinemasV2Props<TChildProps, TDataName>>(CurrentUserCinemasV2Document, {
      alias: 'currentUserCinemasV2',
      ...operationOptions
    });
};

/**
 * __useCurrentUserCinemasV2Query__
 *
 * To run a query within a React component, call `useCurrentUserCinemasV2Query` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCinemasV2Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCinemasV2Query({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCinemasV2Query(baseOptions?: Apollo.QueryHookOptions<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>(CurrentUserCinemasV2Document, options);
      }
export function useCurrentUserCinemasV2LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>(CurrentUserCinemasV2Document, options);
        }
export function useCurrentUserCinemasV2SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>(CurrentUserCinemasV2Document, options);
        }
export type CurrentUserCinemasV2QueryHookResult = ReturnType<typeof useCurrentUserCinemasV2Query>;
export type CurrentUserCinemasV2LazyQueryHookResult = ReturnType<typeof useCurrentUserCinemasV2LazyQuery>;
export type CurrentUserCinemasV2SuspenseQueryHookResult = ReturnType<typeof useCurrentUserCinemasV2SuspenseQuery>;
export type CurrentUserCinemasV2QueryResult = Apollo.QueryResult<CurrentUserCinemasV2Query, CurrentUserCinemasV2QueryVariables>;
export const CampaignsOldDocument = gql`
    query CampaignsOld($cinemaIds: [ID!]!) {
  campaignsByCinemas(cinemaIds: $cinemaIds) {
    campaigns {
      id
      type
      name
      status
      cinemas {
        id
        name
      }
    }
  }
}
    `;
export type CampaignsOldProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignsOldQuery, CampaignsOldQueryVariables>
    } & TChildProps;
export function withCampaignsOld<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignsOldQuery,
  CampaignsOldQueryVariables,
  CampaignsOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CampaignsOldQuery, CampaignsOldQueryVariables, CampaignsOldProps<TChildProps, TDataName>>(CampaignsOldDocument, {
      alias: 'campaignsOld',
      ...operationOptions
    });
};

/**
 * __useCampaignsOldQuery__
 *
 * To run a query within a React component, call `useCampaignsOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsOldQuery({
 *   variables: {
 *      cinemaIds: // value for 'cinemaIds'
 *   },
 * });
 */
export function useCampaignsOldQuery(baseOptions: Apollo.QueryHookOptions<CampaignsOldQuery, CampaignsOldQueryVariables> & ({ variables: CampaignsOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsOldQuery, CampaignsOldQueryVariables>(CampaignsOldDocument, options);
      }
export function useCampaignsOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsOldQuery, CampaignsOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsOldQuery, CampaignsOldQueryVariables>(CampaignsOldDocument, options);
        }
export function useCampaignsOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsOldQuery, CampaignsOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsOldQuery, CampaignsOldQueryVariables>(CampaignsOldDocument, options);
        }
export type CampaignsOldQueryHookResult = ReturnType<typeof useCampaignsOldQuery>;
export type CampaignsOldLazyQueryHookResult = ReturnType<typeof useCampaignsOldLazyQuery>;
export type CampaignsOldSuspenseQueryHookResult = ReturnType<typeof useCampaignsOldSuspenseQuery>;
export type CampaignsOldQueryResult = Apollo.QueryResult<CampaignsOldQuery, CampaignsOldQueryVariables>;
export const CreateCampaignOldDocument = gql`
    mutation CreateCampaignOld($name: String!, $type: CampaignType!, $cinemaIds: [ID!]!) {
  result: createCampaign(name: $name, type: $type, cinemaIds: $cinemaIds) {
    campaign {
      id
      type
      name
      userGroupFilter {
        id
      }
      userGroupFilterOnReferencedMovie {
        id
      }
    }
  }
}
    `;
export type CreateCampaignOldMutationFn = Apollo.MutationFunction<CreateCampaignOldMutation, CreateCampaignOldMutationVariables>;
export type CreateCampaignOldProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCampaignOldMutation, CreateCampaignOldMutationVariables>
    } & TChildProps;
export function withCreateCampaignOld<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCampaignOldMutation,
  CreateCampaignOldMutationVariables,
  CreateCampaignOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCampaignOldMutation, CreateCampaignOldMutationVariables, CreateCampaignOldProps<TChildProps, TDataName>>(CreateCampaignOldDocument, {
      alias: 'createCampaignOld',
      ...operationOptions
    });
};

/**
 * __useCreateCampaignOldMutation__
 *
 * To run a mutation, you first call `useCreateCampaignOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignOldMutation, { data, loading, error }] = useCreateCampaignOldMutation({
 *   variables: {
 *      name: // value for 'name'
 *      type: // value for 'type'
 *      cinemaIds: // value for 'cinemaIds'
 *   },
 * });
 */
export function useCreateCampaignOldMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignOldMutation, CreateCampaignOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignOldMutation, CreateCampaignOldMutationVariables>(CreateCampaignOldDocument, options);
      }
export type CreateCampaignOldMutationHookResult = ReturnType<typeof useCreateCampaignOldMutation>;
export type CreateCampaignOldMutationResult = Apollo.MutationResult<CreateCampaignOldMutation>;
export type CreateCampaignOldMutationOptions = Apollo.BaseMutationOptions<CreateCampaignOldMutation, CreateCampaignOldMutationVariables>;
export const EditCampaignOldDocument = gql`
    mutation EditCampaignOld($id: ID!, $name: String!, $channels: [Channel!]!, $message: String, $messageTitle: String, $link: String, $sendingTime: Time, $sendingDate: Date, $sendOnDayXAfterTrigger: Int, $sendExactlyMinutesAfterTrigger: Int, $userGroupFilter: UserGroupFilterInput!, $userGroupFilterOnReferencedMovie: UserGroupFilterOnReferencedMovieInput!, $status: CampaignStatus!) {
  editCampaign(
    id: $id
    name: $name
    channels: $channels
    message: $message
    messageTitle: $messageTitle
    link: $link
    sendingTime: $sendingTime
    sendingDate: $sendingDate
    sendOnDayXAfterTrigger: $sendOnDayXAfterTrigger
    sendExactlyMinutesAfterTrigger: $sendExactlyMinutesAfterTrigger
    status: $status
  ) {
    campaign {
      id
    }
  }
  editUserGroupFilter(userGroupFilter: $userGroupFilter) {
    userGroupFilter {
      id
    }
  }
  editUserGroupFilterOnReferencedMovie(
    userGroupFilterOnReferencedMovie: $userGroupFilterOnReferencedMovie
  ) {
    userGroupFilterOnReferencedMovie {
      id
    }
  }
}
    `;
export type EditCampaignOldMutationFn = Apollo.MutationFunction<EditCampaignOldMutation, EditCampaignOldMutationVariables>;
export type EditCampaignOldProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<EditCampaignOldMutation, EditCampaignOldMutationVariables>
    } & TChildProps;
export function withEditCampaignOld<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditCampaignOldMutation,
  EditCampaignOldMutationVariables,
  EditCampaignOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditCampaignOldMutation, EditCampaignOldMutationVariables, EditCampaignOldProps<TChildProps, TDataName>>(EditCampaignOldDocument, {
      alias: 'editCampaignOld',
      ...operationOptions
    });
};

/**
 * __useEditCampaignOldMutation__
 *
 * To run a mutation, you first call `useEditCampaignOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCampaignOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCampaignOldMutation, { data, loading, error }] = useEditCampaignOldMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      channels: // value for 'channels'
 *      message: // value for 'message'
 *      messageTitle: // value for 'messageTitle'
 *      link: // value for 'link'
 *      sendingTime: // value for 'sendingTime'
 *      sendingDate: // value for 'sendingDate'
 *      sendOnDayXAfterTrigger: // value for 'sendOnDayXAfterTrigger'
 *      sendExactlyMinutesAfterTrigger: // value for 'sendExactlyMinutesAfterTrigger'
 *      userGroupFilter: // value for 'userGroupFilter'
 *      userGroupFilterOnReferencedMovie: // value for 'userGroupFilterOnReferencedMovie'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useEditCampaignOldMutation(baseOptions?: Apollo.MutationHookOptions<EditCampaignOldMutation, EditCampaignOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCampaignOldMutation, EditCampaignOldMutationVariables>(EditCampaignOldDocument, options);
      }
export type EditCampaignOldMutationHookResult = ReturnType<typeof useEditCampaignOldMutation>;
export type EditCampaignOldMutationResult = Apollo.MutationResult<EditCampaignOldMutation>;
export type EditCampaignOldMutationOptions = Apollo.BaseMutationOptions<EditCampaignOldMutation, EditCampaignOldMutationVariables>;
export const EstimateSizeOldDocument = gql`
    query EstimateSizeOld($id: ID!) {
  size: estimateCampaignSize(campaignId: $id) {
    userGroupSize
    exampleReferenceMovie {
      userGroupSize
      movie {
        title
      }
    }
  }
}
    `;
export type EstimateSizeOldProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>
    } & TChildProps;
export function withEstimateSizeOld<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EstimateSizeOldQuery,
  EstimateSizeOldQueryVariables,
  EstimateSizeOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EstimateSizeOldQuery, EstimateSizeOldQueryVariables, EstimateSizeOldProps<TChildProps, TDataName>>(EstimateSizeOldDocument, {
      alias: 'estimateSizeOld',
      ...operationOptions
    });
};

/**
 * __useEstimateSizeOldQuery__
 *
 * To run a query within a React component, call `useEstimateSizeOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateSizeOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateSizeOldQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstimateSizeOldQuery(baseOptions: Apollo.QueryHookOptions<EstimateSizeOldQuery, EstimateSizeOldQueryVariables> & ({ variables: EstimateSizeOldQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>(EstimateSizeOldDocument, options);
      }
export function useEstimateSizeOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>(EstimateSizeOldDocument, options);
        }
export function useEstimateSizeOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>(EstimateSizeOldDocument, options);
        }
export type EstimateSizeOldQueryHookResult = ReturnType<typeof useEstimateSizeOldQuery>;
export type EstimateSizeOldLazyQueryHookResult = ReturnType<typeof useEstimateSizeOldLazyQuery>;
export type EstimateSizeOldSuspenseQueryHookResult = ReturnType<typeof useEstimateSizeOldSuspenseQuery>;
export type EstimateSizeOldQueryResult = Apollo.QueryResult<EstimateSizeOldQuery, EstimateSizeOldQueryVariables>;
export const DeleteCampaignsOldDocument = gql`
    mutation DeleteCampaignsOld($ids: [ID!]!) {
  deleteCampaigns(ids: $ids) {
    success
  }
}
    `;
export type DeleteCampaignsOldMutationFn = Apollo.MutationFunction<DeleteCampaignsOldMutation, DeleteCampaignsOldMutationVariables>;
export type DeleteCampaignsOldProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteCampaignsOldMutation, DeleteCampaignsOldMutationVariables>
    } & TChildProps;
export function withDeleteCampaignsOld<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCampaignsOldMutation,
  DeleteCampaignsOldMutationVariables,
  DeleteCampaignsOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCampaignsOldMutation, DeleteCampaignsOldMutationVariables, DeleteCampaignsOldProps<TChildProps, TDataName>>(DeleteCampaignsOldDocument, {
      alias: 'deleteCampaignsOld',
      ...operationOptions
    });
};

/**
 * __useDeleteCampaignsOldMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignsOldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignsOldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignsOldMutation, { data, loading, error }] = useDeleteCampaignsOldMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCampaignsOldMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignsOldMutation, DeleteCampaignsOldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignsOldMutation, DeleteCampaignsOldMutationVariables>(DeleteCampaignsOldDocument, options);
      }
export type DeleteCampaignsOldMutationHookResult = ReturnType<typeof useDeleteCampaignsOldMutation>;
export type DeleteCampaignsOldMutationResult = Apollo.MutationResult<DeleteCampaignsOldMutation>;
export type DeleteCampaignsOldMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignsOldMutation, DeleteCampaignsOldMutationVariables>;
export const SetCampaignEditableDocument = gql`
    mutation SetCampaignEditable($id: ID!) {
  setCampaignStatus(id: $id, status: EDITING) {
    campaign {
      id
    }
  }
}
    `;
export type SetCampaignEditableMutationFn = Apollo.MutationFunction<SetCampaignEditableMutation, SetCampaignEditableMutationVariables>;
export type SetCampaignEditableProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SetCampaignEditableMutation, SetCampaignEditableMutationVariables>
    } & TChildProps;
export function withSetCampaignEditable<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetCampaignEditableMutation,
  SetCampaignEditableMutationVariables,
  SetCampaignEditableProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetCampaignEditableMutation, SetCampaignEditableMutationVariables, SetCampaignEditableProps<TChildProps, TDataName>>(SetCampaignEditableDocument, {
      alias: 'setCampaignEditable',
      ...operationOptions
    });
};

/**
 * __useSetCampaignEditableMutation__
 *
 * To run a mutation, you first call `useSetCampaignEditableMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCampaignEditableMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCampaignEditableMutation, { data, loading, error }] = useSetCampaignEditableMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetCampaignEditableMutation(baseOptions?: Apollo.MutationHookOptions<SetCampaignEditableMutation, SetCampaignEditableMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCampaignEditableMutation, SetCampaignEditableMutationVariables>(SetCampaignEditableDocument, options);
      }
export type SetCampaignEditableMutationHookResult = ReturnType<typeof useSetCampaignEditableMutation>;
export type SetCampaignEditableMutationResult = Apollo.MutationResult<SetCampaignEditableMutation>;
export type SetCampaignEditableMutationOptions = Apollo.BaseMutationOptions<SetCampaignEditableMutation, SetCampaignEditableMutationVariables>;
export const EstimateSizeDocument = gql`
    query EstimateSize($id: ID!) {
  size: estimateCampaignSize(campaignId: $id) {
    userGroupSize
  }
}
    `;
export type EstimateSizeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EstimateSizeQuery, EstimateSizeQueryVariables>
    } & TChildProps;
export function withEstimateSize<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EstimateSizeQuery,
  EstimateSizeQueryVariables,
  EstimateSizeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EstimateSizeQuery, EstimateSizeQueryVariables, EstimateSizeProps<TChildProps, TDataName>>(EstimateSizeDocument, {
      alias: 'estimateSize',
      ...operationOptions
    });
};

/**
 * __useEstimateSizeQuery__
 *
 * To run a query within a React component, call `useEstimateSizeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateSizeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateSizeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEstimateSizeQuery(baseOptions: Apollo.QueryHookOptions<EstimateSizeQuery, EstimateSizeQueryVariables> & ({ variables: EstimateSizeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EstimateSizeQuery, EstimateSizeQueryVariables>(EstimateSizeDocument, options);
      }
export function useEstimateSizeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EstimateSizeQuery, EstimateSizeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EstimateSizeQuery, EstimateSizeQueryVariables>(EstimateSizeDocument, options);
        }
export function useEstimateSizeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EstimateSizeQuery, EstimateSizeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EstimateSizeQuery, EstimateSizeQueryVariables>(EstimateSizeDocument, options);
        }
export type EstimateSizeQueryHookResult = ReturnType<typeof useEstimateSizeQuery>;
export type EstimateSizeLazyQueryHookResult = ReturnType<typeof useEstimateSizeLazyQuery>;
export type EstimateSizeSuspenseQueryHookResult = ReturnType<typeof useEstimateSizeSuspenseQuery>;
export type EstimateSizeQueryResult = Apollo.QueryResult<EstimateSizeQuery, EstimateSizeQueryVariables>;
export const CampaignDocument = gql`
    query Campaign($id: ID!) {
  campaign(id: $id) {
    id
    type
    name
    channels
    message
    messageTitle
    link
    status
    sendingTime
    sendingDate
    sendOnDayXAfterTrigger
    sendExactlyMinutesAfterTrigger
    userGroupFilter {
      id
      moviesOnWatchlist {
        id
        title
        poster
      }
      moviesSeen {
        id
        title
        poster
      }
      moviesNotSeen {
        id
        title
        poster
      }
      moviesRatedPositively {
        id
        title
        poster
      }
      moviesRatedNegatively {
        id
        title
        poster
      }
      bonusPointsGeq
      bonusPointsLeq
      visitFrequency {
        id
        visits
        intervalLengthDays
      }
    }
    userGroupFilterOnReferencedMovie {
      id
      onWatchlist
      seen
      ratedPositively
      ratedNegatively
    }
  }
}
    `;
export type CampaignProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignQuery, CampaignQueryVariables>
    } & TChildProps;
export function withCampaign<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignQuery,
  CampaignQueryVariables,
  CampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CampaignQuery, CampaignQueryVariables, CampaignProps<TChildProps, TDataName>>(CampaignDocument, {
      alias: 'campaign',
      ...operationOptions
    });
};

/**
 * __useCampaignQuery__
 *
 * To run a query within a React component, call `useCampaignQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignQuery(baseOptions: Apollo.QueryHookOptions<CampaignQuery, CampaignQueryVariables> & ({ variables: CampaignQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
      }
export function useCampaignLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export function useCampaignSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignQuery, CampaignQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignQuery, CampaignQueryVariables>(CampaignDocument, options);
        }
export type CampaignQueryHookResult = ReturnType<typeof useCampaignQuery>;
export type CampaignLazyQueryHookResult = ReturnType<typeof useCampaignLazyQuery>;
export type CampaignSuspenseQueryHookResult = ReturnType<typeof useCampaignSuspenseQuery>;
export type CampaignQueryResult = Apollo.QueryResult<CampaignQuery, CampaignQueryVariables>;
export const CinemaClustersOverviewDocument = gql`
    query CinemaClustersOverview {
  cinemaClusters {
    ...CinemaClusterTable
  }
}
    ${CinemaClusterTableFragmentDoc}`;
export type CinemaClustersOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>
    } & TChildProps;
export function withCinemaClustersOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CinemaClustersOverviewQuery,
  CinemaClustersOverviewQueryVariables,
  CinemaClustersOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables, CinemaClustersOverviewProps<TChildProps, TDataName>>(CinemaClustersOverviewDocument, {
      alias: 'cinemaClustersOverview',
      ...operationOptions
    });
};

/**
 * __useCinemaClustersOverviewQuery__
 *
 * To run a query within a React component, call `useCinemaClustersOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCinemaClustersOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCinemaClustersOverviewQuery({
 *   variables: {
 *   },
 * });
 */
export function useCinemaClustersOverviewQuery(baseOptions?: Apollo.QueryHookOptions<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>(CinemaClustersOverviewDocument, options);
      }
export function useCinemaClustersOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>(CinemaClustersOverviewDocument, options);
        }
export function useCinemaClustersOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>(CinemaClustersOverviewDocument, options);
        }
export type CinemaClustersOverviewQueryHookResult = ReturnType<typeof useCinemaClustersOverviewQuery>;
export type CinemaClustersOverviewLazyQueryHookResult = ReturnType<typeof useCinemaClustersOverviewLazyQuery>;
export type CinemaClustersOverviewSuspenseQueryHookResult = ReturnType<typeof useCinemaClustersOverviewSuspenseQuery>;
export type CinemaClustersOverviewQueryResult = Apollo.QueryResult<CinemaClustersOverviewQuery, CinemaClustersOverviewQueryVariables>;
export const CreateCinemaClusterDocument = gql`
    mutation CreateCinemaCluster($data: CinemaClusterData!) {
  createCinemaCluster(data: $data) {
    ...CinemaClusterDetails
  }
}
    ${CinemaClusterDetailsFragmentDoc}`;
export type CreateCinemaClusterMutationFn = Apollo.MutationFunction<CreateCinemaClusterMutation, CreateCinemaClusterMutationVariables>;
export type CreateCinemaClusterProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCinemaClusterMutation, CreateCinemaClusterMutationVariables>
    } & TChildProps;
export function withCreateCinemaCluster<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCinemaClusterMutation,
  CreateCinemaClusterMutationVariables,
  CreateCinemaClusterProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCinemaClusterMutation, CreateCinemaClusterMutationVariables, CreateCinemaClusterProps<TChildProps, TDataName>>(CreateCinemaClusterDocument, {
      alias: 'createCinemaCluster',
      ...operationOptions
    });
};

/**
 * __useCreateCinemaClusterMutation__
 *
 * To run a mutation, you first call `useCreateCinemaClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCinemaClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCinemaClusterMutation, { data, loading, error }] = useCreateCinemaClusterMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCinemaClusterMutation(baseOptions?: Apollo.MutationHookOptions<CreateCinemaClusterMutation, CreateCinemaClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCinemaClusterMutation, CreateCinemaClusterMutationVariables>(CreateCinemaClusterDocument, options);
      }
export type CreateCinemaClusterMutationHookResult = ReturnType<typeof useCreateCinemaClusterMutation>;
export type CreateCinemaClusterMutationResult = Apollo.MutationResult<CreateCinemaClusterMutation>;
export type CreateCinemaClusterMutationOptions = Apollo.BaseMutationOptions<CreateCinemaClusterMutation, CreateCinemaClusterMutationVariables>;
export const UpdateCinemaClusterDocument = gql`
    mutation UpdateCinemaCluster($id: ID!, $data: CinemaClusterData!) {
  updateCinemaCluster(id: $id, data: $data) {
    ...CinemaClusterDetails
  }
}
    ${CinemaClusterDetailsFragmentDoc}`;
export type UpdateCinemaClusterMutationFn = Apollo.MutationFunction<UpdateCinemaClusterMutation, UpdateCinemaClusterMutationVariables>;
export type UpdateCinemaClusterProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateCinemaClusterMutation, UpdateCinemaClusterMutationVariables>
    } & TChildProps;
export function withUpdateCinemaCluster<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCinemaClusterMutation,
  UpdateCinemaClusterMutationVariables,
  UpdateCinemaClusterProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCinemaClusterMutation, UpdateCinemaClusterMutationVariables, UpdateCinemaClusterProps<TChildProps, TDataName>>(UpdateCinemaClusterDocument, {
      alias: 'updateCinemaCluster',
      ...operationOptions
    });
};

/**
 * __useUpdateCinemaClusterMutation__
 *
 * To run a mutation, you first call `useUpdateCinemaClusterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCinemaClusterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCinemaClusterMutation, { data, loading, error }] = useUpdateCinemaClusterMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCinemaClusterMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCinemaClusterMutation, UpdateCinemaClusterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCinemaClusterMutation, UpdateCinemaClusterMutationVariables>(UpdateCinemaClusterDocument, options);
      }
export type UpdateCinemaClusterMutationHookResult = ReturnType<typeof useUpdateCinemaClusterMutation>;
export type UpdateCinemaClusterMutationResult = Apollo.MutationResult<UpdateCinemaClusterMutation>;
export type UpdateCinemaClusterMutationOptions = Apollo.BaseMutationOptions<UpdateCinemaClusterMutation, UpdateCinemaClusterMutationVariables>;
export const DeleteCinemaClustersDocument = gql`
    mutation DeleteCinemaClusters($ids: [ID!]!) {
  deleteCinemaClusters(ids: $ids)
}
    `;
export type DeleteCinemaClustersMutationFn = Apollo.MutationFunction<DeleteCinemaClustersMutation, DeleteCinemaClustersMutationVariables>;
export type DeleteCinemaClustersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteCinemaClustersMutation, DeleteCinemaClustersMutationVariables>
    } & TChildProps;
export function withDeleteCinemaClusters<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCinemaClustersMutation,
  DeleteCinemaClustersMutationVariables,
  DeleteCinemaClustersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCinemaClustersMutation, DeleteCinemaClustersMutationVariables, DeleteCinemaClustersProps<TChildProps, TDataName>>(DeleteCinemaClustersDocument, {
      alias: 'deleteCinemaClusters',
      ...operationOptions
    });
};

/**
 * __useDeleteCinemaClustersMutation__
 *
 * To run a mutation, you first call `useDeleteCinemaClustersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCinemaClustersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCinemaClustersMutation, { data, loading, error }] = useDeleteCinemaClustersMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCinemaClustersMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCinemaClustersMutation, DeleteCinemaClustersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCinemaClustersMutation, DeleteCinemaClustersMutationVariables>(DeleteCinemaClustersDocument, options);
      }
export type DeleteCinemaClustersMutationHookResult = ReturnType<typeof useDeleteCinemaClustersMutation>;
export type DeleteCinemaClustersMutationResult = Apollo.MutationResult<DeleteCinemaClustersMutation>;
export type DeleteCinemaClustersMutationOptions = Apollo.BaseMutationOptions<DeleteCinemaClustersMutation, DeleteCinemaClustersMutationVariables>;
export const SingleCinemaClusterDocument = gql`
    query SingleCinemaCluster($id: ID!) {
  cinemaCluster(id: $id) {
    ...CinemaClusterDetails
  }
}
    ${CinemaClusterDetailsFragmentDoc}`;
export type SingleCinemaClusterProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>
    } & TChildProps;
export function withSingleCinemaCluster<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SingleCinemaClusterQuery,
  SingleCinemaClusterQueryVariables,
  SingleCinemaClusterProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables, SingleCinemaClusterProps<TChildProps, TDataName>>(SingleCinemaClusterDocument, {
      alias: 'singleCinemaCluster',
      ...operationOptions
    });
};

/**
 * __useSingleCinemaClusterQuery__
 *
 * To run a query within a React component, call `useSingleCinemaClusterQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCinemaClusterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCinemaClusterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleCinemaClusterQuery(baseOptions: Apollo.QueryHookOptions<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables> & ({ variables: SingleCinemaClusterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>(SingleCinemaClusterDocument, options);
      }
export function useSingleCinemaClusterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>(SingleCinemaClusterDocument, options);
        }
export function useSingleCinemaClusterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>(SingleCinemaClusterDocument, options);
        }
export type SingleCinemaClusterQueryHookResult = ReturnType<typeof useSingleCinemaClusterQuery>;
export type SingleCinemaClusterLazyQueryHookResult = ReturnType<typeof useSingleCinemaClusterLazyQuery>;
export type SingleCinemaClusterSuspenseQueryHookResult = ReturnType<typeof useSingleCinemaClusterSuspenseQuery>;
export type SingleCinemaClusterQueryResult = Apollo.QueryResult<SingleCinemaClusterQuery, SingleCinemaClusterQueryVariables>;
export const CreateCinemaOperatingCompanyDocument = gql`
    mutation CreateCinemaOperatingCompany($data: CinemaOperatingCompanyData!) {
  createCinemaOperatingCompany(data: $data) {
    id
  }
}
    `;
export type CreateCinemaOperatingCompanyMutationFn = Apollo.MutationFunction<CreateCinemaOperatingCompanyMutation, CreateCinemaOperatingCompanyMutationVariables>;
export type CreateCinemaOperatingCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCinemaOperatingCompanyMutation, CreateCinemaOperatingCompanyMutationVariables>
    } & TChildProps;
export function withCreateCinemaOperatingCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCinemaOperatingCompanyMutation,
  CreateCinemaOperatingCompanyMutationVariables,
  CreateCinemaOperatingCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCinemaOperatingCompanyMutation, CreateCinemaOperatingCompanyMutationVariables, CreateCinemaOperatingCompanyProps<TChildProps, TDataName>>(CreateCinemaOperatingCompanyDocument, {
      alias: 'createCinemaOperatingCompany',
      ...operationOptions
    });
};

/**
 * __useCreateCinemaOperatingCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCinemaOperatingCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCinemaOperatingCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCinemaOperatingCompanyMutation, { data, loading, error }] = useCreateCinemaOperatingCompanyMutation({
 *   variables: {
 *      data: // value for 'data'
 *   },
 * });
 */
export function useCreateCinemaOperatingCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCinemaOperatingCompanyMutation, CreateCinemaOperatingCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCinemaOperatingCompanyMutation, CreateCinemaOperatingCompanyMutationVariables>(CreateCinemaOperatingCompanyDocument, options);
      }
export type CreateCinemaOperatingCompanyMutationHookResult = ReturnType<typeof useCreateCinemaOperatingCompanyMutation>;
export type CreateCinemaOperatingCompanyMutationResult = Apollo.MutationResult<CreateCinemaOperatingCompanyMutation>;
export type CreateCinemaOperatingCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCinemaOperatingCompanyMutation, CreateCinemaOperatingCompanyMutationVariables>;
export const UpdateCinemaOperatingCompanyDocument = gql`
    mutation UpdateCinemaOperatingCompany($id: ID!, $data: CinemaOperatingCompanyData!) {
  updateCinemaOperatingCompany(id: $id, data: $data) {
    ...cinemaOperatingCompanyFragment
  }
}
    ${CinemaOperatingCompanyFragmentDoc}`;
export type UpdateCinemaOperatingCompanyMutationFn = Apollo.MutationFunction<UpdateCinemaOperatingCompanyMutation, UpdateCinemaOperatingCompanyMutationVariables>;
export type UpdateCinemaOperatingCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateCinemaOperatingCompanyMutation, UpdateCinemaOperatingCompanyMutationVariables>
    } & TChildProps;
export function withUpdateCinemaOperatingCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCinemaOperatingCompanyMutation,
  UpdateCinemaOperatingCompanyMutationVariables,
  UpdateCinemaOperatingCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCinemaOperatingCompanyMutation, UpdateCinemaOperatingCompanyMutationVariables, UpdateCinemaOperatingCompanyProps<TChildProps, TDataName>>(UpdateCinemaOperatingCompanyDocument, {
      alias: 'updateCinemaOperatingCompany',
      ...operationOptions
    });
};

/**
 * __useUpdateCinemaOperatingCompanyMutation__
 *
 * To run a mutation, you first call `useUpdateCinemaOperatingCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCinemaOperatingCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCinemaOperatingCompanyMutation, { data, loading, error }] = useUpdateCinemaOperatingCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      data: // value for 'data'
 *   },
 * });
 */
export function useUpdateCinemaOperatingCompanyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCinemaOperatingCompanyMutation, UpdateCinemaOperatingCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCinemaOperatingCompanyMutation, UpdateCinemaOperatingCompanyMutationVariables>(UpdateCinemaOperatingCompanyDocument, options);
      }
export type UpdateCinemaOperatingCompanyMutationHookResult = ReturnType<typeof useUpdateCinemaOperatingCompanyMutation>;
export type UpdateCinemaOperatingCompanyMutationResult = Apollo.MutationResult<UpdateCinemaOperatingCompanyMutation>;
export type UpdateCinemaOperatingCompanyMutationOptions = Apollo.BaseMutationOptions<UpdateCinemaOperatingCompanyMutation, UpdateCinemaOperatingCompanyMutationVariables>;
export const AllCinemasDocument = gql`
    query AllCinemas {
  cinemas {
    id
    name
  }
}
    `;
export type AllCinemasProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllCinemasQuery, AllCinemasQueryVariables>
    } & TChildProps;
export function withAllCinemas<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllCinemasQuery,
  AllCinemasQueryVariables,
  AllCinemasProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllCinemasQuery, AllCinemasQueryVariables, AllCinemasProps<TChildProps, TDataName>>(AllCinemasDocument, {
      alias: 'allCinemas',
      ...operationOptions
    });
};

/**
 * __useAllCinemasQuery__
 *
 * To run a query within a React component, call `useAllCinemasQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCinemasQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCinemasQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCinemasQuery(baseOptions?: Apollo.QueryHookOptions<AllCinemasQuery, AllCinemasQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCinemasQuery, AllCinemasQueryVariables>(AllCinemasDocument, options);
      }
export function useAllCinemasLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCinemasQuery, AllCinemasQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCinemasQuery, AllCinemasQueryVariables>(AllCinemasDocument, options);
        }
export function useAllCinemasSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCinemasQuery, AllCinemasQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCinemasQuery, AllCinemasQueryVariables>(AllCinemasDocument, options);
        }
export type AllCinemasQueryHookResult = ReturnType<typeof useAllCinemasQuery>;
export type AllCinemasLazyQueryHookResult = ReturnType<typeof useAllCinemasLazyQuery>;
export type AllCinemasSuspenseQueryHookResult = ReturnType<typeof useAllCinemasSuspenseQuery>;
export type AllCinemasQueryResult = Apollo.QueryResult<AllCinemasQuery, AllCinemasQueryVariables>;
export const CurrentUserCinemasV3Document = gql`
    query CurrentUserCinemasV3 {
  user: currentUser {
    id
    privileges {
      adminForCinemas {
        id
        name
      }
    }
  }
}
    `;
export type CurrentUserCinemasV3Props<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>
    } & TChildProps;
export function withCurrentUserCinemasV3<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserCinemasV3Query,
  CurrentUserCinemasV3QueryVariables,
  CurrentUserCinemasV3Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables, CurrentUserCinemasV3Props<TChildProps, TDataName>>(CurrentUserCinemasV3Document, {
      alias: 'currentUserCinemasV3',
      ...operationOptions
    });
};

/**
 * __useCurrentUserCinemasV3Query__
 *
 * To run a query within a React component, call `useCurrentUserCinemasV3Query` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCinemasV3Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCinemasV3Query({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCinemasV3Query(baseOptions?: Apollo.QueryHookOptions<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>(CurrentUserCinemasV3Document, options);
      }
export function useCurrentUserCinemasV3LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>(CurrentUserCinemasV3Document, options);
        }
export function useCurrentUserCinemasV3SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>(CurrentUserCinemasV3Document, options);
        }
export type CurrentUserCinemasV3QueryHookResult = ReturnType<typeof useCurrentUserCinemasV3Query>;
export type CurrentUserCinemasV3LazyQueryHookResult = ReturnType<typeof useCurrentUserCinemasV3LazyQuery>;
export type CurrentUserCinemasV3SuspenseQueryHookResult = ReturnType<typeof useCurrentUserCinemasV3SuspenseQuery>;
export type CurrentUserCinemasV3QueryResult = Apollo.QueryResult<CurrentUserCinemasV3Query, CurrentUserCinemasV3QueryVariables>;
export const CurrentUserCinemasV4Document = gql`
    query CurrentUserCinemasV4 {
  user: currentUser {
    id
    privileges {
      adminForCinemas {
        id
        name
      }
    }
  }
}
    `;
export type CurrentUserCinemasV4Props<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>
    } & TChildProps;
export function withCurrentUserCinemasV4<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserCinemasV4Query,
  CurrentUserCinemasV4QueryVariables,
  CurrentUserCinemasV4Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables, CurrentUserCinemasV4Props<TChildProps, TDataName>>(CurrentUserCinemasV4Document, {
      alias: 'currentUserCinemasV4',
      ...operationOptions
    });
};

/**
 * __useCurrentUserCinemasV4Query__
 *
 * To run a query within a React component, call `useCurrentUserCinemasV4Query` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCinemasV4Query` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCinemasV4Query({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCinemasV4Query(baseOptions?: Apollo.QueryHookOptions<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>(CurrentUserCinemasV4Document, options);
      }
export function useCurrentUserCinemasV4LazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>(CurrentUserCinemasV4Document, options);
        }
export function useCurrentUserCinemasV4SuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>(CurrentUserCinemasV4Document, options);
        }
export type CurrentUserCinemasV4QueryHookResult = ReturnType<typeof useCurrentUserCinemasV4Query>;
export type CurrentUserCinemasV4LazyQueryHookResult = ReturnType<typeof useCurrentUserCinemasV4LazyQuery>;
export type CurrentUserCinemasV4SuspenseQueryHookResult = ReturnType<typeof useCurrentUserCinemasV4SuspenseQuery>;
export type CurrentUserCinemasV4QueryResult = Apollo.QueryResult<CurrentUserCinemasV4Query, CurrentUserCinemasV4QueryVariables>;
export const CurrentUserCinemaOperatingCompaniesDocument = gql`
    query CurrentUserCinemaOperatingCompanies {
  user: currentUser {
    id
    privileges {
      belongsToCinemaOperatingCompanies {
        id
        name
      }
    }
  }
}
    `;
export type CurrentUserCinemaOperatingCompaniesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>
    } & TChildProps;
export function withCurrentUserCinemaOperatingCompanies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserCinemaOperatingCompaniesQuery,
  CurrentUserCinemaOperatingCompaniesQueryVariables,
  CurrentUserCinemaOperatingCompaniesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables, CurrentUserCinemaOperatingCompaniesProps<TChildProps, TDataName>>(CurrentUserCinemaOperatingCompaniesDocument, {
      alias: 'currentUserCinemaOperatingCompanies',
      ...operationOptions
    });
};

/**
 * __useCurrentUserCinemaOperatingCompaniesQuery__
 *
 * To run a query within a React component, call `useCurrentUserCinemaOperatingCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserCinemaOperatingCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserCinemaOperatingCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserCinemaOperatingCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>(CurrentUserCinemaOperatingCompaniesDocument, options);
      }
export function useCurrentUserCinemaOperatingCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>(CurrentUserCinemaOperatingCompaniesDocument, options);
        }
export function useCurrentUserCinemaOperatingCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>(CurrentUserCinemaOperatingCompaniesDocument, options);
        }
export type CurrentUserCinemaOperatingCompaniesQueryHookResult = ReturnType<typeof useCurrentUserCinemaOperatingCompaniesQuery>;
export type CurrentUserCinemaOperatingCompaniesLazyQueryHookResult = ReturnType<typeof useCurrentUserCinemaOperatingCompaniesLazyQuery>;
export type CurrentUserCinemaOperatingCompaniesSuspenseQueryHookResult = ReturnType<typeof useCurrentUserCinemaOperatingCompaniesSuspenseQuery>;
export type CurrentUserCinemaOperatingCompaniesQueryResult = Apollo.QueryResult<CurrentUserCinemaOperatingCompaniesQuery, CurrentUserCinemaOperatingCompaniesQueryVariables>;
export const RemoveAdminPrivilegesDocument = gql`
    mutation removeAdminPrivileges($userId: ID!, $cinemaOperatingCompanyId: ID!) {
  updateUserAdminStatus(
    userId: $userId
    cinemaOperatingCompanyId: $cinemaOperatingCompanyId
    setAdminPrivilege: false
  ) {
    success
    user {
      id
      name
      email
      privileges {
        belongsToCinemaOperatingCompanies {
          id
          name
        }
        rootRole
      }
    }
  }
}
    `;
export type RemoveAdminPrivilegesMutationFn = Apollo.MutationFunction<RemoveAdminPrivilegesMutation, RemoveAdminPrivilegesMutationVariables>;
export type RemoveAdminPrivilegesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<RemoveAdminPrivilegesMutation, RemoveAdminPrivilegesMutationVariables>
    } & TChildProps;
export function withRemoveAdminPrivileges<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RemoveAdminPrivilegesMutation,
  RemoveAdminPrivilegesMutationVariables,
  RemoveAdminPrivilegesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RemoveAdminPrivilegesMutation, RemoveAdminPrivilegesMutationVariables, RemoveAdminPrivilegesProps<TChildProps, TDataName>>(RemoveAdminPrivilegesDocument, {
      alias: 'removeAdminPrivileges',
      ...operationOptions
    });
};

/**
 * __useRemoveAdminPrivilegesMutation__
 *
 * To run a mutation, you first call `useRemoveAdminPrivilegesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAdminPrivilegesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAdminPrivilegesMutation, { data, loading, error }] = useRemoveAdminPrivilegesMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      cinemaOperatingCompanyId: // value for 'cinemaOperatingCompanyId'
 *   },
 * });
 */
export function useRemoveAdminPrivilegesMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAdminPrivilegesMutation, RemoveAdminPrivilegesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAdminPrivilegesMutation, RemoveAdminPrivilegesMutationVariables>(RemoveAdminPrivilegesDocument, options);
      }
export type RemoveAdminPrivilegesMutationHookResult = ReturnType<typeof useRemoveAdminPrivilegesMutation>;
export type RemoveAdminPrivilegesMutationResult = Apollo.MutationResult<RemoveAdminPrivilegesMutation>;
export type RemoveAdminPrivilegesMutationOptions = Apollo.BaseMutationOptions<RemoveAdminPrivilegesMutation, RemoveAdminPrivilegesMutationVariables>;
export const AddAdminUserPrivilegeDocument = gql`
    mutation addAdminUserPrivilege($userId: ID!, $cinemaOperatingCompanyId: ID!) {
  updateUserAdminStatus(
    userId: $userId
    cinemaOperatingCompanyId: $cinemaOperatingCompanyId
    setAdminPrivilege: true
  ) {
    success
    user {
      id
      name
      email
      privileges {
        belongsToCinemaOperatingCompanies {
          id
          name
        }
        rootRole
      }
    }
  }
}
    `;
export type AddAdminUserPrivilegeMutationFn = Apollo.MutationFunction<AddAdminUserPrivilegeMutation, AddAdminUserPrivilegeMutationVariables>;
export type AddAdminUserPrivilegeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AddAdminUserPrivilegeMutation, AddAdminUserPrivilegeMutationVariables>
    } & TChildProps;
export function withAddAdminUserPrivilege<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddAdminUserPrivilegeMutation,
  AddAdminUserPrivilegeMutationVariables,
  AddAdminUserPrivilegeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddAdminUserPrivilegeMutation, AddAdminUserPrivilegeMutationVariables, AddAdminUserPrivilegeProps<TChildProps, TDataName>>(AddAdminUserPrivilegeDocument, {
      alias: 'addAdminUserPrivilege',
      ...operationOptions
    });
};

/**
 * __useAddAdminUserPrivilegeMutation__
 *
 * To run a mutation, you first call `useAddAdminUserPrivilegeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddAdminUserPrivilegeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addAdminUserPrivilegeMutation, { data, loading, error }] = useAddAdminUserPrivilegeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      cinemaOperatingCompanyId: // value for 'cinemaOperatingCompanyId'
 *   },
 * });
 */
export function useAddAdminUserPrivilegeMutation(baseOptions?: Apollo.MutationHookOptions<AddAdminUserPrivilegeMutation, AddAdminUserPrivilegeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddAdminUserPrivilegeMutation, AddAdminUserPrivilegeMutationVariables>(AddAdminUserPrivilegeDocument, options);
      }
export type AddAdminUserPrivilegeMutationHookResult = ReturnType<typeof useAddAdminUserPrivilegeMutation>;
export type AddAdminUserPrivilegeMutationResult = Apollo.MutationResult<AddAdminUserPrivilegeMutation>;
export type AddAdminUserPrivilegeMutationOptions = Apollo.BaseMutationOptions<AddAdminUserPrivilegeMutation, AddAdminUserPrivilegeMutationVariables>;
export const GetAdminUsersDocument = gql`
    query GetAdminUsers {
  adminUsers {
    id
    name
    email
    privileges {
      belongsToCinemaOperatingCompanies {
        id
        name
      }
      rootRole
    }
  }
}
    `;
export type GetAdminUsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAdminUsersQuery, GetAdminUsersQueryVariables>
    } & TChildProps;
export function withGetAdminUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAdminUsersQuery,
  GetAdminUsersQueryVariables,
  GetAdminUsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAdminUsersQuery, GetAdminUsersQueryVariables, GetAdminUsersProps<TChildProps, TDataName>>(GetAdminUsersDocument, {
      alias: 'getAdminUsers',
      ...operationOptions
    });
};

/**
 * __useGetAdminUsersQuery__
 *
 * To run a query within a React component, call `useGetAdminUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
      }
export function useGetAdminUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export function useGetAdminUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminUsersQuery, GetAdminUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminUsersQuery, GetAdminUsersQueryVariables>(GetAdminUsersDocument, options);
        }
export type GetAdminUsersQueryHookResult = ReturnType<typeof useGetAdminUsersQuery>;
export type GetAdminUsersLazyQueryHookResult = ReturnType<typeof useGetAdminUsersLazyQuery>;
export type GetAdminUsersSuspenseQueryHookResult = ReturnType<typeof useGetAdminUsersSuspenseQuery>;
export type GetAdminUsersQueryResult = Apollo.QueryResult<GetAdminUsersQuery, GetAdminUsersQueryVariables>;
export const BonusProgramEditorOptionsDocument = gql`
    query BonusProgramEditorOptions {
  currentUser {
    id
    privileges {
      adminRole
      rootRole
      supportRole
      adminForCinemas {
        id
        name
      }
      adminForBonusPrograms {
        id
        name
        participatingCinemas {
          id
          name
        }
      }
    }
  }
  cinemas {
    id
    name
    bonusProgram {
      id
      name
    }
  }
}
    `;
export type BonusProgramEditorOptionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>
    } & TChildProps;
export function withBonusProgramEditorOptions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BonusProgramEditorOptionsQuery,
  BonusProgramEditorOptionsQueryVariables,
  BonusProgramEditorOptionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables, BonusProgramEditorOptionsProps<TChildProps, TDataName>>(BonusProgramEditorOptionsDocument, {
      alias: 'bonusProgramEditorOptions',
      ...operationOptions
    });
};

/**
 * __useBonusProgramEditorOptionsQuery__
 *
 * To run a query within a React component, call `useBonusProgramEditorOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusProgramEditorOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusProgramEditorOptionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useBonusProgramEditorOptionsQuery(baseOptions?: Apollo.QueryHookOptions<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>(BonusProgramEditorOptionsDocument, options);
      }
export function useBonusProgramEditorOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>(BonusProgramEditorOptionsDocument, options);
        }
export function useBonusProgramEditorOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>(BonusProgramEditorOptionsDocument, options);
        }
export type BonusProgramEditorOptionsQueryHookResult = ReturnType<typeof useBonusProgramEditorOptionsQuery>;
export type BonusProgramEditorOptionsLazyQueryHookResult = ReturnType<typeof useBonusProgramEditorOptionsLazyQuery>;
export type BonusProgramEditorOptionsSuspenseQueryHookResult = ReturnType<typeof useBonusProgramEditorOptionsSuspenseQuery>;
export type BonusProgramEditorOptionsQueryResult = Apollo.QueryResult<BonusProgramEditorOptionsQuery, BonusProgramEditorOptionsQueryVariables>;
export const BonusProgramEditorDocument = gql`
    query BonusProgramEditor($id: ID!) {
  bonusProgram(id: $id) {
    id
    name
    termsLink
    legalEntity
    termsVersion
  }
}
    `;
export type BonusProgramEditorProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>
    } & TChildProps;
export function withBonusProgramEditor<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BonusProgramEditorQuery,
  BonusProgramEditorQueryVariables,
  BonusProgramEditorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BonusProgramEditorQuery, BonusProgramEditorQueryVariables, BonusProgramEditorProps<TChildProps, TDataName>>(BonusProgramEditorDocument, {
      alias: 'bonusProgramEditor',
      ...operationOptions
    });
};

/**
 * __useBonusProgramEditorQuery__
 *
 * To run a query within a React component, call `useBonusProgramEditorQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusProgramEditorQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusProgramEditorQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBonusProgramEditorQuery(baseOptions: Apollo.QueryHookOptions<BonusProgramEditorQuery, BonusProgramEditorQueryVariables> & ({ variables: BonusProgramEditorQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>(BonusProgramEditorDocument, options);
      }
export function useBonusProgramEditorLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>(BonusProgramEditorDocument, options);
        }
export function useBonusProgramEditorSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>(BonusProgramEditorDocument, options);
        }
export type BonusProgramEditorQueryHookResult = ReturnType<typeof useBonusProgramEditorQuery>;
export type BonusProgramEditorLazyQueryHookResult = ReturnType<typeof useBonusProgramEditorLazyQuery>;
export type BonusProgramEditorSuspenseQueryHookResult = ReturnType<typeof useBonusProgramEditorSuspenseQuery>;
export type BonusProgramEditorQueryResult = Apollo.QueryResult<BonusProgramEditorQuery, BonusProgramEditorQueryVariables>;
export const UpdateBonusProgramEditorDocument = gql`
    mutation UpdateBonusProgramEditor($bonusProgramId: ID!, $name: String!, $legalEntity: String!, $termsVersion: Int!, $termsLink: String) {
  updateBonusProgram(
    bonusProgramId: $bonusProgramId
    name: $name
    legalEntity: $legalEntity
    termsVersion: $termsVersion
    termsLink: $termsLink
  ) {
    success
    bonusProgram {
      id
      name
      termsLink
      legalEntity
      termsVersion
    }
  }
}
    `;
export type UpdateBonusProgramEditorMutationFn = Apollo.MutationFunction<UpdateBonusProgramEditorMutation, UpdateBonusProgramEditorMutationVariables>;
export type UpdateBonusProgramEditorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateBonusProgramEditorMutation, UpdateBonusProgramEditorMutationVariables>
    } & TChildProps;
export function withUpdateBonusProgramEditor<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBonusProgramEditorMutation,
  UpdateBonusProgramEditorMutationVariables,
  UpdateBonusProgramEditorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBonusProgramEditorMutation, UpdateBonusProgramEditorMutationVariables, UpdateBonusProgramEditorProps<TChildProps, TDataName>>(UpdateBonusProgramEditorDocument, {
      alias: 'updateBonusProgramEditor',
      ...operationOptions
    });
};

/**
 * __useUpdateBonusProgramEditorMutation__
 *
 * To run a mutation, you first call `useUpdateBonusProgramEditorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBonusProgramEditorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBonusProgramEditorMutation, { data, loading, error }] = useUpdateBonusProgramEditorMutation({
 *   variables: {
 *      bonusProgramId: // value for 'bonusProgramId'
 *      name: // value for 'name'
 *      legalEntity: // value for 'legalEntity'
 *      termsVersion: // value for 'termsVersion'
 *      termsLink: // value for 'termsLink'
 *   },
 * });
 */
export function useUpdateBonusProgramEditorMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBonusProgramEditorMutation, UpdateBonusProgramEditorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBonusProgramEditorMutation, UpdateBonusProgramEditorMutationVariables>(UpdateBonusProgramEditorDocument, options);
      }
export type UpdateBonusProgramEditorMutationHookResult = ReturnType<typeof useUpdateBonusProgramEditorMutation>;
export type UpdateBonusProgramEditorMutationResult = Apollo.MutationResult<UpdateBonusProgramEditorMutation>;
export type UpdateBonusProgramEditorMutationOptions = Apollo.BaseMutationOptions<UpdateBonusProgramEditorMutation, UpdateBonusProgramEditorMutationVariables>;
export const UpdateBonusProgramParticipatingCinemasDocument = gql`
    mutation UpdateBonusProgramParticipatingCinemas($bonusProgramId: ID!, $cinemaIds: [ID!]!) {
  updateBonusProgramParticipatingCinemas(
    bonusProgramId: $bonusProgramId
    cinemaIds: $cinemaIds
  ) {
    success
    bonusProgram {
      id
      name
      participatingCinemas {
        id
        name
      }
    }
  }
}
    `;
export type UpdateBonusProgramParticipatingCinemasMutationFn = Apollo.MutationFunction<UpdateBonusProgramParticipatingCinemasMutation, UpdateBonusProgramParticipatingCinemasMutationVariables>;
export type UpdateBonusProgramParticipatingCinemasProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateBonusProgramParticipatingCinemasMutation, UpdateBonusProgramParticipatingCinemasMutationVariables>
    } & TChildProps;
export function withUpdateBonusProgramParticipatingCinemas<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBonusProgramParticipatingCinemasMutation,
  UpdateBonusProgramParticipatingCinemasMutationVariables,
  UpdateBonusProgramParticipatingCinemasProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBonusProgramParticipatingCinemasMutation, UpdateBonusProgramParticipatingCinemasMutationVariables, UpdateBonusProgramParticipatingCinemasProps<TChildProps, TDataName>>(UpdateBonusProgramParticipatingCinemasDocument, {
      alias: 'updateBonusProgramParticipatingCinemas',
      ...operationOptions
    });
};

/**
 * __useUpdateBonusProgramParticipatingCinemasMutation__
 *
 * To run a mutation, you first call `useUpdateBonusProgramParticipatingCinemasMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBonusProgramParticipatingCinemasMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBonusProgramParticipatingCinemasMutation, { data, loading, error }] = useUpdateBonusProgramParticipatingCinemasMutation({
 *   variables: {
 *      bonusProgramId: // value for 'bonusProgramId'
 *      cinemaIds: // value for 'cinemaIds'
 *   },
 * });
 */
export function useUpdateBonusProgramParticipatingCinemasMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBonusProgramParticipatingCinemasMutation, UpdateBonusProgramParticipatingCinemasMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBonusProgramParticipatingCinemasMutation, UpdateBonusProgramParticipatingCinemasMutationVariables>(UpdateBonusProgramParticipatingCinemasDocument, options);
      }
export type UpdateBonusProgramParticipatingCinemasMutationHookResult = ReturnType<typeof useUpdateBonusProgramParticipatingCinemasMutation>;
export type UpdateBonusProgramParticipatingCinemasMutationResult = Apollo.MutationResult<UpdateBonusProgramParticipatingCinemasMutation>;
export type UpdateBonusProgramParticipatingCinemasMutationOptions = Apollo.BaseMutationOptions<UpdateBonusProgramParticipatingCinemasMutation, UpdateBonusProgramParticipatingCinemasMutationVariables>;
export const UpdateScreeningDocument = gql`
    mutation updateScreening($id: ID!, $marked: Boolean!) {
  updateScreening(id: $id, lastChance: $marked) {
    success
  }
}
    `;
export type UpdateScreeningMutationFn = Apollo.MutationFunction<UpdateScreeningMutation, UpdateScreeningMutationVariables>;
export type UpdateScreeningProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateScreeningMutation, UpdateScreeningMutationVariables>
    } & TChildProps;
export function withUpdateScreening<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateScreeningMutation,
  UpdateScreeningMutationVariables,
  UpdateScreeningProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateScreeningMutation, UpdateScreeningMutationVariables, UpdateScreeningProps<TChildProps, TDataName>>(UpdateScreeningDocument, {
      alias: 'updateScreening',
      ...operationOptions
    });
};

/**
 * __useUpdateScreeningMutation__
 *
 * To run a mutation, you first call `useUpdateScreeningMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateScreeningMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateScreeningMutation, { data, loading, error }] = useUpdateScreeningMutation({
 *   variables: {
 *      id: // value for 'id'
 *      marked: // value for 'marked'
 *   },
 * });
 */
export function useUpdateScreeningMutation(baseOptions?: Apollo.MutationHookOptions<UpdateScreeningMutation, UpdateScreeningMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateScreeningMutation, UpdateScreeningMutationVariables>(UpdateScreeningDocument, options);
      }
export type UpdateScreeningMutationHookResult = ReturnType<typeof useUpdateScreeningMutation>;
export type UpdateScreeningMutationResult = Apollo.MutationResult<UpdateScreeningMutation>;
export type UpdateScreeningMutationOptions = Apollo.BaseMutationOptions<UpdateScreeningMutation, UpdateScreeningMutationVariables>;
export const GetMoviesWithLastChanceInfoDocument = gql`
    query getMoviesWithLastChanceInfo($id: ID!) {
  cinema(id: $id) {
    id
    moviesWithLastChanceInfo(includeOutdated: false) {
      movie {
        id
        title
        poster
        nonMovieEvent
      }
      lastKnownScreening {
        id
        datetime
      }
      screeningsMarkedAsLastChance {
        id
        datetime
      }
    }
  }
}
    `;
export type GetMoviesWithLastChanceInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>
    } & TChildProps;
export function withGetMoviesWithLastChanceInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMoviesWithLastChanceInfoQuery,
  GetMoviesWithLastChanceInfoQueryVariables,
  GetMoviesWithLastChanceInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables, GetMoviesWithLastChanceInfoProps<TChildProps, TDataName>>(GetMoviesWithLastChanceInfoDocument, {
      alias: 'getMoviesWithLastChanceInfo',
      ...operationOptions
    });
};

/**
 * __useGetMoviesWithLastChanceInfoQuery__
 *
 * To run a query within a React component, call `useGetMoviesWithLastChanceInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMoviesWithLastChanceInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMoviesWithLastChanceInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetMoviesWithLastChanceInfoQuery(baseOptions: Apollo.QueryHookOptions<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables> & ({ variables: GetMoviesWithLastChanceInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>(GetMoviesWithLastChanceInfoDocument, options);
      }
export function useGetMoviesWithLastChanceInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>(GetMoviesWithLastChanceInfoDocument, options);
        }
export function useGetMoviesWithLastChanceInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>(GetMoviesWithLastChanceInfoDocument, options);
        }
export type GetMoviesWithLastChanceInfoQueryHookResult = ReturnType<typeof useGetMoviesWithLastChanceInfoQuery>;
export type GetMoviesWithLastChanceInfoLazyQueryHookResult = ReturnType<typeof useGetMoviesWithLastChanceInfoLazyQuery>;
export type GetMoviesWithLastChanceInfoSuspenseQueryHookResult = ReturnType<typeof useGetMoviesWithLastChanceInfoSuspenseQuery>;
export type GetMoviesWithLastChanceInfoQueryResult = Apollo.QueryResult<GetMoviesWithLastChanceInfoQuery, GetMoviesWithLastChanceInfoQueryVariables>;
export const CreateSoonInCinemaItemDocument = gql`
    mutation createSoonInCinemaItem($cinemaId: ID!, $movieTitle: String, $movieId: ID, $startDate: Date) {
  createSoonInCinemaItem(
    cinemaId: $cinemaId
    movieTitle: $movieTitle
    movieId: $movieId
    startDate: $startDate
  ) {
    success
  }
}
    `;
export type CreateSoonInCinemaItemMutationFn = Apollo.MutationFunction<CreateSoonInCinemaItemMutation, CreateSoonInCinemaItemMutationVariables>;
export type CreateSoonInCinemaItemProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateSoonInCinemaItemMutation, CreateSoonInCinemaItemMutationVariables>
    } & TChildProps;
export function withCreateSoonInCinemaItem<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateSoonInCinemaItemMutation,
  CreateSoonInCinemaItemMutationVariables,
  CreateSoonInCinemaItemProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateSoonInCinemaItemMutation, CreateSoonInCinemaItemMutationVariables, CreateSoonInCinemaItemProps<TChildProps, TDataName>>(CreateSoonInCinemaItemDocument, {
      alias: 'createSoonInCinemaItem',
      ...operationOptions
    });
};

/**
 * __useCreateSoonInCinemaItemMutation__
 *
 * To run a mutation, you first call `useCreateSoonInCinemaItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateSoonInCinemaItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createSoonInCinemaItemMutation, { data, loading, error }] = useCreateSoonInCinemaItemMutation({
 *   variables: {
 *      cinemaId: // value for 'cinemaId'
 *      movieTitle: // value for 'movieTitle'
 *      movieId: // value for 'movieId'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useCreateSoonInCinemaItemMutation(baseOptions?: Apollo.MutationHookOptions<CreateSoonInCinemaItemMutation, CreateSoonInCinemaItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateSoonInCinemaItemMutation, CreateSoonInCinemaItemMutationVariables>(CreateSoonInCinemaItemDocument, options);
      }
export type CreateSoonInCinemaItemMutationHookResult = ReturnType<typeof useCreateSoonInCinemaItemMutation>;
export type CreateSoonInCinemaItemMutationResult = Apollo.MutationResult<CreateSoonInCinemaItemMutation>;
export type CreateSoonInCinemaItemMutationOptions = Apollo.BaseMutationOptions<CreateSoonInCinemaItemMutation, CreateSoonInCinemaItemMutationVariables>;
export const UpdateSoonInCinemaItemDocument = gql`
    mutation updateSoonInCinemaItem($id: ID!, $movieTitle: String, $startDate: Date) {
  updateSoonInCinemaItem(id: $id, movieTitle: $movieTitle, startDate: $startDate) {
    success
  }
}
    `;
export type UpdateSoonInCinemaItemMutationFn = Apollo.MutationFunction<UpdateSoonInCinemaItemMutation, UpdateSoonInCinemaItemMutationVariables>;
export type UpdateSoonInCinemaItemProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateSoonInCinemaItemMutation, UpdateSoonInCinemaItemMutationVariables>
    } & TChildProps;
export function withUpdateSoonInCinemaItem<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSoonInCinemaItemMutation,
  UpdateSoonInCinemaItemMutationVariables,
  UpdateSoonInCinemaItemProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSoonInCinemaItemMutation, UpdateSoonInCinemaItemMutationVariables, UpdateSoonInCinemaItemProps<TChildProps, TDataName>>(UpdateSoonInCinemaItemDocument, {
      alias: 'updateSoonInCinemaItem',
      ...operationOptions
    });
};

/**
 * __useUpdateSoonInCinemaItemMutation__
 *
 * To run a mutation, you first call `useUpdateSoonInCinemaItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSoonInCinemaItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSoonInCinemaItemMutation, { data, loading, error }] = useUpdateSoonInCinemaItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      movieTitle: // value for 'movieTitle'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useUpdateSoonInCinemaItemMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSoonInCinemaItemMutation, UpdateSoonInCinemaItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSoonInCinemaItemMutation, UpdateSoonInCinemaItemMutationVariables>(UpdateSoonInCinemaItemDocument, options);
      }
export type UpdateSoonInCinemaItemMutationHookResult = ReturnType<typeof useUpdateSoonInCinemaItemMutation>;
export type UpdateSoonInCinemaItemMutationResult = Apollo.MutationResult<UpdateSoonInCinemaItemMutation>;
export type UpdateSoonInCinemaItemMutationOptions = Apollo.BaseMutationOptions<UpdateSoonInCinemaItemMutation, UpdateSoonInCinemaItemMutationVariables>;
export const AllMoviesOldDocument = gql`
    query allMoviesOld {
  allMovies {
    title
    id
    poster
  }
}
    `;
export type AllMoviesOldProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllMoviesOldQuery, AllMoviesOldQueryVariables>
    } & TChildProps;
export function withAllMoviesOld<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllMoviesOldQuery,
  AllMoviesOldQueryVariables,
  AllMoviesOldProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllMoviesOldQuery, AllMoviesOldQueryVariables, AllMoviesOldProps<TChildProps, TDataName>>(AllMoviesOldDocument, {
      alias: 'allMoviesOld',
      ...operationOptions
    });
};

/**
 * __useAllMoviesOldQuery__
 *
 * To run a query within a React component, call `useAllMoviesOldQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMoviesOldQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMoviesOldQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllMoviesOldQuery(baseOptions?: Apollo.QueryHookOptions<AllMoviesOldQuery, AllMoviesOldQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMoviesOldQuery, AllMoviesOldQueryVariables>(AllMoviesOldDocument, options);
      }
export function useAllMoviesOldLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMoviesOldQuery, AllMoviesOldQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMoviesOldQuery, AllMoviesOldQueryVariables>(AllMoviesOldDocument, options);
        }
export function useAllMoviesOldSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllMoviesOldQuery, AllMoviesOldQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllMoviesOldQuery, AllMoviesOldQueryVariables>(AllMoviesOldDocument, options);
        }
export type AllMoviesOldQueryHookResult = ReturnType<typeof useAllMoviesOldQuery>;
export type AllMoviesOldLazyQueryHookResult = ReturnType<typeof useAllMoviesOldLazyQuery>;
export type AllMoviesOldSuspenseQueryHookResult = ReturnType<typeof useAllMoviesOldSuspenseQuery>;
export type AllMoviesOldQueryResult = Apollo.QueryResult<AllMoviesOldQuery, AllMoviesOldQueryVariables>;
export const DeleteSoonInCinemaItemDocument = gql`
    mutation deleteSoonInCinemaItem($id: ID!) {
  deleteSoonInCinemaItem(id: $id) {
    success
  }
}
    `;
export type DeleteSoonInCinemaItemMutationFn = Apollo.MutationFunction<DeleteSoonInCinemaItemMutation, DeleteSoonInCinemaItemMutationVariables>;
export type DeleteSoonInCinemaItemProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteSoonInCinemaItemMutation, DeleteSoonInCinemaItemMutationVariables>
    } & TChildProps;
export function withDeleteSoonInCinemaItem<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteSoonInCinemaItemMutation,
  DeleteSoonInCinemaItemMutationVariables,
  DeleteSoonInCinemaItemProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteSoonInCinemaItemMutation, DeleteSoonInCinemaItemMutationVariables, DeleteSoonInCinemaItemProps<TChildProps, TDataName>>(DeleteSoonInCinemaItemDocument, {
      alias: 'deleteSoonInCinemaItem',
      ...operationOptions
    });
};

/**
 * __useDeleteSoonInCinemaItemMutation__
 *
 * To run a mutation, you first call `useDeleteSoonInCinemaItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSoonInCinemaItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSoonInCinemaItemMutation, { data, loading, error }] = useDeleteSoonInCinemaItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteSoonInCinemaItemMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSoonInCinemaItemMutation, DeleteSoonInCinemaItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSoonInCinemaItemMutation, DeleteSoonInCinemaItemMutationVariables>(DeleteSoonInCinemaItemDocument, options);
      }
export type DeleteSoonInCinemaItemMutationHookResult = ReturnType<typeof useDeleteSoonInCinemaItemMutation>;
export type DeleteSoonInCinemaItemMutationResult = Apollo.MutationResult<DeleteSoonInCinemaItemMutation>;
export type DeleteSoonInCinemaItemMutationOptions = Apollo.BaseMutationOptions<DeleteSoonInCinemaItemMutation, DeleteSoonInCinemaItemMutationVariables>;
export const SoonInCinemaItemsDocument = gql`
    query soonInCinemaItems($cinemaId: ID!) {
  soonInCinemaItems(cinemaId: $cinemaId) {
    id
    startDate
    movieTitle
    movie {
      id
      title
      poster
    }
  }
}
    `;
export type SoonInCinemaItemsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>
    } & TChildProps;
export function withSoonInCinemaItems<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SoonInCinemaItemsQuery,
  SoonInCinemaItemsQueryVariables,
  SoonInCinemaItemsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables, SoonInCinemaItemsProps<TChildProps, TDataName>>(SoonInCinemaItemsDocument, {
      alias: 'soonInCinemaItems',
      ...operationOptions
    });
};

/**
 * __useSoonInCinemaItemsQuery__
 *
 * To run a query within a React component, call `useSoonInCinemaItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSoonInCinemaItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSoonInCinemaItemsQuery({
 *   variables: {
 *      cinemaId: // value for 'cinemaId'
 *   },
 * });
 */
export function useSoonInCinemaItemsQuery(baseOptions: Apollo.QueryHookOptions<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables> & ({ variables: SoonInCinemaItemsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>(SoonInCinemaItemsDocument, options);
      }
export function useSoonInCinemaItemsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>(SoonInCinemaItemsDocument, options);
        }
export function useSoonInCinemaItemsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>(SoonInCinemaItemsDocument, options);
        }
export type SoonInCinemaItemsQueryHookResult = ReturnType<typeof useSoonInCinemaItemsQuery>;
export type SoonInCinemaItemsLazyQueryHookResult = ReturnType<typeof useSoonInCinemaItemsLazyQuery>;
export type SoonInCinemaItemsSuspenseQueryHookResult = ReturnType<typeof useSoonInCinemaItemsSuspenseQuery>;
export type SoonInCinemaItemsQueryResult = Apollo.QueryResult<SoonInCinemaItemsQuery, SoonInCinemaItemsQueryVariables>;
export const SetUserContentEditorStatusDocument = gql`
    mutation SetUserContentEditorStatus($userId: ID!, $isContentEditor: Boolean!) {
  setUserContentEditorStatus(userId: $userId, isContentEditor: $isContentEditor) {
    success
    user {
      id
      privileges {
        contentEditorRole
      }
    }
  }
}
    `;
export type SetUserContentEditorStatusMutationFn = Apollo.MutationFunction<SetUserContentEditorStatusMutation, SetUserContentEditorStatusMutationVariables>;
export type SetUserContentEditorStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SetUserContentEditorStatusMutation, SetUserContentEditorStatusMutationVariables>
    } & TChildProps;
export function withSetUserContentEditorStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SetUserContentEditorStatusMutation,
  SetUserContentEditorStatusMutationVariables,
  SetUserContentEditorStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SetUserContentEditorStatusMutation, SetUserContentEditorStatusMutationVariables, SetUserContentEditorStatusProps<TChildProps, TDataName>>(SetUserContentEditorStatusDocument, {
      alias: 'setUserContentEditorStatus',
      ...operationOptions
    });
};

/**
 * __useSetUserContentEditorStatusMutation__
 *
 * To run a mutation, you first call `useSetUserContentEditorStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserContentEditorStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserContentEditorStatusMutation, { data, loading, error }] = useSetUserContentEditorStatusMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      isContentEditor: // value for 'isContentEditor'
 *   },
 * });
 */
export function useSetUserContentEditorStatusMutation(baseOptions?: Apollo.MutationHookOptions<SetUserContentEditorStatusMutation, SetUserContentEditorStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetUserContentEditorStatusMutation, SetUserContentEditorStatusMutationVariables>(SetUserContentEditorStatusDocument, options);
      }
export type SetUserContentEditorStatusMutationHookResult = ReturnType<typeof useSetUserContentEditorStatusMutation>;
export type SetUserContentEditorStatusMutationResult = Apollo.MutationResult<SetUserContentEditorStatusMutation>;
export type SetUserContentEditorStatusMutationOptions = Apollo.BaseMutationOptions<SetUserContentEditorStatusMutation, SetUserContentEditorStatusMutationVariables>;
export const EmailComponentDocument = gql`
    query EmailComponent($id: ID!, $componentName: EmailComponentName!, $componentProps: Json!, $brand: Brand!) {
  emailComponent(
    identifier: $id
    componentName: $componentName
    componentProps: $componentProps
    brand: $brand
  ) {
    id
    html
  }
}
    `;
export type EmailComponentProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EmailComponentQuery, EmailComponentQueryVariables>
    } & TChildProps;
export function withEmailComponent<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EmailComponentQuery,
  EmailComponentQueryVariables,
  EmailComponentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EmailComponentQuery, EmailComponentQueryVariables, EmailComponentProps<TChildProps, TDataName>>(EmailComponentDocument, {
      alias: 'emailComponent',
      ...operationOptions
    });
};

/**
 * __useEmailComponentQuery__
 *
 * To run a query within a React component, call `useEmailComponentQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailComponentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailComponentQuery({
 *   variables: {
 *      id: // value for 'id'
 *      componentName: // value for 'componentName'
 *      componentProps: // value for 'componentProps'
 *      brand: // value for 'brand'
 *   },
 * });
 */
export function useEmailComponentQuery(baseOptions: Apollo.QueryHookOptions<EmailComponentQuery, EmailComponentQueryVariables> & ({ variables: EmailComponentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailComponentQuery, EmailComponentQueryVariables>(EmailComponentDocument, options);
      }
export function useEmailComponentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailComponentQuery, EmailComponentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailComponentQuery, EmailComponentQueryVariables>(EmailComponentDocument, options);
        }
export function useEmailComponentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailComponentQuery, EmailComponentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailComponentQuery, EmailComponentQueryVariables>(EmailComponentDocument, options);
        }
export type EmailComponentQueryHookResult = ReturnType<typeof useEmailComponentQuery>;
export type EmailComponentLazyQueryHookResult = ReturnType<typeof useEmailComponentLazyQuery>;
export type EmailComponentSuspenseQueryHookResult = ReturnType<typeof useEmailComponentSuspenseQuery>;
export type EmailComponentQueryResult = Apollo.QueryResult<EmailComponentQuery, EmailComponentQueryVariables>;
export const AllMovieListsDocument = gql`
    query AllMovieLists($ids: [ID!]!) {
  allCinemaFilmSeries(cinemaIds: $ids) {
    id
    title
  }
}
    `;
export type AllMovieListsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllMovieListsQuery, AllMovieListsQueryVariables>
    } & TChildProps;
export function withAllMovieLists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllMovieListsQuery,
  AllMovieListsQueryVariables,
  AllMovieListsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllMovieListsQuery, AllMovieListsQueryVariables, AllMovieListsProps<TChildProps, TDataName>>(AllMovieListsDocument, {
      alias: 'allMovieLists',
      ...operationOptions
    });
};

/**
 * __useAllMovieListsQuery__
 *
 * To run a query within a React component, call `useAllMovieListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMovieListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMovieListsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useAllMovieListsQuery(baseOptions: Apollo.QueryHookOptions<AllMovieListsQuery, AllMovieListsQueryVariables> & ({ variables: AllMovieListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMovieListsQuery, AllMovieListsQueryVariables>(AllMovieListsDocument, options);
      }
export function useAllMovieListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMovieListsQuery, AllMovieListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMovieListsQuery, AllMovieListsQueryVariables>(AllMovieListsDocument, options);
        }
export function useAllMovieListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllMovieListsQuery, AllMovieListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllMovieListsQuery, AllMovieListsQueryVariables>(AllMovieListsDocument, options);
        }
export type AllMovieListsQueryHookResult = ReturnType<typeof useAllMovieListsQuery>;
export type AllMovieListsLazyQueryHookResult = ReturnType<typeof useAllMovieListsLazyQuery>;
export type AllMovieListsSuspenseQueryHookResult = ReturnType<typeof useAllMovieListsSuspenseQuery>;
export type AllMovieListsQueryResult = Apollo.QueryResult<AllMovieListsQuery, AllMovieListsQueryVariables>;
export const SendTestEmailDocument = gql`
    mutation SendTestEmail($brand: Brand!, $componentData: String!) {
  sendTestEmail(brand: $brand, componentData: $componentData) {
    success
  }
}
    `;
export type SendTestEmailMutationFn = Apollo.MutationFunction<SendTestEmailMutation, SendTestEmailMutationVariables>;
export type SendTestEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SendTestEmailMutation, SendTestEmailMutationVariables>
    } & TChildProps;
export function withSendTestEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendTestEmailMutation,
  SendTestEmailMutationVariables,
  SendTestEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SendTestEmailMutation, SendTestEmailMutationVariables, SendTestEmailProps<TChildProps, TDataName>>(SendTestEmailDocument, {
      alias: 'sendTestEmail',
      ...operationOptions
    });
};

/**
 * __useSendTestEmailMutation__
 *
 * To run a mutation, you first call `useSendTestEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestEmailMutation, { data, loading, error }] = useSendTestEmailMutation({
 *   variables: {
 *      brand: // value for 'brand'
 *      componentData: // value for 'componentData'
 *   },
 * });
 */
export function useSendTestEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendTestEmailMutation, SendTestEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestEmailMutation, SendTestEmailMutationVariables>(SendTestEmailDocument, options);
      }
export type SendTestEmailMutationHookResult = ReturnType<typeof useSendTestEmailMutation>;
export type SendTestEmailMutationResult = Apollo.MutationResult<SendTestEmailMutation>;
export type SendTestEmailMutationOptions = Apollo.BaseMutationOptions<SendTestEmailMutation, SendTestEmailMutationVariables>;
export const ScreeningsDocument = gql`
    query Screenings($ids: [ID!], $foreignIdType: String!, $before: DateTime, $after: DateTime) {
  screenings(cinemaIds: $ids, before: $before, after: $after) {
    movie {
      id
      title
      synopsis
      duration
      poster
      ageRating
      foreignMovieId(foreignIdType: $foreignIdType) {
        foreignId
      }
    }
  }
}
    `;
export type ScreeningsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ScreeningsQuery, ScreeningsQueryVariables>
    } & TChildProps;
export function withScreenings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ScreeningsQuery,
  ScreeningsQueryVariables,
  ScreeningsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ScreeningsQuery, ScreeningsQueryVariables, ScreeningsProps<TChildProps, TDataName>>(ScreeningsDocument, {
      alias: 'screenings',
      ...operationOptions
    });
};

/**
 * __useScreeningsQuery__
 *
 * To run a query within a React component, call `useScreeningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useScreeningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useScreeningsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      foreignIdType: // value for 'foreignIdType'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useScreeningsQuery(baseOptions: Apollo.QueryHookOptions<ScreeningsQuery, ScreeningsQueryVariables> & ({ variables: ScreeningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ScreeningsQuery, ScreeningsQueryVariables>(ScreeningsDocument, options);
      }
export function useScreeningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ScreeningsQuery, ScreeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ScreeningsQuery, ScreeningsQueryVariables>(ScreeningsDocument, options);
        }
export function useScreeningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ScreeningsQuery, ScreeningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ScreeningsQuery, ScreeningsQueryVariables>(ScreeningsDocument, options);
        }
export type ScreeningsQueryHookResult = ReturnType<typeof useScreeningsQuery>;
export type ScreeningsLazyQueryHookResult = ReturnType<typeof useScreeningsLazyQuery>;
export type ScreeningsSuspenseQueryHookResult = ReturnType<typeof useScreeningsSuspenseQuery>;
export type ScreeningsQueryResult = Apollo.QueryResult<ScreeningsQuery, ScreeningsQueryVariables>;
export const CinemasAndScreeningsDocument = gql`
    query CinemasAndScreenings($ids: [ID!], $foreignIdType: String!, $before: DateTime, $after: DateTime) {
  cinemas(ids: $ids) {
    id
    name
    movies(futureOnly: true) {
      id
      title
      synopsis
      duration
      poster
      ageRating
      foreignMovieId(foreignIdType: $foreignIdType) {
        foreignId
      }
    }
  }
  screenings(cinemaIds: $ids, before: $before, after: $after) {
    id
    datetime
    cinema {
      name
      id
    }
    movie {
      title
      id
    }
    is3d
    is2d
  }
}
    `;
export type CinemasAndScreeningsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>
    } & TChildProps;
export function withCinemasAndScreenings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CinemasAndScreeningsQuery,
  CinemasAndScreeningsQueryVariables,
  CinemasAndScreeningsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables, CinemasAndScreeningsProps<TChildProps, TDataName>>(CinemasAndScreeningsDocument, {
      alias: 'cinemasAndScreenings',
      ...operationOptions
    });
};

/**
 * __useCinemasAndScreeningsQuery__
 *
 * To run a query within a React component, call `useCinemasAndScreeningsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCinemasAndScreeningsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCinemasAndScreeningsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      foreignIdType: // value for 'foreignIdType'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useCinemasAndScreeningsQuery(baseOptions: Apollo.QueryHookOptions<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables> & ({ variables: CinemasAndScreeningsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>(CinemasAndScreeningsDocument, options);
      }
export function useCinemasAndScreeningsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>(CinemasAndScreeningsDocument, options);
        }
export function useCinemasAndScreeningsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>(CinemasAndScreeningsDocument, options);
        }
export type CinemasAndScreeningsQueryHookResult = ReturnType<typeof useCinemasAndScreeningsQuery>;
export type CinemasAndScreeningsLazyQueryHookResult = ReturnType<typeof useCinemasAndScreeningsLazyQuery>;
export type CinemasAndScreeningsSuspenseQueryHookResult = ReturnType<typeof useCinemasAndScreeningsSuspenseQuery>;
export type CinemasAndScreeningsQueryResult = Apollo.QueryResult<CinemasAndScreeningsQuery, CinemasAndScreeningsQueryVariables>;
export const MovieListsFullDocument = gql`
    query MovieListsFull($ids: [ID!]!, $foreignIdType: String!, $before: DateTime) {
  cinemas(ids: $ids) {
    id
    name
  }
  allCinemaFilmSeries(cinemaIds: $ids, before: $before) {
    id
    title
    subTitle
    description
    items {
      description
      movie {
        id
        title
        synopsis
        duration
        poster
        ageRating
        foreignMovieId(foreignIdType: $foreignIdType) {
          foreignId
        }
      }
    }
  }
}
    `;
export type MovieListsFullProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MovieListsFullQuery, MovieListsFullQueryVariables>
    } & TChildProps;
export function withMovieListsFull<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MovieListsFullQuery,
  MovieListsFullQueryVariables,
  MovieListsFullProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MovieListsFullQuery, MovieListsFullQueryVariables, MovieListsFullProps<TChildProps, TDataName>>(MovieListsFullDocument, {
      alias: 'movieListsFull',
      ...operationOptions
    });
};

/**
 * __useMovieListsFullQuery__
 *
 * To run a query within a React component, call `useMovieListsFullQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieListsFullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieListsFullQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *      foreignIdType: // value for 'foreignIdType'
 *      before: // value for 'before'
 *   },
 * });
 */
export function useMovieListsFullQuery(baseOptions: Apollo.QueryHookOptions<MovieListsFullQuery, MovieListsFullQueryVariables> & ({ variables: MovieListsFullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovieListsFullQuery, MovieListsFullQueryVariables>(MovieListsFullDocument, options);
      }
export function useMovieListsFullLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovieListsFullQuery, MovieListsFullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovieListsFullQuery, MovieListsFullQueryVariables>(MovieListsFullDocument, options);
        }
export function useMovieListsFullSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MovieListsFullQuery, MovieListsFullQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MovieListsFullQuery, MovieListsFullQueryVariables>(MovieListsFullDocument, options);
        }
export type MovieListsFullQueryHookResult = ReturnType<typeof useMovieListsFullQuery>;
export type MovieListsFullLazyQueryHookResult = ReturnType<typeof useMovieListsFullLazyQuery>;
export type MovieListsFullSuspenseQueryHookResult = ReturnType<typeof useMovieListsFullSuspenseQuery>;
export type MovieListsFullQueryResult = Apollo.QueryResult<MovieListsFullQuery, MovieListsFullQueryVariables>;
export const AssignEditorialForeignIdentifierDocument = gql`
    mutation AssignEditorialForeignIdentifier($identifierId: ID!, $movieId: ID!, $replaceExistingComscoreIdentifierId: ID) {
  assignEditorialForeignIdentifier(
    identifierId: $identifierId
    movieId: $movieId
    replaceExistingComscoreIdentifierId: $replaceExistingComscoreIdentifierId
  ) {
    success
    movieId
    comscoreIdentifierConflict {
      movie {
        movieId
        title
        releaseDate
        poster
        directedBy
        incomplete
        lastEdit
      }
      existingIdentifier {
        identifierId
        title
        foreignId
        foreignIdType
      }
      newIdentifier {
        identifierId
        title
        foreignId
        foreignIdType
      }
    }
  }
}
    `;
export type AssignEditorialForeignIdentifierMutationFn = Apollo.MutationFunction<AssignEditorialForeignIdentifierMutation, AssignEditorialForeignIdentifierMutationVariables>;
export type AssignEditorialForeignIdentifierProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AssignEditorialForeignIdentifierMutation, AssignEditorialForeignIdentifierMutationVariables>
    } & TChildProps;
export function withAssignEditorialForeignIdentifier<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AssignEditorialForeignIdentifierMutation,
  AssignEditorialForeignIdentifierMutationVariables,
  AssignEditorialForeignIdentifierProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AssignEditorialForeignIdentifierMutation, AssignEditorialForeignIdentifierMutationVariables, AssignEditorialForeignIdentifierProps<TChildProps, TDataName>>(AssignEditorialForeignIdentifierDocument, {
      alias: 'assignEditorialForeignIdentifier',
      ...operationOptions
    });
};

/**
 * __useAssignEditorialForeignIdentifierMutation__
 *
 * To run a mutation, you first call `useAssignEditorialForeignIdentifierMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignEditorialForeignIdentifierMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignEditorialForeignIdentifierMutation, { data, loading, error }] = useAssignEditorialForeignIdentifierMutation({
 *   variables: {
 *      identifierId: // value for 'identifierId'
 *      movieId: // value for 'movieId'
 *      replaceExistingComscoreIdentifierId: // value for 'replaceExistingComscoreIdentifierId'
 *   },
 * });
 */
export function useAssignEditorialForeignIdentifierMutation(baseOptions?: Apollo.MutationHookOptions<AssignEditorialForeignIdentifierMutation, AssignEditorialForeignIdentifierMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignEditorialForeignIdentifierMutation, AssignEditorialForeignIdentifierMutationVariables>(AssignEditorialForeignIdentifierDocument, options);
      }
export type AssignEditorialForeignIdentifierMutationHookResult = ReturnType<typeof useAssignEditorialForeignIdentifierMutation>;
export type AssignEditorialForeignIdentifierMutationResult = Apollo.MutationResult<AssignEditorialForeignIdentifierMutation>;
export type AssignEditorialForeignIdentifierMutationOptions = Apollo.BaseMutationOptions<AssignEditorialForeignIdentifierMutation, AssignEditorialForeignIdentifierMutationVariables>;
export const CreateAndAssignEditorialMovieDocument = gql`
    mutation CreateAndAssignEditorialMovie($identifierId: ID!) {
  createAndAssignEditorialMovie(identifierId: $identifierId) {
    success
    movieId
  }
}
    `;
export type CreateAndAssignEditorialMovieMutationFn = Apollo.MutationFunction<CreateAndAssignEditorialMovieMutation, CreateAndAssignEditorialMovieMutationVariables>;
export type CreateAndAssignEditorialMovieProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateAndAssignEditorialMovieMutation, CreateAndAssignEditorialMovieMutationVariables>
    } & TChildProps;
export function withCreateAndAssignEditorialMovie<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateAndAssignEditorialMovieMutation,
  CreateAndAssignEditorialMovieMutationVariables,
  CreateAndAssignEditorialMovieProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateAndAssignEditorialMovieMutation, CreateAndAssignEditorialMovieMutationVariables, CreateAndAssignEditorialMovieProps<TChildProps, TDataName>>(CreateAndAssignEditorialMovieDocument, {
      alias: 'createAndAssignEditorialMovie',
      ...operationOptions
    });
};

/**
 * __useCreateAndAssignEditorialMovieMutation__
 *
 * To run a mutation, you first call `useCreateAndAssignEditorialMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAndAssignEditorialMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAndAssignEditorialMovieMutation, { data, loading, error }] = useCreateAndAssignEditorialMovieMutation({
 *   variables: {
 *      identifierId: // value for 'identifierId'
 *   },
 * });
 */
export function useCreateAndAssignEditorialMovieMutation(baseOptions?: Apollo.MutationHookOptions<CreateAndAssignEditorialMovieMutation, CreateAndAssignEditorialMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAndAssignEditorialMovieMutation, CreateAndAssignEditorialMovieMutationVariables>(CreateAndAssignEditorialMovieDocument, options);
      }
export type CreateAndAssignEditorialMovieMutationHookResult = ReturnType<typeof useCreateAndAssignEditorialMovieMutation>;
export type CreateAndAssignEditorialMovieMutationResult = Apollo.MutationResult<CreateAndAssignEditorialMovieMutation>;
export type CreateAndAssignEditorialMovieMutationOptions = Apollo.BaseMutationOptions<CreateAndAssignEditorialMovieMutation, CreateAndAssignEditorialMovieMutationVariables>;
export const AssignEditorialSoonInCinemaItemDocument = gql`
    mutation AssignEditorialSoonInCinemaItem($itemId: ID!, $movieId: ID!) {
  assignEditorialSoonInCinemaItem(itemId: $itemId, movieId: $movieId) {
    success
    movieId
  }
}
    `;
export type AssignEditorialSoonInCinemaItemMutationFn = Apollo.MutationFunction<AssignEditorialSoonInCinemaItemMutation, AssignEditorialSoonInCinemaItemMutationVariables>;
export type AssignEditorialSoonInCinemaItemProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<AssignEditorialSoonInCinemaItemMutation, AssignEditorialSoonInCinemaItemMutationVariables>
    } & TChildProps;
export function withAssignEditorialSoonInCinemaItem<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AssignEditorialSoonInCinemaItemMutation,
  AssignEditorialSoonInCinemaItemMutationVariables,
  AssignEditorialSoonInCinemaItemProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AssignEditorialSoonInCinemaItemMutation, AssignEditorialSoonInCinemaItemMutationVariables, AssignEditorialSoonInCinemaItemProps<TChildProps, TDataName>>(AssignEditorialSoonInCinemaItemDocument, {
      alias: 'assignEditorialSoonInCinemaItem',
      ...operationOptions
    });
};

/**
 * __useAssignEditorialSoonInCinemaItemMutation__
 *
 * To run a mutation, you first call `useAssignEditorialSoonInCinemaItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignEditorialSoonInCinemaItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignEditorialSoonInCinemaItemMutation, { data, loading, error }] = useAssignEditorialSoonInCinemaItemMutation({
 *   variables: {
 *      itemId: // value for 'itemId'
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useAssignEditorialSoonInCinemaItemMutation(baseOptions?: Apollo.MutationHookOptions<AssignEditorialSoonInCinemaItemMutation, AssignEditorialSoonInCinemaItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AssignEditorialSoonInCinemaItemMutation, AssignEditorialSoonInCinemaItemMutationVariables>(AssignEditorialSoonInCinemaItemDocument, options);
      }
export type AssignEditorialSoonInCinemaItemMutationHookResult = ReturnType<typeof useAssignEditorialSoonInCinemaItemMutation>;
export type AssignEditorialSoonInCinemaItemMutationResult = Apollo.MutationResult<AssignEditorialSoonInCinemaItemMutation>;
export type AssignEditorialSoonInCinemaItemMutationOptions = Apollo.BaseMutationOptions<AssignEditorialSoonInCinemaItemMutation, AssignEditorialSoonInCinemaItemMutationVariables>;
export const MovieEditorialOverviewDocument = gql`
    query MovieEditorialOverview($limitPerQueue: Int!) {
  movieEditorialTodoOverview(limitPerQueue: $limitPerQueue) {
    contentFollowUp {
      ...MovieEditorialTodoQueue
    }
    brokenTrailers {
      ...MovieEditorialTodoQueue
    }
    unmatchedSoonInCinema {
      ...MovieEditorialTodoQueue
    }
    unmatchedForeignIdentifiers {
      ...MovieEditorialTodoQueue
    }
  }
}
    ${MovieEditorialTodoQueueFragmentDoc}`;
export type MovieEditorialOverviewProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>
    } & TChildProps;
export function withMovieEditorialOverview<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MovieEditorialOverviewQuery,
  MovieEditorialOverviewQueryVariables,
  MovieEditorialOverviewProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables, MovieEditorialOverviewProps<TChildProps, TDataName>>(MovieEditorialOverviewDocument, {
      alias: 'movieEditorialOverview',
      ...operationOptions
    });
};

/**
 * __useMovieEditorialOverviewQuery__
 *
 * To run a query within a React component, call `useMovieEditorialOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieEditorialOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieEditorialOverviewQuery({
 *   variables: {
 *      limitPerQueue: // value for 'limitPerQueue'
 *   },
 * });
 */
export function useMovieEditorialOverviewQuery(baseOptions: Apollo.QueryHookOptions<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables> & ({ variables: MovieEditorialOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>(MovieEditorialOverviewDocument, options);
      }
export function useMovieEditorialOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>(MovieEditorialOverviewDocument, options);
        }
export function useMovieEditorialOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>(MovieEditorialOverviewDocument, options);
        }
export type MovieEditorialOverviewQueryHookResult = ReturnType<typeof useMovieEditorialOverviewQuery>;
export type MovieEditorialOverviewLazyQueryHookResult = ReturnType<typeof useMovieEditorialOverviewLazyQuery>;
export type MovieEditorialOverviewSuspenseQueryHookResult = ReturnType<typeof useMovieEditorialOverviewSuspenseQuery>;
export type MovieEditorialOverviewQueryResult = Apollo.QueryResult<MovieEditorialOverviewQuery, MovieEditorialOverviewQueryVariables>;
export const SearchEditorialMoviesDocument = gql`
    query SearchEditorialMovies($query: String!, $limit: Int!) {
  searchEditorialMovies(query: $query, limit: $limit) {
    movieId
    title
    releaseDate
    poster
    directedBy
    incomplete
    lastEdit
  }
}
    `;
export type SearchEditorialMoviesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>
    } & TChildProps;
export function withSearchEditorialMovies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchEditorialMoviesQuery,
  SearchEditorialMoviesQueryVariables,
  SearchEditorialMoviesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables, SearchEditorialMoviesProps<TChildProps, TDataName>>(SearchEditorialMoviesDocument, {
      alias: 'searchEditorialMovies',
      ...operationOptions
    });
};

/**
 * __useSearchEditorialMoviesQuery__
 *
 * To run a query within a React component, call `useSearchEditorialMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEditorialMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEditorialMoviesQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchEditorialMoviesQuery(baseOptions: Apollo.QueryHookOptions<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables> & ({ variables: SearchEditorialMoviesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>(SearchEditorialMoviesDocument, options);
      }
export function useSearchEditorialMoviesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>(SearchEditorialMoviesDocument, options);
        }
export function useSearchEditorialMoviesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>(SearchEditorialMoviesDocument, options);
        }
export type SearchEditorialMoviesQueryHookResult = ReturnType<typeof useSearchEditorialMoviesQuery>;
export type SearchEditorialMoviesLazyQueryHookResult = ReturnType<typeof useSearchEditorialMoviesLazyQuery>;
export type SearchEditorialMoviesSuspenseQueryHookResult = ReturnType<typeof useSearchEditorialMoviesSuspenseQuery>;
export type SearchEditorialMoviesQueryResult = Apollo.QueryResult<SearchEditorialMoviesQuery, SearchEditorialMoviesQueryVariables>;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(email: $email, password: $password, privileged: true) {
    user {
      id
    }
    csrf
    fileServerToken
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;
export type LoginProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<LoginMutation, LoginMutationVariables>
    } & TChildProps;
export function withLogin<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LoginMutation,
  LoginMutationVariables,
  LoginProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LoginMutation, LoginMutationVariables, LoginProps<TChildProps, TDataName>>(LoginDocument, {
      alias: 'login',
      ...operationOptions
    });
};

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      email: // value for 'email'
 *      password: // value for 'password'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const MissedPayoutsDocument = gql`
    query MissedPayouts($from: Date, $to: Date) {
  missedPayouts(filter: {from: $from, to: $to}) {
    user {
      id
      fullName
      email
    }
    subscription {
      id
      paidUntil: payedUntil
    }
  }
}
    `;
export type MissedPayoutsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MissedPayoutsQuery, MissedPayoutsQueryVariables>
    } & TChildProps;
export function withMissedPayouts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MissedPayoutsQuery,
  MissedPayoutsQueryVariables,
  MissedPayoutsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MissedPayoutsQuery, MissedPayoutsQueryVariables, MissedPayoutsProps<TChildProps, TDataName>>(MissedPayoutsDocument, {
      alias: 'missedPayouts',
      ...operationOptions
    });
};

/**
 * __useMissedPayoutsQuery__
 *
 * To run a query within a React component, call `useMissedPayoutsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMissedPayoutsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMissedPayoutsQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useMissedPayoutsQuery(baseOptions?: Apollo.QueryHookOptions<MissedPayoutsQuery, MissedPayoutsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MissedPayoutsQuery, MissedPayoutsQueryVariables>(MissedPayoutsDocument, options);
      }
export function useMissedPayoutsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MissedPayoutsQuery, MissedPayoutsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MissedPayoutsQuery, MissedPayoutsQueryVariables>(MissedPayoutsDocument, options);
        }
export function useMissedPayoutsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MissedPayoutsQuery, MissedPayoutsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MissedPayoutsQuery, MissedPayoutsQueryVariables>(MissedPayoutsDocument, options);
        }
export type MissedPayoutsQueryHookResult = ReturnType<typeof useMissedPayoutsQuery>;
export type MissedPayoutsLazyQueryHookResult = ReturnType<typeof useMissedPayoutsLazyQuery>;
export type MissedPayoutsSuspenseQueryHookResult = ReturnType<typeof useMissedPayoutsSuspenseQuery>;
export type MissedPayoutsQueryResult = Apollo.QueryResult<MissedPayoutsQuery, MissedPayoutsQueryVariables>;
export const IncomingForeignMovieIdentifiersDocument = gql`
    query IncomingForeignMovieIdentifiers($cinemaIds: [ID!]!, $force: Boolean) {
  incomingForeignMovieIdentifiers(cinemaIds: $cinemaIds, force: $force) {
    ...ForeignMovieIdentifierListing
  }
}
    ${ForeignMovieIdentifierListingFragmentDoc}`;
export type IncomingForeignMovieIdentifiersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>
    } & TChildProps;
export function withIncomingForeignMovieIdentifiers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  IncomingForeignMovieIdentifiersQuery,
  IncomingForeignMovieIdentifiersQueryVariables,
  IncomingForeignMovieIdentifiersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables, IncomingForeignMovieIdentifiersProps<TChildProps, TDataName>>(IncomingForeignMovieIdentifiersDocument, {
      alias: 'incomingForeignMovieIdentifiers',
      ...operationOptions
    });
};

/**
 * __useIncomingForeignMovieIdentifiersQuery__
 *
 * To run a query within a React component, call `useIncomingForeignMovieIdentifiersQuery` and pass it any options that fit your needs.
 * When your component renders, `useIncomingForeignMovieIdentifiersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useIncomingForeignMovieIdentifiersQuery({
 *   variables: {
 *      cinemaIds: // value for 'cinemaIds'
 *      force: // value for 'force'
 *   },
 * });
 */
export function useIncomingForeignMovieIdentifiersQuery(baseOptions: Apollo.QueryHookOptions<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables> & ({ variables: IncomingForeignMovieIdentifiersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>(IncomingForeignMovieIdentifiersDocument, options);
      }
export function useIncomingForeignMovieIdentifiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>(IncomingForeignMovieIdentifiersDocument, options);
        }
export function useIncomingForeignMovieIdentifiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>(IncomingForeignMovieIdentifiersDocument, options);
        }
export type IncomingForeignMovieIdentifiersQueryHookResult = ReturnType<typeof useIncomingForeignMovieIdentifiersQuery>;
export type IncomingForeignMovieIdentifiersLazyQueryHookResult = ReturnType<typeof useIncomingForeignMovieIdentifiersLazyQuery>;
export type IncomingForeignMovieIdentifiersSuspenseQueryHookResult = ReturnType<typeof useIncomingForeignMovieIdentifiersSuspenseQuery>;
export type IncomingForeignMovieIdentifiersQueryResult = Apollo.QueryResult<IncomingForeignMovieIdentifiersQuery, IncomingForeignMovieIdentifiersQueryVariables>;
export const UpdateMovieMappingDocument = gql`
    mutation UpdateMovieMapping($foreignId: ID!, $movieId: ID!) {
  updateForeignMovieMapping(foreignId: $foreignId, movieId: $movieId)
}
    `;
export type UpdateMovieMappingMutationFn = Apollo.MutationFunction<UpdateMovieMappingMutation, UpdateMovieMappingMutationVariables>;
export type UpdateMovieMappingProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateMovieMappingMutation, UpdateMovieMappingMutationVariables>
    } & TChildProps;
export function withUpdateMovieMapping<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateMovieMappingMutation,
  UpdateMovieMappingMutationVariables,
  UpdateMovieMappingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateMovieMappingMutation, UpdateMovieMappingMutationVariables, UpdateMovieMappingProps<TChildProps, TDataName>>(UpdateMovieMappingDocument, {
      alias: 'updateMovieMapping',
      ...operationOptions
    });
};

/**
 * __useUpdateMovieMappingMutation__
 *
 * To run a mutation, you first call `useUpdateMovieMappingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMovieMappingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMovieMappingMutation, { data, loading, error }] = useUpdateMovieMappingMutation({
 *   variables: {
 *      foreignId: // value for 'foreignId'
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useUpdateMovieMappingMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMovieMappingMutation, UpdateMovieMappingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMovieMappingMutation, UpdateMovieMappingMutationVariables>(UpdateMovieMappingDocument, options);
      }
export type UpdateMovieMappingMutationHookResult = ReturnType<typeof useUpdateMovieMappingMutation>;
export type UpdateMovieMappingMutationResult = Apollo.MutationResult<UpdateMovieMappingMutation>;
export type UpdateMovieMappingMutationOptions = Apollo.BaseMutationOptions<UpdateMovieMappingMutation, UpdateMovieMappingMutationVariables>;
export const EditorialMovieDocument = gql`
    query EditorialMovie($movieId: ID!) {
  movieEditorialMovie(movieId: $movieId) {
    movieId
    title
    releaseDate
    synopsis
    synopsisSource
    duration
    ageRating
    genres
    poster
    posterSource
    banner
    bannerSource
    youtubeTrailerId
    incomplete
    special
    imdbId
    shownIn
    lastEdit
    stages {
      initial
      shouldSoonExpectedInApp
      soonExpectedInApp
      shouldFirstAppVisibility
      firstAppVisibility
      shouldRelease
      release
      manualReminder
    }
    externalReferences {
      provider
      title
      releaseDate
      synopsis
      duration
      ageRating
      genres
      poster
      banner
    }
  }
  movieEditorialOptions {
    ageRatings
    genres
  }
  posterStockImages: movieEditorialStockImages(type: POSTER) {
    id
    title
    url
  }
  bannerStockImages: movieEditorialStockImages(type: BANNER) {
    id
    title
    url
  }
}
    `;
export type EditorialMovieProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EditorialMovieQuery, EditorialMovieQueryVariables>
    } & TChildProps;
export function withEditorialMovie<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditorialMovieQuery,
  EditorialMovieQueryVariables,
  EditorialMovieProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EditorialMovieQuery, EditorialMovieQueryVariables, EditorialMovieProps<TChildProps, TDataName>>(EditorialMovieDocument, {
      alias: 'editorialMovie',
      ...operationOptions
    });
};

/**
 * __useEditorialMovieQuery__
 *
 * To run a query within a React component, call `useEditorialMovieQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorialMovieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorialMovieQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useEditorialMovieQuery(baseOptions: Apollo.QueryHookOptions<EditorialMovieQuery, EditorialMovieQueryVariables> & ({ variables: EditorialMovieQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditorialMovieQuery, EditorialMovieQueryVariables>(EditorialMovieDocument, options);
      }
export function useEditorialMovieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditorialMovieQuery, EditorialMovieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditorialMovieQuery, EditorialMovieQueryVariables>(EditorialMovieDocument, options);
        }
export function useEditorialMovieSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditorialMovieQuery, EditorialMovieQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditorialMovieQuery, EditorialMovieQueryVariables>(EditorialMovieDocument, options);
        }
export type EditorialMovieQueryHookResult = ReturnType<typeof useEditorialMovieQuery>;
export type EditorialMovieLazyQueryHookResult = ReturnType<typeof useEditorialMovieLazyQuery>;
export type EditorialMovieSuspenseQueryHookResult = ReturnType<typeof useEditorialMovieSuspenseQuery>;
export type EditorialMovieQueryResult = Apollo.QueryResult<EditorialMovieQuery, EditorialMovieQueryVariables>;
export const UpdateEditorialMovieDocument = gql`
    mutation UpdateEditorialMovie($movieId: ID!, $expectedLastEdit: DateTime, $input: MovieEditorialMovieInput!) {
  updateEditorialMovie(
    movieId: $movieId
    expectedLastEdit: $expectedLastEdit
    input: $input
  ) {
    movieId
    title
    releaseDate
    synopsis
    synopsisSource
    duration
    ageRating
    genres
    poster
    posterSource
    banner
    bannerSource
    youtubeTrailerId
    incomplete
    special
    imdbId
    shownIn
    lastEdit
    stages {
      initial
      shouldSoonExpectedInApp
      soonExpectedInApp
      shouldFirstAppVisibility
      firstAppVisibility
      shouldRelease
      release
      manualReminder
    }
    externalReferences {
      provider
      title
      releaseDate
      synopsis
      duration
      ageRating
      genres
      poster
      banner
    }
  }
}
    `;
export type UpdateEditorialMovieMutationFn = Apollo.MutationFunction<UpdateEditorialMovieMutation, UpdateEditorialMovieMutationVariables>;
export type UpdateEditorialMovieProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateEditorialMovieMutation, UpdateEditorialMovieMutationVariables>
    } & TChildProps;
export function withUpdateEditorialMovie<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateEditorialMovieMutation,
  UpdateEditorialMovieMutationVariables,
  UpdateEditorialMovieProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateEditorialMovieMutation, UpdateEditorialMovieMutationVariables, UpdateEditorialMovieProps<TChildProps, TDataName>>(UpdateEditorialMovieDocument, {
      alias: 'updateEditorialMovie',
      ...operationOptions
    });
};

/**
 * __useUpdateEditorialMovieMutation__
 *
 * To run a mutation, you first call `useUpdateEditorialMovieMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEditorialMovieMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEditorialMovieMutation, { data, loading, error }] = useUpdateEditorialMovieMutation({
 *   variables: {
 *      movieId: // value for 'movieId'
 *      expectedLastEdit: // value for 'expectedLastEdit'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEditorialMovieMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEditorialMovieMutation, UpdateEditorialMovieMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEditorialMovieMutation, UpdateEditorialMovieMutationVariables>(UpdateEditorialMovieDocument, options);
      }
export type UpdateEditorialMovieMutationHookResult = ReturnType<typeof useUpdateEditorialMovieMutation>;
export type UpdateEditorialMovieMutationResult = Apollo.MutationResult<UpdateEditorialMovieMutation>;
export type UpdateEditorialMovieMutationOptions = Apollo.BaseMutationOptions<UpdateEditorialMovieMutation, UpdateEditorialMovieMutationVariables>;
export const EditorialMovieTmdbReferenceDocument = gql`
    query EditorialMovieTmdbReference($movieId: ID!) {
  movieEditorialTmdbReference(movieId: $movieId) {
    provider
    title
    releaseDate
    synopsis
    duration
    ageRating
    genres
    posterImages
    bannerImages
  }
}
    `;
export type EditorialMovieTmdbReferenceProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>
    } & TChildProps;
export function withEditorialMovieTmdbReference<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditorialMovieTmdbReferenceQuery,
  EditorialMovieTmdbReferenceQueryVariables,
  EditorialMovieTmdbReferenceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables, EditorialMovieTmdbReferenceProps<TChildProps, TDataName>>(EditorialMovieTmdbReferenceDocument, {
      alias: 'editorialMovieTmdbReference',
      ...operationOptions
    });
};

/**
 * __useEditorialMovieTmdbReferenceQuery__
 *
 * To run a query within a React component, call `useEditorialMovieTmdbReferenceQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorialMovieTmdbReferenceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorialMovieTmdbReferenceQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *   },
 * });
 */
export function useEditorialMovieTmdbReferenceQuery(baseOptions: Apollo.QueryHookOptions<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables> & ({ variables: EditorialMovieTmdbReferenceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>(EditorialMovieTmdbReferenceDocument, options);
      }
export function useEditorialMovieTmdbReferenceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>(EditorialMovieTmdbReferenceDocument, options);
        }
export function useEditorialMovieTmdbReferenceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>(EditorialMovieTmdbReferenceDocument, options);
        }
export type EditorialMovieTmdbReferenceQueryHookResult = ReturnType<typeof useEditorialMovieTmdbReferenceQuery>;
export type EditorialMovieTmdbReferenceLazyQueryHookResult = ReturnType<typeof useEditorialMovieTmdbReferenceLazyQuery>;
export type EditorialMovieTmdbReferenceSuspenseQueryHookResult = ReturnType<typeof useEditorialMovieTmdbReferenceSuspenseQuery>;
export type EditorialMovieTmdbReferenceQueryResult = Apollo.QueryResult<EditorialMovieTmdbReferenceQuery, EditorialMovieTmdbReferenceQueryVariables>;
export const EditorialMovieImdbConflictDocument = gql`
    query EditorialMovieImdbConflict($movieId: ID!, $imdbId: String!) {
  movieEditorialImdbConflict(movieId: $movieId, imdbId: $imdbId) {
    imdbId
    currentMovie {
      movieId
      title
      releaseDate
      synopsis
      duration
      ageRating
      genres
      poster
      imdbIds
      shownIn
      incomplete
      lastEdit
    }
    existingMovie {
      movieId
      title
      releaseDate
      synopsis
      duration
      ageRating
      genres
      poster
      imdbIds
      shownIn
      incomplete
      lastEdit
    }
  }
}
    `;
export type EditorialMovieImdbConflictProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>
    } & TChildProps;
export function withEditorialMovieImdbConflict<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditorialMovieImdbConflictQuery,
  EditorialMovieImdbConflictQueryVariables,
  EditorialMovieImdbConflictProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables, EditorialMovieImdbConflictProps<TChildProps, TDataName>>(EditorialMovieImdbConflictDocument, {
      alias: 'editorialMovieImdbConflict',
      ...operationOptions
    });
};

/**
 * __useEditorialMovieImdbConflictQuery__
 *
 * To run a query within a React component, call `useEditorialMovieImdbConflictQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditorialMovieImdbConflictQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditorialMovieImdbConflictQuery({
 *   variables: {
 *      movieId: // value for 'movieId'
 *      imdbId: // value for 'imdbId'
 *   },
 * });
 */
export function useEditorialMovieImdbConflictQuery(baseOptions: Apollo.QueryHookOptions<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables> & ({ variables: EditorialMovieImdbConflictQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>(EditorialMovieImdbConflictDocument, options);
      }
export function useEditorialMovieImdbConflictLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>(EditorialMovieImdbConflictDocument, options);
        }
export function useEditorialMovieImdbConflictSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>(EditorialMovieImdbConflictDocument, options);
        }
export type EditorialMovieImdbConflictQueryHookResult = ReturnType<typeof useEditorialMovieImdbConflictQuery>;
export type EditorialMovieImdbConflictLazyQueryHookResult = ReturnType<typeof useEditorialMovieImdbConflictLazyQuery>;
export type EditorialMovieImdbConflictSuspenseQueryHookResult = ReturnType<typeof useEditorialMovieImdbConflictSuspenseQuery>;
export type EditorialMovieImdbConflictQueryResult = Apollo.QueryResult<EditorialMovieImdbConflictQuery, EditorialMovieImdbConflictQueryVariables>;
export const MergeEditorialMoviesForImdbConflictDocument = gql`
    mutation MergeEditorialMoviesForImdbConflict($movieId: ID!, $imdbId: String!, $movieIdToKeep: ID!) {
  mergeEditorialMoviesForImdbConflict(
    movieId: $movieId
    imdbId: $imdbId
    movieIdToKeep: $movieIdToKeep
  ) {
    movieId
  }
}
    `;
export type MergeEditorialMoviesForImdbConflictMutationFn = Apollo.MutationFunction<MergeEditorialMoviesForImdbConflictMutation, MergeEditorialMoviesForImdbConflictMutationVariables>;
export type MergeEditorialMoviesForImdbConflictProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<MergeEditorialMoviesForImdbConflictMutation, MergeEditorialMoviesForImdbConflictMutationVariables>
    } & TChildProps;
export function withMergeEditorialMoviesForImdbConflict<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MergeEditorialMoviesForImdbConflictMutation,
  MergeEditorialMoviesForImdbConflictMutationVariables,
  MergeEditorialMoviesForImdbConflictProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, MergeEditorialMoviesForImdbConflictMutation, MergeEditorialMoviesForImdbConflictMutationVariables, MergeEditorialMoviesForImdbConflictProps<TChildProps, TDataName>>(MergeEditorialMoviesForImdbConflictDocument, {
      alias: 'mergeEditorialMoviesForImdbConflict',
      ...operationOptions
    });
};

/**
 * __useMergeEditorialMoviesForImdbConflictMutation__
 *
 * To run a mutation, you first call `useMergeEditorialMoviesForImdbConflictMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeEditorialMoviesForImdbConflictMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeEditorialMoviesForImdbConflictMutation, { data, loading, error }] = useMergeEditorialMoviesForImdbConflictMutation({
 *   variables: {
 *      movieId: // value for 'movieId'
 *      imdbId: // value for 'imdbId'
 *      movieIdToKeep: // value for 'movieIdToKeep'
 *   },
 * });
 */
export function useMergeEditorialMoviesForImdbConflictMutation(baseOptions?: Apollo.MutationHookOptions<MergeEditorialMoviesForImdbConflictMutation, MergeEditorialMoviesForImdbConflictMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeEditorialMoviesForImdbConflictMutation, MergeEditorialMoviesForImdbConflictMutationVariables>(MergeEditorialMoviesForImdbConflictDocument, options);
      }
export type MergeEditorialMoviesForImdbConflictMutationHookResult = ReturnType<typeof useMergeEditorialMoviesForImdbConflictMutation>;
export type MergeEditorialMoviesForImdbConflictMutationResult = Apollo.MutationResult<MergeEditorialMoviesForImdbConflictMutation>;
export type MergeEditorialMoviesForImdbConflictMutationOptions = Apollo.BaseMutationOptions<MergeEditorialMoviesForImdbConflictMutation, MergeEditorialMoviesForImdbConflictMutationVariables>;
export const CurrentUserPosTokensDocument = gql`
    query CurrentUserPOSTokens {
  user: currentUser {
    id
    privileges {
      adminForCinemas {
        id
        name
        posTokens
      }
    }
  }
}
    `;
export type CurrentUserPosTokensProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>
    } & TChildProps;
export function withCurrentUserPosTokens<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CurrentUserPosTokensQuery,
  CurrentUserPosTokensQueryVariables,
  CurrentUserPosTokensProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables, CurrentUserPosTokensProps<TChildProps, TDataName>>(CurrentUserPosTokensDocument, {
      alias: 'currentUserPosTokens',
      ...operationOptions
    });
};

/**
 * __useCurrentUserPosTokensQuery__
 *
 * To run a query within a React component, call `useCurrentUserPosTokensQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserPosTokensQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserPosTokensQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserPosTokensQuery(baseOptions?: Apollo.QueryHookOptions<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>(CurrentUserPosTokensDocument, options);
      }
export function useCurrentUserPosTokensLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>(CurrentUserPosTokensDocument, options);
        }
export function useCurrentUserPosTokensSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>(CurrentUserPosTokensDocument, options);
        }
export type CurrentUserPosTokensQueryHookResult = ReturnType<typeof useCurrentUserPosTokensQuery>;
export type CurrentUserPosTokensLazyQueryHookResult = ReturnType<typeof useCurrentUserPosTokensLazyQuery>;
export type CurrentUserPosTokensSuspenseQueryHookResult = ReturnType<typeof useCurrentUserPosTokensSuspenseQuery>;
export type CurrentUserPosTokensQueryResult = Apollo.QueryResult<CurrentUserPosTokensQuery, CurrentUserPosTokensQueryVariables>;
export const BonusProgramStatisticsDocument = gql`
    query BonusProgramStatistics($bonusProgramIds: [ID!]!, $from: Date!, $to: Date!) {
  bonusPrograms(ids: $bonusProgramIds) {
    name
    statistics(from: $from, to: $to) {
      numBpBookingsInInterval
      numBpBookingsTotal
      numNewUsersInInterval
      numNewUsersTotal
      numUsersInInterval
      numUsersTotal
      scannedVouchersInInterval
      scannedVouchersTotal
      sumBonusPointsInInterval
      sumBonusPointsTotal
      sumBonusPointsSupportInInterval
      sumBonusPointsSupportTotal
      numUsersMultipleBookingsTotal
      redeemedVouchersInInterval {
        id
        name
        redeemedAt
        amountPoints
      }
    }
  }
}
    `;
export type BonusProgramStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>
    } & TChildProps;
export function withBonusProgramStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BonusProgramStatisticsQuery,
  BonusProgramStatisticsQueryVariables,
  BonusProgramStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables, BonusProgramStatisticsProps<TChildProps, TDataName>>(BonusProgramStatisticsDocument, {
      alias: 'bonusProgramStatistics',
      ...operationOptions
    });
};

/**
 * __useBonusProgramStatisticsQuery__
 *
 * To run a query within a React component, call `useBonusProgramStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBonusProgramStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBonusProgramStatisticsQuery({
 *   variables: {
 *      bonusProgramIds: // value for 'bonusProgramIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useBonusProgramStatisticsQuery(baseOptions: Apollo.QueryHookOptions<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables> & ({ variables: BonusProgramStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>(BonusProgramStatisticsDocument, options);
      }
export function useBonusProgramStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>(BonusProgramStatisticsDocument, options);
        }
export function useBonusProgramStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>(BonusProgramStatisticsDocument, options);
        }
export type BonusProgramStatisticsQueryHookResult = ReturnType<typeof useBonusProgramStatisticsQuery>;
export type BonusProgramStatisticsLazyQueryHookResult = ReturnType<typeof useBonusProgramStatisticsLazyQuery>;
export type BonusProgramStatisticsSuspenseQueryHookResult = ReturnType<typeof useBonusProgramStatisticsSuspenseQuery>;
export type BonusProgramStatisticsQueryResult = Apollo.QueryResult<BonusProgramStatisticsQuery, BonusProgramStatisticsQueryVariables>;
export const MovieStatisticsDocument = gql`
    query MovieStatistics {
  movieStatistics {
    id
    movie {
      title
      poster
      averageRating
    }
    numWatchlistings
    numInteractions
  }
}
    `;
export type MovieStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MovieStatisticsQuery, MovieStatisticsQueryVariables>
    } & TChildProps;
export function withMovieStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MovieStatisticsQuery,
  MovieStatisticsQueryVariables,
  MovieStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MovieStatisticsQuery, MovieStatisticsQueryVariables, MovieStatisticsProps<TChildProps, TDataName>>(MovieStatisticsDocument, {
      alias: 'movieStatistics',
      ...operationOptions
    });
};

/**
 * __useMovieStatisticsQuery__
 *
 * To run a query within a React component, call `useMovieStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieStatisticsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMovieStatisticsQuery(baseOptions?: Apollo.QueryHookOptions<MovieStatisticsQuery, MovieStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovieStatisticsQuery, MovieStatisticsQueryVariables>(MovieStatisticsDocument, options);
      }
export function useMovieStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovieStatisticsQuery, MovieStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovieStatisticsQuery, MovieStatisticsQueryVariables>(MovieStatisticsDocument, options);
        }
export function useMovieStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MovieStatisticsQuery, MovieStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MovieStatisticsQuery, MovieStatisticsQueryVariables>(MovieStatisticsDocument, options);
        }
export type MovieStatisticsQueryHookResult = ReturnType<typeof useMovieStatisticsQuery>;
export type MovieStatisticsLazyQueryHookResult = ReturnType<typeof useMovieStatisticsLazyQuery>;
export type MovieStatisticsSuspenseQueryHookResult = ReturnType<typeof useMovieStatisticsSuspenseQuery>;
export type MovieStatisticsQueryResult = Apollo.QueryResult<MovieStatisticsQuery, MovieStatisticsQueryVariables>;
export const UsageStatisticsDocument = gql`
    query usageStatistics($cinemaIds: [ID!]!, $from: Date!, $to: Date!) {
  usageStatistics(cinemaIds: $cinemaIds) {
    id
    sentMessagesInterval: sentMessagesInInterval(from: $from, to: $to) {
      numberOfCountedMessages
      numberOfFreeMessages
    }
    totalSentMessages: sentMessagesInInterval(to: $to) {
      numberOfCountedMessages
      numberOfFreeMessages
    }
    installsInterval: installationsInInterval(from: $from, to: $to)
    totalInstalls: installationsInInterval(to: $to)
    activeInInterval: activeUsersInInterval(from: $from, to: $to)
    activeTotal: activeUsersInInterval(to: $to)
    watchlistUsedInInterval: watchlistUsedInInterval(from: $from, to: $to)
    watchllistUsedTotal: watchlistUsedInInterval(to: $to)
  }
  cinemas(ids: $cinemaIds) {
    hasDynamicPricing
  }
}
    `;
export type UsageStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UsageStatisticsQuery, UsageStatisticsQueryVariables>
    } & TChildProps;
export function withUsageStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UsageStatisticsQuery,
  UsageStatisticsQueryVariables,
  UsageStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UsageStatisticsQuery, UsageStatisticsQueryVariables, UsageStatisticsProps<TChildProps, TDataName>>(UsageStatisticsDocument, {
      alias: 'usageStatistics',
      ...operationOptions
    });
};

/**
 * __useUsageStatisticsQuery__
 *
 * To run a query within a React component, call `useUsageStatisticsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUsageStatisticsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUsageStatisticsQuery({
 *   variables: {
 *      cinemaIds: // value for 'cinemaIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useUsageStatisticsQuery(baseOptions: Apollo.QueryHookOptions<UsageStatisticsQuery, UsageStatisticsQueryVariables> & ({ variables: UsageStatisticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UsageStatisticsQuery, UsageStatisticsQueryVariables>(UsageStatisticsDocument, options);
      }
export function useUsageStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UsageStatisticsQuery, UsageStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UsageStatisticsQuery, UsageStatisticsQueryVariables>(UsageStatisticsDocument, options);
        }
export function useUsageStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UsageStatisticsQuery, UsageStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UsageStatisticsQuery, UsageStatisticsQueryVariables>(UsageStatisticsDocument, options);
        }
export type UsageStatisticsQueryHookResult = ReturnType<typeof useUsageStatisticsQuery>;
export type UsageStatisticsLazyQueryHookResult = ReturnType<typeof useUsageStatisticsLazyQuery>;
export type UsageStatisticsSuspenseQueryHookResult = ReturnType<typeof useUsageStatisticsSuspenseQuery>;
export type UsageStatisticsQueryResult = Apollo.QueryResult<UsageStatisticsQuery, UsageStatisticsQueryVariables>;
export const GetAvailableVoucherClassesDocument = gql`
    query getAvailableVoucherClasses {
  getAvailableVoucherClasses {
    id
    title
  }
}
    `;
export type GetAvailableVoucherClassesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>
    } & TChildProps;
export function withGetAvailableVoucherClasses<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAvailableVoucherClassesQuery,
  GetAvailableVoucherClassesQueryVariables,
  GetAvailableVoucherClassesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables, GetAvailableVoucherClassesProps<TChildProps, TDataName>>(GetAvailableVoucherClassesDocument, {
      alias: 'getAvailableVoucherClasses',
      ...operationOptions
    });
};

/**
 * __useGetAvailableVoucherClassesQuery__
 *
 * To run a query within a React component, call `useGetAvailableVoucherClassesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAvailableVoucherClassesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAvailableVoucherClassesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAvailableVoucherClassesQuery(baseOptions?: Apollo.QueryHookOptions<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>(GetAvailableVoucherClassesDocument, options);
      }
export function useGetAvailableVoucherClassesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>(GetAvailableVoucherClassesDocument, options);
        }
export function useGetAvailableVoucherClassesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>(GetAvailableVoucherClassesDocument, options);
        }
export type GetAvailableVoucherClassesQueryHookResult = ReturnType<typeof useGetAvailableVoucherClassesQuery>;
export type GetAvailableVoucherClassesLazyQueryHookResult = ReturnType<typeof useGetAvailableVoucherClassesLazyQuery>;
export type GetAvailableVoucherClassesSuspenseQueryHookResult = ReturnType<typeof useGetAvailableVoucherClassesSuspenseQuery>;
export type GetAvailableVoucherClassesQueryResult = Apollo.QueryResult<GetAvailableVoucherClassesQuery, GetAvailableVoucherClassesQueryVariables>;
export const LogAnalyticsItemsDocument = gql`
    mutation logAnalyticsItems($items: [LogItem], $options: LogOptions) {
  logItems(items: $items, options: $options) {
    success
  }
}
    `;
export type LogAnalyticsItemsMutationFn = Apollo.MutationFunction<LogAnalyticsItemsMutation, LogAnalyticsItemsMutationVariables>;
export type LogAnalyticsItemsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<LogAnalyticsItemsMutation, LogAnalyticsItemsMutationVariables>
    } & TChildProps;
export function withLogAnalyticsItems<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LogAnalyticsItemsMutation,
  LogAnalyticsItemsMutationVariables,
  LogAnalyticsItemsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LogAnalyticsItemsMutation, LogAnalyticsItemsMutationVariables, LogAnalyticsItemsProps<TChildProps, TDataName>>(LogAnalyticsItemsDocument, {
      alias: 'logAnalyticsItems',
      ...operationOptions
    });
};

/**
 * __useLogAnalyticsItemsMutation__
 *
 * To run a mutation, you first call `useLogAnalyticsItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogAnalyticsItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logAnalyticsItemsMutation, { data, loading, error }] = useLogAnalyticsItemsMutation({
 *   variables: {
 *      items: // value for 'items'
 *      options: // value for 'options'
 *   },
 * });
 */
export function useLogAnalyticsItemsMutation(baseOptions?: Apollo.MutationHookOptions<LogAnalyticsItemsMutation, LogAnalyticsItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogAnalyticsItemsMutation, LogAnalyticsItemsMutationVariables>(LogAnalyticsItemsDocument, options);
      }
export type LogAnalyticsItemsMutationHookResult = ReturnType<typeof useLogAnalyticsItemsMutation>;
export type LogAnalyticsItemsMutationResult = Apollo.MutationResult<LogAnalyticsItemsMutation>;
export type LogAnalyticsItemsMutationOptions = Apollo.BaseMutationOptions<LogAnalyticsItemsMutation, LogAnalyticsItemsMutationVariables>;
export const AllAchievementsDocument = gql`
    query AllAchievements {
  allAchievements {
    id
    title
    description
  }
}
    `;
export type AllAchievementsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllAchievementsQuery, AllAchievementsQueryVariables>
    } & TChildProps;
export function withAllAchievements<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllAchievementsQuery,
  AllAchievementsQueryVariables,
  AllAchievementsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllAchievementsQuery, AllAchievementsQueryVariables, AllAchievementsProps<TChildProps, TDataName>>(AllAchievementsDocument, {
      alias: 'allAchievements',
      ...operationOptions
    });
};

/**
 * __useAllAchievementsQuery__
 *
 * To run a query within a React component, call `useAllAchievementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllAchievementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllAchievementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllAchievementsQuery(baseOptions?: Apollo.QueryHookOptions<AllAchievementsQuery, AllAchievementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllAchievementsQuery, AllAchievementsQueryVariables>(AllAchievementsDocument, options);
      }
export function useAllAchievementsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllAchievementsQuery, AllAchievementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllAchievementsQuery, AllAchievementsQueryVariables>(AllAchievementsDocument, options);
        }
export function useAllAchievementsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllAchievementsQuery, AllAchievementsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllAchievementsQuery, AllAchievementsQueryVariables>(AllAchievementsDocument, options);
        }
export type AllAchievementsQueryHookResult = ReturnType<typeof useAllAchievementsQuery>;
export type AllAchievementsLazyQueryHookResult = ReturnType<typeof useAllAchievementsLazyQuery>;
export type AllAchievementsSuspenseQueryHookResult = ReturnType<typeof useAllAchievementsSuspenseQuery>;
export type AllAchievementsQueryResult = Apollo.QueryResult<AllAchievementsQuery, AllAchievementsQueryVariables>;
export const FetchBeaconsDocument = gql`
    query FetchBeacons {
  beacons {
    ...BeaconFragment
  }
}
    ${BeaconFragmentDoc}`;
export type FetchBeaconsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchBeaconsQuery, FetchBeaconsQueryVariables>
    } & TChildProps;
export function withFetchBeacons<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchBeaconsQuery,
  FetchBeaconsQueryVariables,
  FetchBeaconsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchBeaconsQuery, FetchBeaconsQueryVariables, FetchBeaconsProps<TChildProps, TDataName>>(FetchBeaconsDocument, {
      alias: 'fetchBeacons',
      ...operationOptions
    });
};

/**
 * __useFetchBeaconsQuery__
 *
 * To run a query within a React component, call `useFetchBeaconsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchBeaconsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchBeaconsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFetchBeaconsQuery(baseOptions?: Apollo.QueryHookOptions<FetchBeaconsQuery, FetchBeaconsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FetchBeaconsQuery, FetchBeaconsQueryVariables>(FetchBeaconsDocument, options);
      }
export function useFetchBeaconsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FetchBeaconsQuery, FetchBeaconsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FetchBeaconsQuery, FetchBeaconsQueryVariables>(FetchBeaconsDocument, options);
        }
export function useFetchBeaconsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FetchBeaconsQuery, FetchBeaconsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FetchBeaconsQuery, FetchBeaconsQueryVariables>(FetchBeaconsDocument, options);
        }
export type FetchBeaconsQueryHookResult = ReturnType<typeof useFetchBeaconsQuery>;
export type FetchBeaconsLazyQueryHookResult = ReturnType<typeof useFetchBeaconsLazyQuery>;
export type FetchBeaconsSuspenseQueryHookResult = ReturnType<typeof useFetchBeaconsSuspenseQuery>;
export type FetchBeaconsQueryResult = Apollo.QueryResult<FetchBeaconsQuery, FetchBeaconsQueryVariables>;
export const BeaconByIdDocument = gql`
    query BeaconById($id: ID!) {
  beaconById(id: $id) {
    ...BeaconFragment
  }
}
    ${BeaconFragmentDoc}`;
export type BeaconByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BeaconByIdQuery, BeaconByIdQueryVariables>
    } & TChildProps;
export function withBeaconById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BeaconByIdQuery,
  BeaconByIdQueryVariables,
  BeaconByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BeaconByIdQuery, BeaconByIdQueryVariables, BeaconByIdProps<TChildProps, TDataName>>(BeaconByIdDocument, {
      alias: 'beaconById',
      ...operationOptions
    });
};

/**
 * __useBeaconByIdQuery__
 *
 * To run a query within a React component, call `useBeaconByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useBeaconByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBeaconByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useBeaconByIdQuery(baseOptions: Apollo.QueryHookOptions<BeaconByIdQuery, BeaconByIdQueryVariables> & ({ variables: BeaconByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BeaconByIdQuery, BeaconByIdQueryVariables>(BeaconByIdDocument, options);
      }
export function useBeaconByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BeaconByIdQuery, BeaconByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BeaconByIdQuery, BeaconByIdQueryVariables>(BeaconByIdDocument, options);
        }
export function useBeaconByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BeaconByIdQuery, BeaconByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BeaconByIdQuery, BeaconByIdQueryVariables>(BeaconByIdDocument, options);
        }
export type BeaconByIdQueryHookResult = ReturnType<typeof useBeaconByIdQuery>;
export type BeaconByIdLazyQueryHookResult = ReturnType<typeof useBeaconByIdLazyQuery>;
export type BeaconByIdSuspenseQueryHookResult = ReturnType<typeof useBeaconByIdSuspenseQuery>;
export type BeaconByIdQueryResult = Apollo.QueryResult<BeaconByIdQuery, BeaconByIdQueryVariables>;
export const CreateBeaconDocument = gql`
    mutation CreateBeacon($cinemaId: ID!, $comments: String, $lastBatteryChange: DateTime) {
  createBeacon(
    cinemaId: $cinemaId
    comments: $comments
    lastBatteryChange: $lastBatteryChange
  ) {
    ...BeaconFragment
  }
}
    ${BeaconFragmentDoc}`;
export type CreateBeaconMutationFn = Apollo.MutationFunction<CreateBeaconMutation, CreateBeaconMutationVariables>;
export type CreateBeaconProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateBeaconMutation, CreateBeaconMutationVariables>
    } & TChildProps;
export function withCreateBeacon<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateBeaconMutation,
  CreateBeaconMutationVariables,
  CreateBeaconProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateBeaconMutation, CreateBeaconMutationVariables, CreateBeaconProps<TChildProps, TDataName>>(CreateBeaconDocument, {
      alias: 'createBeacon',
      ...operationOptions
    });
};

/**
 * __useCreateBeaconMutation__
 *
 * To run a mutation, you first call `useCreateBeaconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBeaconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBeaconMutation, { data, loading, error }] = useCreateBeaconMutation({
 *   variables: {
 *      cinemaId: // value for 'cinemaId'
 *      comments: // value for 'comments'
 *      lastBatteryChange: // value for 'lastBatteryChange'
 *   },
 * });
 */
export function useCreateBeaconMutation(baseOptions?: Apollo.MutationHookOptions<CreateBeaconMutation, CreateBeaconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBeaconMutation, CreateBeaconMutationVariables>(CreateBeaconDocument, options);
      }
export type CreateBeaconMutationHookResult = ReturnType<typeof useCreateBeaconMutation>;
export type CreateBeaconMutationResult = Apollo.MutationResult<CreateBeaconMutation>;
export type CreateBeaconMutationOptions = Apollo.BaseMutationOptions<CreateBeaconMutation, CreateBeaconMutationVariables>;
export const UpdateBeaconDocument = gql`
    mutation UpdateBeacon($id: ID!, $comments: String, $lastBatteryChange: DateTime) {
  updateBeacon(
    id: $id
    comments: $comments
    lastBatteryChange: $lastBatteryChange
  ) {
    ...BeaconFragment
  }
}
    ${BeaconFragmentDoc}`;
export type UpdateBeaconMutationFn = Apollo.MutationFunction<UpdateBeaconMutation, UpdateBeaconMutationVariables>;
export type UpdateBeaconProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateBeaconMutation, UpdateBeaconMutationVariables>
    } & TChildProps;
export function withUpdateBeacon<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateBeaconMutation,
  UpdateBeaconMutationVariables,
  UpdateBeaconProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateBeaconMutation, UpdateBeaconMutationVariables, UpdateBeaconProps<TChildProps, TDataName>>(UpdateBeaconDocument, {
      alias: 'updateBeacon',
      ...operationOptions
    });
};

/**
 * __useUpdateBeaconMutation__
 *
 * To run a mutation, you first call `useUpdateBeaconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBeaconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBeaconMutation, { data, loading, error }] = useUpdateBeaconMutation({
 *   variables: {
 *      id: // value for 'id'
 *      comments: // value for 'comments'
 *      lastBatteryChange: // value for 'lastBatteryChange'
 *   },
 * });
 */
export function useUpdateBeaconMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBeaconMutation, UpdateBeaconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBeaconMutation, UpdateBeaconMutationVariables>(UpdateBeaconDocument, options);
      }
export type UpdateBeaconMutationHookResult = ReturnType<typeof useUpdateBeaconMutation>;
export type UpdateBeaconMutationResult = Apollo.MutationResult<UpdateBeaconMutation>;
export type UpdateBeaconMutationOptions = Apollo.BaseMutationOptions<UpdateBeaconMutation, UpdateBeaconMutationVariables>;
export const DeleteBeaconDocument = gql`
    mutation DeleteBeacon($id: ID!) {
  deleteBeacon(id: $id) {
    success
  }
}
    `;
export type DeleteBeaconMutationFn = Apollo.MutationFunction<DeleteBeaconMutation, DeleteBeaconMutationVariables>;
export type DeleteBeaconProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteBeaconMutation, DeleteBeaconMutationVariables>
    } & TChildProps;
export function withDeleteBeacon<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteBeaconMutation,
  DeleteBeaconMutationVariables,
  DeleteBeaconProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteBeaconMutation, DeleteBeaconMutationVariables, DeleteBeaconProps<TChildProps, TDataName>>(DeleteBeaconDocument, {
      alias: 'deleteBeacon',
      ...operationOptions
    });
};

/**
 * __useDeleteBeaconMutation__
 *
 * To run a mutation, you first call `useDeleteBeaconMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBeaconMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBeaconMutation, { data, loading, error }] = useDeleteBeaconMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBeaconMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBeaconMutation, DeleteBeaconMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBeaconMutation, DeleteBeaconMutationVariables>(DeleteBeaconDocument, options);
      }
export type DeleteBeaconMutationHookResult = ReturnType<typeof useDeleteBeaconMutation>;
export type DeleteBeaconMutationResult = Apollo.MutationResult<DeleteBeaconMutation>;
export type DeleteBeaconMutationOptions = Apollo.BaseMutationOptions<DeleteBeaconMutation, DeleteBeaconMutationVariables>;
export const NewsItemDocument = gql`
    query NewsItem($newsItemId: ID!) {
  newsItem(id: $newsItemId) {
    id
    title
    teaser
    body
    link
    image
    poster
    linkText
  }
}
    `;
export type NewsItemProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NewsItemQuery, NewsItemQueryVariables>
    } & TChildProps;
export function withNewsItem<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NewsItemQuery,
  NewsItemQueryVariables,
  NewsItemProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NewsItemQuery, NewsItemQueryVariables, NewsItemProps<TChildProps, TDataName>>(NewsItemDocument, {
      alias: 'newsItem',
      ...operationOptions
    });
};

/**
 * __useNewsItemQuery__
 *
 * To run a query within a React component, call `useNewsItemQuery` and pass it any options that fit your needs.
 * When your component renders, `useNewsItemQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewsItemQuery({
 *   variables: {
 *      newsItemId: // value for 'newsItemId'
 *   },
 * });
 */
export function useNewsItemQuery(baseOptions: Apollo.QueryHookOptions<NewsItemQuery, NewsItemQueryVariables> & ({ variables: NewsItemQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, options);
      }
export function useNewsItemLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewsItemQuery, NewsItemQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, options);
        }
export function useNewsItemSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewsItemQuery, NewsItemQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewsItemQuery, NewsItemQueryVariables>(NewsItemDocument, options);
        }
export type NewsItemQueryHookResult = ReturnType<typeof useNewsItemQuery>;
export type NewsItemLazyQueryHookResult = ReturnType<typeof useNewsItemLazyQuery>;
export type NewsItemSuspenseQueryHookResult = ReturnType<typeof useNewsItemSuspenseQuery>;
export type NewsItemQueryResult = Apollo.QueryResult<NewsItemQuery, NewsItemQueryVariables>;
export const UpsertNewsItemDocument = gql`
    mutation UpsertNewsItem($id: ID, $title: String, $teaser: String, $body: String, $movieId: ID, $poster: String, $link: String, $linkText: String, $image: String) {
  result: upsertNewsItem(
    id: $id
    title: $title
    teaser: $teaser
    body: $body
    movieId: $movieId
    poster: $poster
    link: $link
    linkText: $linkText
    image: $image
  ) {
    newsItem {
      id
      title
      teaser
      body
      movie {
        id
      }
      poster
      link
      image
      linkText
    }
  }
}
    `;
export type UpsertNewsItemMutationFn = Apollo.MutationFunction<UpsertNewsItemMutation, UpsertNewsItemMutationVariables>;
export type UpsertNewsItemProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpsertNewsItemMutation, UpsertNewsItemMutationVariables>
    } & TChildProps;
export function withUpsertNewsItem<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpsertNewsItemMutation,
  UpsertNewsItemMutationVariables,
  UpsertNewsItemProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpsertNewsItemMutation, UpsertNewsItemMutationVariables, UpsertNewsItemProps<TChildProps, TDataName>>(UpsertNewsItemDocument, {
      alias: 'upsertNewsItem',
      ...operationOptions
    });
};

/**
 * __useUpsertNewsItemMutation__
 *
 * To run a mutation, you first call `useUpsertNewsItemMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertNewsItemMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertNewsItemMutation, { data, loading, error }] = useUpsertNewsItemMutation({
 *   variables: {
 *      id: // value for 'id'
 *      title: // value for 'title'
 *      teaser: // value for 'teaser'
 *      body: // value for 'body'
 *      movieId: // value for 'movieId'
 *      poster: // value for 'poster'
 *      link: // value for 'link'
 *      linkText: // value for 'linkText'
 *      image: // value for 'image'
 *   },
 * });
 */
export function useUpsertNewsItemMutation(baseOptions?: Apollo.MutationHookOptions<UpsertNewsItemMutation, UpsertNewsItemMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertNewsItemMutation, UpsertNewsItemMutationVariables>(UpsertNewsItemDocument, options);
      }
export type UpsertNewsItemMutationHookResult = ReturnType<typeof useUpsertNewsItemMutation>;
export type UpsertNewsItemMutationResult = Apollo.MutationResult<UpsertNewsItemMutation>;
export type UpsertNewsItemMutationOptions = Apollo.BaseMutationOptions<UpsertNewsItemMutation, UpsertNewsItemMutationVariables>;
export const EditCampaignDocument = gql`
    mutation EditCampaign($id: ID!, $name: String!, $channels: [Channel!]!, $cinemaIds: [ID!], $message: String, $messageTitle: String, $messageImage: String, $link: String, $sendingTime: Time, $sendingDate: Date, $sendOnDayXAfterTrigger: Int, $sendExactlyMinutesAfterTrigger: Int, $status: CampaignStatus!, $trigger: CampaignTrigger!, $startDate: String, $endDate: String, $startTime: String, $endTime: String, $timeUnit: CampaignTimeUnit, $timeUnitFactor: Int, $numberOfIntervals: Int, $intervalEndType: CampaignIntervalEndType, $eventType: CampaignEventType, $emailSubject: String, $targetGroupIds: [ID!], $triggerThreshold: String) {
  editCampaign(
    id: $id
    name: $name
    channels: $channels
    cinemaIds: $cinemaIds
    message: $message
    messageTitle: $messageTitle
    messageImage: $messageImage
    link: $link
    sendingTime: $sendingTime
    sendingDate: $sendingDate
    sendOnDayXAfterTrigger: $sendOnDayXAfterTrigger
    sendExactlyMinutesAfterTrigger: $sendExactlyMinutesAfterTrigger
    status: $status
    trigger: $trigger
    startDate: $startDate
    endDate: $endDate
    startTime: $startTime
    endTime: $endTime
    timeUnit: $timeUnit
    timeUnitFactor: $timeUnitFactor
    numberOfIntervals: $numberOfIntervals
    intervalEndType: $intervalEndType
    eventType: $eventType
    emailSubject: $emailSubject
    targetGroupIds: $targetGroupIds
    triggerThreshold: $triggerThreshold
  ) {
    campaign {
      ...campaignDataFragment
    }
  }
}
    ${CampaignDataFragmentDoc}`;
export type EditCampaignMutationFn = Apollo.MutationFunction<EditCampaignMutation, EditCampaignMutationVariables>;
export type EditCampaignProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<EditCampaignMutation, EditCampaignMutationVariables>
    } & TChildProps;
export function withEditCampaign<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditCampaignMutation,
  EditCampaignMutationVariables,
  EditCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditCampaignMutation, EditCampaignMutationVariables, EditCampaignProps<TChildProps, TDataName>>(EditCampaignDocument, {
      alias: 'editCampaign',
      ...operationOptions
    });
};

/**
 * __useEditCampaignMutation__
 *
 * To run a mutation, you first call `useEditCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCampaignMutation, { data, loading, error }] = useEditCampaignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      channels: // value for 'channels'
 *      cinemaIds: // value for 'cinemaIds'
 *      message: // value for 'message'
 *      messageTitle: // value for 'messageTitle'
 *      messageImage: // value for 'messageImage'
 *      link: // value for 'link'
 *      sendingTime: // value for 'sendingTime'
 *      sendingDate: // value for 'sendingDate'
 *      sendOnDayXAfterTrigger: // value for 'sendOnDayXAfterTrigger'
 *      sendExactlyMinutesAfterTrigger: // value for 'sendExactlyMinutesAfterTrigger'
 *      status: // value for 'status'
 *      trigger: // value for 'trigger'
 *      startDate: // value for 'startDate'
 *      endDate: // value for 'endDate'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *      timeUnit: // value for 'timeUnit'
 *      timeUnitFactor: // value for 'timeUnitFactor'
 *      numberOfIntervals: // value for 'numberOfIntervals'
 *      intervalEndType: // value for 'intervalEndType'
 *      eventType: // value for 'eventType'
 *      emailSubject: // value for 'emailSubject'
 *      targetGroupIds: // value for 'targetGroupIds'
 *      triggerThreshold: // value for 'triggerThreshold'
 *   },
 * });
 */
export function useEditCampaignMutation(baseOptions?: Apollo.MutationHookOptions<EditCampaignMutation, EditCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCampaignMutation, EditCampaignMutationVariables>(EditCampaignDocument, options);
      }
export type EditCampaignMutationHookResult = ReturnType<typeof useEditCampaignMutation>;
export type EditCampaignMutationResult = Apollo.MutationResult<EditCampaignMutation>;
export type EditCampaignMutationOptions = Apollo.BaseMutationOptions<EditCampaignMutation, EditCampaignMutationVariables>;
export const CampaignDataDocument = gql`
    query CampaignData($id: ID!) {
  campaign(id: $id) {
    ...campaignDataFragment
  }
}
    ${CampaignDataFragmentDoc}`;
export type CampaignDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignDataQuery, CampaignDataQueryVariables>
    } & TChildProps;
export function withCampaignData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignDataQuery,
  CampaignDataQueryVariables,
  CampaignDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CampaignDataQuery, CampaignDataQueryVariables, CampaignDataProps<TChildProps, TDataName>>(CampaignDataDocument, {
      alias: 'campaignData',
      ...operationOptions
    });
};

/**
 * __useCampaignDataQuery__
 *
 * To run a query within a React component, call `useCampaignDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignDataQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCampaignDataQuery(baseOptions: Apollo.QueryHookOptions<CampaignDataQuery, CampaignDataQueryVariables> & ({ variables: CampaignDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignDataQuery, CampaignDataQueryVariables>(CampaignDataDocument, options);
      }
export function useCampaignDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignDataQuery, CampaignDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignDataQuery, CampaignDataQueryVariables>(CampaignDataDocument, options);
        }
export function useCampaignDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignDataQuery, CampaignDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignDataQuery, CampaignDataQueryVariables>(CampaignDataDocument, options);
        }
export type CampaignDataQueryHookResult = ReturnType<typeof useCampaignDataQuery>;
export type CampaignDataLazyQueryHookResult = ReturnType<typeof useCampaignDataLazyQuery>;
export type CampaignDataSuspenseQueryHookResult = ReturnType<typeof useCampaignDataSuspenseQuery>;
export type CampaignDataQueryResult = Apollo.QueryResult<CampaignDataQuery, CampaignDataQueryVariables>;
export const CampaignsDocument = gql`
    query Campaigns($cinemaIds: [ID!]!, $newCampaigns: Boolean) {
  campaignsByCinemas(cinemaIds: $cinemaIds, newCampaigns: $newCampaigns) {
    campaigns {
      ...campaignDataFragment
    }
  }
}
    ${CampaignDataFragmentDoc}`;
export type CampaignsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CampaignsQuery, CampaignsQueryVariables>
    } & TChildProps;
export function withCampaigns<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CampaignsQuery,
  CampaignsQueryVariables,
  CampaignsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CampaignsQuery, CampaignsQueryVariables, CampaignsProps<TChildProps, TDataName>>(CampaignsDocument, {
      alias: 'campaigns',
      ...operationOptions
    });
};

/**
 * __useCampaignsQuery__
 *
 * To run a query within a React component, call `useCampaignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCampaignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCampaignsQuery({
 *   variables: {
 *      cinemaIds: // value for 'cinemaIds'
 *      newCampaigns: // value for 'newCampaigns'
 *   },
 * });
 */
export function useCampaignsQuery(baseOptions: Apollo.QueryHookOptions<CampaignsQuery, CampaignsQueryVariables> & ({ variables: CampaignsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
      }
export function useCampaignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export function useCampaignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CampaignsQuery, CampaignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CampaignsQuery, CampaignsQueryVariables>(CampaignsDocument, options);
        }
export type CampaignsQueryHookResult = ReturnType<typeof useCampaignsQuery>;
export type CampaignsLazyQueryHookResult = ReturnType<typeof useCampaignsLazyQuery>;
export type CampaignsSuspenseQueryHookResult = ReturnType<typeof useCampaignsSuspenseQuery>;
export type CampaignsQueryResult = Apollo.QueryResult<CampaignsQuery, CampaignsQueryVariables>;
export const CreateCampaignDocument = gql`
    mutation CreateCampaign($name: String!, $trigger: CampaignTrigger!, $cinemaIds: [ID!]!, $isNewCampaign: Boolean) {
  result: createCampaign(
    name: $name
    trigger: $trigger
    cinemaIds: $cinemaIds
    isNewCampaign: $isNewCampaign
  ) {
    campaign {
      ...campaignDataFragment
    }
  }
}
    ${CampaignDataFragmentDoc}`;
export type CreateCampaignMutationFn = Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>;
export type CreateCampaignProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCampaignMutation, CreateCampaignMutationVariables>
    } & TChildProps;
export function withCreateCampaign<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCampaignMutation,
  CreateCampaignMutationVariables,
  CreateCampaignProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCampaignMutation, CreateCampaignMutationVariables, CreateCampaignProps<TChildProps, TDataName>>(CreateCampaignDocument, {
      alias: 'createCampaign',
      ...operationOptions
    });
};

/**
 * __useCreateCampaignMutation__
 *
 * To run a mutation, you first call `useCreateCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCampaignMutation, { data, loading, error }] = useCreateCampaignMutation({
 *   variables: {
 *      name: // value for 'name'
 *      trigger: // value for 'trigger'
 *      cinemaIds: // value for 'cinemaIds'
 *      isNewCampaign: // value for 'isNewCampaign'
 *   },
 * });
 */
export function useCreateCampaignMutation(baseOptions?: Apollo.MutationHookOptions<CreateCampaignMutation, CreateCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCampaignMutation, CreateCampaignMutationVariables>(CreateCampaignDocument, options);
      }
export type CreateCampaignMutationHookResult = ReturnType<typeof useCreateCampaignMutation>;
export type CreateCampaignMutationResult = Apollo.MutationResult<CreateCampaignMutation>;
export type CreateCampaignMutationOptions = Apollo.BaseMutationOptions<CreateCampaignMutation, CreateCampaignMutationVariables>;
export const DeleteCampaignsDocument = gql`
    mutation DeleteCampaigns($ids: [ID!]!) {
  deleteCampaigns(ids: $ids) {
    success
  }
}
    `;
export type DeleteCampaignsMutationFn = Apollo.MutationFunction<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>;
export type DeleteCampaignsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>
    } & TChildProps;
export function withDeleteCampaigns<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCampaignsMutation,
  DeleteCampaignsMutationVariables,
  DeleteCampaignsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCampaignsMutation, DeleteCampaignsMutationVariables, DeleteCampaignsProps<TChildProps, TDataName>>(DeleteCampaignsDocument, {
      alias: 'deleteCampaigns',
      ...operationOptions
    });
};

/**
 * __useDeleteCampaignsMutation__
 *
 * To run a mutation, you first call `useDeleteCampaignsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCampaignsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCampaignsMutation, { data, loading, error }] = useDeleteCampaignsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCampaignsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>(DeleteCampaignsDocument, options);
      }
export type DeleteCampaignsMutationHookResult = ReturnType<typeof useDeleteCampaignsMutation>;
export type DeleteCampaignsMutationResult = Apollo.MutationResult<DeleteCampaignsMutation>;
export type DeleteCampaignsMutationOptions = Apollo.BaseMutationOptions<DeleteCampaignsMutation, DeleteCampaignsMutationVariables>;
export const UpdateCampaignsStatusDocument = gql`
    mutation UpdateCampaignsStatus($ids: [ID!]!, $status: CampaignStatus!) {
  updateCampaignsStatus(ids: $ids, status: $status) {
    campaigns {
      ...campaignDataFragment
    }
  }
}
    ${CampaignDataFragmentDoc}`;
export type UpdateCampaignsStatusMutationFn = Apollo.MutationFunction<UpdateCampaignsStatusMutation, UpdateCampaignsStatusMutationVariables>;
export type UpdateCampaignsStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateCampaignsStatusMutation, UpdateCampaignsStatusMutationVariables>
    } & TChildProps;
export function withUpdateCampaignsStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCampaignsStatusMutation,
  UpdateCampaignsStatusMutationVariables,
  UpdateCampaignsStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCampaignsStatusMutation, UpdateCampaignsStatusMutationVariables, UpdateCampaignsStatusProps<TChildProps, TDataName>>(UpdateCampaignsStatusDocument, {
      alias: 'updateCampaignsStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateCampaignsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateCampaignsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCampaignsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCampaignsStatusMutation, { data, loading, error }] = useUpdateCampaignsStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useUpdateCampaignsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCampaignsStatusMutation, UpdateCampaignsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCampaignsStatusMutation, UpdateCampaignsStatusMutationVariables>(UpdateCampaignsStatusDocument, options);
      }
export type UpdateCampaignsStatusMutationHookResult = ReturnType<typeof useUpdateCampaignsStatusMutation>;
export type UpdateCampaignsStatusMutationResult = Apollo.MutationResult<UpdateCampaignsStatusMutation>;
export type UpdateCampaignsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateCampaignsStatusMutation, UpdateCampaignsStatusMutationVariables>;
export const SaveCampaignEmailDocument = gql`
    mutation SaveCampaignEmail($id: ID!, $emailContent: Json!) {
  editCampaignEmail(id: $id, emailContent: $emailContent) {
    campaign {
      ...campaignDataFragment
    }
  }
}
    ${CampaignDataFragmentDoc}`;
export type SaveCampaignEmailMutationFn = Apollo.MutationFunction<SaveCampaignEmailMutation, SaveCampaignEmailMutationVariables>;
export type SaveCampaignEmailProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SaveCampaignEmailMutation, SaveCampaignEmailMutationVariables>
    } & TChildProps;
export function withSaveCampaignEmail<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveCampaignEmailMutation,
  SaveCampaignEmailMutationVariables,
  SaveCampaignEmailProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveCampaignEmailMutation, SaveCampaignEmailMutationVariables, SaveCampaignEmailProps<TChildProps, TDataName>>(SaveCampaignEmailDocument, {
      alias: 'saveCampaignEmail',
      ...operationOptions
    });
};

/**
 * __useSaveCampaignEmailMutation__
 *
 * To run a mutation, you first call `useSaveCampaignEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveCampaignEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveCampaignEmailMutation, { data, loading, error }] = useSaveCampaignEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      emailContent: // value for 'emailContent'
 *   },
 * });
 */
export function useSaveCampaignEmailMutation(baseOptions?: Apollo.MutationHookOptions<SaveCampaignEmailMutation, SaveCampaignEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveCampaignEmailMutation, SaveCampaignEmailMutationVariables>(SaveCampaignEmailDocument, options);
      }
export type SaveCampaignEmailMutationHookResult = ReturnType<typeof useSaveCampaignEmailMutation>;
export type SaveCampaignEmailMutationResult = Apollo.MutationResult<SaveCampaignEmailMutation>;
export type SaveCampaignEmailMutationOptions = Apollo.BaseMutationOptions<SaveCampaignEmailMutation, SaveCampaignEmailMutationVariables>;
export const SearchCastOrCrewMemberDocument = gql`
    query SearchCastOrCrewMember($fullName: String!) {
  searchCastOrCrewMember(fullName: $fullName) {
    id
    fullName
  }
}
    `;
export type SearchCastOrCrewMemberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>
    } & TChildProps;
export function withSearchCastOrCrewMember<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchCastOrCrewMemberQuery,
  SearchCastOrCrewMemberQueryVariables,
  SearchCastOrCrewMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables, SearchCastOrCrewMemberProps<TChildProps, TDataName>>(SearchCastOrCrewMemberDocument, {
      alias: 'searchCastOrCrewMember',
      ...operationOptions
    });
};

/**
 * __useSearchCastOrCrewMemberQuery__
 *
 * To run a query within a React component, call `useSearchCastOrCrewMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCastOrCrewMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCastOrCrewMemberQuery({
 *   variables: {
 *      fullName: // value for 'fullName'
 *   },
 * });
 */
export function useSearchCastOrCrewMemberQuery(baseOptions: Apollo.QueryHookOptions<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables> & ({ variables: SearchCastOrCrewMemberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>(SearchCastOrCrewMemberDocument, options);
      }
export function useSearchCastOrCrewMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>(SearchCastOrCrewMemberDocument, options);
        }
export function useSearchCastOrCrewMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>(SearchCastOrCrewMemberDocument, options);
        }
export type SearchCastOrCrewMemberQueryHookResult = ReturnType<typeof useSearchCastOrCrewMemberQuery>;
export type SearchCastOrCrewMemberLazyQueryHookResult = ReturnType<typeof useSearchCastOrCrewMemberLazyQuery>;
export type SearchCastOrCrewMemberSuspenseQueryHookResult = ReturnType<typeof useSearchCastOrCrewMemberSuspenseQuery>;
export type SearchCastOrCrewMemberQueryResult = Apollo.QueryResult<SearchCastOrCrewMemberQuery, SearchCastOrCrewMemberQueryVariables>;
export const CinemaDetailsDocument = gql`
    query CinemaDetails($cinemaId: ID!) {
  cinema(id: $cinemaId) {
    ...CinemaDetailsFragment
  }
}
    ${CinemaDetailsFragmentDoc}`;
export type CinemaDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CinemaDetailsQuery, CinemaDetailsQueryVariables>
    } & TChildProps;
export function withCinemaDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CinemaDetailsQuery,
  CinemaDetailsQueryVariables,
  CinemaDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CinemaDetailsQuery, CinemaDetailsQueryVariables, CinemaDetailsProps<TChildProps, TDataName>>(CinemaDetailsDocument, {
      alias: 'cinemaDetails',
      ...operationOptions
    });
};

/**
 * __useCinemaDetailsQuery__
 *
 * To run a query within a React component, call `useCinemaDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCinemaDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCinemaDetailsQuery({
 *   variables: {
 *      cinemaId: // value for 'cinemaId'
 *   },
 * });
 */
export function useCinemaDetailsQuery(baseOptions: Apollo.QueryHookOptions<CinemaDetailsQuery, CinemaDetailsQueryVariables> & ({ variables: CinemaDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CinemaDetailsQuery, CinemaDetailsQueryVariables>(CinemaDetailsDocument, options);
      }
export function useCinemaDetailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CinemaDetailsQuery, CinemaDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CinemaDetailsQuery, CinemaDetailsQueryVariables>(CinemaDetailsDocument, options);
        }
export function useCinemaDetailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CinemaDetailsQuery, CinemaDetailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CinemaDetailsQuery, CinemaDetailsQueryVariables>(CinemaDetailsDocument, options);
        }
export type CinemaDetailsQueryHookResult = ReturnType<typeof useCinemaDetailsQuery>;
export type CinemaDetailsLazyQueryHookResult = ReturnType<typeof useCinemaDetailsLazyQuery>;
export type CinemaDetailsSuspenseQueryHookResult = ReturnType<typeof useCinemaDetailsSuspenseQuery>;
export type CinemaDetailsQueryResult = Apollo.QueryResult<CinemaDetailsQuery, CinemaDetailsQueryVariables>;
export const UpdateCinemaDocument = gql`
    mutation updateCinema($id: ID!, $name: String!, $logo: String, $claim: String, $hasBonusProgram: Boolean, $headerImage: String, $imprint: String, $technologies: String, $history: String, $currentInformation: String, $specialAboutUs: String, $onlineTicketingBaseUrl: String, $street: String, $houseNumber: String, $zipCode: String, $city: String, $parkingDescription: String, $locationDescription: String, $googleMapsLink: String, $appleMapsLink: String, $phone: String, $facebook: String, $twitter: String, $website: String, $email: String, $instagram: String, $barrierFree: Boolean, $barrierFreeText: String, $hearingImpaired: Boolean, $hearingImpairedText: String, $blind: Boolean, $blindText: String, $brands: [Brand!]!, $openingHoursDisplay: [CinemaOpeningHoursInput!]!, $pricesDisplay: [CinemaInformationParagraphInput!]!, $specialOffersDisplay: [CinemaInformationParagraphInput!]!, $giftVouchersDisplay: [CinemaInformationParagraphInput!]!, $sneaksDisplay: [CinemaInformationParagraphInput!]!, $additionalInfoSections: [CinemaInformationParagraphInput!]!, $accessRestrictedTo: AccessRestriction!, $location: CinemaLocationInput) {
  updateCinema(
    cinema: {id: $id, name: $name, logo: $logo, claim: $claim, hasBonusProgram: $hasBonusProgram, headerImage: $headerImage, imprint: $imprint, technologies: $technologies, history: $history, specialAboutUs: $specialAboutUs, currentInformation: $currentInformation, onlineTicketingBaseUrl: $onlineTicketingBaseUrl, street: $street, houseNumber: $houseNumber, zipCode: $zipCode, city: $city, parkingDescription: $parkingDescription, locationDescription: $locationDescription, googleMapsLink: $googleMapsLink, appleMapsLink: $appleMapsLink, phone: $phone, facebook: $facebook, twitter: $twitter, instagram: $instagram, website: $website, email: $email, barrierFree: $barrierFree, barrierFreeText: $barrierFreeText, hearingImpaired: $hearingImpaired, hearingImpairedText: $hearingImpairedText, blind: $blind, blindText: $blindText, openingHoursDisplay: $openingHoursDisplay, pricesDisplay: $pricesDisplay, specialOffersDisplay: $specialOffersDisplay, giftVouchersDisplay: $giftVouchersDisplay, sneaksDisplay: $sneaksDisplay, additionalInfoSections: $additionalInfoSections, brands: $brands, accessRestrictedTo: $accessRestrictedTo, location: $location}
  ) {
    success
    cinema {
      ...CinemaDetailsFragment
    }
  }
}
    ${CinemaDetailsFragmentDoc}`;
export type UpdateCinemaMutationFn = Apollo.MutationFunction<UpdateCinemaMutation, UpdateCinemaMutationVariables>;
export type UpdateCinemaProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateCinemaMutation, UpdateCinemaMutationVariables>
    } & TChildProps;
export function withUpdateCinema<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCinemaMutation,
  UpdateCinemaMutationVariables,
  UpdateCinemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCinemaMutation, UpdateCinemaMutationVariables, UpdateCinemaProps<TChildProps, TDataName>>(UpdateCinemaDocument, {
      alias: 'updateCinema',
      ...operationOptions
    });
};

/**
 * __useUpdateCinemaMutation__
 *
 * To run a mutation, you first call `useUpdateCinemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCinemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCinemaMutation, { data, loading, error }] = useUpdateCinemaMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      logo: // value for 'logo'
 *      claim: // value for 'claim'
 *      hasBonusProgram: // value for 'hasBonusProgram'
 *      headerImage: // value for 'headerImage'
 *      imprint: // value for 'imprint'
 *      technologies: // value for 'technologies'
 *      history: // value for 'history'
 *      currentInformation: // value for 'currentInformation'
 *      specialAboutUs: // value for 'specialAboutUs'
 *      onlineTicketingBaseUrl: // value for 'onlineTicketingBaseUrl'
 *      street: // value for 'street'
 *      houseNumber: // value for 'houseNumber'
 *      zipCode: // value for 'zipCode'
 *      city: // value for 'city'
 *      parkingDescription: // value for 'parkingDescription'
 *      locationDescription: // value for 'locationDescription'
 *      googleMapsLink: // value for 'googleMapsLink'
 *      appleMapsLink: // value for 'appleMapsLink'
 *      phone: // value for 'phone'
 *      facebook: // value for 'facebook'
 *      twitter: // value for 'twitter'
 *      website: // value for 'website'
 *      email: // value for 'email'
 *      instagram: // value for 'instagram'
 *      barrierFree: // value for 'barrierFree'
 *      barrierFreeText: // value for 'barrierFreeText'
 *      hearingImpaired: // value for 'hearingImpaired'
 *      hearingImpairedText: // value for 'hearingImpairedText'
 *      blind: // value for 'blind'
 *      blindText: // value for 'blindText'
 *      brands: // value for 'brands'
 *      openingHoursDisplay: // value for 'openingHoursDisplay'
 *      pricesDisplay: // value for 'pricesDisplay'
 *      specialOffersDisplay: // value for 'specialOffersDisplay'
 *      giftVouchersDisplay: // value for 'giftVouchersDisplay'
 *      sneaksDisplay: // value for 'sneaksDisplay'
 *      additionalInfoSections: // value for 'additionalInfoSections'
 *      accessRestrictedTo: // value for 'accessRestrictedTo'
 *      location: // value for 'location'
 *   },
 * });
 */
export function useUpdateCinemaMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCinemaMutation, UpdateCinemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCinemaMutation, UpdateCinemaMutationVariables>(UpdateCinemaDocument, options);
      }
export type UpdateCinemaMutationHookResult = ReturnType<typeof useUpdateCinemaMutation>;
export type UpdateCinemaMutationResult = Apollo.MutationResult<UpdateCinemaMutation>;
export type UpdateCinemaMutationOptions = Apollo.BaseMutationOptions<UpdateCinemaMutation, UpdateCinemaMutationVariables>;
export const CreateCinemaDocument = gql`
    mutation createCinema {
  createCinema {
    success
    cinema {
      ...CinemaDetailsFragment
    }
  }
}
    ${CinemaDetailsFragmentDoc}`;
export type CreateCinemaMutationFn = Apollo.MutationFunction<CreateCinemaMutation, CreateCinemaMutationVariables>;
export type CreateCinemaProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCinemaMutation, CreateCinemaMutationVariables>
    } & TChildProps;
export function withCreateCinema<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCinemaMutation,
  CreateCinemaMutationVariables,
  CreateCinemaProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCinemaMutation, CreateCinemaMutationVariables, CreateCinemaProps<TChildProps, TDataName>>(CreateCinemaDocument, {
      alias: 'createCinema',
      ...operationOptions
    });
};

/**
 * __useCreateCinemaMutation__
 *
 * To run a mutation, you first call `useCreateCinemaMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCinemaMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCinemaMutation, { data, loading, error }] = useCreateCinemaMutation({
 *   variables: {
 *   },
 * });
 */
export function useCreateCinemaMutation(baseOptions?: Apollo.MutationHookOptions<CreateCinemaMutation, CreateCinemaMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCinemaMutation, CreateCinemaMutationVariables>(CreateCinemaDocument, options);
      }
export type CreateCinemaMutationHookResult = ReturnType<typeof useCreateCinemaMutation>;
export type CreateCinemaMutationResult = Apollo.MutationResult<CreateCinemaMutation>;
export type CreateCinemaMutationOptions = Apollo.BaseMutationOptions<CreateCinemaMutation, CreateCinemaMutationVariables>;
export const SingleCompanyDocument = gql`
    query SingleCompany($id: ID!) {
  company(id: $id) {
    ...companyFragment
  }
}
    ${CompanyFragmentDoc}`;
export type SingleCompanyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SingleCompanyQuery, SingleCompanyQueryVariables>
    } & TChildProps;
export function withSingleCompany<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SingleCompanyQuery,
  SingleCompanyQueryVariables,
  SingleCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SingleCompanyQuery, SingleCompanyQueryVariables, SingleCompanyProps<TChildProps, TDataName>>(SingleCompanyDocument, {
      alias: 'singleCompany',
      ...operationOptions
    });
};

/**
 * __useSingleCompanyQuery__
 *
 * To run a query within a React component, call `useSingleCompanyQuery` and pass it any options that fit your needs.
 * When your component renders, `useSingleCompanyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSingleCompanyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSingleCompanyQuery(baseOptions: Apollo.QueryHookOptions<SingleCompanyQuery, SingleCompanyQueryVariables> & ({ variables: SingleCompanyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SingleCompanyQuery, SingleCompanyQueryVariables>(SingleCompanyDocument, options);
      }
export function useSingleCompanyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SingleCompanyQuery, SingleCompanyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SingleCompanyQuery, SingleCompanyQueryVariables>(SingleCompanyDocument, options);
        }
export function useSingleCompanySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SingleCompanyQuery, SingleCompanyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SingleCompanyQuery, SingleCompanyQueryVariables>(SingleCompanyDocument, options);
        }
export type SingleCompanyQueryHookResult = ReturnType<typeof useSingleCompanyQuery>;
export type SingleCompanyLazyQueryHookResult = ReturnType<typeof useSingleCompanyLazyQuery>;
export type SingleCompanySuspenseQueryHookResult = ReturnType<typeof useSingleCompanySuspenseQuery>;
export type SingleCompanyQueryResult = Apollo.QueryResult<SingleCompanyQuery, SingleCompanyQueryVariables>;
export const AllCompaniesDocument = gql`
    query AllCompanies {
  companies {
    ...companyFragment
  }
}
    ${CompanyFragmentDoc}`;
export type AllCompaniesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllCompaniesQuery, AllCompaniesQueryVariables>
    } & TChildProps;
export function withAllCompanies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllCompaniesQuery,
  AllCompaniesQueryVariables,
  AllCompaniesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllCompaniesQuery, AllCompaniesQueryVariables, AllCompaniesProps<TChildProps, TDataName>>(AllCompaniesDocument, {
      alias: 'allCompanies',
      ...operationOptions
    });
};

/**
 * __useAllCompaniesQuery__
 *
 * To run a query within a React component, call `useAllCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllCompaniesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllCompaniesQuery(baseOptions?: Apollo.QueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
      }
export function useAllCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export function useAllCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllCompaniesQuery, AllCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllCompaniesQuery, AllCompaniesQueryVariables>(AllCompaniesDocument, options);
        }
export type AllCompaniesQueryHookResult = ReturnType<typeof useAllCompaniesQuery>;
export type AllCompaniesLazyQueryHookResult = ReturnType<typeof useAllCompaniesLazyQuery>;
export type AllCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllCompaniesSuspenseQuery>;
export type AllCompaniesQueryResult = Apollo.QueryResult<AllCompaniesQuery, AllCompaniesQueryVariables>;
export const EditCompanyDocument = gql`
    mutation EditCompany($id: ID!, $name: String!, $logo: String!) {
  editCompany(id: $id, name: $name, logo: $logo) {
    ...companyFragment
  }
}
    ${CompanyFragmentDoc}`;
export type EditCompanyMutationFn = Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>;
export type EditCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<EditCompanyMutation, EditCompanyMutationVariables>
    } & TChildProps;
export function withEditCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditCompanyMutation,
  EditCompanyMutationVariables,
  EditCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditCompanyMutation, EditCompanyMutationVariables, EditCompanyProps<TChildProps, TDataName>>(EditCompanyDocument, {
      alias: 'editCompany',
      ...operationOptions
    });
};

/**
 * __useEditCompanyMutation__
 *
 * To run a mutation, you first call `useEditCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editCompanyMutation, { data, loading, error }] = useEditCompanyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useEditCompanyMutation(baseOptions?: Apollo.MutationHookOptions<EditCompanyMutation, EditCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EditCompanyMutation, EditCompanyMutationVariables>(EditCompanyDocument, options);
      }
export type EditCompanyMutationHookResult = ReturnType<typeof useEditCompanyMutation>;
export type EditCompanyMutationResult = Apollo.MutationResult<EditCompanyMutation>;
export type EditCompanyMutationOptions = Apollo.BaseMutationOptions<EditCompanyMutation, EditCompanyMutationVariables>;
export const DeleteCompaniesDocument = gql`
    mutation DeleteCompanies($ids: [ID!]!) {
  deleteCompanies(ids: $ids)
}
    `;
export type DeleteCompaniesMutationFn = Apollo.MutationFunction<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>;
export type DeleteCompaniesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>
    } & TChildProps;
export function withDeleteCompanies<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteCompaniesMutation,
  DeleteCompaniesMutationVariables,
  DeleteCompaniesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteCompaniesMutation, DeleteCompaniesMutationVariables, DeleteCompaniesProps<TChildProps, TDataName>>(DeleteCompaniesDocument, {
      alias: 'deleteCompanies',
      ...operationOptions
    });
};

/**
 * __useDeleteCompaniesMutation__
 *
 * To run a mutation, you first call `useDeleteCompaniesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCompaniesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCompaniesMutation, { data, loading, error }] = useDeleteCompaniesMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteCompaniesMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>(DeleteCompaniesDocument, options);
      }
export type DeleteCompaniesMutationHookResult = ReturnType<typeof useDeleteCompaniesMutation>;
export type DeleteCompaniesMutationResult = Apollo.MutationResult<DeleteCompaniesMutation>;
export type DeleteCompaniesMutationOptions = Apollo.BaseMutationOptions<DeleteCompaniesMutation, DeleteCompaniesMutationVariables>;
export const CreateCompanyDocument = gql`
    mutation CreateCompany($name: String!, $logo: String!) {
  createCompany(name: $name, logo: $logo) {
    ...companyFragment
  }
}
    ${CompanyFragmentDoc}`;
export type CreateCompanyMutationFn = Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>;
export type CreateCompanyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateCompanyMutation, CreateCompanyMutationVariables>
    } & TChildProps;
export function withCreateCompany<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateCompanyMutation,
  CreateCompanyMutationVariables,
  CreateCompanyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateCompanyMutation, CreateCompanyMutationVariables, CreateCompanyProps<TChildProps, TDataName>>(CreateCompanyDocument, {
      alias: 'createCompany',
      ...operationOptions
    });
};

/**
 * __useCreateCompanyMutation__
 *
 * To run a mutation, you first call `useCreateCompanyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCompanyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCompanyMutation, { data, loading, error }] = useCreateCompanyMutation({
 *   variables: {
 *      name: // value for 'name'
 *      logo: // value for 'logo'
 *   },
 * });
 */
export function useCreateCompanyMutation(baseOptions?: Apollo.MutationHookOptions<CreateCompanyMutation, CreateCompanyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCompanyMutation, CreateCompanyMutationVariables>(CreateCompanyDocument, options);
      }
export type CreateCompanyMutationHookResult = ReturnType<typeof useCreateCompanyMutation>;
export type CreateCompanyMutationResult = Apollo.MutationResult<CreateCompanyMutation>;
export type CreateCompanyMutationOptions = Apollo.BaseMutationOptions<CreateCompanyMutation, CreateCompanyMutationVariables>;
export const AllGenresDocument = gql`
    query AllGenres {
  allGenres {
    id
    name
  }
}
    `;
export type AllGenresProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllGenresQuery, AllGenresQueryVariables>
    } & TChildProps;
export function withAllGenres<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllGenresQuery,
  AllGenresQueryVariables,
  AllGenresProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllGenresQuery, AllGenresQueryVariables, AllGenresProps<TChildProps, TDataName>>(AllGenresDocument, {
      alias: 'allGenres',
      ...operationOptions
    });
};

/**
 * __useAllGenresQuery__
 *
 * To run a query within a React component, call `useAllGenresQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllGenresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllGenresQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllGenresQuery(baseOptions?: Apollo.QueryHookOptions<AllGenresQuery, AllGenresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllGenresQuery, AllGenresQueryVariables>(AllGenresDocument, options);
      }
export function useAllGenresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllGenresQuery, AllGenresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllGenresQuery, AllGenresQueryVariables>(AllGenresDocument, options);
        }
export function useAllGenresSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllGenresQuery, AllGenresQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllGenresQuery, AllGenresQueryVariables>(AllGenresDocument, options);
        }
export type AllGenresQueryHookResult = ReturnType<typeof useAllGenresQuery>;
export type AllGenresLazyQueryHookResult = ReturnType<typeof useAllGenresLazyQuery>;
export type AllGenresSuspenseQueryHookResult = ReturnType<typeof useAllGenresSuspenseQuery>;
export type AllGenresQueryResult = Apollo.QueryResult<AllGenresQuery, AllGenresQueryVariables>;
export const AllImagesDocument = gql`
    query AllImages {
  allImages {
    id
    datetime
    url
  }
}
    `;
export type AllImagesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllImagesQuery, AllImagesQueryVariables>
    } & TChildProps;
export function withAllImages<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllImagesQuery,
  AllImagesQueryVariables,
  AllImagesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllImagesQuery, AllImagesQueryVariables, AllImagesProps<TChildProps, TDataName>>(AllImagesDocument, {
      alias: 'allImages',
      ...operationOptions
    });
};

/**
 * __useAllImagesQuery__
 *
 * To run a query within a React component, call `useAllImagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllImagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllImagesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllImagesQuery(baseOptions?: Apollo.QueryHookOptions<AllImagesQuery, AllImagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllImagesQuery, AllImagesQueryVariables>(AllImagesDocument, options);
      }
export function useAllImagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllImagesQuery, AllImagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllImagesQuery, AllImagesQueryVariables>(AllImagesDocument, options);
        }
export function useAllImagesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllImagesQuery, AllImagesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllImagesQuery, AllImagesQueryVariables>(AllImagesDocument, options);
        }
export type AllImagesQueryHookResult = ReturnType<typeof useAllImagesQuery>;
export type AllImagesLazyQueryHookResult = ReturnType<typeof useAllImagesLazyQuery>;
export type AllImagesSuspenseQueryHookResult = ReturnType<typeof useAllImagesSuspenseQuery>;
export type AllImagesQueryResult = Apollo.QueryResult<AllImagesQuery, AllImagesQueryVariables>;
export const SaveImagePathDocument = gql`
    mutation SaveImagePath($filePath: String!) {
  saveImagePath(filePath: $filePath) {
    success
    uploadedImage {
      id
      url
      datetime
    }
  }
}
    `;
export type SaveImagePathMutationFn = Apollo.MutationFunction<SaveImagePathMutation, SaveImagePathMutationVariables>;
export type SaveImagePathProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SaveImagePathMutation, SaveImagePathMutationVariables>
    } & TChildProps;
export function withSaveImagePath<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveImagePathMutation,
  SaveImagePathMutationVariables,
  SaveImagePathProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveImagePathMutation, SaveImagePathMutationVariables, SaveImagePathProps<TChildProps, TDataName>>(SaveImagePathDocument, {
      alias: 'saveImagePath',
      ...operationOptions
    });
};

/**
 * __useSaveImagePathMutation__
 *
 * To run a mutation, you first call `useSaveImagePathMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveImagePathMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveImagePathMutation, { data, loading, error }] = useSaveImagePathMutation({
 *   variables: {
 *      filePath: // value for 'filePath'
 *   },
 * });
 */
export function useSaveImagePathMutation(baseOptions?: Apollo.MutationHookOptions<SaveImagePathMutation, SaveImagePathMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveImagePathMutation, SaveImagePathMutationVariables>(SaveImagePathDocument, options);
      }
export type SaveImagePathMutationHookResult = ReturnType<typeof useSaveImagePathMutation>;
export type SaveImagePathMutationResult = Apollo.MutationResult<SaveImagePathMutation>;
export type SaveImagePathMutationOptions = Apollo.BaseMutationOptions<SaveImagePathMutation, SaveImagePathMutationVariables>;
export const DeleteImageDocument = gql`
    mutation DeleteImage($id: ID!) {
  deleteImage(id: $id) {
    success
  }
}
    `;
export type DeleteImageMutationFn = Apollo.MutationFunction<DeleteImageMutation, DeleteImageMutationVariables>;
export type DeleteImageProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteImageMutation, DeleteImageMutationVariables>
    } & TChildProps;
export function withDeleteImage<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteImageMutation,
  DeleteImageMutationVariables,
  DeleteImageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteImageMutation, DeleteImageMutationVariables, DeleteImageProps<TChildProps, TDataName>>(DeleteImageDocument, {
      alias: 'deleteImage',
      ...operationOptions
    });
};

/**
 * __useDeleteImageMutation__
 *
 * To run a mutation, you first call `useDeleteImageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteImageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteImageMutation, { data, loading, error }] = useDeleteImageMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteImageMutation(baseOptions?: Apollo.MutationHookOptions<DeleteImageMutation, DeleteImageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteImageMutation, DeleteImageMutationVariables>(DeleteImageDocument, options);
      }
export type DeleteImageMutationHookResult = ReturnType<typeof useDeleteImageMutation>;
export type DeleteImageMutationResult = Apollo.MutationResult<DeleteImageMutation>;
export type DeleteImageMutationOptions = Apollo.BaseMutationOptions<DeleteImageMutation, DeleteImageMutationVariables>;
export const AllMoviesDocument = gql`
    query AllMovies($isFromMasterFilmDB: Boolean) {
  allMovies(isFromMasterFilmDB: $isFromMasterFilmDB) {
    ...MovieInfoFragment
  }
}
    ${MovieInfoFragmentDoc}`;
export type AllMoviesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllMoviesQuery, AllMoviesQueryVariables>
    } & TChildProps;
export function withAllMovies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllMoviesQuery,
  AllMoviesQueryVariables,
  AllMoviesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllMoviesQuery, AllMoviesQueryVariables, AllMoviesProps<TChildProps, TDataName>>(AllMoviesDocument, {
      alias: 'allMovies',
      ...operationOptions
    });
};

/**
 * __useAllMoviesQuery__
 *
 * To run a query within a React component, call `useAllMoviesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllMoviesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllMoviesQuery({
 *   variables: {
 *      isFromMasterFilmDB: // value for 'isFromMasterFilmDB'
 *   },
 * });
 */
export function useAllMoviesQuery(baseOptions?: Apollo.QueryHookOptions<AllMoviesQuery, AllMoviesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllMoviesQuery, AllMoviesQueryVariables>(AllMoviesDocument, options);
      }
export function useAllMoviesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllMoviesQuery, AllMoviesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllMoviesQuery, AllMoviesQueryVariables>(AllMoviesDocument, options);
        }
export function useAllMoviesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllMoviesQuery, AllMoviesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllMoviesQuery, AllMoviesQueryVariables>(AllMoviesDocument, options);
        }
export type AllMoviesQueryHookResult = ReturnType<typeof useAllMoviesQuery>;
export type AllMoviesLazyQueryHookResult = ReturnType<typeof useAllMoviesLazyQuery>;
export type AllMoviesSuspenseQueryHookResult = ReturnType<typeof useAllMoviesSuspenseQuery>;
export type AllMoviesQueryResult = Apollo.QueryResult<AllMoviesQuery, AllMoviesQueryVariables>;
export const SearchMovieDocument = gql`
    query SearchMovie($title: String!) {
  searchMovie(title: $title) {
    ...MovieInfoFragment
  }
}
    ${MovieInfoFragmentDoc}`;
export type SearchMovieProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchMovieQuery, SearchMovieQueryVariables>
    } & TChildProps;
export function withSearchMovie<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchMovieQuery,
  SearchMovieQueryVariables,
  SearchMovieProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchMovieQuery, SearchMovieQueryVariables, SearchMovieProps<TChildProps, TDataName>>(SearchMovieDocument, {
      alias: 'searchMovie',
      ...operationOptions
    });
};

/**
 * __useSearchMovieQuery__
 *
 * To run a query within a React component, call `useSearchMovieQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMovieQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMovieQuery({
 *   variables: {
 *      title: // value for 'title'
 *   },
 * });
 */
export function useSearchMovieQuery(baseOptions: Apollo.QueryHookOptions<SearchMovieQuery, SearchMovieQueryVariables> & ({ variables: SearchMovieQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMovieQuery, SearchMovieQueryVariables>(SearchMovieDocument, options);
      }
export function useSearchMovieLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMovieQuery, SearchMovieQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMovieQuery, SearchMovieQueryVariables>(SearchMovieDocument, options);
        }
export function useSearchMovieSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMovieQuery, SearchMovieQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMovieQuery, SearchMovieQueryVariables>(SearchMovieDocument, options);
        }
export type SearchMovieQueryHookResult = ReturnType<typeof useSearchMovieQuery>;
export type SearchMovieLazyQueryHookResult = ReturnType<typeof useSearchMovieLazyQuery>;
export type SearchMovieSuspenseQueryHookResult = ReturnType<typeof useSearchMovieSuspenseQuery>;
export type SearchMovieQueryResult = Apollo.QueryResult<SearchMovieQuery, SearchMovieQueryVariables>;
export const MoviePosterDocument = gql`
    query MoviePoster($id: ID!) {
  movie(id: $id) {
    title
    poster
    banner
  }
}
    `;
export type MoviePosterProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MoviePosterQuery, MoviePosterQueryVariables>
    } & TChildProps;
export function withMoviePoster<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MoviePosterQuery,
  MoviePosterQueryVariables,
  MoviePosterProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MoviePosterQuery, MoviePosterQueryVariables, MoviePosterProps<TChildProps, TDataName>>(MoviePosterDocument, {
      alias: 'moviePoster',
      ...operationOptions
    });
};

/**
 * __useMoviePosterQuery__
 *
 * To run a query within a React component, call `useMoviePosterQuery` and pass it any options that fit your needs.
 * When your component renders, `useMoviePosterQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMoviePosterQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMoviePosterQuery(baseOptions: Apollo.QueryHookOptions<MoviePosterQuery, MoviePosterQueryVariables> & ({ variables: MoviePosterQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MoviePosterQuery, MoviePosterQueryVariables>(MoviePosterDocument, options);
      }
export function useMoviePosterLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MoviePosterQuery, MoviePosterQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MoviePosterQuery, MoviePosterQueryVariables>(MoviePosterDocument, options);
        }
export function useMoviePosterSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MoviePosterQuery, MoviePosterQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MoviePosterQuery, MoviePosterQueryVariables>(MoviePosterDocument, options);
        }
export type MoviePosterQueryHookResult = ReturnType<typeof useMoviePosterQuery>;
export type MoviePosterLazyQueryHookResult = ReturnType<typeof useMoviePosterLazyQuery>;
export type MoviePosterSuspenseQueryHookResult = ReturnType<typeof useMoviePosterSuspenseQuery>;
export type MoviePosterQueryResult = Apollo.QueryResult<MoviePosterQuery, MoviePosterQueryVariables>;
export const MovieListsDocument = gql`
    query MovieLists($ids: [ID!]!) {
  allCinemaFilmSeries(cinemaIds: $ids) {
    id
    title
    type
  }
}
    `;
export type MovieListsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MovieListsQuery, MovieListsQueryVariables>
    } & TChildProps;
export function withMovieLists<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MovieListsQuery,
  MovieListsQueryVariables,
  MovieListsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MovieListsQuery, MovieListsQueryVariables, MovieListsProps<TChildProps, TDataName>>(MovieListsDocument, {
      alias: 'movieLists',
      ...operationOptions
    });
};

/**
 * __useMovieListsQuery__
 *
 * To run a query within a React component, call `useMovieListsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieListsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieListsQuery({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useMovieListsQuery(baseOptions: Apollo.QueryHookOptions<MovieListsQuery, MovieListsQueryVariables> & ({ variables: MovieListsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovieListsQuery, MovieListsQueryVariables>(MovieListsDocument, options);
      }
export function useMovieListsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovieListsQuery, MovieListsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovieListsQuery, MovieListsQueryVariables>(MovieListsDocument, options);
        }
export function useMovieListsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MovieListsQuery, MovieListsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MovieListsQuery, MovieListsQueryVariables>(MovieListsDocument, options);
        }
export type MovieListsQueryHookResult = ReturnType<typeof useMovieListsQuery>;
export type MovieListsLazyQueryHookResult = ReturnType<typeof useMovieListsLazyQuery>;
export type MovieListsSuspenseQueryHookResult = ReturnType<typeof useMovieListsSuspenseQuery>;
export type MovieListsQueryResult = Apollo.QueryResult<MovieListsQuery, MovieListsQueryVariables>;
export const MovieListDocument = gql`
    query MovieList($id: ID!) {
  movieList(id: $id) {
    id
    title
  }
}
    `;
export type MovieListProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<MovieListQuery, MovieListQueryVariables>
    } & TChildProps;
export function withMovieList<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  MovieListQuery,
  MovieListQueryVariables,
  MovieListProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, MovieListQuery, MovieListQueryVariables, MovieListProps<TChildProps, TDataName>>(MovieListDocument, {
      alias: 'movieList',
      ...operationOptions
    });
};

/**
 * __useMovieListQuery__
 *
 * To run a query within a React component, call `useMovieListQuery` and pass it any options that fit your needs.
 * When your component renders, `useMovieListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMovieListQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMovieListQuery(baseOptions: Apollo.QueryHookOptions<MovieListQuery, MovieListQueryVariables> & ({ variables: MovieListQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MovieListQuery, MovieListQueryVariables>(MovieListDocument, options);
      }
export function useMovieListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MovieListQuery, MovieListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MovieListQuery, MovieListQueryVariables>(MovieListDocument, options);
        }
export function useMovieListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MovieListQuery, MovieListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MovieListQuery, MovieListQueryVariables>(MovieListDocument, options);
        }
export type MovieListQueryHookResult = ReturnType<typeof useMovieListQuery>;
export type MovieListLazyQueryHookResult = ReturnType<typeof useMovieListLazyQuery>;
export type MovieListSuspenseQueryHookResult = ReturnType<typeof useMovieListSuspenseQuery>;
export type MovieListQueryResult = Apollo.QueryResult<MovieListQuery, MovieListQueryVariables>;
export const SendTestNotificationDocument = gql`
    mutation SendTestNotification($title: String!, $body: String!, $link: String!, $imageUrl: String!, $inAppNotification: Boolean!, $pushNotificationChannel: String!, $language: String!, $cinemaIds: [ID!]!) {
  sendTestNotification(
    title: $title
    body: $body
    link: $link
    imageUrl: $imageUrl
    inAppNotification: $inAppNotification
    pushNotificationChannel: $pushNotificationChannel
    language: $language
    cinemaIds: $cinemaIds
  ) {
    success
  }
}
    `;
export type SendTestNotificationMutationFn = Apollo.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export type SendTestNotificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SendTestNotificationMutation, SendTestNotificationMutationVariables>
    } & TChildProps;
export function withSendTestNotification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SendTestNotificationMutation,
  SendTestNotificationMutationVariables,
  SendTestNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SendTestNotificationMutation, SendTestNotificationMutationVariables, SendTestNotificationProps<TChildProps, TDataName>>(SendTestNotificationDocument, {
      alias: 'sendTestNotification',
      ...operationOptions
    });
};

/**
 * __useSendTestNotificationMutation__
 *
 * To run a mutation, you first call `useSendTestNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendTestNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendTestNotificationMutation, { data, loading, error }] = useSendTestNotificationMutation({
 *   variables: {
 *      title: // value for 'title'
 *      body: // value for 'body'
 *      link: // value for 'link'
 *      imageUrl: // value for 'imageUrl'
 *      inAppNotification: // value for 'inAppNotification'
 *      pushNotificationChannel: // value for 'pushNotificationChannel'
 *      language: // value for 'language'
 *      cinemaIds: // value for 'cinemaIds'
 *   },
 * });
 */
export function useSendTestNotificationMutation(baseOptions?: Apollo.MutationHookOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendTestNotificationMutation, SendTestNotificationMutationVariables>(SendTestNotificationDocument, options);
      }
export type SendTestNotificationMutationHookResult = ReturnType<typeof useSendTestNotificationMutation>;
export type SendTestNotificationMutationResult = Apollo.MutationResult<SendTestNotificationMutation>;
export type SendTestNotificationMutationOptions = Apollo.BaseMutationOptions<SendTestNotificationMutation, SendTestNotificationMutationVariables>;
export const AllScreeningAttributesDocument = gql`
    query AllScreeningAttributes {
  allScreeningAttributes {
    id
    label
  }
}
    `;
export type AllScreeningAttributesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>
    } & TChildProps;
export function withAllScreeningAttributes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllScreeningAttributesQuery,
  AllScreeningAttributesQueryVariables,
  AllScreeningAttributesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables, AllScreeningAttributesProps<TChildProps, TDataName>>(AllScreeningAttributesDocument, {
      alias: 'allScreeningAttributes',
      ...operationOptions
    });
};

/**
 * __useAllScreeningAttributesQuery__
 *
 * To run a query within a React component, call `useAllScreeningAttributesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllScreeningAttributesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllScreeningAttributesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAllScreeningAttributesQuery(baseOptions?: Apollo.QueryHookOptions<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>(AllScreeningAttributesDocument, options);
      }
export function useAllScreeningAttributesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>(AllScreeningAttributesDocument, options);
        }
export function useAllScreeningAttributesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>(AllScreeningAttributesDocument, options);
        }
export type AllScreeningAttributesQueryHookResult = ReturnType<typeof useAllScreeningAttributesQuery>;
export type AllScreeningAttributesLazyQueryHookResult = ReturnType<typeof useAllScreeningAttributesLazyQuery>;
export type AllScreeningAttributesSuspenseQueryHookResult = ReturnType<typeof useAllScreeningAttributesSuspenseQuery>;
export type AllScreeningAttributesQueryResult = Apollo.QueryResult<AllScreeningAttributesQuery, AllScreeningAttributesQueryVariables>;
export const SubscriptionStaticticsDocument = gql`
    query SubscriptionStatictics($from: Date!, $to: Date!) {
  subscriptionsStatistics(from: $from, to: $to) {
    numberOfUsers
    numberOfActiveSubscriptions
    numberOfSubscriptionTickets
    numberOfNewSubscriptions
    canceledSubscriptions
    numberOfUsersPerTier {
      tierName
      numActiveSubscribers
    }
    visitFrequency {
      zero
      one
      two
      three
      four
      five
      sixToTen
      elevenToTwenty
      twentyPlus
    }
    seenMovies {
      numVisits
      movie {
        id
        title
        banner
        poster
        averageRating
      }
    }
  }
}
    `;
export type SubscriptionStaticticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>
    } & TChildProps;
export function withSubscriptionStatictics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscriptionStaticticsQuery,
  SubscriptionStaticticsQueryVariables,
  SubscriptionStaticticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables, SubscriptionStaticticsProps<TChildProps, TDataName>>(SubscriptionStaticticsDocument, {
      alias: 'subscriptionStatictics',
      ...operationOptions
    });
};

/**
 * __useSubscriptionStatictics__
 *
 * To run a query within a React component, call `useSubscriptionStatictics` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionStatictics` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionStatictics({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useSubscriptionStatictics(baseOptions: Apollo.QueryHookOptions<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables> & ({ variables: SubscriptionStaticticsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>(SubscriptionStaticticsDocument, options);
      }
export function useSubscriptionStaticticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>(SubscriptionStaticticsDocument, options);
        }
export function useSubscriptionStaticticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>(SubscriptionStaticticsDocument, options);
        }
export type SubscriptionStaticticsHookResult = ReturnType<typeof useSubscriptionStatictics>;
export type SubscriptionStaticticsLazyQueryHookResult = ReturnType<typeof useSubscriptionStaticticsLazyQuery>;
export type SubscriptionStaticticsSuspenseQueryHookResult = ReturnType<typeof useSubscriptionStaticticsSuspenseQuery>;
export type SubscriptionStaticticsQueryResult = Apollo.QueryResult<SubscriptionStaticticsQuery, SubscriptionStaticticsQueryVariables>;
export const PayoutInfoDocument = gql`
    query PayoutInfo($from: Date!, $to: Date!) {
  payoutInfo(from: $from, to: $to) {
    numOfSubscriptionTickets
    numAdditionalTickets
    cinema {
      id
      name
      city
    }
  }
}
    `;
export type PayoutInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PayoutInfoQuery, PayoutInfoQueryVariables>
    } & TChildProps;
export function withPayoutInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PayoutInfoQuery,
  PayoutInfoQueryVariables,
  PayoutInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PayoutInfoQuery, PayoutInfoQueryVariables, PayoutInfoProps<TChildProps, TDataName>>(PayoutInfoDocument, {
      alias: 'payoutInfo',
      ...operationOptions
    });
};

/**
 * __usePayoutInfoQuery__
 *
 * To run a query within a React component, call `usePayoutInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayoutInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayoutInfoQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function usePayoutInfoQuery(baseOptions: Apollo.QueryHookOptions<PayoutInfoQuery, PayoutInfoQueryVariables> & ({ variables: PayoutInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PayoutInfoQuery, PayoutInfoQueryVariables>(PayoutInfoDocument, options);
      }
export function usePayoutInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PayoutInfoQuery, PayoutInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PayoutInfoQuery, PayoutInfoQueryVariables>(PayoutInfoDocument, options);
        }
export function usePayoutInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PayoutInfoQuery, PayoutInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PayoutInfoQuery, PayoutInfoQueryVariables>(PayoutInfoDocument, options);
        }
export type PayoutInfoQueryHookResult = ReturnType<typeof usePayoutInfoQuery>;
export type PayoutInfoLazyQueryHookResult = ReturnType<typeof usePayoutInfoLazyQuery>;
export type PayoutInfoSuspenseQueryHookResult = ReturnType<typeof usePayoutInfoSuspenseQuery>;
export type PayoutInfoQueryResult = Apollo.QueryResult<PayoutInfoQuery, PayoutInfoQueryVariables>;
export const NewSubscriptionStatisticsDocument = gql`
    query NewSubscriptionStatistics($cinemaIds: [ID!]) {
  newSubscriptionStatistics(cinemaIds: $cinemaIds) {
    numberOfUsers
    numberOfActiveSubscriptions
    subscriptionsPerMonth: averageData(dataType: SUBSCRIPTION, groupBy: MONTH) {
      date
      count
      newCount
    }
    subscriptionsPerWeek: averageData(dataType: SUBSCRIPTION, groupBy: WEEK) {
      date
      count
      newCount
    }
    subscriptionsPerDay: averageData(dataType: SUBSCRIPTION, groupBy: DAY) {
      date
      count
      newCount
    }
    moviesPerDay: averageData(dataType: MOVIE, groupBy: DAY) {
      date
      count
    }
    moviesPerWeek: averageData(dataType: MOVIE, groupBy: WEEK) {
      date
      count
    }
    moviesPerMonth: averageData(dataType: MOVIE, groupBy: MONTH) {
      date
      count
    }
    ticketsUserPerDay: averageData(dataType: TICKET, groupBy: DAY) {
      date
      count
    }
    ticketsUserPerWeek: averageData(dataType: TICKET, groupBy: WEEK) {
      date
      count
    }
    ticketsUserPerMonth: averageData(dataType: TICKET, groupBy: MONTH) {
      date
      count
    }
  }
}
    `;
export type NewSubscriptionStatisticsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>
    } & TChildProps;
export function withNewSubscriptionStatistics<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NewSubscriptionStatisticsQuery,
  NewSubscriptionStatisticsQueryVariables,
  NewSubscriptionStatisticsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables, NewSubscriptionStatisticsProps<TChildProps, TDataName>>(NewSubscriptionStatisticsDocument, {
      alias: 'newSubscriptionStatistics',
      ...operationOptions
    });
};

/**
 * __useNewSubscriptionStatistics__
 *
 * To run a query within a React component, call `useNewSubscriptionStatistics` and pass it any options that fit your needs.
 * When your component renders, `useNewSubscriptionStatistics` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNewSubscriptionStatistics({
 *   variables: {
 *      cinemaIds: // value for 'cinemaIds'
 *   },
 * });
 */
export function useNewSubscriptionStatistics(baseOptions?: Apollo.QueryHookOptions<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>(NewSubscriptionStatisticsDocument, options);
      }
export function useNewSubscriptionStatisticsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>(NewSubscriptionStatisticsDocument, options);
        }
export function useNewSubscriptionStatisticsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>(NewSubscriptionStatisticsDocument, options);
        }
export type NewSubscriptionStatisticsHookResult = ReturnType<typeof useNewSubscriptionStatistics>;
export type NewSubscriptionStatisticsLazyQueryHookResult = ReturnType<typeof useNewSubscriptionStatisticsLazyQuery>;
export type NewSubscriptionStatisticsSuspenseQueryHookResult = ReturnType<typeof useNewSubscriptionStatisticsSuspenseQuery>;
export type NewSubscriptionStatisticsQueryResult = Apollo.QueryResult<NewSubscriptionStatisticsQuery, NewSubscriptionStatisticsQueryVariables>;
export const CinfinityCinemaStatsDocument = gql`
    query CinfinityCinemaStats($cinemaIds: [ID!], $from: String!, $to: String!) {
  cinfinityCinemaStats(cinemaIds: $cinemaIds, from: $from, to: $to) {
    users
    visitors
    visits
    additionalTickets
    monthlyVisits {
      month
      visits
      additionalTickets
    }
  }
}
    `;
export type CinfinityCinemaStatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>
    } & TChildProps;
export function withCinfinityCinemaStats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CinfinityCinemaStatsQuery,
  CinfinityCinemaStatsQueryVariables,
  CinfinityCinemaStatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables, CinfinityCinemaStatsProps<TChildProps, TDataName>>(CinfinityCinemaStatsDocument, {
      alias: 'cinfinityCinemaStats',
      ...operationOptions
    });
};

/**
 * __useCinfinityCinemaStatsQuery__
 *
 * To run a query within a React component, call `useCinfinityCinemaStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCinfinityCinemaStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCinfinityCinemaStatsQuery({
 *   variables: {
 *      cinemaIds: // value for 'cinemaIds'
 *      from: // value for 'from'
 *      to: // value for 'to'
 *   },
 * });
 */
export function useCinfinityCinemaStatsQuery(baseOptions: Apollo.QueryHookOptions<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables> & ({ variables: CinfinityCinemaStatsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>(CinfinityCinemaStatsDocument, options);
      }
export function useCinfinityCinemaStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>(CinfinityCinemaStatsDocument, options);
        }
export function useCinfinityCinemaStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>(CinfinityCinemaStatsDocument, options);
        }
export type CinfinityCinemaStatsQueryHookResult = ReturnType<typeof useCinfinityCinemaStatsQuery>;
export type CinfinityCinemaStatsLazyQueryHookResult = ReturnType<typeof useCinfinityCinemaStatsLazyQuery>;
export type CinfinityCinemaStatsSuspenseQueryHookResult = ReturnType<typeof useCinfinityCinemaStatsSuspenseQuery>;
export type CinfinityCinemaStatsQueryResult = Apollo.QueryResult<CinfinityCinemaStatsQuery, CinfinityCinemaStatsQueryVariables>;
export const OnlineTicketingVoucherStatsDocument = gql`
    query OnlineTicketingVoucherStats {
  onlineTicketingVoucherStats {
    cinemaId
    cinemaName
    cinemaCity
    totalVouchers
    usedVouchers
    freeVouchers
  }
}
    `;
export type OnlineTicketingVoucherStatsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>
    } & TChildProps;
export function withOnlineTicketingVoucherStats<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  OnlineTicketingVoucherStatsQuery,
  OnlineTicketingVoucherStatsQueryVariables,
  OnlineTicketingVoucherStatsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables, OnlineTicketingVoucherStatsProps<TChildProps, TDataName>>(OnlineTicketingVoucherStatsDocument, {
      alias: 'onlineTicketingVoucherStats',
      ...operationOptions
    });
};

/**
 * __useOnlineTicketingVoucherStatsQuery__
 *
 * To run a query within a React component, call `useOnlineTicketingVoucherStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useOnlineTicketingVoucherStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOnlineTicketingVoucherStatsQuery({
 *   variables: {
 *   },
 * });
 */
export function useOnlineTicketingVoucherStatsQuery(baseOptions?: Apollo.QueryHookOptions<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>(OnlineTicketingVoucherStatsDocument, options);
      }
export function useOnlineTicketingVoucherStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>(OnlineTicketingVoucherStatsDocument, options);
        }
export function useOnlineTicketingVoucherStatsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>(OnlineTicketingVoucherStatsDocument, options);
        }
export type OnlineTicketingVoucherStatsQueryHookResult = ReturnType<typeof useOnlineTicketingVoucherStatsQuery>;
export type OnlineTicketingVoucherStatsLazyQueryHookResult = ReturnType<typeof useOnlineTicketingVoucherStatsLazyQuery>;
export type OnlineTicketingVoucherStatsSuspenseQueryHookResult = ReturnType<typeof useOnlineTicketingVoucherStatsSuspenseQuery>;
export type OnlineTicketingVoucherStatsQueryResult = Apollo.QueryResult<OnlineTicketingVoucherStatsQuery, OnlineTicketingVoucherStatsQueryVariables>;
export const SubscriptionTiersDocument = gql`
    query SubscriptionTiers {
  subscriptionTiers {
    id
    name
    description
    details
    paypalBillingPlanId
  }
}
    `;
export type SubscriptionTiersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>
    } & TChildProps;
export function withSubscriptionTiers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SubscriptionTiersQuery,
  SubscriptionTiersQueryVariables,
  SubscriptionTiersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SubscriptionTiersQuery, SubscriptionTiersQueryVariables, SubscriptionTiersProps<TChildProps, TDataName>>(SubscriptionTiersDocument, {
      alias: 'subscriptionTiers',
      ...operationOptions
    });
};

/**
 * __useSubscriptionTiers__
 *
 * To run a query within a React component, call `useSubscriptionTiers` and pass it any options that fit your needs.
 * When your component renders, `useSubscriptionTiers` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSubscriptionTiers({
 *   variables: {
 *   },
 * });
 */
export function useSubscriptionTiers(baseOptions?: Apollo.QueryHookOptions<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>(SubscriptionTiersDocument, options);
      }
export function useSubscriptionTiersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>(SubscriptionTiersDocument, options);
        }
export function useSubscriptionTiersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>(SubscriptionTiersDocument, options);
        }
export type SubscriptionTiersHookResult = ReturnType<typeof useSubscriptionTiers>;
export type SubscriptionTiersLazyQueryHookResult = ReturnType<typeof useSubscriptionTiersLazyQuery>;
export type SubscriptionTiersSuspenseQueryHookResult = ReturnType<typeof useSubscriptionTiersSuspenseQuery>;
export type SubscriptionTiersQueryResult = Apollo.QueryResult<SubscriptionTiersQuery, SubscriptionTiersQueryVariables>;
export const ReschedulePaymentDocument = gql`
    mutation ReschedulePayment($subscriptionId: ID!) {
  reschedulePayment(subscriptionId: $subscriptionId) {
    success
  }
}
    `;
export type ReschedulePaymentMutationFn = Apollo.MutationFunction<ReschedulePaymentMutation, ReschedulePaymentMutationVariables>;
export type ReschedulePaymentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ReschedulePaymentMutation, ReschedulePaymentMutationVariables>
    } & TChildProps;
export function withReschedulePayment<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReschedulePaymentMutation,
  ReschedulePaymentMutationVariables,
  ReschedulePaymentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReschedulePaymentMutation, ReschedulePaymentMutationVariables, ReschedulePaymentProps<TChildProps, TDataName>>(ReschedulePaymentDocument, {
      alias: 'reschedulePayment',
      ...operationOptions
    });
};

/**
 * __useReschedulePaymentMutation__
 *
 * To run a mutation, you first call `useReschedulePaymentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReschedulePaymentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reschedulePaymentMutation, { data, loading, error }] = useReschedulePaymentMutation({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useReschedulePaymentMutation(baseOptions?: Apollo.MutationHookOptions<ReschedulePaymentMutation, ReschedulePaymentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReschedulePaymentMutation, ReschedulePaymentMutationVariables>(ReschedulePaymentDocument, options);
      }
export type ReschedulePaymentMutationHookResult = ReturnType<typeof useReschedulePaymentMutation>;
export type ReschedulePaymentMutationResult = Apollo.MutationResult<ReschedulePaymentMutation>;
export type ReschedulePaymentMutationOptions = Apollo.BaseMutationOptions<ReschedulePaymentMutation, ReschedulePaymentMutationVariables>;
export const CancelSubscriptionImmediatelyDocument = gql`
    mutation CancelSubscriptionImmediately($id: ID!, $cancellationEffectiveAtType: CancellationEffectiveAtType!) {
  cancelSubscriptionImmediately(
    id: $id
    cancellationEffectiveAtType: $cancellationEffectiveAtType
  ) {
    id
  }
}
    `;
export type CancelSubscriptionImmediatelyMutationFn = Apollo.MutationFunction<CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables>;
export type CancelSubscriptionImmediatelyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables>
    } & TChildProps;
export function withCancelSubscriptionImmediately<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelSubscriptionImmediatelyMutation,
  CancelSubscriptionImmediatelyMutationVariables,
  CancelSubscriptionImmediatelyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables, CancelSubscriptionImmediatelyProps<TChildProps, TDataName>>(CancelSubscriptionImmediatelyDocument, {
      alias: 'cancelSubscriptionImmediately',
      ...operationOptions
    });
};

/**
 * __useCancelSubscriptionImmediately__
 *
 * To run a mutation, you first call `useCancelSubscriptionImmediately` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelSubscriptionImmediately` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelSubscriptionImmediately, { data, loading, error }] = useCancelSubscriptionImmediately({
 *   variables: {
 *      id: // value for 'id'
 *      cancellationEffectiveAtType: // value for 'cancellationEffectiveAtType'
 *   },
 * });
 */
export function useCancelSubscriptionImmediately(baseOptions?: Apollo.MutationHookOptions<CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables>(CancelSubscriptionImmediatelyDocument, options);
      }
export type CancelSubscriptionImmediatelyHookResult = ReturnType<typeof useCancelSubscriptionImmediately>;
export type CancelSubscriptionImmediatelyMutationResult = Apollo.MutationResult<CancelSubscriptionImmediatelyMutation>;
export type CancelSubscriptionImmediatelyMutationOptions = Apollo.BaseMutationOptions<CancelSubscriptionImmediatelyMutation, CancelSubscriptionImmediatelyMutationVariables>;
export const ReactivateSubscriptionDocument = gql`
    mutation ReactivateSubscription($subscriptionId: ID!) {
  reactivateSubscription(subscriptionId: $subscriptionId) {
    success
    subscription {
      ...SubscriptionDetailFragment
    }
  }
}
    ${SubscriptionDetailFragmentDoc}
${CompanyFragmentDoc}`;
export type ReactivateSubscriptionMutationFn = Apollo.MutationFunction<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export type ReactivateSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>
    } & TChildProps;
export function withReactivateSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReactivateSubscriptionMutation,
  ReactivateSubscriptionMutationVariables,
  ReactivateSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables, ReactivateSubscriptionProps<TChildProps, TDataName>>(ReactivateSubscriptionDocument, {
      alias: 'reactivateSubscription',
      ...operationOptions
    });
};

/**
 * __useReactivateSubscription__
 *
 * To run a mutation, you first call `useReactivateSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateSubscription, { data, loading, error }] = useReactivateSubscription({
 *   variables: {
 *      subscriptionId: // value for 'subscriptionId'
 *   },
 * });
 */
export function useReactivateSubscription(baseOptions?: Apollo.MutationHookOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>(ReactivateSubscriptionDocument, options);
      }
export type ReactivateSubscriptionHookResult = ReturnType<typeof useReactivateSubscription>;
export type ReactivateSubscriptionMutationResult = Apollo.MutationResult<ReactivateSubscriptionMutation>;
export type ReactivateSubscriptionMutationOptions = Apollo.BaseMutationOptions<ReactivateSubscriptionMutation, ReactivateSubscriptionMutationVariables>;
export const TargetGroupDocument = gql`
    query TargetGroup($id: ID!) {
  targetGroup(id: $id) {
    ...targetGroupDataFragment
  }
}
    ${TargetGroupDataFragmentDoc}`;
export type TargetGroupProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TargetGroupQuery, TargetGroupQueryVariables>
    } & TChildProps;
export function withTargetGroup<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TargetGroupQuery,
  TargetGroupQueryVariables,
  TargetGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TargetGroupQuery, TargetGroupQueryVariables, TargetGroupProps<TChildProps, TDataName>>(TargetGroupDocument, {
      alias: 'targetGroup',
      ...operationOptions
    });
};

/**
 * __useTargetGroupQuery__
 *
 * To run a query within a React component, call `useTargetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useTargetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTargetGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTargetGroupQuery(baseOptions: Apollo.QueryHookOptions<TargetGroupQuery, TargetGroupQueryVariables> & ({ variables: TargetGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TargetGroupQuery, TargetGroupQueryVariables>(TargetGroupDocument, options);
      }
export function useTargetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TargetGroupQuery, TargetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TargetGroupQuery, TargetGroupQueryVariables>(TargetGroupDocument, options);
        }
export function useTargetGroupSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TargetGroupQuery, TargetGroupQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TargetGroupQuery, TargetGroupQueryVariables>(TargetGroupDocument, options);
        }
export type TargetGroupQueryHookResult = ReturnType<typeof useTargetGroupQuery>;
export type TargetGroupLazyQueryHookResult = ReturnType<typeof useTargetGroupLazyQuery>;
export type TargetGroupSuspenseQueryHookResult = ReturnType<typeof useTargetGroupSuspenseQuery>;
export type TargetGroupQueryResult = Apollo.QueryResult<TargetGroupQuery, TargetGroupQueryVariables>;
export const AllTargetGroupsByCinemaOperatingCompaniesDocument = gql`
    query AllTargetGroupsByCinemaOperatingCompanies($cinemaOperatingCompanyIds: [ID!]!) {
  allTargetGroupsByCinemaOperatingCompanies(
    cinemaOperatingCompanyIds: $cinemaOperatingCompanyIds
  ) {
    targetGroups {
      ...targetGroupDataFragment
    }
  }
}
    ${TargetGroupDataFragmentDoc}`;
export type AllTargetGroupsByCinemaOperatingCompaniesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>
    } & TChildProps;
export function withAllTargetGroupsByCinemaOperatingCompanies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AllTargetGroupsByCinemaOperatingCompaniesQuery,
  AllTargetGroupsByCinemaOperatingCompaniesQueryVariables,
  AllTargetGroupsByCinemaOperatingCompaniesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables, AllTargetGroupsByCinemaOperatingCompaniesProps<TChildProps, TDataName>>(AllTargetGroupsByCinemaOperatingCompaniesDocument, {
      alias: 'allTargetGroupsByCinemaOperatingCompanies',
      ...operationOptions
    });
};

/**
 * __useAllTargetGroupsByCinemaOperatingCompaniesQuery__
 *
 * To run a query within a React component, call `useAllTargetGroupsByCinemaOperatingCompaniesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAllTargetGroupsByCinemaOperatingCompaniesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAllTargetGroupsByCinemaOperatingCompaniesQuery({
 *   variables: {
 *      cinemaOperatingCompanyIds: // value for 'cinemaOperatingCompanyIds'
 *   },
 * });
 */
export function useAllTargetGroupsByCinemaOperatingCompaniesQuery(baseOptions: Apollo.QueryHookOptions<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables> & ({ variables: AllTargetGroupsByCinemaOperatingCompaniesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>(AllTargetGroupsByCinemaOperatingCompaniesDocument, options);
      }
export function useAllTargetGroupsByCinemaOperatingCompaniesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>(AllTargetGroupsByCinemaOperatingCompaniesDocument, options);
        }
export function useAllTargetGroupsByCinemaOperatingCompaniesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>(AllTargetGroupsByCinemaOperatingCompaniesDocument, options);
        }
export type AllTargetGroupsByCinemaOperatingCompaniesQueryHookResult = ReturnType<typeof useAllTargetGroupsByCinemaOperatingCompaniesQuery>;
export type AllTargetGroupsByCinemaOperatingCompaniesLazyQueryHookResult = ReturnType<typeof useAllTargetGroupsByCinemaOperatingCompaniesLazyQuery>;
export type AllTargetGroupsByCinemaOperatingCompaniesSuspenseQueryHookResult = ReturnType<typeof useAllTargetGroupsByCinemaOperatingCompaniesSuspenseQuery>;
export type AllTargetGroupsByCinemaOperatingCompaniesQueryResult = Apollo.QueryResult<AllTargetGroupsByCinemaOperatingCompaniesQuery, AllTargetGroupsByCinemaOperatingCompaniesQueryVariables>;
export const SaveTargetGroupDocument = gql`
    mutation SaveTargetGroup($id: ID!, $name: String!, $cluster: [TargetGroupClusterInput!]!) {
  editTargetGroup(id: $id, name: $name, cluster: $cluster) {
    targetGroup {
      ...targetGroupDataFragment
    }
  }
}
    ${TargetGroupDataFragmentDoc}`;
export type SaveTargetGroupMutationFn = Apollo.MutationFunction<SaveTargetGroupMutation, SaveTargetGroupMutationVariables>;
export type SaveTargetGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SaveTargetGroupMutation, SaveTargetGroupMutationVariables>
    } & TChildProps;
export function withSaveTargetGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SaveTargetGroupMutation,
  SaveTargetGroupMutationVariables,
  SaveTargetGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SaveTargetGroupMutation, SaveTargetGroupMutationVariables, SaveTargetGroupProps<TChildProps, TDataName>>(SaveTargetGroupDocument, {
      alias: 'saveTargetGroup',
      ...operationOptions
    });
};

/**
 * __useSaveTargetGroupMutation__
 *
 * To run a mutation, you first call `useSaveTargetGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTargetGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTargetGroupMutation, { data, loading, error }] = useSaveTargetGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      name: // value for 'name'
 *      cluster: // value for 'cluster'
 *   },
 * });
 */
export function useSaveTargetGroupMutation(baseOptions?: Apollo.MutationHookOptions<SaveTargetGroupMutation, SaveTargetGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTargetGroupMutation, SaveTargetGroupMutationVariables>(SaveTargetGroupDocument, options);
      }
export type SaveTargetGroupMutationHookResult = ReturnType<typeof useSaveTargetGroupMutation>;
export type SaveTargetGroupMutationResult = Apollo.MutationResult<SaveTargetGroupMutation>;
export type SaveTargetGroupMutationOptions = Apollo.BaseMutationOptions<SaveTargetGroupMutation, SaveTargetGroupMutationVariables>;
export const CreateTargetGroupDocument = gql`
    mutation CreateTargetGroup($name: String!, $cinemaIds: [ID!]!) {
  result: createTargetGroup(name: $name, cinemaIds: $cinemaIds) {
    targetGroup {
      id
    }
  }
}
    `;
export type CreateTargetGroupMutationFn = Apollo.MutationFunction<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>;
export type CreateTargetGroupProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>
    } & TChildProps;
export function withCreateTargetGroup<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateTargetGroupMutation,
  CreateTargetGroupMutationVariables,
  CreateTargetGroupProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateTargetGroupMutation, CreateTargetGroupMutationVariables, CreateTargetGroupProps<TChildProps, TDataName>>(CreateTargetGroupDocument, {
      alias: 'createTargetGroup',
      ...operationOptions
    });
};

/**
 * __useCreateTargetGroupMutation__
 *
 * To run a mutation, you first call `useCreateTargetGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTargetGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTargetGroupMutation, { data, loading, error }] = useCreateTargetGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      cinemaIds: // value for 'cinemaIds'
 *   },
 * });
 */
export function useCreateTargetGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>(CreateTargetGroupDocument, options);
      }
export type CreateTargetGroupMutationHookResult = ReturnType<typeof useCreateTargetGroupMutation>;
export type CreateTargetGroupMutationResult = Apollo.MutationResult<CreateTargetGroupMutation>;
export type CreateTargetGroupMutationOptions = Apollo.BaseMutationOptions<CreateTargetGroupMutation, CreateTargetGroupMutationVariables>;
export const DeleteTargetGroupsDocument = gql`
    mutation DeleteTargetGroups($ids: [ID!]!) {
  result: deleteTargetGroups(ids: $ids) {
    success
  }
}
    `;
export type DeleteTargetGroupsMutationFn = Apollo.MutationFunction<DeleteTargetGroupsMutation, DeleteTargetGroupsMutationVariables>;
export type DeleteTargetGroupsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<DeleteTargetGroupsMutation, DeleteTargetGroupsMutationVariables>
    } & TChildProps;
export function withDeleteTargetGroups<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteTargetGroupsMutation,
  DeleteTargetGroupsMutationVariables,
  DeleteTargetGroupsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteTargetGroupsMutation, DeleteTargetGroupsMutationVariables, DeleteTargetGroupsProps<TChildProps, TDataName>>(DeleteTargetGroupsDocument, {
      alias: 'deleteTargetGroups',
      ...operationOptions
    });
};

/**
 * __useDeleteTargetGroupsMutation__
 *
 * To run a mutation, you first call `useDeleteTargetGroupsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTargetGroupsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTargetGroupsMutation, { data, loading, error }] = useDeleteTargetGroupsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useDeleteTargetGroupsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTargetGroupsMutation, DeleteTargetGroupsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTargetGroupsMutation, DeleteTargetGroupsMutationVariables>(DeleteTargetGroupsDocument, options);
      }
export type DeleteTargetGroupsMutationHookResult = ReturnType<typeof useDeleteTargetGroupsMutation>;
export type DeleteTargetGroupsMutationResult = Apollo.MutationResult<DeleteTargetGroupsMutation>;
export type DeleteTargetGroupsMutationOptions = Apollo.BaseMutationOptions<DeleteTargetGroupsMutation, DeleteTargetGroupsMutationVariables>;
export const UpdateTargetGroupsStatusDocument = gql`
    mutation UpdateTargetGroupsStatus($ids: [ID!]!, $newStatus: UpdatedTargetGroupStatus!) {
  updateTargetGroupsStatus(ids: $ids, newStatus: $newStatus) {
    targetGroups {
      ...targetGroupDataFragment
    }
  }
}
    ${TargetGroupDataFragmentDoc}`;
export type UpdateTargetGroupsStatusMutationFn = Apollo.MutationFunction<UpdateTargetGroupsStatusMutation, UpdateTargetGroupsStatusMutationVariables>;
export type UpdateTargetGroupsStatusProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateTargetGroupsStatusMutation, UpdateTargetGroupsStatusMutationVariables>
    } & TChildProps;
export function withUpdateTargetGroupsStatus<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateTargetGroupsStatusMutation,
  UpdateTargetGroupsStatusMutationVariables,
  UpdateTargetGroupsStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateTargetGroupsStatusMutation, UpdateTargetGroupsStatusMutationVariables, UpdateTargetGroupsStatusProps<TChildProps, TDataName>>(UpdateTargetGroupsStatusDocument, {
      alias: 'updateTargetGroupsStatus',
      ...operationOptions
    });
};

/**
 * __useUpdateTargetGroupsStatusMutation__
 *
 * To run a mutation, you first call `useUpdateTargetGroupsStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTargetGroupsStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTargetGroupsStatusMutation, { data, loading, error }] = useUpdateTargetGroupsStatusMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *      newStatus: // value for 'newStatus'
 *   },
 * });
 */
export function useUpdateTargetGroupsStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTargetGroupsStatusMutation, UpdateTargetGroupsStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTargetGroupsStatusMutation, UpdateTargetGroupsStatusMutationVariables>(UpdateTargetGroupsStatusDocument, options);
      }
export type UpdateTargetGroupsStatusMutationHookResult = ReturnType<typeof useUpdateTargetGroupsStatusMutation>;
export type UpdateTargetGroupsStatusMutationResult = Apollo.MutationResult<UpdateTargetGroupsStatusMutation>;
export type UpdateTargetGroupsStatusMutationOptions = Apollo.BaseMutationOptions<UpdateTargetGroupsStatusMutation, UpdateTargetGroupsStatusMutationVariables>;
export const UpdateTicketDocument = gql`
    mutation UpdateTicket($id: ID!, $scanned: Boolean!) {
  updateTicket(id: $id, scanned: $scanned) {
    ...TicketDetails
  }
}
    ${TicketDetailsFragmentDoc}`;
export type UpdateTicketMutationFn = Apollo.MutationFunction<UpdateTicketMutation, UpdateTicketMutationVariables>;
export type UpdateTicketProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateTicketMutation, UpdateTicketMutationVariables>
    } & TChildProps;
export function withUpdateTicket<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateTicketMutation,
  UpdateTicketMutationVariables,
  UpdateTicketProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateTicketMutation, UpdateTicketMutationVariables, UpdateTicketProps<TChildProps, TDataName>>(UpdateTicketDocument, {
      alias: 'updateTicket',
      ...operationOptions
    });
};

/**
 * __useUpdateTicketMutation__
 *
 * To run a mutation, you first call `useUpdateTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTicketMutation, { data, loading, error }] = useUpdateTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *      scanned: // value for 'scanned'
 *   },
 * });
 */
export function useUpdateTicketMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTicketMutation, UpdateTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTicketMutation, UpdateTicketMutationVariables>(UpdateTicketDocument, options);
      }
export type UpdateTicketMutationHookResult = ReturnType<typeof useUpdateTicketMutation>;
export type UpdateTicketMutationResult = Apollo.MutationResult<UpdateTicketMutation>;
export type UpdateTicketMutationOptions = Apollo.BaseMutationOptions<UpdateTicketMutation, UpdateTicketMutationVariables>;
export const SyncTicketDocument = gql`
    mutation SyncTicket($id: ID!) {
  syncTicket(id: $id) {
    ...TicketDetails
  }
}
    ${TicketDetailsFragmentDoc}`;
export type SyncTicketMutationFn = Apollo.MutationFunction<SyncTicketMutation, SyncTicketMutationVariables>;
export type SyncTicketProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<SyncTicketMutation, SyncTicketMutationVariables>
    } & TChildProps;
export function withSyncTicket<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SyncTicketMutation,
  SyncTicketMutationVariables,
  SyncTicketProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, SyncTicketMutation, SyncTicketMutationVariables, SyncTicketProps<TChildProps, TDataName>>(SyncTicketDocument, {
      alias: 'syncTicket',
      ...operationOptions
    });
};

/**
 * __useSyncTicketMutation__
 *
 * To run a mutation, you first call `useSyncTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncTicketMutation, { data, loading, error }] = useSyncTicketMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncTicketMutation(baseOptions?: Apollo.MutationHookOptions<SyncTicketMutation, SyncTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncTicketMutation, SyncTicketMutationVariables>(SyncTicketDocument, options);
      }
export type SyncTicketMutationHookResult = ReturnType<typeof useSyncTicketMutation>;
export type SyncTicketMutationResult = Apollo.MutationResult<SyncTicketMutation>;
export type SyncTicketMutationOptions = Apollo.BaseMutationOptions<SyncTicketMutation, SyncTicketMutationVariables>;
export const CancelTicketDocument = gql`
    mutation CancelTicket($ticketId: ID!) {
  cancelTicket(id: $ticketId) {
    canceledTicket {
      id
      status
      screening {
        id
        movie {
          id
          title
        }
      }
    }
    user: currentUser {
      id
      name
    }
  }
}
    `;
export type CancelTicketMutationFn = Apollo.MutationFunction<CancelTicketMutation, CancelTicketMutationVariables>;
export type CancelTicketProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CancelTicketMutation, CancelTicketMutationVariables>
    } & TChildProps;
export function withCancelTicket<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelTicketMutation,
  CancelTicketMutationVariables,
  CancelTicketProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelTicketMutation, CancelTicketMutationVariables, CancelTicketProps<TChildProps, TDataName>>(CancelTicketDocument, {
      alias: 'cancelTicket',
      ...operationOptions
    });
};

/**
 * __useCancelTicketMutation__
 *
 * To run a mutation, you first call `useCancelTicketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelTicketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelTicketMutation, { data, loading, error }] = useCancelTicketMutation({
 *   variables: {
 *      ticketId: // value for 'ticketId'
 *   },
 * });
 */
export function useCancelTicketMutation(baseOptions?: Apollo.MutationHookOptions<CancelTicketMutation, CancelTicketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelTicketMutation, CancelTicketMutationVariables>(CancelTicketDocument, options);
      }
export type CancelTicketMutationHookResult = ReturnType<typeof useCancelTicketMutation>;
export type CancelTicketMutationResult = Apollo.MutationResult<CancelTicketMutation>;
export type CancelTicketMutationOptions = Apollo.BaseMutationOptions<CancelTicketMutation, CancelTicketMutationVariables>;
export const PrivilegesDocument = gql`
    query Privileges {
  user: currentUser {
    ...UserFragment
  }
}
    ${UserFragmentDoc}
${CinemaFragmentDoc}
${CinemaOperatingCompanyFragmentDoc}`;
export type PrivilegesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<PrivilegesQuery, PrivilegesQueryVariables>
    } & TChildProps;
export function withPrivileges<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  PrivilegesQuery,
  PrivilegesQueryVariables,
  PrivilegesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, PrivilegesQuery, PrivilegesQueryVariables, PrivilegesProps<TChildProps, TDataName>>(PrivilegesDocument, {
      alias: 'privileges',
      ...operationOptions
    });
};

/**
 * __usePrivilegesQuery__
 *
 * To run a query within a React component, call `usePrivilegesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePrivilegesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePrivilegesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePrivilegesQuery(baseOptions?: Apollo.QueryHookOptions<PrivilegesQuery, PrivilegesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PrivilegesQuery, PrivilegesQueryVariables>(PrivilegesDocument, options);
      }
export function usePrivilegesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PrivilegesQuery, PrivilegesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PrivilegesQuery, PrivilegesQueryVariables>(PrivilegesDocument, options);
        }
export function usePrivilegesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PrivilegesQuery, PrivilegesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PrivilegesQuery, PrivilegesQueryVariables>(PrivilegesDocument, options);
        }
export type PrivilegesQueryHookResult = ReturnType<typeof usePrivilegesQuery>;
export type PrivilegesLazyQueryHookResult = ReturnType<typeof usePrivilegesLazyQuery>;
export type PrivilegesSuspenseQueryHookResult = ReturnType<typeof usePrivilegesSuspenseQuery>;
export type PrivilegesQueryResult = Apollo.QueryResult<PrivilegesQuery, PrivilegesQueryVariables>;
export const LogoutDocument = gql`
    mutation Logout {
  logout {
    success
  }
}
    `;
export type LogoutMutationFn = Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>;
export type LogoutProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<LogoutMutation, LogoutMutationVariables>
    } & TChildProps;
export function withLogout<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  LogoutMutation,
  LogoutMutationVariables,
  LogoutProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, LogoutMutation, LogoutMutationVariables, LogoutProps<TChildProps, TDataName>>(LogoutDocument, {
      alias: 'logout',
      ...operationOptions
    });
};

/**
 * __useLogoutMutation__
 *
 * To run a mutation, you first call `useLogoutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLogoutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [logoutMutation, { data, loading, error }] = useLogoutMutation({
 *   variables: {
 *   },
 * });
 */
export function useLogoutMutation(baseOptions?: Apollo.MutationHookOptions<LogoutMutation, LogoutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LogoutMutation, LogoutMutationVariables>(LogoutDocument, options);
      }
export type LogoutMutationHookResult = ReturnType<typeof useLogoutMutation>;
export type LogoutMutationResult = Apollo.MutationResult<LogoutMutation>;
export type LogoutMutationOptions = Apollo.BaseMutationOptions<LogoutMutation, LogoutMutationVariables>;
export const UpdateUserDocument = gql`
    mutation UpdateUser($userId: ID!, $blocked: Boolean, $blockedText: String, $firstname: String, $lastname: String, $street: String, $houseNumber: String, $zipCode: String, $city: String, $email: String, $adminCinemaOperatingCompanyIds: [ID!], $resetAppChangeBlockedUntil: Boolean) {
  updateUser(
    userId: $userId
    blocked: $blocked
    blockedText: $blockedText
    firstname: $firstname
    lastname: $lastname
    street: $street
    houseNumber: $houseNumber
    zipCode: $zipCode
    city: $city
    email: $email
    adminCinemaOperatingCompanyIds: $adminCinemaOperatingCompanyIds
    resetAppChangeBlockedUntil: $resetAppChangeBlockedUntil
  ) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}
${SubscriptionDetailFragmentDoc}
${CompanyFragmentDoc}
${TicketDetailsFragmentDoc}
${CinemaFragmentDoc}
${VoucherInstanceFragmentDoc}`;
export type UpdateUserMutationFn = Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>;
export type UpdateUserProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateUserMutation, UpdateUserMutationVariables>
    } & TChildProps;
export function withUpdateUser<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserMutation,
  UpdateUserMutationVariables,
  UpdateUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserMutation, UpdateUserMutationVariables, UpdateUserProps<TChildProps, TDataName>>(UpdateUserDocument, {
      alias: 'updateUser',
      ...operationOptions
    });
};

/**
 * __useUpdateUserMutation__
 *
 * To run a mutation, you first call `useUpdateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserMutation, { data, loading, error }] = useUpdateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      blocked: // value for 'blocked'
 *      blockedText: // value for 'blockedText'
 *      firstname: // value for 'firstname'
 *      lastname: // value for 'lastname'
 *      street: // value for 'street'
 *      houseNumber: // value for 'houseNumber'
 *      zipCode: // value for 'zipCode'
 *      city: // value for 'city'
 *      email: // value for 'email'
 *      adminCinemaOperatingCompanyIds: // value for 'adminCinemaOperatingCompanyIds'
 *      resetAppChangeBlockedUntil: // value for 'resetAppChangeBlockedUntil'
 *   },
 * });
 */
export function useUpdateUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserMutation, UpdateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserMutation, UpdateUserMutationVariables>(UpdateUserDocument, options);
      }
export type UpdateUserMutationHookResult = ReturnType<typeof useUpdateUserMutation>;
export type UpdateUserMutationResult = Apollo.MutationResult<UpdateUserMutation>;
export type UpdateUserMutationOptions = Apollo.BaseMutationOptions<UpdateUserMutation, UpdateUserMutationVariables>;
export const UserByIdDocument = gql`
    query UserById($id: ID!) {
  userById(id: $id) {
    ...UserDetails
  }
}
    ${UserDetailsFragmentDoc}
${SubscriptionDetailFragmentDoc}
${CompanyFragmentDoc}
${TicketDetailsFragmentDoc}
${CinemaFragmentDoc}
${VoucherInstanceFragmentDoc}`;
export type UserByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<UserByIdQuery, UserByIdQueryVariables>
    } & TChildProps;
export function withUserById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UserByIdQuery,
  UserByIdQueryVariables,
  UserByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, UserByIdQuery, UserByIdQueryVariables, UserByIdProps<TChildProps, TDataName>>(UserByIdDocument, {
      alias: 'userById',
      ...operationOptions
    });
};

/**
 * __useUserByIdQuery__
 *
 * To run a query within a React component, call `useUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUserByIdQuery(baseOptions: Apollo.QueryHookOptions<UserByIdQuery, UserByIdQueryVariables> & ({ variables: UserByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
      }
export function useUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export function useUserByIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserByIdQuery, UserByIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserByIdQuery, UserByIdQueryVariables>(UserByIdDocument, options);
        }
export type UserByIdQueryHookResult = ReturnType<typeof useUserByIdQuery>;
export type UserByIdLazyQueryHookResult = ReturnType<typeof useUserByIdLazyQuery>;
export type UserByIdSuspenseQueryHookResult = ReturnType<typeof useUserByIdSuspenseQuery>;
export type UserByIdQueryResult = Apollo.QueryResult<UserByIdQuery, UserByIdQueryVariables>;
export const UpdateUserSubscriptionDocument = gql`
    mutation UpdateUserSubscription($id: ID!, $blocked: Boolean!, $blockedText: String) {
  updateUserSubscription(id: $id, blocked: $blocked, blockedText: $blockedText) {
    id
  }
}
    `;
export type UpdateUserSubscriptionMutationFn = Apollo.MutationFunction<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>;
export type UpdateUserSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>
    } & TChildProps;
export function withUpdateUserSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateUserSubscriptionMutation,
  UpdateUserSubscriptionMutationVariables,
  UpdateUserSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables, UpdateUserSubscriptionProps<TChildProps, TDataName>>(UpdateUserSubscriptionDocument, {
      alias: 'updateUserSubscription',
      ...operationOptions
    });
};

/**
 * __useUpdateUserSubscription__
 *
 * To run a mutation, you first call `useUpdateUserSubscription` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserSubscription` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserSubscription, { data, loading, error }] = useUpdateUserSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      blocked: // value for 'blocked'
 *      blockedText: // value for 'blockedText'
 *   },
 * });
 */
export function useUpdateUserSubscription(baseOptions?: Apollo.MutationHookOptions<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>(UpdateUserSubscriptionDocument, options);
      }
export type UpdateUserSubscriptionHookResult = ReturnType<typeof useUpdateUserSubscription>;
export type UpdateUserSubscriptionMutationResult = Apollo.MutationResult<UpdateUserSubscriptionMutation>;
export type UpdateUserSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateUserSubscriptionMutation, UpdateUserSubscriptionMutationVariables>;
export const SearchUsersTotalDocument = gql`
    query SearchUsersTotal($queryText: String, $filterActiveSubscriptions: Boolean) {
  searchUsersTotal(
    queryText: $queryText
    filterActiveSubscriptions: $filterActiveSubscriptions
  )
}
    `;
export type SearchUsersTotalProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>
    } & TChildProps;
export function withSearchUsersTotal<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchUsersTotalQuery,
  SearchUsersTotalQueryVariables,
  SearchUsersTotalProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchUsersTotalQuery, SearchUsersTotalQueryVariables, SearchUsersTotalProps<TChildProps, TDataName>>(SearchUsersTotalDocument, {
      alias: 'searchUsersTotal',
      ...operationOptions
    });
};

/**
 * __useSearchUsersTotalQuery__
 *
 * To run a query within a React component, call `useSearchUsersTotalQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersTotalQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersTotalQuery({
 *   variables: {
 *      queryText: // value for 'queryText'
 *      filterActiveSubscriptions: // value for 'filterActiveSubscriptions'
 *   },
 * });
 */
export function useSearchUsersTotalQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>(SearchUsersTotalDocument, options);
      }
export function useSearchUsersTotalLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>(SearchUsersTotalDocument, options);
        }
export function useSearchUsersTotalSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>(SearchUsersTotalDocument, options);
        }
export type SearchUsersTotalQueryHookResult = ReturnType<typeof useSearchUsersTotalQuery>;
export type SearchUsersTotalLazyQueryHookResult = ReturnType<typeof useSearchUsersTotalLazyQuery>;
export type SearchUsersTotalSuspenseQueryHookResult = ReturnType<typeof useSearchUsersTotalSuspenseQuery>;
export type SearchUsersTotalQueryResult = Apollo.QueryResult<SearchUsersTotalQuery, SearchUsersTotalQueryVariables>;
export const SearchUsersDocument = gql`
    query SearchUsers($queryText: String, $filterActiveSubscriptions: Boolean, $skip: Int, $limit: Int) {
  searchUsers(
    queryText: $queryText
    filterActiveSubscriptions: $filterActiveSubscriptions
    skip: $skip
    limit: $limit
  ) {
    id
    firstName
    lastName
    email
    telephone
    country
    blocked
    privileges {
      contentEditorRole
      adminForCinemas {
        id
      }
    }
  }
}
    `;
export type SearchUsersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SearchUsersQuery, SearchUsersQueryVariables>
    } & TChildProps;
export function withSearchUsers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SearchUsersQuery,
  SearchUsersQueryVariables,
  SearchUsersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SearchUsersQuery, SearchUsersQueryVariables, SearchUsersProps<TChildProps, TDataName>>(SearchUsersDocument, {
      alias: 'searchUsers',
      ...operationOptions
    });
};

/**
 * __useSearchUsersQuery__
 *
 * To run a query within a React component, call `useSearchUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchUsersQuery({
 *   variables: {
 *      queryText: // value for 'queryText'
 *      filterActiveSubscriptions: // value for 'filterActiveSubscriptions'
 *      skip: // value for 'skip'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchUsersQuery(baseOptions?: Apollo.QueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
      }
export function useSearchUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export function useSearchUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchUsersQuery, SearchUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchUsersQuery, SearchUsersQueryVariables>(SearchUsersDocument, options);
        }
export type SearchUsersQueryHookResult = ReturnType<typeof useSearchUsersQuery>;
export type SearchUsersLazyQueryHookResult = ReturnType<typeof useSearchUsersLazyQuery>;
export type SearchUsersSuspenseQueryHookResult = ReturnType<typeof useSearchUsersSuspenseQuery>;
export type SearchUsersQueryResult = Apollo.QueryResult<SearchUsersQuery, SearchUsersQueryVariables>;
export const CreateVouchersDocument = gql`
    mutation CreateVouchers($voucherClassId: ID!, $companyId: ID, $numberOfVouchers: Int!, $reason: String, $validUntil: Date) {
  createVoucherInstances(
    voucherClassId: $voucherClassId
    companyId: $companyId
    numberOfVouchers: $numberOfVouchers
    reason: $reason
    validUntil: $validUntil
  ) {
    ...VoucherInstanceFragment
  }
}
    ${VoucherInstanceFragmentDoc}`;
export type CreateVouchersMutationFn = Apollo.MutationFunction<CreateVouchersMutation, CreateVouchersMutationVariables>;
export type CreateVouchersProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<CreateVouchersMutation, CreateVouchersMutationVariables>
    } & TChildProps;
export function withCreateVouchers<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateVouchersMutation,
  CreateVouchersMutationVariables,
  CreateVouchersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateVouchersMutation, CreateVouchersMutationVariables, CreateVouchersProps<TChildProps, TDataName>>(CreateVouchersDocument, {
      alias: 'createVouchers',
      ...operationOptions
    });
};

/**
 * __useCreateVouchersMutation__
 *
 * To run a mutation, you first call `useCreateVouchersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVouchersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVouchersMutation, { data, loading, error }] = useCreateVouchersMutation({
 *   variables: {
 *      voucherClassId: // value for 'voucherClassId'
 *      companyId: // value for 'companyId'
 *      numberOfVouchers: // value for 'numberOfVouchers'
 *      reason: // value for 'reason'
 *      validUntil: // value for 'validUntil'
 *   },
 * });
 */
export function useCreateVouchersMutation(baseOptions?: Apollo.MutationHookOptions<CreateVouchersMutation, CreateVouchersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVouchersMutation, CreateVouchersMutationVariables>(CreateVouchersDocument, options);
      }
export type CreateVouchersMutationHookResult = ReturnType<typeof useCreateVouchersMutation>;
export type CreateVouchersMutationResult = Apollo.MutationResult<CreateVouchersMutation>;
export type CreateVouchersMutationOptions = Apollo.BaseMutationOptions<CreateVouchersMutation, CreateVouchersMutationVariables>;
export const GetVoucherInstanceDocument = gql`
    query GetVoucherInstance($qrCode: String!) {
  voucherInstanceByQR(qrCode: $qrCode) {
    ...VoucherInstanceFragment
  }
}
    ${VoucherInstanceFragmentDoc}`;
export type GetVoucherInstanceProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>
    } & TChildProps;
export function withGetVoucherInstance<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVoucherInstanceQuery,
  GetVoucherInstanceQueryVariables,
  GetVoucherInstanceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables, GetVoucherInstanceProps<TChildProps, TDataName>>(GetVoucherInstanceDocument, {
      alias: 'getVoucherInstance',
      ...operationOptions
    });
};

/**
 * __useGetVoucherInstanceQuery__
 *
 * To run a query within a React component, call `useGetVoucherInstanceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherInstanceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherInstanceQuery({
 *   variables: {
 *      qrCode: // value for 'qrCode'
 *   },
 * });
 */
export function useGetVoucherInstanceQuery(baseOptions: Apollo.QueryHookOptions<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables> & ({ variables: GetVoucherInstanceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>(GetVoucherInstanceDocument, options);
      }
export function useGetVoucherInstanceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>(GetVoucherInstanceDocument, options);
        }
export function useGetVoucherInstanceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>(GetVoucherInstanceDocument, options);
        }
export type GetVoucherInstanceQueryHookResult = ReturnType<typeof useGetVoucherInstanceQuery>;
export type GetVoucherInstanceLazyQueryHookResult = ReturnType<typeof useGetVoucherInstanceLazyQuery>;
export type GetVoucherInstanceSuspenseQueryHookResult = ReturnType<typeof useGetVoucherInstanceSuspenseQuery>;
export type GetVoucherInstanceQueryResult = Apollo.QueryResult<GetVoucherInstanceQuery, GetVoucherInstanceQueryVariables>;
export const GetVoucherInstancesByOrderNumberDocument = gql`
    query GetVoucherInstancesByOrderNumber($orderNumber: String!) {
  voucherInstancesByOrderNumber(orderNumber: $orderNumber) {
    ...VoucherInstanceFragment
  }
}
    ${VoucherInstanceFragmentDoc}`;
export type GetVoucherInstancesByOrderNumberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>
    } & TChildProps;
export function withGetVoucherInstancesByOrderNumber<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetVoucherInstancesByOrderNumberQuery,
  GetVoucherInstancesByOrderNumberQueryVariables,
  GetVoucherInstancesByOrderNumberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables, GetVoucherInstancesByOrderNumberProps<TChildProps, TDataName>>(GetVoucherInstancesByOrderNumberDocument, {
      alias: 'getVoucherInstancesByOrderNumber',
      ...operationOptions
    });
};

/**
 * __useGetVoucherInstancesByOrderNumberQuery__
 *
 * To run a query within a React component, call `useGetVoucherInstancesByOrderNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoucherInstancesByOrderNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoucherInstancesByOrderNumberQuery({
 *   variables: {
 *      orderNumber: // value for 'orderNumber'
 *   },
 * });
 */
export function useGetVoucherInstancesByOrderNumberQuery(baseOptions: Apollo.QueryHookOptions<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables> & ({ variables: GetVoucherInstancesByOrderNumberQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>(GetVoucherInstancesByOrderNumberDocument, options);
      }
export function useGetVoucherInstancesByOrderNumberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>(GetVoucherInstancesByOrderNumberDocument, options);
        }
export function useGetVoucherInstancesByOrderNumberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>(GetVoucherInstancesByOrderNumberDocument, options);
        }
export type GetVoucherInstancesByOrderNumberQueryHookResult = ReturnType<typeof useGetVoucherInstancesByOrderNumberQuery>;
export type GetVoucherInstancesByOrderNumberLazyQueryHookResult = ReturnType<typeof useGetVoucherInstancesByOrderNumberLazyQuery>;
export type GetVoucherInstancesByOrderNumberSuspenseQueryHookResult = ReturnType<typeof useGetVoucherInstancesByOrderNumberSuspenseQuery>;
export type GetVoucherInstancesByOrderNumberQueryResult = Apollo.QueryResult<GetVoucherInstancesByOrderNumberQuery, GetVoucherInstancesByOrderNumberQueryVariables>;
export const UpdateVoucherInstanceDocument = gql`
    mutation UpdateVoucherInstance($id: ID!, $isValid: Boolean!) {
  updateVoucherInstance(id: $id, isValid: $isValid) {
    ...VoucherInstanceFragment
  }
}
    ${VoucherInstanceFragmentDoc}`;
export type UpdateVoucherInstanceMutationFn = Apollo.MutationFunction<UpdateVoucherInstanceMutation, UpdateVoucherInstanceMutationVariables>;
export type UpdateVoucherInstanceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: Apollo.MutationFunction<UpdateVoucherInstanceMutation, UpdateVoucherInstanceMutationVariables>
    } & TChildProps;
export function withUpdateVoucherInstance<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateVoucherInstanceMutation,
  UpdateVoucherInstanceMutationVariables,
  UpdateVoucherInstanceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateVoucherInstanceMutation, UpdateVoucherInstanceMutationVariables, UpdateVoucherInstanceProps<TChildProps, TDataName>>(UpdateVoucherInstanceDocument, {
      alias: 'updateVoucherInstance',
      ...operationOptions
    });
};

/**
 * __useUpdateVoucherInstanceMutation__
 *
 * To run a mutation, you first call `useUpdateVoucherInstanceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoucherInstanceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoucherInstanceMutation, { data, loading, error }] = useUpdateVoucherInstanceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      isValid: // value for 'isValid'
 *   },
 * });
 */
export function useUpdateVoucherInstanceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVoucherInstanceMutation, UpdateVoucherInstanceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVoucherInstanceMutation, UpdateVoucherInstanceMutationVariables>(UpdateVoucherInstanceDocument, options);
      }
export type UpdateVoucherInstanceMutationHookResult = ReturnType<typeof useUpdateVoucherInstanceMutation>;
export type UpdateVoucherInstanceMutationResult = Apollo.MutationResult<UpdateVoucherInstanceMutation>;
export type UpdateVoucherInstanceMutationOptions = Apollo.BaseMutationOptions<UpdateVoucherInstanceMutation, UpdateVoucherInstanceMutationVariables>;